/*! jQuery v2.2.4 | (c) jQuery Foundation | jquery.org/license */ (function (
  a,
  b
) {
  typeof module == "object" && typeof module.exports == "object"
    ? (module.exports = a.document
        ? b(a, !0)
        : function (a2) {
            if (!a2.document)
              throw new Error("jQuery requires a window with a document");
            return b(a2);
          })
    : b(a);
})(typeof window < "u" ? window : this, function (a, b) {
  var c = [],
    d = a.document,
    e = c.slice,
    f = c.concat,
    g = c.push,
    h = c.indexOf,
    i2 = {},
    j = i2.toString,
    k = i2.hasOwnProperty,
    l = {},
    m = "2.2.4",
    n = function (a2, b2) {
      return new n.fn.init(a2, b2);
    },
    o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
    p = /^-ms-/,
    q = /-([\da-z])/gi,
    r = function (a2, b2) {
      return b2.toUpperCase();
    };
  (n.fn = n.prototype =
    {
      jquery: m,
      constructor: n,
      selector: "",
      length: 0,
      toArray: function () {
        return e.call(this);
      },
      get: function (a2) {
        return a2 != null
          ? 0 > a2
            ? this[a2 + this.length]
            : this[a2]
          : e.call(this);
      },
      pushStack: function (a2) {
        var b2 = n.merge(this.constructor(), a2);
        return (b2.prevObject = this), (b2.context = this.context), b2;
      },
      each: function (a2) {
        return n.each(this, a2);
      },
      map: function (a2) {
        return this.pushStack(
          n.map(this, function (b2, c2) {
            return a2.call(b2, c2, b2);
          })
        );
      },
      slice: function () {
        return this.pushStack(e.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      eq: function (a2) {
        var b2 = this.length,
          c2 = +a2 + (0 > a2 ? b2 : 0);
        return this.pushStack(c2 >= 0 && b2 > c2 ? [this[c2]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: g,
      sort: c.sort,
      splice: c.splice,
    }),
    (n.extend = n.fn.extend =
      function () {
        var a2,
          b2,
          c2,
          d2,
          e2,
          f2,
          g2 = arguments[0] || {},
          h2 = 1,
          i3 = arguments.length,
          j2 = !1;
        for (
          typeof g2 == "boolean" &&
            ((j2 = g2), (g2 = arguments[h2] || {}), h2++),
            typeof g2 == "object" || n.isFunction(g2) || (g2 = {}),
            h2 === i3 && ((g2 = this), h2--);
          i3 > h2;
          h2++
        )
          if ((a2 = arguments[h2]) != null)
            for (b2 in a2)
              (c2 = g2[b2]),
                (d2 = a2[b2]),
                g2 !== d2 &&
                  (j2 && d2 && (n.isPlainObject(d2) || (e2 = n.isArray(d2)))
                    ? (e2
                        ? ((e2 = !1), (f2 = c2 && n.isArray(c2) ? c2 : []))
                        : (f2 = c2 && n.isPlainObject(c2) ? c2 : {}),
                      (g2[b2] = n.extend(j2, f2, d2)))
                    : d2 !== void 0 && (g2[b2] = d2));
        return g2;
      }),
    n.extend({
      expando: "jQuery" + (m + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (a2) {
        throw new Error(a2);
      },
      noop: function () {},
      isFunction: function (a2) {
        return n.type(a2) === "function";
      },
      isArray: Array.isArray,
      isWindow: function (a2) {
        return a2 != null && a2 === a2.window;
      },
      isNumeric: function (a2) {
        var b2 = a2 && a2.toString();
        return !n.isArray(a2) && b2 - parseFloat(b2) + 1 >= 0;
      },
      isPlainObject: function (a2) {
        var b2;
        if (
          n.type(a2) !== "object" ||
          a2.nodeType ||
          n.isWindow(a2) ||
          (a2.constructor &&
            !k.call(a2, "constructor") &&
            !k.call(a2.constructor.prototype || {}, "isPrototypeOf"))
        )
          return !1;
        for (b2 in a2);
        return b2 === void 0 || k.call(a2, b2);
      },
      isEmptyObject: function (a2) {
        var b2;
        for (b2 in a2) return !1;
        return !0;
      },
      type: function (a2) {
        return a2 == null
          ? a2 + ""
          : typeof a2 == "object" || typeof a2 == "function"
          ? i2[j.call(a2)] || "object"
          : typeof a2;
      },
      globalEval: function (a2) {
        var b2,
          c2 = eval;
        (a2 = n.trim(a2)),
          a2 &&
            (a2.indexOf("use strict") === 1
              ? ((b2 = d.createElement("script")),
                (b2.text = a2),
                d.head.appendChild(b2).parentNode.removeChild(b2))
              : c2(a2));
      },
      camelCase: function (a2) {
        return a2.replace(p, "ms-").replace(q, r);
      },
      nodeName: function (a2, b2) {
        return a2.nodeName && a2.nodeName.toLowerCase() === b2.toLowerCase();
      },
      each: function (a2, b2) {
        var c2,
          d2 = 0;
        if (s(a2))
          for (
            c2 = a2.length;
            c2 > d2 && b2.call(a2[d2], d2, a2[d2]) !== !1;
            d2++
          );
        else for (d2 in a2) if (b2.call(a2[d2], d2, a2[d2]) === !1) break;
        return a2;
      },
      trim: function (a2) {
        return a2 == null ? "" : (a2 + "").replace(o, "");
      },
      makeArray: function (a2, b2) {
        var c2 = b2 || [];
        return (
          a2 != null &&
            (s(Object(a2))
              ? n.merge(c2, typeof a2 == "string" ? [a2] : a2)
              : g.call(c2, a2)),
          c2
        );
      },
      inArray: function (a2, b2, c2) {
        return b2 == null ? -1 : h.call(b2, a2, c2);
      },
      merge: function (a2, b2) {
        for (var c2 = +b2.length, d2 = 0, e2 = a2.length; c2 > d2; d2++)
          a2[e2++] = b2[d2];
        return (a2.length = e2), a2;
      },
      grep: function (a2, b2, c2) {
        for (var d2, e2 = [], f2 = 0, g2 = a2.length, h2 = !c2; g2 > f2; f2++)
          (d2 = !b2(a2[f2], f2)), d2 !== h2 && e2.push(a2[f2]);
        return e2;
      },
      map: function (a2, b2, c2) {
        var d2,
          e2,
          g2 = 0,
          h2 = [];
        if (s(a2))
          for (d2 = a2.length; d2 > g2; g2++)
            (e2 = b2(a2[g2], g2, c2)), e2 != null && h2.push(e2);
        else
          for (g2 in a2) (e2 = b2(a2[g2], g2, c2)), e2 != null && h2.push(e2);
        return f.apply([], h2);
      },
      guid: 1,
      proxy: function (a2, b2) {
        var c2, d2, f2;
        return (
          typeof b2 == "string" && ((c2 = a2[b2]), (b2 = a2), (a2 = c2)),
          n.isFunction(a2)
            ? ((d2 = e.call(arguments, 2)),
              (f2 = function () {
                return a2.apply(b2 || this, d2.concat(e.call(arguments)));
              }),
              (f2.guid = a2.guid = a2.guid || n.guid++),
              f2)
            : void 0
        );
      },
      now: Date.now,
      support: l,
    }),
    typeof Symbol == "function" && (n.fn[Symbol.iterator] = c[Symbol.iterator]),
    n.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (a2, b2) {
        i2["[object " + b2 + "]"] = b2.toLowerCase();
      }
    );
  function s(a2) {
    var b2 = !!a2 && "length" in a2 && a2.length,
      c2 = n.type(a2);
    return c2 === "function" || n.isWindow(a2)
      ? !1
      : c2 === "array" ||
          b2 === 0 ||
          (typeof b2 == "number" && b2 > 0 && b2 - 1 in a2);
  }
  var t = (function (a2) {
    var b2,
      c2,
      d2,
      e2,
      f2,
      g2,
      h2,
      i3,
      j2,
      k2,
      l2,
      m2,
      n2,
      o2,
      p2,
      q2,
      r2,
      s2,
      t2,
      u2 = "sizzle" + 1 * new Date(),
      v2 = a2.document,
      w2 = 0,
      x2 = 0,
      y2 = ga2(),
      z2 = ga2(),
      A2 = ga2(),
      B2 = function (a3, b3) {
        return a3 === b3 && (l2 = !0), 0;
      },
      C2 = 1 << 31,
      D2 = {}.hasOwnProperty,
      E2 = [],
      F2 = E2.pop,
      G2 = E2.push,
      H2 = E2.push,
      I2 = E2.slice,
      J2 = function (a3, b3) {
        for (var c3 = 0, d3 = a3.length; d3 > c3; c3++)
          if (a3[c3] === b3) return c3;
        return -1;
      },
      K2 =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      L2 = "[\\x20\\t\\r\\n\\f]",
      M2 = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
      N2 =
        "\\[" +
        L2 +
        "*(" +
        M2 +
        ")(?:" +
        L2 +
        "*([*^$|!~]?=)" +
        L2 +
        `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` +
        M2 +
        "))|)" +
        L2 +
        "*\\]",
      O2 =
        ":(" +
        M2 +
        `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` +
        N2 +
        ")*)|.*)\\)|)",
      P2 = new RegExp(L2 + "+", "g"),
      Q2 = new RegExp(
        "^" + L2 + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L2 + "+$",
        "g"
      ),
      R2 = new RegExp("^" + L2 + "*," + L2 + "*"),
      S2 = new RegExp("^" + L2 + "*([>+~]|" + L2 + ")" + L2 + "*"),
      T2 = new RegExp("=" + L2 + `*([^\\]'"]*?)` + L2 + "*\\]", "g"),
      U2 = new RegExp(O2),
      V2 = new RegExp("^" + M2 + "$"),
      W2 = {
        ID: new RegExp("^#(" + M2 + ")"),
        CLASS: new RegExp("^\\.(" + M2 + ")"),
        TAG: new RegExp("^(" + M2 + "|[*])"),
        ATTR: new RegExp("^" + N2),
        PSEUDO: new RegExp("^" + O2),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            L2 +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            L2 +
            "*(?:([+-]|)" +
            L2 +
            "*(\\d+)|))" +
            L2 +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + K2 + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            L2 +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            L2 +
            "*((?:-\\d)?\\d*)" +
            L2 +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      },
      X2 = /^(?:input|select|textarea|button)$/i,
      Y2 = /^h\d$/i,
      Z2 = /^[^{]+\{\s*\[native \w/,
      $3 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      _2 = /[+~]/,
      aa2 = /'|\\/g,
      ba2 = new RegExp("\\\\([\\da-f]{1,6}" + L2 + "?|(" + L2 + ")|.)", "ig"),
      ca2 = function (a3, b3, c3) {
        var d3 = "0x" + b3 - 65536;
        return d3 !== d3 || c3
          ? b3
          : 0 > d3
          ? String.fromCharCode(d3 + 65536)
          : String.fromCharCode((d3 >> 10) | 55296, (1023 & d3) | 56320);
      },
      da2 = function () {
        m2();
      };
    try {
      H2.apply((E2 = I2.call(v2.childNodes)), v2.childNodes),
        E2[v2.childNodes.length].nodeType;
    } catch {
      H2 = {
        apply: E2.length
          ? function (a3, b3) {
              G2.apply(a3, I2.call(b3));
            }
          : function (a3, b3) {
              for (var c3 = a3.length, d3 = 0; (a3[c3++] = b3[d3++]); );
              a3.length = c3 - 1;
            },
      };
    }
    function fa2(a3, b3, d3, e3) {
      var f3,
        h3,
        j3,
        k3,
        l3,
        o3,
        r3,
        s3,
        w3 = b3 && b3.ownerDocument,
        x3 = b3 ? b3.nodeType : 9;
      if (
        ((d3 = d3 || []),
        typeof a3 != "string" || !a3 || (x3 !== 1 && x3 !== 9 && x3 !== 11))
      )
        return d3;
      if (
        !e3 &&
        ((b3 ? b3.ownerDocument || b3 : v2) !== n2 && m2(b3),
        (b3 = b3 || n2),
        p2)
      ) {
        if (x3 !== 11 && (o3 = $3.exec(a3)))
          if ((f3 = o3[1])) {
            if (x3 === 9) {
              if (!(j3 = b3.getElementById(f3))) return d3;
              if (j3.id === f3) return d3.push(j3), d3;
            } else if (
              w3 &&
              (j3 = w3.getElementById(f3)) &&
              t2(b3, j3) &&
              j3.id === f3
            )
              return d3.push(j3), d3;
          } else {
            if (o3[2]) return H2.apply(d3, b3.getElementsByTagName(a3)), d3;
            if (
              (f3 = o3[3]) &&
              c2.getElementsByClassName &&
              b3.getElementsByClassName
            )
              return H2.apply(d3, b3.getElementsByClassName(f3)), d3;
          }
        if (c2.qsa && !A2[a3 + " "] && (!q2 || !q2.test(a3))) {
          if (x3 !== 1) (w3 = b3), (s3 = a3);
          else if (b3.nodeName.toLowerCase() !== "object") {
            for (
              (k3 = b3.getAttribute("id"))
                ? (k3 = k3.replace(aa2, "\\$&"))
                : b3.setAttribute("id", (k3 = u2)),
                r3 = g2(a3),
                h3 = r3.length,
                l3 = V2.test(k3) ? "#" + k3 : "[id='" + k3 + "']";
              h3--;

            )
              r3[h3] = l3 + " " + qa2(r3[h3]);
            (s3 = r3.join(",")),
              (w3 = (_2.test(a3) && oa2(b3.parentNode)) || b3);
          }
          if (s3)
            try {
              return H2.apply(d3, w3.querySelectorAll(s3)), d3;
            } catch {
            } finally {
              k3 === u2 && b3.removeAttribute("id");
            }
        }
      }
      return i3(a3.replace(Q2, "$1"), b3, d3, e3);
    }
    function ga2() {
      var a3 = [];
      function b3(c3, e3) {
        return (
          a3.push(c3 + " ") > d2.cacheLength && delete b3[a3.shift()],
          (b3[c3 + " "] = e3)
        );
      }
      return b3;
    }
    function ha2(a3) {
      return (a3[u2] = !0), a3;
    }
    function ia2(a3) {
      var b3 = n2.createElement("div");
      try {
        return !!a3(b3);
      } catch {
        return !1;
      } finally {
        b3.parentNode && b3.parentNode.removeChild(b3), (b3 = null);
      }
    }
    function ja2(a3, b3) {
      for (var c3 = a3.split("|"), e3 = c3.length; e3--; )
        d2.attrHandle[c3[e3]] = b3;
    }
    function ka2(a3, b3) {
      var c3 = b3 && a3,
        d3 =
          c3 &&
          a3.nodeType === 1 &&
          b3.nodeType === 1 &&
          (~b3.sourceIndex || C2) - (~a3.sourceIndex || C2);
      if (d3) return d3;
      if (c3) {
        for (; (c3 = c3.nextSibling); ) if (c3 === b3) return -1;
      }
      return a3 ? 1 : -1;
    }
    function la2(a3) {
      return function (b3) {
        var c3 = b3.nodeName.toLowerCase();
        return c3 === "input" && b3.type === a3;
      };
    }
    function ma2(a3) {
      return function (b3) {
        var c3 = b3.nodeName.toLowerCase();
        return (c3 === "input" || c3 === "button") && b3.type === a3;
      };
    }
    function na2(a3) {
      return ha2(function (b3) {
        return (
          (b3 = +b3),
          ha2(function (c3, d3) {
            for (var e3, f3 = a3([], c3.length, b3), g3 = f3.length; g3--; )
              c3[(e3 = f3[g3])] && (c3[e3] = !(d3[e3] = c3[e3]));
          })
        );
      });
    }
    function oa2(a3) {
      return a3 && typeof a3.getElementsByTagName < "u" && a3;
    }
    (c2 = fa2.support = {}),
      (f2 = fa2.isXML =
        function (a3) {
          var b3 = a3 && (a3.ownerDocument || a3).documentElement;
          return b3 ? b3.nodeName !== "HTML" : !1;
        }),
      (m2 = fa2.setDocument =
        function (a3) {
          var b3,
            e3,
            g3 = a3 ? a3.ownerDocument || a3 : v2;
          return (
            g3 !== n2 &&
              g3.nodeType === 9 &&
              g3.documentElement &&
              ((n2 = g3),
              (o2 = n2.documentElement),
              (p2 = !f2(n2)),
              (e3 = n2.defaultView) &&
                e3.top !== e3 &&
                (e3.addEventListener
                  ? e3.addEventListener("unload", da2, !1)
                  : e3.attachEvent && e3.attachEvent("onunload", da2)),
              (c2.attributes = ia2(function (a4) {
                return (a4.className = "i"), !a4.getAttribute("className");
              })),
              (c2.getElementsByTagName = ia2(function (a4) {
                return (
                  a4.appendChild(n2.createComment("")),
                  !a4.getElementsByTagName("*").length
                );
              })),
              (c2.getElementsByClassName = Z2.test(n2.getElementsByClassName)),
              (c2.getById = ia2(function (a4) {
                return (
                  (o2.appendChild(a4).id = u2),
                  !n2.getElementsByName || !n2.getElementsByName(u2).length
                );
              })),
              c2.getById
                ? ((d2.find.ID = function (a4, b4) {
                    if (typeof b4.getElementById < "u" && p2) {
                      var c3 = b4.getElementById(a4);
                      return c3 ? [c3] : [];
                    }
                  }),
                  (d2.filter.ID = function (a4) {
                    var b4 = a4.replace(ba2, ca2);
                    return function (a5) {
                      return a5.getAttribute("id") === b4;
                    };
                  }))
                : (delete d2.find.ID,
                  (d2.filter.ID = function (a4) {
                    var b4 = a4.replace(ba2, ca2);
                    return function (a5) {
                      var c3 =
                        typeof a5.getAttributeNode < "u" &&
                        a5.getAttributeNode("id");
                      return c3 && c3.value === b4;
                    };
                  })),
              (d2.find.TAG = c2.getElementsByTagName
                ? function (a4, b4) {
                    return typeof b4.getElementsByTagName < "u"
                      ? b4.getElementsByTagName(a4)
                      : c2.qsa
                      ? b4.querySelectorAll(a4)
                      : void 0;
                  }
                : function (a4, b4) {
                    var c3,
                      d3 = [],
                      e4 = 0,
                      f3 = b4.getElementsByTagName(a4);
                    if (a4 === "*") {
                      for (; (c3 = f3[e4++]); )
                        c3.nodeType === 1 && d3.push(c3);
                      return d3;
                    }
                    return f3;
                  }),
              (d2.find.CLASS =
                c2.getElementsByClassName &&
                function (a4, b4) {
                  return typeof b4.getElementsByClassName < "u" && p2
                    ? b4.getElementsByClassName(a4)
                    : void 0;
                }),
              (r2 = []),
              (q2 = []),
              (c2.qsa = Z2.test(n2.querySelectorAll)) &&
                (ia2(function (a4) {
                  (o2.appendChild(a4).innerHTML =
                    "<a id='" +
                    u2 +
                    "'></a><select id='" +
                    u2 +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    a4.querySelectorAll("[msallowcapture^='']").length &&
                      q2.push("[*^$]=" + L2 + `*(?:''|"")`),
                    a4.querySelectorAll("[selected]").length ||
                      q2.push("\\[" + L2 + "*(?:value|" + K2 + ")"),
                    a4.querySelectorAll("[id~=" + u2 + "-]").length ||
                      q2.push("~="),
                    a4.querySelectorAll(":checked").length ||
                      q2.push(":checked"),
                    a4.querySelectorAll("a#" + u2 + "+*").length ||
                      q2.push(".#.+[+~]");
                }),
                ia2(function (a4) {
                  var b4 = n2.createElement("input");
                  b4.setAttribute("type", "hidden"),
                    a4.appendChild(b4).setAttribute("name", "D"),
                    a4.querySelectorAll("[name=d]").length &&
                      q2.push("name" + L2 + "*[*^$|!~]?="),
                    a4.querySelectorAll(":enabled").length ||
                      q2.push(":enabled", ":disabled"),
                    a4.querySelectorAll("*,:x"),
                    q2.push(",.*:");
                })),
              (c2.matchesSelector = Z2.test(
                (s2 =
                  o2.matches ||
                  o2.webkitMatchesSelector ||
                  o2.mozMatchesSelector ||
                  o2.oMatchesSelector ||
                  o2.msMatchesSelector)
              )) &&
                ia2(function (a4) {
                  (c2.disconnectedMatch = s2.call(a4, "div")),
                    s2.call(a4, "[s!='']:x"),
                    r2.push("!=", O2);
                }),
              (q2 = q2.length && new RegExp(q2.join("|"))),
              (r2 = r2.length && new RegExp(r2.join("|"))),
              (b3 = Z2.test(o2.compareDocumentPosition)),
              (t2 =
                b3 || Z2.test(o2.contains)
                  ? function (a4, b4) {
                      var c3 = a4.nodeType === 9 ? a4.documentElement : a4,
                        d3 = b4 && b4.parentNode;
                      return (
                        a4 === d3 ||
                        !(
                          !d3 ||
                          d3.nodeType !== 1 ||
                          !(c3.contains
                            ? c3.contains(d3)
                            : a4.compareDocumentPosition &&
                              16 & a4.compareDocumentPosition(d3))
                        )
                      );
                    }
                  : function (a4, b4) {
                      if (b4) {
                        for (; (b4 = b4.parentNode); ) if (b4 === a4) return !0;
                      }
                      return !1;
                    }),
              (B2 = b3
                ? function (a4, b4) {
                    if (a4 === b4) return (l2 = !0), 0;
                    var d3 =
                      !a4.compareDocumentPosition - !b4.compareDocumentPosition;
                    return (
                      d3 ||
                      ((d3 =
                        (a4.ownerDocument || a4) === (b4.ownerDocument || b4)
                          ? a4.compareDocumentPosition(b4)
                          : 1),
                      1 & d3 ||
                      (!c2.sortDetached &&
                        b4.compareDocumentPosition(a4) === d3)
                        ? a4 === n2 || (a4.ownerDocument === v2 && t2(v2, a4))
                          ? -1
                          : b4 === n2 || (b4.ownerDocument === v2 && t2(v2, b4))
                          ? 1
                          : k2
                          ? J2(k2, a4) - J2(k2, b4)
                          : 0
                        : 4 & d3
                        ? -1
                        : 1)
                    );
                  }
                : function (a4, b4) {
                    if (a4 === b4) return (l2 = !0), 0;
                    var c3,
                      d3 = 0,
                      e4 = a4.parentNode,
                      f3 = b4.parentNode,
                      g4 = [a4],
                      h3 = [b4];
                    if (!e4 || !f3)
                      return a4 === n2
                        ? -1
                        : b4 === n2
                        ? 1
                        : e4
                        ? -1
                        : f3
                        ? 1
                        : k2
                        ? J2(k2, a4) - J2(k2, b4)
                        : 0;
                    if (e4 === f3) return ka2(a4, b4);
                    for (c3 = a4; (c3 = c3.parentNode); ) g4.unshift(c3);
                    for (c3 = b4; (c3 = c3.parentNode); ) h3.unshift(c3);
                    for (; g4[d3] === h3[d3]; ) d3++;
                    return d3
                      ? ka2(g4[d3], h3[d3])
                      : g4[d3] === v2
                      ? -1
                      : h3[d3] === v2
                      ? 1
                      : 0;
                  })),
            n2
          );
        }),
      (fa2.matches = function (a3, b3) {
        return fa2(a3, null, null, b3);
      }),
      (fa2.matchesSelector = function (a3, b3) {
        if (
          ((a3.ownerDocument || a3) !== n2 && m2(a3),
          (b3 = b3.replace(T2, "='$1']")),
          c2.matchesSelector &&
            p2 &&
            !A2[b3 + " "] &&
            (!r2 || !r2.test(b3)) &&
            (!q2 || !q2.test(b3)))
        )
          try {
            var d3 = s2.call(a3, b3);
            if (
              d3 ||
              c2.disconnectedMatch ||
              (a3.document && a3.document.nodeType !== 11)
            )
              return d3;
          } catch {}
        return fa2(b3, n2, null, [a3]).length > 0;
      }),
      (fa2.contains = function (a3, b3) {
        return (a3.ownerDocument || a3) !== n2 && m2(a3), t2(a3, b3);
      }),
      (fa2.attr = function (a3, b3) {
        (a3.ownerDocument || a3) !== n2 && m2(a3);
        var e3 = d2.attrHandle[b3.toLowerCase()],
          f3 =
            e3 && D2.call(d2.attrHandle, b3.toLowerCase())
              ? e3(a3, b3, !p2)
              : void 0;
        return f3 !== void 0
          ? f3
          : c2.attributes || !p2
          ? a3.getAttribute(b3)
          : (f3 = a3.getAttributeNode(b3)) && f3.specified
          ? f3.value
          : null;
      }),
      (fa2.error = function (a3) {
        throw new Error("Syntax error, unrecognized expression: " + a3);
      }),
      (fa2.uniqueSort = function (a3) {
        var b3,
          d3 = [],
          e3 = 0,
          f3 = 0;
        if (
          ((l2 = !c2.detectDuplicates),
          (k2 = !c2.sortStable && a3.slice(0)),
          a3.sort(B2),
          l2)
        ) {
          for (; (b3 = a3[f3++]); ) b3 === a3[f3] && (e3 = d3.push(f3));
          for (; e3--; ) a3.splice(d3[e3], 1);
        }
        return (k2 = null), a3;
      }),
      (e2 = fa2.getText =
        function (a3) {
          var b3,
            c3 = "",
            d3 = 0,
            f3 = a3.nodeType;
          if (f3) {
            if (f3 === 1 || f3 === 9 || f3 === 11) {
              if (typeof a3.textContent == "string") return a3.textContent;
              for (a3 = a3.firstChild; a3; a3 = a3.nextSibling) c3 += e2(a3);
            } else if (f3 === 3 || f3 === 4) return a3.nodeValue;
          } else for (; (b3 = a3[d3++]); ) c3 += e2(b3);
          return c3;
        }),
      (d2 = fa2.selectors =
        {
          cacheLength: 50,
          createPseudo: ha2,
          match: W2,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (a3) {
              return (
                (a3[1] = a3[1].replace(ba2, ca2)),
                (a3[3] = (a3[3] || a3[4] || a3[5] || "").replace(ba2, ca2)),
                a3[2] === "~=" && (a3[3] = " " + a3[3] + " "),
                a3.slice(0, 4)
              );
            },
            CHILD: function (a3) {
              return (
                (a3[1] = a3[1].toLowerCase()),
                a3[1].slice(0, 3) === "nth"
                  ? (a3[3] || fa2.error(a3[0]),
                    (a3[4] = +(a3[4]
                      ? a3[5] + (a3[6] || 1)
                      : 2 * (a3[3] === "even" || a3[3] === "odd"))),
                    (a3[5] = +(a3[7] + a3[8] || a3[3] === "odd")))
                  : a3[3] && fa2.error(a3[0]),
                a3
              );
            },
            PSEUDO: function (a3) {
              var b3,
                c3 = !a3[6] && a3[2];
              return W2.CHILD.test(a3[0])
                ? null
                : (a3[3]
                    ? (a3[2] = a3[4] || a3[5] || "")
                    : c3 &&
                      U2.test(c3) &&
                      (b3 = g2(c3, !0)) &&
                      (b3 = c3.indexOf(")", c3.length - b3) - c3.length) &&
                      ((a3[0] = a3[0].slice(0, b3)), (a3[2] = c3.slice(0, b3))),
                  a3.slice(0, 3));
            },
          },
          filter: {
            TAG: function (a3) {
              var b3 = a3.replace(ba2, ca2).toLowerCase();
              return a3 === "*"
                ? function () {
                    return !0;
                  }
                : function (a4) {
                    return a4.nodeName && a4.nodeName.toLowerCase() === b3;
                  };
            },
            CLASS: function (a3) {
              var b3 = y2[a3 + " "];
              return (
                b3 ||
                ((b3 = new RegExp("(^|" + L2 + ")" + a3 + "(" + L2 + "|$)")) &&
                  y2(a3, function (a4) {
                    return b3.test(
                      (typeof a4.className == "string" && a4.className) ||
                        (typeof a4.getAttribute < "u" &&
                          a4.getAttribute("class")) ||
                        ""
                    );
                  }))
              );
            },
            ATTR: function (a3, b3, c3) {
              return function (d3) {
                var e3 = fa2.attr(d3, a3);
                return e3 == null
                  ? b3 === "!="
                  : b3
                  ? ((e3 += ""),
                    b3 === "="
                      ? e3 === c3
                      : b3 === "!="
                      ? e3 !== c3
                      : b3 === "^="
                      ? c3 && e3.indexOf(c3) === 0
                      : b3 === "*="
                      ? c3 && e3.indexOf(c3) > -1
                      : b3 === "$="
                      ? c3 && e3.slice(-c3.length) === c3
                      : b3 === "~="
                      ? (" " + e3.replace(P2, " ") + " ").indexOf(c3) > -1
                      : b3 === "|="
                      ? e3 === c3 || e3.slice(0, c3.length + 1) === c3 + "-"
                      : !1)
                  : !0;
              };
            },
            CHILD: function (a3, b3, c3, d3, e3) {
              var f3 = a3.slice(0, 3) !== "nth",
                g3 = a3.slice(-4) !== "last",
                h3 = b3 === "of-type";
              return d3 === 1 && e3 === 0
                ? function (a4) {
                    return !!a4.parentNode;
                  }
                : function (b4, c4, i4) {
                    var j3,
                      k3,
                      l3,
                      m3,
                      n3,
                      o3,
                      p3 = f3 !== g3 ? "nextSibling" : "previousSibling",
                      q3 = b4.parentNode,
                      r3 = h3 && b4.nodeName.toLowerCase(),
                      s3 = !i4 && !h3,
                      t3 = !1;
                    if (q3) {
                      if (f3) {
                        for (; p3; ) {
                          for (m3 = b4; (m3 = m3[p3]); )
                            if (
                              h3
                                ? m3.nodeName.toLowerCase() === r3
                                : m3.nodeType === 1
                            )
                              return !1;
                          o3 = p3 = a3 === "only" && !o3 && "nextSibling";
                        }
                        return !0;
                      }
                      if (
                        ((o3 = [g3 ? q3.firstChild : q3.lastChild]), g3 && s3)
                      ) {
                        for (
                          m3 = q3,
                            l3 = m3[u2] || (m3[u2] = {}),
                            k3 = l3[m3.uniqueID] || (l3[m3.uniqueID] = {}),
                            j3 = k3[a3] || [],
                            n3 = j3[0] === w2 && j3[1],
                            t3 = n3 && j3[2],
                            m3 = n3 && q3.childNodes[n3];
                          (m3 =
                            (++n3 && m3 && m3[p3]) ||
                            (t3 = n3 = 0) ||
                            o3.pop());

                        )
                          if (m3.nodeType === 1 && ++t3 && m3 === b4) {
                            k3[a3] = [w2, n3, t3];
                            break;
                          }
                      } else if (
                        (s3 &&
                          ((m3 = b4),
                          (l3 = m3[u2] || (m3[u2] = {})),
                          (k3 = l3[m3.uniqueID] || (l3[m3.uniqueID] = {})),
                          (j3 = k3[a3] || []),
                          (n3 = j3[0] === w2 && j3[1]),
                          (t3 = n3)),
                        t3 === !1)
                      )
                        for (
                          ;
                          (m3 =
                            (++n3 && m3 && m3[p3]) ||
                            (t3 = n3 = 0) ||
                            o3.pop()) &&
                          !(
                            (h3
                              ? m3.nodeName.toLowerCase() === r3
                              : m3.nodeType === 1) &&
                            ++t3 &&
                            (s3 &&
                              ((l3 = m3[u2] || (m3[u2] = {})),
                              (k3 = l3[m3.uniqueID] || (l3[m3.uniqueID] = {})),
                              (k3[a3] = [w2, t3])),
                            m3 === b4)
                          );

                        );
                      return (
                        (t3 -= e3), t3 === d3 || (t3 % d3 === 0 && t3 / d3 >= 0)
                      );
                    }
                  };
            },
            PSEUDO: function (a3, b3) {
              var c3,
                e3 =
                  d2.pseudos[a3] ||
                  d2.setFilters[a3.toLowerCase()] ||
                  fa2.error("unsupported pseudo: " + a3);
              return e3[u2]
                ? e3(b3)
                : e3.length > 1
                ? ((c3 = [a3, a3, "", b3]),
                  d2.setFilters.hasOwnProperty(a3.toLowerCase())
                    ? ha2(function (a4, c4) {
                        for (var d3, f3 = e3(a4, b3), g3 = f3.length; g3--; )
                          (d3 = J2(a4, f3[g3])), (a4[d3] = !(c4[d3] = f3[g3]));
                      })
                    : function (a4) {
                        return e3(a4, 0, c3);
                      })
                : e3;
            },
          },
          pseudos: {
            not: ha2(function (a3) {
              var b3 = [],
                c3 = [],
                d3 = h2(a3.replace(Q2, "$1"));
              return d3[u2]
                ? ha2(function (a4, b4, c4, e3) {
                    for (
                      var f3, g3 = d3(a4, null, e3, []), h3 = a4.length;
                      h3--;

                    )
                      (f3 = g3[h3]) && (a4[h3] = !(b4[h3] = f3));
                  })
                : function (a4, e3, f3) {
                    return (
                      (b3[0] = a4),
                      d3(b3, null, f3, c3),
                      (b3[0] = null),
                      !c3.pop()
                    );
                  };
            }),
            has: ha2(function (a3) {
              return function (b3) {
                return fa2(a3, b3).length > 0;
              };
            }),
            contains: ha2(function (a3) {
              return (
                (a3 = a3.replace(ba2, ca2)),
                function (b3) {
                  return (
                    (b3.textContent || b3.innerText || e2(b3)).indexOf(a3) > -1
                  );
                }
              );
            }),
            lang: ha2(function (a3) {
              return (
                V2.test(a3 || "") || fa2.error("unsupported lang: " + a3),
                (a3 = a3.replace(ba2, ca2).toLowerCase()),
                function (b3) {
                  var c3;
                  do
                    if (
                      (c3 = p2
                        ? b3.lang
                        : b3.getAttribute("xml:lang") ||
                          b3.getAttribute("lang"))
                    )
                      return (
                        (c3 = c3.toLowerCase()),
                        c3 === a3 || c3.indexOf(a3 + "-") === 0
                      );
                  while ((b3 = b3.parentNode) && b3.nodeType === 1);
                  return !1;
                }
              );
            }),
            target: function (b3) {
              var c3 = a2.location && a2.location.hash;
              return c3 && c3.slice(1) === b3.id;
            },
            root: function (a3) {
              return a3 === o2;
            },
            focus: function (a3) {
              return (
                a3 === n2.activeElement &&
                (!n2.hasFocus || n2.hasFocus()) &&
                !!(a3.type || a3.href || ~a3.tabIndex)
              );
            },
            enabled: function (a3) {
              return a3.disabled === !1;
            },
            disabled: function (a3) {
              return a3.disabled === !0;
            },
            checked: function (a3) {
              var b3 = a3.nodeName.toLowerCase();
              return (
                (b3 === "input" && !!a3.checked) ||
                (b3 === "option" && !!a3.selected)
              );
            },
            selected: function (a3) {
              return (
                a3.parentNode && a3.parentNode.selectedIndex, a3.selected === !0
              );
            },
            empty: function (a3) {
              for (a3 = a3.firstChild; a3; a3 = a3.nextSibling)
                if (a3.nodeType < 6) return !1;
              return !0;
            },
            parent: function (a3) {
              return !d2.pseudos.empty(a3);
            },
            header: function (a3) {
              return Y2.test(a3.nodeName);
            },
            input: function (a3) {
              return X2.test(a3.nodeName);
            },
            button: function (a3) {
              var b3 = a3.nodeName.toLowerCase();
              return (
                (b3 === "input" && a3.type === "button") || b3 === "button"
              );
            },
            text: function (a3) {
              var b3;
              return (
                a3.nodeName.toLowerCase() === "input" &&
                a3.type === "text" &&
                ((b3 = a3.getAttribute("type")) == null ||
                  b3.toLowerCase() === "text")
              );
            },
            first: na2(function () {
              return [0];
            }),
            last: na2(function (a3, b3) {
              return [b3 - 1];
            }),
            eq: na2(function (a3, b3, c3) {
              return [0 > c3 ? c3 + b3 : c3];
            }),
            even: na2(function (a3, b3) {
              for (var c3 = 0; b3 > c3; c3 += 2) a3.push(c3);
              return a3;
            }),
            odd: na2(function (a3, b3) {
              for (var c3 = 1; b3 > c3; c3 += 2) a3.push(c3);
              return a3;
            }),
            lt: na2(function (a3, b3, c3) {
              for (var d3 = 0 > c3 ? c3 + b3 : c3; --d3 >= 0; ) a3.push(d3);
              return a3;
            }),
            gt: na2(function (a3, b3, c3) {
              for (var d3 = 0 > c3 ? c3 + b3 : c3; ++d3 < b3; ) a3.push(d3);
              return a3;
            }),
          },
        }),
      (d2.pseudos.nth = d2.pseudos.eq);
    for (b2 in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
      d2.pseudos[b2] = la2(b2);
    for (b2 in { submit: !0, reset: !0 }) d2.pseudos[b2] = ma2(b2);
    function pa2() {}
    (pa2.prototype = d2.filters = d2.pseudos),
      (d2.setFilters = new pa2()),
      (g2 = fa2.tokenize =
        function (a3, b3) {
          var c3,
            e3,
            f3,
            g3,
            h3,
            i4,
            j3,
            k3 = z2[a3 + " "];
          if (k3) return b3 ? 0 : k3.slice(0);
          for (h3 = a3, i4 = [], j3 = d2.preFilter; h3; ) {
            (c3 && !(e3 = R2.exec(h3))) ||
              (e3 && (h3 = h3.slice(e3[0].length) || h3), i4.push((f3 = []))),
              (c3 = !1),
              (e3 = S2.exec(h3)) &&
                ((c3 = e3.shift()),
                f3.push({ value: c3, type: e3[0].replace(Q2, " ") }),
                (h3 = h3.slice(c3.length)));
            for (g3 in d2.filter)
              !(e3 = W2[g3].exec(h3)) ||
                (j3[g3] && !(e3 = j3[g3](e3))) ||
                ((c3 = e3.shift()),
                f3.push({ value: c3, type: g3, matches: e3 }),
                (h3 = h3.slice(c3.length)));
            if (!c3) break;
          }
          return b3 ? h3.length : h3 ? fa2.error(a3) : z2(a3, i4).slice(0);
        });
    function qa2(a3) {
      for (var b3 = 0, c3 = a3.length, d3 = ""; c3 > b3; b3++)
        d3 += a3[b3].value;
      return d3;
    }
    function ra2(a3, b3, c3) {
      var d3 = b3.dir,
        e3 = c3 && d3 === "parentNode",
        f3 = x2++;
      return b3.first
        ? function (b4, c4, f4) {
            for (; (b4 = b4[d3]); )
              if (b4.nodeType === 1 || e3) return a3(b4, c4, f4);
          }
        : function (b4, c4, g3) {
            var h3,
              i4,
              j3,
              k3 = [w2, f3];
            if (g3) {
              for (; (b4 = b4[d3]); )
                if ((b4.nodeType === 1 || e3) && a3(b4, c4, g3)) return !0;
            } else
              for (; (b4 = b4[d3]); )
                if (b4.nodeType === 1 || e3) {
                  if (
                    ((j3 = b4[u2] || (b4[u2] = {})),
                    (i4 = j3[b4.uniqueID] || (j3[b4.uniqueID] = {})),
                    (h3 = i4[d3]) && h3[0] === w2 && h3[1] === f3)
                  )
                    return (k3[2] = h3[2]);
                  if (((i4[d3] = k3), (k3[2] = a3(b4, c4, g3)))) return !0;
                }
          };
    }
    function sa2(a3) {
      return a3.length > 1
        ? function (b3, c3, d3) {
            for (var e3 = a3.length; e3--; ) if (!a3[e3](b3, c3, d3)) return !1;
            return !0;
          }
        : a3[0];
    }
    function ta2(a3, b3, c3) {
      for (var d3 = 0, e3 = b3.length; e3 > d3; d3++) fa2(a3, b3[d3], c3);
      return c3;
    }
    function ua2(a3, b3, c3, d3, e3) {
      for (
        var f3, g3 = [], h3 = 0, i4 = a3.length, j3 = b3 != null;
        i4 > h3;
        h3++
      )
        (f3 = a3[h3]) &&
          ((c3 && !c3(f3, d3, e3)) || (g3.push(f3), j3 && b3.push(h3)));
      return g3;
    }
    function va2(a3, b3, c3, d3, e3, f3) {
      return (
        d3 && !d3[u2] && (d3 = va2(d3)),
        e3 && !e3[u2] && (e3 = va2(e3, f3)),
        ha2(function (f4, g3, h3, i4) {
          var j3,
            k3,
            l3,
            m3 = [],
            n3 = [],
            o3 = g3.length,
            p3 = f4 || ta2(b3 || "*", h3.nodeType ? [h3] : h3, []),
            q3 = !a3 || (!f4 && b3) ? p3 : ua2(p3, m3, a3, h3, i4),
            r3 = c3 ? (e3 || (f4 ? a3 : o3 || d3) ? [] : g3) : q3;
          if ((c3 && c3(q3, r3, h3, i4), d3))
            for (j3 = ua2(r3, n3), d3(j3, [], h3, i4), k3 = j3.length; k3--; )
              (l3 = j3[k3]) && (r3[n3[k3]] = !(q3[n3[k3]] = l3));
          if (f4) {
            if (e3 || a3) {
              if (e3) {
                for (j3 = [], k3 = r3.length; k3--; )
                  (l3 = r3[k3]) && j3.push((q3[k3] = l3));
                e3(null, (r3 = []), j3, i4);
              }
              for (k3 = r3.length; k3--; )
                (l3 = r3[k3]) &&
                  (j3 = e3 ? J2(f4, l3) : m3[k3]) > -1 &&
                  (f4[j3] = !(g3[j3] = l3));
            }
          } else (r3 = ua2(r3 === g3 ? r3.splice(o3, r3.length) : r3)), e3 ? e3(null, g3, r3, i4) : H2.apply(g3, r3);
        })
      );
    }
    function wa2(a3) {
      for (
        var b3,
          c3,
          e3,
          f3 = a3.length,
          g3 = d2.relative[a3[0].type],
          h3 = g3 || d2.relative[" "],
          i4 = g3 ? 1 : 0,
          k3 = ra2(
            function (a4) {
              return a4 === b3;
            },
            h3,
            !0
          ),
          l3 = ra2(
            function (a4) {
              return J2(b3, a4) > -1;
            },
            h3,
            !0
          ),
          m3 = [
            function (a4, c4, d3) {
              var e4 =
                (!g3 && (d3 || c4 !== j2)) ||
                ((b3 = c4).nodeType ? k3(a4, c4, d3) : l3(a4, c4, d3));
              return (b3 = null), e4;
            },
          ];
        f3 > i4;
        i4++
      )
        if ((c3 = d2.relative[a3[i4].type])) m3 = [ra2(sa2(m3), c3)];
        else {
          if (
            ((c3 = d2.filter[a3[i4].type].apply(null, a3[i4].matches)), c3[u2])
          ) {
            for (e3 = ++i4; f3 > e3 && !d2.relative[a3[e3].type]; e3++);
            return va2(
              i4 > 1 && sa2(m3),
              i4 > 1 &&
                qa2(
                  a3
                    .slice(0, i4 - 1)
                    .concat({ value: a3[i4 - 2].type === " " ? "*" : "" })
                ).replace(Q2, "$1"),
              c3,
              e3 > i4 && wa2(a3.slice(i4, e3)),
              f3 > e3 && wa2((a3 = a3.slice(e3))),
              f3 > e3 && qa2(a3)
            );
          }
          m3.push(c3);
        }
      return sa2(m3);
    }
    function xa2(a3, b3) {
      var c3 = b3.length > 0,
        e3 = a3.length > 0,
        f3 = function (f4, g3, h3, i4, k3) {
          var l3,
            o3,
            q3,
            r3 = 0,
            s3 = "0",
            t3 = f4 && [],
            u3 = [],
            v3 = j2,
            x3 = f4 || (e3 && d2.find.TAG("*", k3)),
            y3 = (w2 += v3 == null ? 1 : Math.random() || 0.1),
            z3 = x3.length;
          for (
            k3 && (j2 = g3 === n2 || g3 || k3);
            s3 !== z3 && (l3 = x3[s3]) != null;
            s3++
          ) {
            if (e3 && l3) {
              for (
                o3 = 0, g3 || l3.ownerDocument === n2 || (m2(l3), (h3 = !p2));
                (q3 = a3[o3++]);

              )
                if (q3(l3, g3 || n2, h3)) {
                  i4.push(l3);
                  break;
                }
              k3 && (w2 = y3);
            }
            c3 && ((l3 = !q3 && l3) && r3--, f4 && t3.push(l3));
          }
          if (((r3 += s3), c3 && s3 !== r3)) {
            for (o3 = 0; (q3 = b3[o3++]); ) q3(t3, u3, g3, h3);
            if (f4) {
              if (r3 > 0)
                for (; s3--; ) t3[s3] || u3[s3] || (u3[s3] = F2.call(i4));
              u3 = ua2(u3);
            }
            H2.apply(i4, u3),
              k3 &&
                !f4 &&
                u3.length > 0 &&
                r3 + b3.length > 1 &&
                fa2.uniqueSort(i4);
          }
          return k3 && ((w2 = y3), (j2 = v3)), t3;
        };
      return c3 ? ha2(f3) : f3;
    }
    return (
      (h2 = fa2.compile =
        function (a3, b3) {
          var c3,
            d3 = [],
            e3 = [],
            f3 = A2[a3 + " "];
          if (!f3) {
            for (b3 || (b3 = g2(a3)), c3 = b3.length; c3--; )
              (f3 = wa2(b3[c3])), f3[u2] ? d3.push(f3) : e3.push(f3);
            (f3 = A2(a3, xa2(e3, d3))), (f3.selector = a3);
          }
          return f3;
        }),
      (i3 = fa2.select =
        function (a3, b3, e3, f3) {
          var i4,
            j3,
            k3,
            l3,
            m3,
            n3 = typeof a3 == "function" && a3,
            o3 = !f3 && g2((a3 = n3.selector || a3));
          if (((e3 = e3 || []), o3.length === 1)) {
            if (
              ((j3 = o3[0] = o3[0].slice(0)),
              j3.length > 2 &&
                (k3 = j3[0]).type === "ID" &&
                c2.getById &&
                b3.nodeType === 9 &&
                p2 &&
                d2.relative[j3[1].type])
            ) {
              if (
                ((b3 = (d2.find.ID(k3.matches[0].replace(ba2, ca2), b3) ||
                  [])[0]),
                !b3)
              )
                return e3;
              n3 && (b3 = b3.parentNode),
                (a3 = a3.slice(j3.shift().value.length));
            }
            for (
              i4 = W2.needsContext.test(a3) ? 0 : j3.length;
              i4-- && ((k3 = j3[i4]), !d2.relative[(l3 = k3.type)]);

            )
              if (
                (m3 = d2.find[l3]) &&
                (f3 = m3(
                  k3.matches[0].replace(ba2, ca2),
                  (_2.test(j3[0].type) && oa2(b3.parentNode)) || b3
                ))
              ) {
                if ((j3.splice(i4, 1), (a3 = f3.length && qa2(j3)), !a3))
                  return H2.apply(e3, f3), e3;
                break;
              }
          }
          return (
            (n3 || h2(a3, o3))(
              f3,
              b3,
              !p2,
              e3,
              !b3 || (_2.test(a3) && oa2(b3.parentNode)) || b3
            ),
            e3
          );
        }),
      (c2.sortStable = u2.split("").sort(B2).join("") === u2),
      (c2.detectDuplicates = !!l2),
      m2(),
      (c2.sortDetached = ia2(function (a3) {
        return 1 & a3.compareDocumentPosition(n2.createElement("div"));
      })),
      ia2(function (a3) {
        return (
          (a3.innerHTML = "<a href='#'></a>"),
          a3.firstChild.getAttribute("href") === "#"
        );
      }) ||
        ja2("type|href|height|width", function (a3, b3, c3) {
          return c3
            ? void 0
            : a3.getAttribute(b3, b3.toLowerCase() === "type" ? 1 : 2);
        }),
      (c2.attributes &&
        ia2(function (a3) {
          return (
            (a3.innerHTML = "<input/>"),
            a3.firstChild.setAttribute("value", ""),
            a3.firstChild.getAttribute("value") === ""
          );
        })) ||
        ja2("value", function (a3, b3, c3) {
          return c3 || a3.nodeName.toLowerCase() !== "input"
            ? void 0
            : a3.defaultValue;
        }),
      ia2(function (a3) {
        return a3.getAttribute("disabled") == null;
      }) ||
        ja2(K2, function (a3, b3, c3) {
          var d3;
          return c3
            ? void 0
            : a3[b3] === !0
            ? b3.toLowerCase()
            : (d3 = a3.getAttributeNode(b3)) && d3.specified
            ? d3.value
            : null;
        }),
      fa2
    );
  })(a);
  (n.find = t),
    (n.expr = t.selectors),
    (n.expr[":"] = n.expr.pseudos),
    (n.uniqueSort = n.unique = t.uniqueSort),
    (n.text = t.getText),
    (n.isXMLDoc = t.isXML),
    (n.contains = t.contains);
  var u = function (a2, b2, c2) {
      for (
        var d2 = [], e2 = c2 !== void 0;
        (a2 = a2[b2]) && a2.nodeType !== 9;

      )
        if (a2.nodeType === 1) {
          if (e2 && n(a2).is(c2)) break;
          d2.push(a2);
        }
      return d2;
    },
    v = function (a2, b2) {
      for (var c2 = []; a2; a2 = a2.nextSibling)
        a2.nodeType === 1 && a2 !== b2 && c2.push(a2);
      return c2;
    },
    w = n.expr.match.needsContext,
    x = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
    y = /^.[^:#\[\.,]*$/;
  function z(a2, b2, c2) {
    if (n.isFunction(b2))
      return n.grep(a2, function (a3, d2) {
        return !!b2.call(a3, d2, a3) !== c2;
      });
    if (b2.nodeType)
      return n.grep(a2, function (a3) {
        return (a3 === b2) !== c2;
      });
    if (typeof b2 == "string") {
      if (y.test(b2)) return n.filter(b2, a2, c2);
      b2 = n.filter(b2, a2);
    }
    return n.grep(a2, function (a3) {
      return h.call(b2, a3) > -1 !== c2;
    });
  }
  (n.filter = function (a2, b2, c2) {
    var d2 = b2[0];
    return (
      c2 && (a2 = ":not(" + a2 + ")"),
      b2.length === 1 && d2.nodeType === 1
        ? n.find.matchesSelector(d2, a2)
          ? [d2]
          : []
        : n.find.matches(
            a2,
            n.grep(b2, function (a3) {
              return a3.nodeType === 1;
            })
          )
    );
  }),
    n.fn.extend({
      find: function (a2) {
        var b2,
          c2 = this.length,
          d2 = [],
          e2 = this;
        if (typeof a2 != "string")
          return this.pushStack(
            n(a2).filter(function () {
              for (b2 = 0; c2 > b2; b2++)
                if (n.contains(e2[b2], this)) return !0;
            })
          );
        for (b2 = 0; c2 > b2; b2++) n.find(a2, e2[b2], d2);
        return (
          (d2 = this.pushStack(c2 > 1 ? n.unique(d2) : d2)),
          (d2.selector = this.selector ? this.selector + " " + a2 : a2),
          d2
        );
      },
      filter: function (a2) {
        return this.pushStack(z(this, a2 || [], !1));
      },
      not: function (a2) {
        return this.pushStack(z(this, a2 || [], !0));
      },
      is: function (a2) {
        return !!z(
          this,
          typeof a2 == "string" && w.test(a2) ? n(a2) : a2 || [],
          !1
        ).length;
      },
    });
  var A,
    B = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
    C = (n.fn.init = function (a2, b2, c2) {
      var e2, f2;
      if (!a2) return this;
      if (((c2 = c2 || A), typeof a2 == "string")) {
        if (
          ((e2 =
            a2[0] === "<" && a2[a2.length - 1] === ">" && a2.length >= 3
              ? [null, a2, null]
              : B.exec(a2)),
          !e2 || (!e2[1] && b2))
        )
          return !b2 || b2.jquery
            ? (b2 || c2).find(a2)
            : this.constructor(b2).find(a2);
        if (e2[1]) {
          if (
            ((b2 = b2 instanceof n ? b2[0] : b2),
            n.merge(
              this,
              n.parseHTML(
                e2[1],
                b2 && b2.nodeType ? b2.ownerDocument || b2 : d,
                !0
              )
            ),
            x.test(e2[1]) && n.isPlainObject(b2))
          )
            for (e2 in b2)
              n.isFunction(this[e2]) ? this[e2](b2[e2]) : this.attr(e2, b2[e2]);
          return this;
        }
        return (
          (f2 = d.getElementById(e2[2])),
          f2 && f2.parentNode && ((this.length = 1), (this[0] = f2)),
          (this.context = d),
          (this.selector = a2),
          this
        );
      }
      return a2.nodeType
        ? ((this.context = this[0] = a2), (this.length = 1), this)
        : n.isFunction(a2)
        ? c2.ready !== void 0
          ? c2.ready(a2)
          : a2(n)
        : (a2.selector !== void 0 &&
            ((this.selector = a2.selector), (this.context = a2.context)),
          n.makeArray(a2, this));
    });
  (C.prototype = n.fn), (A = n(d));
  var D = /^(?:parents|prev(?:Until|All))/,
    E = { children: !0, contents: !0, next: !0, prev: !0 };
  n.fn.extend({
    has: function (a2) {
      var b2 = n(a2, this),
        c2 = b2.length;
      return this.filter(function () {
        for (var a3 = 0; c2 > a3; a3++) if (n.contains(this, b2[a3])) return !0;
      });
    },
    closest: function (a2, b2) {
      for (
        var c2,
          d2 = 0,
          e2 = this.length,
          f2 = [],
          g2 =
            w.test(a2) || typeof a2 != "string" ? n(a2, b2 || this.context) : 0;
        e2 > d2;
        d2++
      )
        for (c2 = this[d2]; c2 && c2 !== b2; c2 = c2.parentNode)
          if (
            c2.nodeType < 11 &&
            (g2
              ? g2.index(c2) > -1
              : c2.nodeType === 1 && n.find.matchesSelector(c2, a2))
          ) {
            f2.push(c2);
            break;
          }
      return this.pushStack(f2.length > 1 ? n.uniqueSort(f2) : f2);
    },
    index: function (a2) {
      return a2
        ? typeof a2 == "string"
          ? h.call(n(a2), this[0])
          : h.call(this, a2.jquery ? a2[0] : a2)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (a2, b2) {
      return this.pushStack(n.uniqueSort(n.merge(this.get(), n(a2, b2))));
    },
    addBack: function (a2) {
      return this.add(
        a2 == null ? this.prevObject : this.prevObject.filter(a2)
      );
    },
  });
  function F(a2, b2) {
    for (; (a2 = a2[b2]) && a2.nodeType !== 1; );
    return a2;
  }
  n.each(
    {
      parent: function (a2) {
        var b2 = a2.parentNode;
        return b2 && b2.nodeType !== 11 ? b2 : null;
      },
      parents: function (a2) {
        return u(a2, "parentNode");
      },
      parentsUntil: function (a2, b2, c2) {
        return u(a2, "parentNode", c2);
      },
      next: function (a2) {
        return F(a2, "nextSibling");
      },
      prev: function (a2) {
        return F(a2, "previousSibling");
      },
      nextAll: function (a2) {
        return u(a2, "nextSibling");
      },
      prevAll: function (a2) {
        return u(a2, "previousSibling");
      },
      nextUntil: function (a2, b2, c2) {
        return u(a2, "nextSibling", c2);
      },
      prevUntil: function (a2, b2, c2) {
        return u(a2, "previousSibling", c2);
      },
      siblings: function (a2) {
        return v((a2.parentNode || {}).firstChild, a2);
      },
      children: function (a2) {
        return v(a2.firstChild);
      },
      contents: function (a2) {
        return a2.contentDocument || n.merge([], a2.childNodes);
      },
    },
    function (a2, b2) {
      n.fn[a2] = function (c2, d2) {
        var e2 = n.map(this, b2, c2);
        return (
          a2.slice(-5) !== "Until" && (d2 = c2),
          d2 && typeof d2 == "string" && (e2 = n.filter(d2, e2)),
          this.length > 1 &&
            (E[a2] || n.uniqueSort(e2), D.test(a2) && e2.reverse()),
          this.pushStack(e2)
        );
      };
    }
  );
  var G = /\S+/g;
  function H(a2) {
    var b2 = {};
    return (
      n.each(a2.match(G) || [], function (a3, c2) {
        b2[c2] = !0;
      }),
      b2
    );
  }
  (n.Callbacks = function (a2) {
    a2 = typeof a2 == "string" ? H(a2) : n.extend({}, a2);
    var b2,
      c2,
      d2,
      e2,
      f2 = [],
      g2 = [],
      h2 = -1,
      i3 = function () {
        for (e2 = a2.once, d2 = b2 = !0; g2.length; h2 = -1)
          for (c2 = g2.shift(); ++h2 < f2.length; )
            f2[h2].apply(c2[0], c2[1]) === !1 &&
              a2.stopOnFalse &&
              ((h2 = f2.length), (c2 = !1));
        a2.memory || (c2 = !1), (b2 = !1), e2 && (f2 = c2 ? [] : "");
      },
      j2 = {
        add: function () {
          return (
            f2 &&
              (c2 && !b2 && ((h2 = f2.length - 1), g2.push(c2)),
              (function d3(b3) {
                n.each(b3, function (b4, c3) {
                  n.isFunction(c3)
                    ? (a2.unique && j2.has(c3)) || f2.push(c3)
                    : c3 && c3.length && n.type(c3) !== "string" && d3(c3);
                });
              })(arguments),
              c2 && !b2 && i3()),
            this
          );
        },
        remove: function () {
          return (
            n.each(arguments, function (a3, b3) {
              for (var c3; (c3 = n.inArray(b3, f2, c3)) > -1; )
                f2.splice(c3, 1), h2 >= c3 && h2--;
            }),
            this
          );
        },
        has: function (a3) {
          return a3 ? n.inArray(a3, f2) > -1 : f2.length > 0;
        },
        empty: function () {
          return f2 && (f2 = []), this;
        },
        disable: function () {
          return (e2 = g2 = []), (f2 = c2 = ""), this;
        },
        disabled: function () {
          return !f2;
        },
        lock: function () {
          return (e2 = g2 = []), c2 || (f2 = c2 = ""), this;
        },
        locked: function () {
          return !!e2;
        },
        fireWith: function (a3, c3) {
          return (
            e2 ||
              ((c3 = c3 || []),
              (c3 = [a3, c3.slice ? c3.slice() : c3]),
              g2.push(c3),
              b2 || i3()),
            this
          );
        },
        fire: function () {
          return j2.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!d2;
        },
      };
    return j2;
  }),
    n.extend({
      Deferred: function (a2) {
        var b2 = [
            ["resolve", "done", n.Callbacks("once memory"), "resolved"],
            ["reject", "fail", n.Callbacks("once memory"), "rejected"],
            ["notify", "progress", n.Callbacks("memory")],
          ],
          c2 = "pending",
          d2 = {
            state: function () {
              return c2;
            },
            always: function () {
              return e2.done(arguments).fail(arguments), this;
            },
            then: function () {
              var a3 = arguments;
              return n
                .Deferred(function (c3) {
                  n.each(b2, function (b3, f2) {
                    var g2 = n.isFunction(a3[b3]) && a3[b3];
                    e2[f2[1]](function () {
                      var a4 = g2 && g2.apply(this, arguments);
                      a4 && n.isFunction(a4.promise)
                        ? a4
                            .promise()
                            .progress(c3.notify)
                            .done(c3.resolve)
                            .fail(c3.reject)
                        : c3[f2[0] + "With"](
                            this === d2 ? c3.promise() : this,
                            g2 ? [a4] : arguments
                          );
                    });
                  }),
                    (a3 = null);
                })
                .promise();
            },
            promise: function (a3) {
              return a3 != null ? n.extend(a3, d2) : d2;
            },
          },
          e2 = {};
        return (
          (d2.pipe = d2.then),
          n.each(b2, function (a3, f2) {
            var g2 = f2[2],
              h2 = f2[3];
            (d2[f2[1]] = g2.add),
              h2 &&
                g2.add(
                  function () {
                    c2 = h2;
                  },
                  b2[1 ^ a3][2].disable,
                  b2[2][2].lock
                ),
              (e2[f2[0]] = function () {
                return (
                  e2[f2[0] + "With"](this === e2 ? d2 : this, arguments), this
                );
              }),
              (e2[f2[0] + "With"] = g2.fireWith);
          }),
          d2.promise(e2),
          a2 && a2.call(e2, e2),
          e2
        );
      },
      when: function (a2) {
        var b2 = 0,
          c2 = e.call(arguments),
          d2 = c2.length,
          f2 = d2 !== 1 || (a2 && n.isFunction(a2.promise)) ? d2 : 0,
          g2 = f2 === 1 ? a2 : n.Deferred(),
          h2 = function (a3, b3, c3) {
            return function (d3) {
              (b3[a3] = this),
                (c3[a3] = arguments.length > 1 ? e.call(arguments) : d3),
                c3 === i3
                  ? g2.notifyWith(b3, c3)
                  : --f2 || g2.resolveWith(b3, c3);
            };
          },
          i3,
          j2,
          k2;
        if (d2 > 1)
          for (
            i3 = new Array(d2), j2 = new Array(d2), k2 = new Array(d2);
            d2 > b2;
            b2++
          )
            c2[b2] && n.isFunction(c2[b2].promise)
              ? c2[b2]
                  .promise()
                  .progress(h2(b2, j2, i3))
                  .done(h2(b2, k2, c2))
                  .fail(g2.reject)
              : --f2;
        return f2 || g2.resolveWith(k2, c2), g2.promise();
      },
    });
  var I;
  (n.fn.ready = function (a2) {
    return n.ready.promise().done(a2), this;
  }),
    n.extend({
      isReady: !1,
      readyWait: 1,
      holdReady: function (a2) {
        a2 ? n.readyWait++ : n.ready(!0);
      },
      ready: function (a2) {
        (a2 === !0 ? --n.readyWait : n.isReady) ||
          ((n.isReady = !0),
          (a2 !== !0 && --n.readyWait > 0) ||
            (I.resolveWith(d, [n]),
            n.fn.triggerHandler &&
              (n(d).triggerHandler("ready"), n(d).off("ready"))));
      },
    });
  function J() {
    d.removeEventListener("DOMContentLoaded", J),
      a.removeEventListener("load", J),
      n.ready();
  }
  (n.ready.promise = function (b2) {
    return (
      I ||
        ((I = n.Deferred()),
        d.readyState === "complete" ||
        (d.readyState !== "loading" && !d.documentElement.doScroll)
          ? a.setTimeout(n.ready)
          : (d.addEventListener("DOMContentLoaded", J),
            a.addEventListener("load", J))),
      I.promise(b2)
    );
  }),
    n.ready.promise();
  var K = function (a2, b2, c2, d2, e2, f2, g2) {
      var h2 = 0,
        i3 = a2.length,
        j2 = c2 == null;
      if (n.type(c2) === "object") {
        e2 = !0;
        for (h2 in c2) K(a2, b2, h2, c2[h2], !0, f2, g2);
      } else if (
        d2 !== void 0 &&
        ((e2 = !0),
        n.isFunction(d2) || (g2 = !0),
        j2 &&
          (g2
            ? (b2.call(a2, d2), (b2 = null))
            : ((j2 = b2),
              (b2 = function (a3, b3, c3) {
                return j2.call(n(a3), c3);
              }))),
        b2)
      )
        for (; i3 > h2; h2++)
          b2(a2[h2], c2, g2 ? d2 : d2.call(a2[h2], h2, b2(a2[h2], c2)));
      return e2 ? a2 : j2 ? b2.call(a2) : i3 ? b2(a2[0], c2) : f2;
    },
    L = function (a2) {
      return a2.nodeType === 1 || a2.nodeType === 9 || !+a2.nodeType;
    };
  function M() {
    this.expando = n.expando + M.uid++;
  }
  (M.uid = 1),
    (M.prototype = {
      register: function (a2, b2) {
        var c2 = b2 || {};
        return (
          a2.nodeType
            ? (a2[this.expando] = c2)
            : Object.defineProperty(a2, this.expando, {
                value: c2,
                writable: !0,
                configurable: !0,
              }),
          a2[this.expando]
        );
      },
      cache: function (a2) {
        if (!L(a2)) return {};
        var b2 = a2[this.expando];
        return (
          b2 ||
            ((b2 = {}),
            L(a2) &&
              (a2.nodeType
                ? (a2[this.expando] = b2)
                : Object.defineProperty(a2, this.expando, {
                    value: b2,
                    configurable: !0,
                  }))),
          b2
        );
      },
      set: function (a2, b2, c2) {
        var d2,
          e2 = this.cache(a2);
        if (typeof b2 == "string") e2[b2] = c2;
        else for (d2 in b2) e2[d2] = b2[d2];
        return e2;
      },
      get: function (a2, b2) {
        return b2 === void 0
          ? this.cache(a2)
          : a2[this.expando] && a2[this.expando][b2];
      },
      access: function (a2, b2, c2) {
        var d2;
        return b2 === void 0 || (b2 && typeof b2 == "string" && c2 === void 0)
          ? ((d2 = this.get(a2, b2)),
            d2 !== void 0 ? d2 : this.get(a2, n.camelCase(b2)))
          : (this.set(a2, b2, c2), c2 !== void 0 ? c2 : b2);
      },
      remove: function (a2, b2) {
        var c2,
          d2,
          e2,
          f2 = a2[this.expando];
        if (f2 !== void 0) {
          if (b2 === void 0) this.register(a2);
          else
            for (
              n.isArray(b2)
                ? (d2 = b2.concat(b2.map(n.camelCase)))
                : ((e2 = n.camelCase(b2)),
                  (b2 in f2)
                    ? (d2 = [b2, e2])
                    : ((d2 = e2),
                      (d2 = (d2 in f2) ? [d2] : d2.match(G) || []))),
                c2 = d2.length;
              c2--;

            )
              delete f2[d2[c2]];
          (b2 === void 0 || n.isEmptyObject(f2)) &&
            (a2.nodeType
              ? (a2[this.expando] = void 0)
              : delete a2[this.expando]);
        }
      },
      hasData: function (a2) {
        var b2 = a2[this.expando];
        return b2 !== void 0 && !n.isEmptyObject(b2);
      },
    });
  var N = new M(),
    O = new M(),
    P = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    Q = /[A-Z]/g;
  function R(a2, b2, c2) {
    var d2;
    if (c2 === void 0 && a2.nodeType === 1)
      if (
        ((d2 = "data-" + b2.replace(Q, "-$&").toLowerCase()),
        (c2 = a2.getAttribute(d2)),
        typeof c2 == "string")
      ) {
        try {
          c2 =
            c2 === "true"
              ? !0
              : c2 === "false"
              ? !1
              : c2 === "null"
              ? null
              : +c2 + "" === c2
              ? +c2
              : P.test(c2)
              ? n.parseJSON(c2)
              : c2;
        } catch {}
        O.set(a2, b2, c2);
      } else c2 = void 0;
    return c2;
  }
  n.extend({
    hasData: function (a2) {
      return O.hasData(a2) || N.hasData(a2);
    },
    data: function (a2, b2, c2) {
      return O.access(a2, b2, c2);
    },
    removeData: function (a2, b2) {
      O.remove(a2, b2);
    },
    _data: function (a2, b2, c2) {
      return N.access(a2, b2, c2);
    },
    _removeData: function (a2, b2) {
      N.remove(a2, b2);
    },
  }),
    n.fn.extend({
      data: function (a2, b2) {
        var c2,
          d2,
          e2,
          f2 = this[0],
          g2 = f2 && f2.attributes;
        if (a2 === void 0) {
          if (
            this.length &&
            ((e2 = O.get(f2)), f2.nodeType === 1 && !N.get(f2, "hasDataAttrs"))
          ) {
            for (c2 = g2.length; c2--; )
              g2[c2] &&
                ((d2 = g2[c2].name),
                d2.indexOf("data-") === 0 &&
                  ((d2 = n.camelCase(d2.slice(5))), R(f2, d2, e2[d2])));
            N.set(f2, "hasDataAttrs", !0);
          }
          return e2;
        }
        return typeof a2 == "object"
          ? this.each(function () {
              O.set(this, a2);
            })
          : K(
              this,
              function (b3) {
                var c3, d3;
                if (f2 && b3 === void 0) {
                  if (
                    ((c3 =
                      O.get(f2, a2) ||
                      O.get(f2, a2.replace(Q, "-$&").toLowerCase())),
                    c3 !== void 0 ||
                      ((d3 = n.camelCase(a2)),
                      (c3 = O.get(f2, d3)),
                      c3 !== void 0) ||
                      ((c3 = R(f2, d3, void 0)), c3 !== void 0))
                  )
                    return c3;
                } else
                  (d3 = n.camelCase(a2)),
                    this.each(function () {
                      var c4 = O.get(this, d3);
                      O.set(this, d3, b3),
                        a2.indexOf("-") > -1 &&
                          c4 !== void 0 &&
                          O.set(this, a2, b3);
                    });
              },
              null,
              b2,
              arguments.length > 1,
              null,
              !0
            );
      },
      removeData: function (a2) {
        return this.each(function () {
          O.remove(this, a2);
        });
      },
    }),
    n.extend({
      queue: function (a2, b2, c2) {
        var d2;
        return a2
          ? ((b2 = (b2 || "fx") + "queue"),
            (d2 = N.get(a2, b2)),
            c2 &&
              (!d2 || n.isArray(c2)
                ? (d2 = N.access(a2, b2, n.makeArray(c2)))
                : d2.push(c2)),
            d2 || [])
          : void 0;
      },
      dequeue: function (a2, b2) {
        b2 = b2 || "fx";
        var c2 = n.queue(a2, b2),
          d2 = c2.length,
          e2 = c2.shift(),
          f2 = n._queueHooks(a2, b2),
          g2 = function () {
            n.dequeue(a2, b2);
          };
        e2 === "inprogress" && ((e2 = c2.shift()), d2--),
          e2 &&
            (b2 === "fx" && c2.unshift("inprogress"),
            delete f2.stop,
            e2.call(a2, g2, f2)),
          !d2 && f2 && f2.empty.fire();
      },
      _queueHooks: function (a2, b2) {
        var c2 = b2 + "queueHooks";
        return (
          N.get(a2, c2) ||
          N.access(a2, c2, {
            empty: n.Callbacks("once memory").add(function () {
              N.remove(a2, [b2 + "queue", c2]);
            }),
          })
        );
      },
    }),
    n.fn.extend({
      queue: function (a2, b2) {
        var c2 = 2;
        return (
          typeof a2 != "string" && ((b2 = a2), (a2 = "fx"), c2--),
          arguments.length < c2
            ? n.queue(this[0], a2)
            : b2 === void 0
            ? this
            : this.each(function () {
                var c3 = n.queue(this, a2, b2);
                n._queueHooks(this, a2),
                  a2 === "fx" && c3[0] !== "inprogress" && n.dequeue(this, a2);
              })
        );
      },
      dequeue: function (a2) {
        return this.each(function () {
          n.dequeue(this, a2);
        });
      },
      clearQueue: function (a2) {
        return this.queue(a2 || "fx", []);
      },
      promise: function (a2, b2) {
        var c2,
          d2 = 1,
          e2 = n.Deferred(),
          f2 = this,
          g2 = this.length,
          h2 = function () {
            --d2 || e2.resolveWith(f2, [f2]);
          };
        for (
          typeof a2 != "string" && ((b2 = a2), (a2 = void 0)), a2 = a2 || "fx";
          g2--;

        )
          (c2 = N.get(f2[g2], a2 + "queueHooks")),
            c2 && c2.empty && (d2++, c2.empty.add(h2));
        return h2(), e2.promise(b2);
      },
    });
  var S = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    T = new RegExp("^(?:([+-])=|)(" + S + ")([a-z%]*)$", "i"),
    U = ["Top", "Right", "Bottom", "Left"],
    V = function (a2, b2) {
      return (
        (a2 = b2 || a2),
        n.css(a2, "display") === "none" || !n.contains(a2.ownerDocument, a2)
      );
    };
  function W(a2, b2, c2, d2) {
    var e2,
      f2 = 1,
      g2 = 20,
      h2 = d2
        ? function () {
            return d2.cur();
          }
        : function () {
            return n.css(a2, b2, "");
          },
      i3 = h2(),
      j2 = (c2 && c2[3]) || (n.cssNumber[b2] ? "" : "px"),
      k2 = (n.cssNumber[b2] || (j2 !== "px" && +i3)) && T.exec(n.css(a2, b2));
    if (k2 && k2[3] !== j2) {
      (j2 = j2 || k2[3]), (c2 = c2 || []), (k2 = +i3 || 1);
      do (f2 = f2 || ".5"), (k2 /= f2), n.style(a2, b2, k2 + j2);
      while (f2 !== (f2 = h2() / i3) && f2 !== 1 && --g2);
    }
    return (
      c2 &&
        ((k2 = +k2 || +i3 || 0),
        (e2 = c2[1] ? k2 + (c2[1] + 1) * c2[2] : +c2[2]),
        d2 && ((d2.unit = j2), (d2.start = k2), (d2.end = e2))),
      e2
    );
  }
  var X = /^(?:checkbox|radio)$/i,
    Y = /<([\w:-]+)/,
    Z = /^$|\/(?:java|ecma)script/i,
    $2 = {
      option: [1, "<select multiple='multiple'>", "</select>"],
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""],
    };
  ($2.optgroup = $2.option),
    ($2.tbody = $2.tfoot = $2.colgroup = $2.caption = $2.thead),
    ($2.th = $2.td);
  function _(a2, b2) {
    var c2 =
      typeof a2.getElementsByTagName < "u"
        ? a2.getElementsByTagName(b2 || "*")
        : typeof a2.querySelectorAll < "u"
        ? a2.querySelectorAll(b2 || "*")
        : [];
    return b2 === void 0 || (b2 && n.nodeName(a2, b2)) ? n.merge([a2], c2) : c2;
  }
  function aa(a2, b2) {
    for (var c2 = 0, d2 = a2.length; d2 > c2; c2++)
      N.set(a2[c2], "globalEval", !b2 || N.get(b2[c2], "globalEval"));
  }
  var ba = /<|&#?\w+;/;
  function ca(a2, b2, c2, d2, e2) {
    for (
      var f2,
        g2,
        h2,
        i3,
        j2,
        k2,
        l2 = b2.createDocumentFragment(),
        m2 = [],
        o2 = 0,
        p2 = a2.length;
      p2 > o2;
      o2++
    )
      if (((f2 = a2[o2]), f2 || f2 === 0))
        if (n.type(f2) === "object") n.merge(m2, f2.nodeType ? [f2] : f2);
        else if (ba.test(f2)) {
          for (
            g2 = g2 || l2.appendChild(b2.createElement("div")),
              h2 = (Y.exec(f2) || ["", ""])[1].toLowerCase(),
              i3 = $2[h2] || $2._default,
              g2.innerHTML = i3[1] + n.htmlPrefilter(f2) + i3[2],
              k2 = i3[0];
            k2--;

          )
            g2 = g2.lastChild;
          n.merge(m2, g2.childNodes),
            (g2 = l2.firstChild),
            (g2.textContent = "");
        } else m2.push(b2.createTextNode(f2));
    for (l2.textContent = "", o2 = 0; (f2 = m2[o2++]); )
      if (d2 && n.inArray(f2, d2) > -1) e2 && e2.push(f2);
      else if (
        ((j2 = n.contains(f2.ownerDocument, f2)),
        (g2 = _(l2.appendChild(f2), "script")),
        j2 && aa(g2),
        c2)
      )
        for (k2 = 0; (f2 = g2[k2++]); ) Z.test(f2.type || "") && c2.push(f2);
    return l2;
  }
  (function () {
    var a2 = d.createDocumentFragment(),
      b2 = a2.appendChild(d.createElement("div")),
      c2 = d.createElement("input");
    c2.setAttribute("type", "radio"),
      c2.setAttribute("checked", "checked"),
      c2.setAttribute("name", "t"),
      b2.appendChild(c2),
      (l.checkClone = b2.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (b2.innerHTML = "<textarea>x</textarea>"),
      (l.noCloneChecked = !!b2.cloneNode(!0).lastChild.defaultValue);
  })();
  var da = /^key/,
    ea = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    fa = /^([^.]*)(?:\.(.+)|)/;
  function ga() {
    return !0;
  }
  function ha() {
    return !1;
  }
  function ia() {
    try {
      return d.activeElement;
    } catch {}
  }
  function ja(a2, b2, c2, d2, e2, f2) {
    var g2, h2;
    if (typeof b2 == "object") {
      typeof c2 != "string" && ((d2 = d2 || c2), (c2 = void 0));
      for (h2 in b2) ja(a2, h2, c2, d2, b2[h2], f2);
      return a2;
    }
    if (
      (d2 == null && e2 == null
        ? ((e2 = c2), (d2 = c2 = void 0))
        : e2 == null &&
          (typeof c2 == "string"
            ? ((e2 = d2), (d2 = void 0))
            : ((e2 = d2), (d2 = c2), (c2 = void 0))),
      e2 === !1)
    )
      e2 = ha;
    else if (!e2) return a2;
    return (
      f2 === 1 &&
        ((g2 = e2),
        (e2 = function (a3) {
          return n().off(a3), g2.apply(this, arguments);
        }),
        (e2.guid = g2.guid || (g2.guid = n.guid++))),
      a2.each(function () {
        n.event.add(this, b2, e2, d2, c2);
      })
    );
  }
  (n.event = {
    global: {},
    add: function (a2, b2, c2, d2, e2) {
      var f2,
        g2,
        h2,
        i3,
        j2,
        k2,
        l2,
        m2,
        o2,
        p2,
        q2,
        r2 = N.get(a2);
      if (r2)
        for (
          c2.handler && ((f2 = c2), (c2 = f2.handler), (e2 = f2.selector)),
            c2.guid || (c2.guid = n.guid++),
            (i3 = r2.events) || (i3 = r2.events = {}),
            (g2 = r2.handle) ||
              (g2 = r2.handle =
                function (b3) {
                  return typeof n < "u" && n.event.triggered !== b3.type
                    ? n.event.dispatch.apply(a2, arguments)
                    : void 0;
                }),
            b2 = (b2 || "").match(G) || [""],
            j2 = b2.length;
          j2--;

        )
          (h2 = fa.exec(b2[j2]) || []),
            (o2 = q2 = h2[1]),
            (p2 = (h2[2] || "").split(".").sort()),
            o2 &&
              ((l2 = n.event.special[o2] || {}),
              (o2 = (e2 ? l2.delegateType : l2.bindType) || o2),
              (l2 = n.event.special[o2] || {}),
              (k2 = n.extend(
                {
                  type: o2,
                  origType: q2,
                  data: d2,
                  handler: c2,
                  guid: c2.guid,
                  selector: e2,
                  needsContext: e2 && n.expr.match.needsContext.test(e2),
                  namespace: p2.join("."),
                },
                f2
              )),
              (m2 = i3[o2]) ||
                ((m2 = i3[o2] = []),
                (m2.delegateCount = 0),
                (l2.setup && l2.setup.call(a2, d2, p2, g2) !== !1) ||
                  (a2.addEventListener && a2.addEventListener(o2, g2))),
              l2.add &&
                (l2.add.call(a2, k2),
                k2.handler.guid || (k2.handler.guid = c2.guid)),
              e2 ? m2.splice(m2.delegateCount++, 0, k2) : m2.push(k2),
              (n.event.global[o2] = !0));
    },
    remove: function (a2, b2, c2, d2, e2) {
      var f2,
        g2,
        h2,
        i3,
        j2,
        k2,
        l2,
        m2,
        o2,
        p2,
        q2,
        r2 = N.hasData(a2) && N.get(a2);
      if (r2 && (i3 = r2.events)) {
        for (b2 = (b2 || "").match(G) || [""], j2 = b2.length; j2--; )
          if (
            ((h2 = fa.exec(b2[j2]) || []),
            (o2 = q2 = h2[1]),
            (p2 = (h2[2] || "").split(".").sort()),
            o2)
          ) {
            for (
              l2 = n.event.special[o2] || {},
                o2 = (d2 ? l2.delegateType : l2.bindType) || o2,
                m2 = i3[o2] || [],
                h2 =
                  h2[2] &&
                  new RegExp("(^|\\.)" + p2.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                g2 = f2 = m2.length;
              f2--;

            )
              (k2 = m2[f2]),
                (!e2 && q2 !== k2.origType) ||
                  (c2 && c2.guid !== k2.guid) ||
                  (h2 && !h2.test(k2.namespace)) ||
                  (d2 && d2 !== k2.selector && (d2 !== "**" || !k2.selector)) ||
                  (m2.splice(f2, 1),
                  k2.selector && m2.delegateCount--,
                  l2.remove && l2.remove.call(a2, k2));
            g2 &&
              !m2.length &&
              ((l2.teardown && l2.teardown.call(a2, p2, r2.handle) !== !1) ||
                n.removeEvent(a2, o2, r2.handle),
              delete i3[o2]);
          } else for (o2 in i3) n.event.remove(a2, o2 + b2[j2], c2, d2, !0);
        n.isEmptyObject(i3) && N.remove(a2, "handle events");
      }
    },
    dispatch: function (a2) {
      a2 = n.event.fix(a2);
      var b2,
        c2,
        d2,
        f2,
        g2,
        h2 = [],
        i3 = e.call(arguments),
        j2 = (N.get(this, "events") || {})[a2.type] || [],
        k2 = n.event.special[a2.type] || {};
      if (
        ((i3[0] = a2),
        (a2.delegateTarget = this),
        !k2.preDispatch || k2.preDispatch.call(this, a2) !== !1)
      ) {
        for (
          h2 = n.event.handlers.call(this, a2, j2), b2 = 0;
          (f2 = h2[b2++]) && !a2.isPropagationStopped();

        )
          for (
            a2.currentTarget = f2.elem, c2 = 0;
            (g2 = f2.handlers[c2++]) && !a2.isImmediatePropagationStopped();

          )
            (a2.rnamespace && !a2.rnamespace.test(g2.namespace)) ||
              ((a2.handleObj = g2),
              (a2.data = g2.data),
              (d2 = (
                (n.event.special[g2.origType] || {}).handle || g2.handler
              ).apply(f2.elem, i3)),
              d2 !== void 0 &&
                (a2.result = d2) === !1 &&
                (a2.preventDefault(), a2.stopPropagation()));
        return k2.postDispatch && k2.postDispatch.call(this, a2), a2.result;
      }
    },
    handlers: function (a2, b2) {
      var c2,
        d2,
        e2,
        f2,
        g2 = [],
        h2 = b2.delegateCount,
        i3 = a2.target;
      if (
        h2 &&
        i3.nodeType &&
        (a2.type !== "click" || isNaN(a2.button) || a2.button < 1)
      ) {
        for (; i3 !== this; i3 = i3.parentNode || this)
          if (
            i3.nodeType === 1 &&
            (i3.disabled !== !0 || a2.type !== "click")
          ) {
            for (d2 = [], c2 = 0; h2 > c2; c2++)
              (f2 = b2[c2]),
                (e2 = f2.selector + " "),
                d2[e2] === void 0 &&
                  (d2[e2] = f2.needsContext
                    ? n(e2, this).index(i3) > -1
                    : n.find(e2, this, null, [i3]).length),
                d2[e2] && d2.push(f2);
            d2.length && g2.push({ elem: i3, handlers: d2 });
          }
      }
      return (
        h2 < b2.length && g2.push({ elem: this, handlers: b2.slice(h2) }), g2
      );
    },
    props:
      "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
        " "
      ),
    fixHooks: {},
    keyHooks: {
      props: "char charCode key keyCode".split(" "),
      filter: function (a2, b2) {
        return (
          a2.which == null &&
            (a2.which = b2.charCode != null ? b2.charCode : b2.keyCode),
          a2
        );
      },
    },
    mouseHooks: {
      props:
        "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(
          " "
        ),
      filter: function (a2, b2) {
        var c2,
          e2,
          f2,
          g2 = b2.button;
        return (
          a2.pageX == null &&
            b2.clientX != null &&
            ((c2 = a2.target.ownerDocument || d),
            (e2 = c2.documentElement),
            (f2 = c2.body),
            (a2.pageX =
              b2.clientX +
              ((e2 && e2.scrollLeft) || (f2 && f2.scrollLeft) || 0) -
              ((e2 && e2.clientLeft) || (f2 && f2.clientLeft) || 0)),
            (a2.pageY =
              b2.clientY +
              ((e2 && e2.scrollTop) || (f2 && f2.scrollTop) || 0) -
              ((e2 && e2.clientTop) || (f2 && f2.clientTop) || 0))),
          a2.which ||
            g2 === void 0 ||
            (a2.which = 1 & g2 ? 1 : 2 & g2 ? 3 : 4 & g2 ? 2 : 0),
          a2
        );
      },
    },
    fix: function (a2) {
      if (a2[n.expando]) return a2;
      var b2,
        c2,
        e2,
        f2 = a2.type,
        g2 = a2,
        h2 = this.fixHooks[f2];
      for (
        h2 ||
          (this.fixHooks[f2] = h2 =
            ea.test(f2) ? this.mouseHooks : da.test(f2) ? this.keyHooks : {}),
          e2 = h2.props ? this.props.concat(h2.props) : this.props,
          a2 = new n.Event(g2),
          b2 = e2.length;
        b2--;

      )
        (c2 = e2[b2]), (a2[c2] = g2[c2]);
      return (
        a2.target || (a2.target = d),
        a2.target.nodeType === 3 && (a2.target = a2.target.parentNode),
        h2.filter ? h2.filter(a2, g2) : a2
      );
    },
    special: {
      load: { noBubble: !0 },
      focus: {
        trigger: function () {
          return this !== ia() && this.focus ? (this.focus(), !1) : void 0;
        },
        delegateType: "focusin",
      },
      blur: {
        trigger: function () {
          return this === ia() && this.blur ? (this.blur(), !1) : void 0;
        },
        delegateType: "focusout",
      },
      click: {
        trigger: function () {
          return this.type === "checkbox" &&
            this.click &&
            n.nodeName(this, "input")
            ? (this.click(), !1)
            : void 0;
        },
        _default: function (a2) {
          return n.nodeName(a2.target, "a");
        },
      },
      beforeunload: {
        postDispatch: function (a2) {
          a2.result !== void 0 &&
            a2.originalEvent &&
            (a2.originalEvent.returnValue = a2.result);
        },
      },
    },
  }),
    (n.removeEvent = function (a2, b2, c2) {
      a2.removeEventListener && a2.removeEventListener(b2, c2);
    }),
    (n.Event = function (a2, b2) {
      return this instanceof n.Event
        ? (a2 && a2.type
            ? ((this.originalEvent = a2),
              (this.type = a2.type),
              (this.isDefaultPrevented =
                a2.defaultPrevented ||
                (a2.defaultPrevented === void 0 && a2.returnValue === !1)
                  ? ga
                  : ha))
            : (this.type = a2),
          b2 && n.extend(this, b2),
          (this.timeStamp = (a2 && a2.timeStamp) || n.now()),
          void (this[n.expando] = !0))
        : new n.Event(a2, b2);
    }),
    (n.Event.prototype = {
      constructor: n.Event,
      isDefaultPrevented: ha,
      isPropagationStopped: ha,
      isImmediatePropagationStopped: ha,
      isSimulated: !1,
      preventDefault: function () {
        var a2 = this.originalEvent;
        (this.isDefaultPrevented = ga),
          a2 && !this.isSimulated && a2.preventDefault();
      },
      stopPropagation: function () {
        var a2 = this.originalEvent;
        (this.isPropagationStopped = ga),
          a2 && !this.isSimulated && a2.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var a2 = this.originalEvent;
        (this.isImmediatePropagationStopped = ga),
          a2 && !this.isSimulated && a2.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    n.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (a2, b2) {
        n.event.special[a2] = {
          delegateType: b2,
          bindType: b2,
          handle: function (a3) {
            var c2,
              d2 = this,
              e2 = a3.relatedTarget,
              f2 = a3.handleObj;
            return (
              (e2 && (e2 === d2 || n.contains(d2, e2))) ||
                ((a3.type = f2.origType),
                (c2 = f2.handler.apply(this, arguments)),
                (a3.type = b2)),
              c2
            );
          },
        };
      }
    ),
    n.fn.extend({
      on: function (a2, b2, c2, d2) {
        return ja(this, a2, b2, c2, d2);
      },
      one: function (a2, b2, c2, d2) {
        return ja(this, a2, b2, c2, d2, 1);
      },
      off: function (a2, b2, c2) {
        var d2, e2;
        if (a2 && a2.preventDefault && a2.handleObj)
          return (
            (d2 = a2.handleObj),
            n(a2.delegateTarget).off(
              d2.namespace ? d2.origType + "." + d2.namespace : d2.origType,
              d2.selector,
              d2.handler
            ),
            this
          );
        if (typeof a2 == "object") {
          for (e2 in a2) this.off(e2, b2, a2[e2]);
          return this;
        }
        return (
          (b2 !== !1 && typeof b2 != "function") || ((c2 = b2), (b2 = void 0)),
          c2 === !1 && (c2 = ha),
          this.each(function () {
            n.event.remove(this, a2, c2, b2);
          })
        );
      },
    });
  var ka =
      /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
    la = /<script|<style|<link/i,
    ma = /checked\s*(?:[^=]|=\s*.checked.)/i,
    na = /^true\/(.*)/,
    oa = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function pa(a2, b2) {
    return n.nodeName(a2, "table") &&
      n.nodeName(b2.nodeType !== 11 ? b2 : b2.firstChild, "tr")
      ? a2.getElementsByTagName("tbody")[0] ||
          a2.appendChild(a2.ownerDocument.createElement("tbody"))
      : a2;
  }
  function qa(a2) {
    return (a2.type = (a2.getAttribute("type") !== null) + "/" + a2.type), a2;
  }
  function ra(a2) {
    var b2 = na.exec(a2.type);
    return b2 ? (a2.type = b2[1]) : a2.removeAttribute("type"), a2;
  }
  function sa(a2, b2) {
    var c2, d2, e2, f2, g2, h2, i3, j2;
    if (b2.nodeType === 1) {
      if (
        N.hasData(a2) &&
        ((f2 = N.access(a2)), (g2 = N.set(b2, f2)), (j2 = f2.events))
      ) {
        delete g2.handle, (g2.events = {});
        for (e2 in j2)
          for (c2 = 0, d2 = j2[e2].length; d2 > c2; c2++)
            n.event.add(b2, e2, j2[e2][c2]);
      }
      O.hasData(a2) &&
        ((h2 = O.access(a2)), (i3 = n.extend({}, h2)), O.set(b2, i3));
    }
  }
  function ta(a2, b2) {
    var c2 = b2.nodeName.toLowerCase();
    c2 === "input" && X.test(a2.type)
      ? (b2.checked = a2.checked)
      : (c2 !== "input" && c2 !== "textarea") ||
        (b2.defaultValue = a2.defaultValue);
  }
  function ua(a2, b2, c2, d2) {
    b2 = f.apply([], b2);
    var e2,
      g2,
      h2,
      i3,
      j2,
      k2,
      m2 = 0,
      o2 = a2.length,
      p2 = o2 - 1,
      q2 = b2[0],
      r2 = n.isFunction(q2);
    if (r2 || (o2 > 1 && typeof q2 == "string" && !l.checkClone && ma.test(q2)))
      return a2.each(function (e3) {
        var f2 = a2.eq(e3);
        r2 && (b2[0] = q2.call(this, e3, f2.html())), ua(f2, b2, c2, d2);
      });
    if (
      o2 &&
      ((e2 = ca(b2, a2[0].ownerDocument, !1, a2, d2)),
      (g2 = e2.firstChild),
      e2.childNodes.length === 1 && (e2 = g2),
      g2 || d2)
    ) {
      for (h2 = n.map(_(e2, "script"), qa), i3 = h2.length; o2 > m2; m2++)
        (j2 = e2),
          m2 !== p2 &&
            ((j2 = n.clone(j2, !0, !0)), i3 && n.merge(h2, _(j2, "script"))),
          c2.call(a2[m2], j2, m2);
      if (i3)
        for (
          k2 = h2[h2.length - 1].ownerDocument, n.map(h2, ra), m2 = 0;
          i3 > m2;
          m2++
        )
          (j2 = h2[m2]),
            Z.test(j2.type || "") &&
              !N.access(j2, "globalEval") &&
              n.contains(k2, j2) &&
              (j2.src
                ? n._evalUrl && n._evalUrl(j2.src)
                : n.globalEval(j2.textContent.replace(oa, "")));
    }
    return a2;
  }
  function va(a2, b2, c2) {
    for (
      var d2, e2 = b2 ? n.filter(b2, a2) : a2, f2 = 0;
      (d2 = e2[f2]) != null;
      f2++
    )
      c2 || d2.nodeType !== 1 || n.cleanData(_(d2)),
        d2.parentNode &&
          (c2 && n.contains(d2.ownerDocument, d2) && aa(_(d2, "script")),
          d2.parentNode.removeChild(d2));
    return a2;
  }
  n.extend({
    htmlPrefilter: function (a2) {
      return a2.replace(ka, "<$1></$2>");
    },
    clone: function (a2, b2, c2) {
      var d2,
        e2,
        f2,
        g2,
        h2 = a2.cloneNode(!0),
        i3 = n.contains(a2.ownerDocument, a2);
      if (
        !(
          l.noCloneChecked ||
          (a2.nodeType !== 1 && a2.nodeType !== 11) ||
          n.isXMLDoc(a2)
        )
      )
        for (g2 = _(h2), f2 = _(a2), d2 = 0, e2 = f2.length; e2 > d2; d2++)
          ta(f2[d2], g2[d2]);
      if (b2)
        if (c2)
          for (
            f2 = f2 || _(a2), g2 = g2 || _(h2), d2 = 0, e2 = f2.length;
            e2 > d2;
            d2++
          )
            sa(f2[d2], g2[d2]);
        else sa(a2, h2);
      return (
        (g2 = _(h2, "script")),
        g2.length > 0 && aa(g2, !i3 && _(a2, "script")),
        h2
      );
    },
    cleanData: function (a2) {
      for (
        var b2, c2, d2, e2 = n.event.special, f2 = 0;
        (c2 = a2[f2]) !== void 0;
        f2++
      )
        if (L(c2)) {
          if ((b2 = c2[N.expando])) {
            if (b2.events)
              for (d2 in b2.events)
                e2[d2]
                  ? n.event.remove(c2, d2)
                  : n.removeEvent(c2, d2, b2.handle);
            c2[N.expando] = void 0;
          }
          c2[O.expando] && (c2[O.expando] = void 0);
        }
    },
  }),
    n.fn.extend({
      domManip: ua,
      detach: function (a2) {
        return va(this, a2, !0);
      },
      remove: function (a2) {
        return va(this, a2);
      },
      text: function (a2) {
        return K(
          this,
          function (a3) {
            return a3 === void 0
              ? n.text(this)
              : this.empty().each(function () {
                  (this.nodeType !== 1 &&
                    this.nodeType !== 11 &&
                    this.nodeType !== 9) ||
                    (this.textContent = a3);
                });
          },
          null,
          a2,
          arguments.length
        );
      },
      append: function () {
        return ua(this, arguments, function (a2) {
          if (
            this.nodeType === 1 ||
            this.nodeType === 11 ||
            this.nodeType === 9
          ) {
            var b2 = pa(this, a2);
            b2.appendChild(a2);
          }
        });
      },
      prepend: function () {
        return ua(this, arguments, function (a2) {
          if (
            this.nodeType === 1 ||
            this.nodeType === 11 ||
            this.nodeType === 9
          ) {
            var b2 = pa(this, a2);
            b2.insertBefore(a2, b2.firstChild);
          }
        });
      },
      before: function () {
        return ua(this, arguments, function (a2) {
          this.parentNode && this.parentNode.insertBefore(a2, this);
        });
      },
      after: function () {
        return ua(this, arguments, function (a2) {
          this.parentNode && this.parentNode.insertBefore(a2, this.nextSibling);
        });
      },
      empty: function () {
        for (var a2, b2 = 0; (a2 = this[b2]) != null; b2++)
          a2.nodeType === 1 && (n.cleanData(_(a2, !1)), (a2.textContent = ""));
        return this;
      },
      clone: function (a2, b2) {
        return (
          (a2 = a2 ?? !1),
          (b2 = b2 ?? a2),
          this.map(function () {
            return n.clone(this, a2, b2);
          })
        );
      },
      html: function (a2) {
        return K(
          this,
          function (a3) {
            var b2 = this[0] || {},
              c2 = 0,
              d2 = this.length;
            if (a3 === void 0 && b2.nodeType === 1) return b2.innerHTML;
            if (
              typeof a3 == "string" &&
              !la.test(a3) &&
              !$2[(Y.exec(a3) || ["", ""])[1].toLowerCase()]
            ) {
              a3 = n.htmlPrefilter(a3);
              try {
                for (; d2 > c2; c2++)
                  (b2 = this[c2] || {}),
                    b2.nodeType === 1 &&
                      (n.cleanData(_(b2, !1)), (b2.innerHTML = a3));
                b2 = 0;
              } catch {}
            }
            b2 && this.empty().append(a3);
          },
          null,
          a2,
          arguments.length
        );
      },
      replaceWith: function () {
        var a2 = [];
        return ua(
          this,
          arguments,
          function (b2) {
            var c2 = this.parentNode;
            n.inArray(this, a2) < 0 &&
              (n.cleanData(_(this)), c2 && c2.replaceChild(b2, this));
          },
          a2
        );
      },
    }),
    n.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (a2, b2) {
        n.fn[a2] = function (a3) {
          for (
            var c2, d2 = [], e2 = n(a3), f2 = e2.length - 1, h2 = 0;
            f2 >= h2;
            h2++
          )
            (c2 = h2 === f2 ? this : this.clone(!0)),
              n(e2[h2])[b2](c2),
              g.apply(d2, c2.get());
          return this.pushStack(d2);
        };
      }
    );
  var wa,
    xa = { HTML: "block", BODY: "block" };
  function ya(a2, b2) {
    var c2 = n(b2.createElement(a2)).appendTo(b2.body),
      d2 = n.css(c2[0], "display");
    return c2.detach(), d2;
  }
  function za(a2) {
    var b2 = d,
      c2 = xa[a2];
    return (
      c2 ||
        ((c2 = ya(a2, b2)),
        (c2 !== "none" && c2) ||
          ((wa = (
            wa || n("<iframe frameborder='0' width='0' height='0'/>")
          ).appendTo(b2.documentElement)),
          (b2 = wa[0].contentDocument),
          b2.write(),
          b2.close(),
          (c2 = ya(a2, b2)),
          wa.detach()),
        (xa[a2] = c2)),
      c2
    );
  }
  var Aa = /^margin/,
    Ba = new RegExp("^(" + S + ")(?!px)[a-z%]+$", "i"),
    Ca = function (b2) {
      var c2 = b2.ownerDocument.defaultView;
      return (c2 && c2.opener) || (c2 = a), c2.getComputedStyle(b2);
    },
    Da = function (a2, b2, c2, d2) {
      var e2,
        f2,
        g2 = {};
      for (f2 in b2) (g2[f2] = a2.style[f2]), (a2.style[f2] = b2[f2]);
      e2 = c2.apply(a2, d2 || []);
      for (f2 in b2) a2.style[f2] = g2[f2];
      return e2;
    },
    Ea = d.documentElement;
  (function () {
    var b2,
      c2,
      e2,
      f2,
      g2 = d.createElement("div"),
      h2 = d.createElement("div");
    if (h2.style) {
      let i4 = function () {
        (h2.style.cssText =
          "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"),
          (h2.innerHTML = ""),
          Ea.appendChild(g2);
        var d2 = a.getComputedStyle(h2);
        (b2 = d2.top !== "1%"),
          (f2 = d2.marginLeft === "2px"),
          (c2 = d2.width === "4px"),
          (h2.style.marginRight = "50%"),
          (e2 = d2.marginRight === "4px"),
          Ea.removeChild(g2);
      };
      var i3 = i4;
      (h2.style.backgroundClip = "content-box"),
        (h2.cloneNode(!0).style.backgroundClip = ""),
        (l.clearCloneStyle = h2.style.backgroundClip === "content-box"),
        (g2.style.cssText =
          "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
        g2.appendChild(h2),
        n.extend(l, {
          pixelPosition: function () {
            return i4(), b2;
          },
          boxSizingReliable: function () {
            return c2 == null && i4(), c2;
          },
          pixelMarginRight: function () {
            return c2 == null && i4(), e2;
          },
          reliableMarginLeft: function () {
            return c2 == null && i4(), f2;
          },
          reliableMarginRight: function () {
            var b3,
              c3 = h2.appendChild(d.createElement("div"));
            return (
              (c3.style.cssText = h2.style.cssText =
                "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
              (c3.style.marginRight = c3.style.width = "0"),
              (h2.style.width = "1px"),
              Ea.appendChild(g2),
              (b3 = !parseFloat(a.getComputedStyle(c3).marginRight)),
              Ea.removeChild(g2),
              h2.removeChild(c3),
              b3
            );
          },
        });
    }
  })();
  function Fa(a2, b2, c2) {
    var d2,
      e2,
      f2,
      g2,
      h2 = a2.style;
    return (
      (c2 = c2 || Ca(a2)),
      (g2 = c2 ? c2.getPropertyValue(b2) || c2[b2] : void 0),
      (g2 !== "" && g2 !== void 0) ||
        n.contains(a2.ownerDocument, a2) ||
        (g2 = n.style(a2, b2)),
      c2 &&
        !l.pixelMarginRight() &&
        Ba.test(g2) &&
        Aa.test(b2) &&
        ((d2 = h2.width),
        (e2 = h2.minWidth),
        (f2 = h2.maxWidth),
        (h2.minWidth = h2.maxWidth = h2.width = g2),
        (g2 = c2.width),
        (h2.width = d2),
        (h2.minWidth = e2),
        (h2.maxWidth = f2)),
      g2 !== void 0 ? g2 + "" : g2
    );
  }
  function Ga(a2, b2) {
    return {
      get: function () {
        return a2()
          ? void delete this.get
          : (this.get = b2).apply(this, arguments);
      },
    };
  }
  var Ha = /^(none|table(?!-c[ea]).+)/,
    Ia = { position: "absolute", visibility: "hidden", display: "block" },
    Ja = { letterSpacing: "0", fontWeight: "400" },
    Ka = ["Webkit", "O", "Moz", "ms"],
    La = d.createElement("div").style;
  function Ma(a2) {
    if (a2 in La) return a2;
    for (var b2 = a2[0].toUpperCase() + a2.slice(1), c2 = Ka.length; c2--; )
      if (((a2 = Ka[c2] + b2), a2 in La)) return a2;
  }
  function Na(a2, b2, c2) {
    var d2 = T.exec(b2);
    return d2 ? Math.max(0, d2[2] - (c2 || 0)) + (d2[3] || "px") : b2;
  }
  function Oa(a2, b2, c2, d2, e2) {
    for (
      var f2 = c2 === (d2 ? "border" : "content") ? 4 : b2 === "width" ? 1 : 0,
        g2 = 0;
      4 > f2;
      f2 += 2
    )
      c2 === "margin" && (g2 += n.css(a2, c2 + U[f2], !0, e2)),
        d2
          ? (c2 === "content" && (g2 -= n.css(a2, "padding" + U[f2], !0, e2)),
            c2 !== "margin" &&
              (g2 -= n.css(a2, "border" + U[f2] + "Width", !0, e2)))
          : ((g2 += n.css(a2, "padding" + U[f2], !0, e2)),
            c2 !== "padding" &&
              (g2 += n.css(a2, "border" + U[f2] + "Width", !0, e2)));
    return g2;
  }
  function Pa(a2, b2, c2) {
    var d2 = !0,
      e2 = b2 === "width" ? a2.offsetWidth : a2.offsetHeight,
      f2 = Ca(a2),
      g2 = n.css(a2, "boxSizing", !1, f2) === "border-box";
    if (0 >= e2 || e2 == null) {
      if (
        ((e2 = Fa(a2, b2, f2)),
        (0 > e2 || e2 == null) && (e2 = a2.style[b2]),
        Ba.test(e2))
      )
        return e2;
      (d2 = g2 && (l.boxSizingReliable() || e2 === a2.style[b2])),
        (e2 = parseFloat(e2) || 0);
    }
    return e2 + Oa(a2, b2, c2 || (g2 ? "border" : "content"), d2, f2) + "px";
  }
  function Qa(a2, b2) {
    for (var c2, d2, e2, f2 = [], g2 = 0, h2 = a2.length; h2 > g2; g2++)
      (d2 = a2[g2]),
        d2.style &&
          ((f2[g2] = N.get(d2, "olddisplay")),
          (c2 = d2.style.display),
          b2
            ? (f2[g2] || c2 !== "none" || (d2.style.display = ""),
              d2.style.display === "" &&
                V(d2) &&
                (f2[g2] = N.access(d2, "olddisplay", za(d2.nodeName))))
            : ((e2 = V(d2)),
              (c2 === "none" && e2) ||
                N.set(d2, "olddisplay", e2 ? c2 : n.css(d2, "display"))));
    for (g2 = 0; h2 > g2; g2++)
      (d2 = a2[g2]),
        d2.style &&
          ((b2 && d2.style.display !== "none" && d2.style.display !== "") ||
            (d2.style.display = b2 ? f2[g2] || "" : "none"));
    return a2;
  }
  n.extend({
    cssHooks: {
      opacity: {
        get: function (a2, b2) {
          if (b2) {
            var c2 = Fa(a2, "opacity");
            return c2 === "" ? "1" : c2;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: { float: "cssFloat" },
    style: function (a2, b2, c2, d2) {
      if (a2 && a2.nodeType !== 3 && a2.nodeType !== 8 && a2.style) {
        var e2,
          f2,
          g2,
          h2 = n.camelCase(b2),
          i3 = a2.style;
        return (
          (b2 = n.cssProps[h2] || (n.cssProps[h2] = Ma(h2) || h2)),
          (g2 = n.cssHooks[b2] || n.cssHooks[h2]),
          c2 === void 0
            ? g2 && "get" in g2 && (e2 = g2.get(a2, !1, d2)) !== void 0
              ? e2
              : i3[b2]
            : ((f2 = typeof c2),
              f2 === "string" &&
                (e2 = T.exec(c2)) &&
                e2[1] &&
                ((c2 = W(a2, b2, e2)), (f2 = "number")),
              c2 != null &&
                c2 === c2 &&
                (f2 === "number" &&
                  (c2 += (e2 && e2[3]) || (n.cssNumber[h2] ? "" : "px")),
                l.clearCloneStyle ||
                  c2 !== "" ||
                  b2.indexOf("background") !== 0 ||
                  (i3[b2] = "inherit"),
                (g2 && "set" in g2 && (c2 = g2.set(a2, c2, d2)) === void 0) ||
                  (i3[b2] = c2)),
              void 0)
        );
      }
    },
    css: function (a2, b2, c2, d2) {
      var e2,
        f2,
        g2,
        h2 = n.camelCase(b2);
      return (
        (b2 = n.cssProps[h2] || (n.cssProps[h2] = Ma(h2) || h2)),
        (g2 = n.cssHooks[b2] || n.cssHooks[h2]),
        g2 && "get" in g2 && (e2 = g2.get(a2, !0, c2)),
        e2 === void 0 && (e2 = Fa(a2, b2, d2)),
        e2 === "normal" && b2 in Ja && (e2 = Ja[b2]),
        c2 === "" || c2
          ? ((f2 = parseFloat(e2)), c2 === !0 || isFinite(f2) ? f2 || 0 : e2)
          : e2
      );
    },
  }),
    n.each(["height", "width"], function (a2, b2) {
      n.cssHooks[b2] = {
        get: function (a3, c2, d2) {
          return c2
            ? Ha.test(n.css(a3, "display")) && a3.offsetWidth === 0
              ? Da(a3, Ia, function () {
                  return Pa(a3, b2, d2);
                })
              : Pa(a3, b2, d2)
            : void 0;
        },
        set: function (a3, c2, d2) {
          var e2,
            f2 = d2 && Ca(a3),
            g2 =
              d2 &&
              Oa(
                a3,
                b2,
                d2,
                n.css(a3, "boxSizing", !1, f2) === "border-box",
                f2
              );
          return (
            g2 &&
              (e2 = T.exec(c2)) &&
              (e2[3] || "px") !== "px" &&
              ((a3.style[b2] = c2), (c2 = n.css(a3, b2))),
            Na(a3, c2, g2)
          );
        },
      };
    }),
    (n.cssHooks.marginLeft = Ga(l.reliableMarginLeft, function (a2, b2) {
      return b2
        ? (parseFloat(Fa(a2, "marginLeft")) ||
            a2.getBoundingClientRect().left -
              Da(a2, { marginLeft: 0 }, function () {
                return a2.getBoundingClientRect().left;
              })) + "px"
        : void 0;
    })),
    (n.cssHooks.marginRight = Ga(l.reliableMarginRight, function (a2, b2) {
      return b2
        ? Da(a2, { display: "inline-block" }, Fa, [a2, "marginRight"])
        : void 0;
    })),
    n.each({ margin: "", padding: "", border: "Width" }, function (a2, b2) {
      (n.cssHooks[a2 + b2] = {
        expand: function (c2) {
          for (
            var d2 = 0,
              e2 = {},
              f2 = typeof c2 == "string" ? c2.split(" ") : [c2];
            4 > d2;
            d2++
          )
            e2[a2 + U[d2] + b2] = f2[d2] || f2[d2 - 2] || f2[0];
          return e2;
        },
      }),
        Aa.test(a2) || (n.cssHooks[a2 + b2].set = Na);
    }),
    n.fn.extend({
      css: function (a2, b2) {
        return K(
          this,
          function (a3, b3, c2) {
            var d2,
              e2,
              f2 = {},
              g2 = 0;
            if (n.isArray(b3)) {
              for (d2 = Ca(a3), e2 = b3.length; e2 > g2; g2++)
                f2[b3[g2]] = n.css(a3, b3[g2], !1, d2);
              return f2;
            }
            return c2 !== void 0 ? n.style(a3, b3, c2) : n.css(a3, b3);
          },
          a2,
          b2,
          arguments.length > 1
        );
      },
      show: function () {
        return Qa(this, !0);
      },
      hide: function () {
        return Qa(this);
      },
      toggle: function (a2) {
        return typeof a2 == "boolean"
          ? a2
            ? this.show()
            : this.hide()
          : this.each(function () {
              V(this) ? n(this).show() : n(this).hide();
            });
      },
    });
  function Ra(a2, b2, c2, d2, e2) {
    return new Ra.prototype.init(a2, b2, c2, d2, e2);
  }
  (n.Tween = Ra),
    (Ra.prototype = {
      constructor: Ra,
      init: function (a2, b2, c2, d2, e2, f2) {
        (this.elem = a2),
          (this.prop = c2),
          (this.easing = e2 || n.easing._default),
          (this.options = b2),
          (this.start = this.now = this.cur()),
          (this.end = d2),
          (this.unit = f2 || (n.cssNumber[c2] ? "" : "px"));
      },
      cur: function () {
        var a2 = Ra.propHooks[this.prop];
        return a2 && a2.get ? a2.get(this) : Ra.propHooks._default.get(this);
      },
      run: function (a2) {
        var b2,
          c2 = Ra.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = b2 =
                n.easing[this.easing](
                  a2,
                  this.options.duration * a2,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = b2 = a2),
          (this.now = (this.end - this.start) * b2 + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          c2 && c2.set ? c2.set(this) : Ra.propHooks._default.set(this),
          this
        );
      },
    }),
    (Ra.prototype.init.prototype = Ra.prototype),
    (Ra.propHooks = {
      _default: {
        get: function (a2) {
          var b2;
          return a2.elem.nodeType !== 1 ||
            (a2.elem[a2.prop] != null && a2.elem.style[a2.prop] == null)
            ? a2.elem[a2.prop]
            : ((b2 = n.css(a2.elem, a2.prop, "")),
              b2 && b2 !== "auto" ? b2 : 0);
        },
        set: function (a2) {
          n.fx.step[a2.prop]
            ? n.fx.step[a2.prop](a2)
            : a2.elem.nodeType !== 1 ||
              (a2.elem.style[n.cssProps[a2.prop]] == null &&
                !n.cssHooks[a2.prop])
            ? (a2.elem[a2.prop] = a2.now)
            : n.style(a2.elem, a2.prop, a2.now + a2.unit);
        },
      },
    }),
    (Ra.propHooks.scrollTop = Ra.propHooks.scrollLeft =
      {
        set: function (a2) {
          a2.elem.nodeType && a2.elem.parentNode && (a2.elem[a2.prop] = a2.now);
        },
      }),
    (n.easing = {
      linear: function (a2) {
        return a2;
      },
      swing: function (a2) {
        return 0.5 - Math.cos(a2 * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (n.fx = Ra.prototype.init),
    (n.fx.step = {});
  var Sa,
    Ta,
    Ua = /^(?:toggle|show|hide)$/,
    Va = /queueHooks$/;
  function Wa() {
    return (
      a.setTimeout(function () {
        Sa = void 0;
      }),
      (Sa = n.now())
    );
  }
  function Xa(a2, b2) {
    var c2,
      d2 = 0,
      e2 = { height: a2 };
    for (b2 = b2 ? 1 : 0; 4 > d2; d2 += 2 - b2)
      (c2 = U[d2]), (e2["margin" + c2] = e2["padding" + c2] = a2);
    return b2 && (e2.opacity = e2.width = a2), e2;
  }
  function Ya(a2, b2, c2) {
    for (
      var d2,
        e2 = (_a.tweeners[b2] || []).concat(_a.tweeners["*"]),
        f2 = 0,
        g2 = e2.length;
      g2 > f2;
      f2++
    )
      if ((d2 = e2[f2].call(c2, b2, a2))) return d2;
  }
  function Za(a2, b2, c2) {
    var d2,
      e2,
      f2,
      g2,
      h2,
      i3,
      j2,
      k2,
      l2 = this,
      m2 = {},
      o2 = a2.style,
      p2 = a2.nodeType && V(a2),
      q2 = N.get(a2, "fxshow");
    c2.queue ||
      ((h2 = n._queueHooks(a2, "fx")),
      h2.unqueued == null &&
        ((h2.unqueued = 0),
        (i3 = h2.empty.fire),
        (h2.empty.fire = function () {
          h2.unqueued || i3();
        })),
      h2.unqueued++,
      l2.always(function () {
        l2.always(function () {
          h2.unqueued--, n.queue(a2, "fx").length || h2.empty.fire();
        });
      })),
      a2.nodeType === 1 &&
        ("height" in b2 || "width" in b2) &&
        ((c2.overflow = [o2.overflow, o2.overflowX, o2.overflowY]),
        (j2 = n.css(a2, "display")),
        (k2 = j2 === "none" ? N.get(a2, "olddisplay") || za(a2.nodeName) : j2),
        k2 === "inline" &&
          n.css(a2, "float") === "none" &&
          (o2.display = "inline-block")),
      c2.overflow &&
        ((o2.overflow = "hidden"),
        l2.always(function () {
          (o2.overflow = c2.overflow[0]),
            (o2.overflowX = c2.overflow[1]),
            (o2.overflowY = c2.overflow[2]);
        }));
    for (d2 in b2)
      if (((e2 = b2[d2]), Ua.exec(e2))) {
        if (
          (delete b2[d2],
          (f2 = f2 || e2 === "toggle"),
          e2 === (p2 ? "hide" : "show"))
        ) {
          if (e2 !== "show" || !q2 || q2[d2] === void 0) continue;
          p2 = !0;
        }
        m2[d2] = (q2 && q2[d2]) || n.style(a2, d2);
      } else j2 = void 0;
    if (n.isEmptyObject(m2))
      (j2 === "none" ? za(a2.nodeName) : j2) === "inline" && (o2.display = j2);
    else {
      q2
        ? "hidden" in q2 && (p2 = q2.hidden)
        : (q2 = N.access(a2, "fxshow", {})),
        f2 && (q2.hidden = !p2),
        p2
          ? n(a2).show()
          : l2.done(function () {
              n(a2).hide();
            }),
        l2.done(function () {
          var b3;
          N.remove(a2, "fxshow");
          for (b3 in m2) n.style(a2, b3, m2[b3]);
        });
      for (d2 in m2)
        (g2 = Ya(p2 ? q2[d2] : 0, d2, l2)),
          d2 in q2 ||
            ((q2[d2] = g2.start),
            p2 &&
              ((g2.end = g2.start),
              (g2.start = d2 === "width" || d2 === "height" ? 1 : 0)));
    }
  }
  function $a(a2, b2) {
    var c2, d2, e2, f2, g2;
    for (c2 in a2)
      if (
        ((d2 = n.camelCase(c2)),
        (e2 = b2[d2]),
        (f2 = a2[c2]),
        n.isArray(f2) && ((e2 = f2[1]), (f2 = a2[c2] = f2[0])),
        c2 !== d2 && ((a2[d2] = f2), delete a2[c2]),
        (g2 = n.cssHooks[d2]),
        g2 && "expand" in g2)
      ) {
        (f2 = g2.expand(f2)), delete a2[d2];
        for (c2 in f2) c2 in a2 || ((a2[c2] = f2[c2]), (b2[c2] = e2));
      } else b2[d2] = e2;
  }
  function _a(a2, b2, c2) {
    var d2,
      e2,
      f2 = 0,
      g2 = _a.prefilters.length,
      h2 = n.Deferred().always(function () {
        delete i3.elem;
      }),
      i3 = function () {
        if (e2) return !1;
        for (
          var b3 = Sa || Wa(),
            c3 = Math.max(0, j2.startTime + j2.duration - b3),
            d3 = c3 / j2.duration || 0,
            f3 = 1 - d3,
            g3 = 0,
            i4 = j2.tweens.length;
          i4 > g3;
          g3++
        )
          j2.tweens[g3].run(f3);
        return (
          h2.notifyWith(a2, [j2, f3, c3]),
          1 > f3 && i4 ? c3 : (h2.resolveWith(a2, [j2]), !1)
        );
      },
      j2 = h2.promise({
        elem: a2,
        props: n.extend({}, b2),
        opts: n.extend(
          !0,
          { specialEasing: {}, easing: n.easing._default },
          c2
        ),
        originalProperties: b2,
        originalOptions: c2,
        startTime: Sa || Wa(),
        duration: c2.duration,
        tweens: [],
        createTween: function (b3, c3) {
          var d3 = n.Tween(
            a2,
            j2.opts,
            b3,
            c3,
            j2.opts.specialEasing[b3] || j2.opts.easing
          );
          return j2.tweens.push(d3), d3;
        },
        stop: function (b3) {
          var c3 = 0,
            d3 = b3 ? j2.tweens.length : 0;
          if (e2) return this;
          for (e2 = !0; d3 > c3; c3++) j2.tweens[c3].run(1);
          return (
            b3
              ? (h2.notifyWith(a2, [j2, 1, 0]), h2.resolveWith(a2, [j2, b3]))
              : h2.rejectWith(a2, [j2, b3]),
            this
          );
        },
      }),
      k2 = j2.props;
    for ($a(k2, j2.opts.specialEasing); g2 > f2; f2++)
      if ((d2 = _a.prefilters[f2].call(j2, a2, k2, j2.opts)))
        return (
          n.isFunction(d2.stop) &&
            (n._queueHooks(j2.elem, j2.opts.queue).stop = n.proxy(d2.stop, d2)),
          d2
        );
    return (
      n.map(k2, Ya, j2),
      n.isFunction(j2.opts.start) && j2.opts.start.call(a2, j2),
      n.fx.timer(n.extend(i3, { elem: a2, anim: j2, queue: j2.opts.queue })),
      j2
        .progress(j2.opts.progress)
        .done(j2.opts.done, j2.opts.complete)
        .fail(j2.opts.fail)
        .always(j2.opts.always)
    );
  }
  (n.Animation = n.extend(_a, {
    tweeners: {
      "*": [
        function (a2, b2) {
          var c2 = this.createTween(a2, b2);
          return W(c2.elem, a2, T.exec(b2), c2), c2;
        },
      ],
    },
    tweener: function (a2, b2) {
      n.isFunction(a2) ? ((b2 = a2), (a2 = ["*"])) : (a2 = a2.match(G));
      for (var c2, d2 = 0, e2 = a2.length; e2 > d2; d2++)
        (c2 = a2[d2]),
          (_a.tweeners[c2] = _a.tweeners[c2] || []),
          _a.tweeners[c2].unshift(b2);
    },
    prefilters: [Za],
    prefilter: function (a2, b2) {
      b2 ? _a.prefilters.unshift(a2) : _a.prefilters.push(a2);
    },
  })),
    (n.speed = function (a2, b2, c2) {
      var d2 =
        a2 && typeof a2 == "object"
          ? n.extend({}, a2)
          : {
              complete: c2 || (!c2 && b2) || (n.isFunction(a2) && a2),
              duration: a2,
              easing: (c2 && b2) || (b2 && !n.isFunction(b2) && b2),
            };
      return (
        (d2.duration = n.fx.off
          ? 0
          : typeof d2.duration == "number"
          ? d2.duration
          : d2.duration in n.fx.speeds
          ? n.fx.speeds[d2.duration]
          : n.fx.speeds._default),
        (d2.queue != null && d2.queue !== !0) || (d2.queue = "fx"),
        (d2.old = d2.complete),
        (d2.complete = function () {
          n.isFunction(d2.old) && d2.old.call(this),
            d2.queue && n.dequeue(this, d2.queue);
        }),
        d2
      );
    }),
    n.fn.extend({
      fadeTo: function (a2, b2, c2, d2) {
        return this.filter(V)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: b2 }, a2, c2, d2);
      },
      animate: function (a2, b2, c2, d2) {
        var e2 = n.isEmptyObject(a2),
          f2 = n.speed(b2, c2, d2),
          g2 = function () {
            var b3 = _a(this, n.extend({}, a2), f2);
            (e2 || N.get(this, "finish")) && b3.stop(!0);
          };
        return (
          (g2.finish = g2),
          e2 || f2.queue === !1 ? this.each(g2) : this.queue(f2.queue, g2)
        );
      },
      stop: function (a2, b2, c2) {
        var d2 = function (a3) {
          var b3 = a3.stop;
          delete a3.stop, b3(c2);
        };
        return (
          typeof a2 != "string" && ((c2 = b2), (b2 = a2), (a2 = void 0)),
          b2 && a2 !== !1 && this.queue(a2 || "fx", []),
          this.each(function () {
            var b3 = !0,
              e2 = a2 != null && a2 + "queueHooks",
              f2 = n.timers,
              g2 = N.get(this);
            if (e2) g2[e2] && g2[e2].stop && d2(g2[e2]);
            else
              for (e2 in g2) g2[e2] && g2[e2].stop && Va.test(e2) && d2(g2[e2]);
            for (e2 = f2.length; e2--; )
              f2[e2].elem !== this ||
                (a2 != null && f2[e2].queue !== a2) ||
                (f2[e2].anim.stop(c2), (b3 = !1), f2.splice(e2, 1));
            (!b3 && c2) || n.dequeue(this, a2);
          })
        );
      },
      finish: function (a2) {
        return (
          a2 !== !1 && (a2 = a2 || "fx"),
          this.each(function () {
            var b2,
              c2 = N.get(this),
              d2 = c2[a2 + "queue"],
              e2 = c2[a2 + "queueHooks"],
              f2 = n.timers,
              g2 = d2 ? d2.length : 0;
            for (
              c2.finish = !0,
                n.queue(this, a2, []),
                e2 && e2.stop && e2.stop.call(this, !0),
                b2 = f2.length;
              b2--;

            )
              f2[b2].elem === this &&
                f2[b2].queue === a2 &&
                (f2[b2].anim.stop(!0), f2.splice(b2, 1));
            for (b2 = 0; g2 > b2; b2++)
              d2[b2] && d2[b2].finish && d2[b2].finish.call(this);
            delete c2.finish;
          })
        );
      },
    }),
    n.each(["toggle", "show", "hide"], function (a2, b2) {
      var c2 = n.fn[b2];
      n.fn[b2] = function (a3, d2, e2) {
        return a3 == null || typeof a3 == "boolean"
          ? c2.apply(this, arguments)
          : this.animate(Xa(b2, !0), a3, d2, e2);
      };
    }),
    n.each(
      {
        slideDown: Xa("show"),
        slideUp: Xa("hide"),
        slideToggle: Xa("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (a2, b2) {
        n.fn[a2] = function (a3, c2, d2) {
          return this.animate(b2, a3, c2, d2);
        };
      }
    ),
    (n.timers = []),
    (n.fx.tick = function () {
      var a2,
        b2 = 0,
        c2 = n.timers;
      for (Sa = n.now(); b2 < c2.length; b2++)
        (a2 = c2[b2]), a2() || c2[b2] !== a2 || c2.splice(b2--, 1);
      c2.length || n.fx.stop(), (Sa = void 0);
    }),
    (n.fx.timer = function (a2) {
      n.timers.push(a2), a2() ? n.fx.start() : n.timers.pop();
    }),
    (n.fx.interval = 13),
    (n.fx.start = function () {
      Ta || (Ta = a.setInterval(n.fx.tick, n.fx.interval));
    }),
    (n.fx.stop = function () {
      a.clearInterval(Ta), (Ta = null);
    }),
    (n.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (n.fn.delay = function (b2, c2) {
      return (
        (b2 = (n.fx && n.fx.speeds[b2]) || b2),
        (c2 = c2 || "fx"),
        this.queue(c2, function (c3, d2) {
          var e2 = a.setTimeout(c3, b2);
          d2.stop = function () {
            a.clearTimeout(e2);
          };
        })
      );
    }),
    (function () {
      var a2 = d.createElement("input"),
        b2 = d.createElement("select"),
        c2 = b2.appendChild(d.createElement("option"));
      (a2.type = "checkbox"),
        (l.checkOn = a2.value !== ""),
        (l.optSelected = c2.selected),
        (b2.disabled = !0),
        (l.optDisabled = !c2.disabled),
        (a2 = d.createElement("input")),
        (a2.value = "t"),
        (a2.type = "radio"),
        (l.radioValue = a2.value === "t");
    })();
  var ab,
    bb = n.expr.attrHandle;
  n.fn.extend({
    attr: function (a2, b2) {
      return K(this, n.attr, a2, b2, arguments.length > 1);
    },
    removeAttr: function (a2) {
      return this.each(function () {
        n.removeAttr(this, a2);
      });
    },
  }),
    n.extend({
      attr: function (a2, b2, c2) {
        var d2,
          e2,
          f2 = a2.nodeType;
        if (f2 !== 3 && f2 !== 8 && f2 !== 2)
          return typeof a2.getAttribute > "u"
            ? n.prop(a2, b2, c2)
            : ((f2 === 1 && n.isXMLDoc(a2)) ||
                ((b2 = b2.toLowerCase()),
                (e2 =
                  n.attrHooks[b2] ||
                  (n.expr.match.bool.test(b2) ? ab : void 0))),
              c2 !== void 0
                ? c2 === null
                  ? void n.removeAttr(a2, b2)
                  : e2 && "set" in e2 && (d2 = e2.set(a2, c2, b2)) !== void 0
                  ? d2
                  : (a2.setAttribute(b2, c2 + ""), c2)
                : e2 && "get" in e2 && (d2 = e2.get(a2, b2)) !== null
                ? d2
                : ((d2 = n.find.attr(a2, b2)), d2 ?? void 0));
      },
      attrHooks: {
        type: {
          set: function (a2, b2) {
            if (!l.radioValue && b2 === "radio" && n.nodeName(a2, "input")) {
              var c2 = a2.value;
              return a2.setAttribute("type", b2), c2 && (a2.value = c2), b2;
            }
          },
        },
      },
      removeAttr: function (a2, b2) {
        var c2,
          d2,
          e2 = 0,
          f2 = b2 && b2.match(G);
        if (f2 && a2.nodeType === 1)
          for (; (c2 = f2[e2++]); )
            (d2 = n.propFix[c2] || c2),
              n.expr.match.bool.test(c2) && (a2[d2] = !1),
              a2.removeAttribute(c2);
      },
    }),
    (ab = {
      set: function (a2, b2, c2) {
        return b2 === !1 ? n.removeAttr(a2, c2) : a2.setAttribute(c2, c2), c2;
      },
    }),
    n.each(n.expr.match.bool.source.match(/\w+/g), function (a2, b2) {
      var c2 = bb[b2] || n.find.attr;
      bb[b2] = function (a3, b3, d2) {
        var e2, f2;
        return (
          d2 ||
            ((f2 = bb[b3]),
            (bb[b3] = e2),
            (e2 = c2(a3, b3, d2) != null ? b3.toLowerCase() : null),
            (bb[b3] = f2)),
          e2
        );
      };
    });
  var cb = /^(?:input|select|textarea|button)$/i,
    db = /^(?:a|area)$/i;
  n.fn.extend({
    prop: function (a2, b2) {
      return K(this, n.prop, a2, b2, arguments.length > 1);
    },
    removeProp: function (a2) {
      return this.each(function () {
        delete this[n.propFix[a2] || a2];
      });
    },
  }),
    n.extend({
      prop: function (a2, b2, c2) {
        var d2,
          e2,
          f2 = a2.nodeType;
        if (f2 !== 3 && f2 !== 8 && f2 !== 2)
          return (
            (f2 === 1 && n.isXMLDoc(a2)) ||
              ((b2 = n.propFix[b2] || b2), (e2 = n.propHooks[b2])),
            c2 !== void 0
              ? e2 && "set" in e2 && (d2 = e2.set(a2, c2, b2)) !== void 0
                ? d2
                : (a2[b2] = c2)
              : e2 && "get" in e2 && (d2 = e2.get(a2, b2)) !== null
              ? d2
              : a2[b2]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (a2) {
            var b2 = n.find.attr(a2, "tabindex");
            return b2
              ? parseInt(b2, 10)
              : cb.test(a2.nodeName) || (db.test(a2.nodeName) && a2.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    l.optSelected ||
      (n.propHooks.selected = {
        get: function (a2) {
          var b2 = a2.parentNode;
          return b2 && b2.parentNode && b2.parentNode.selectedIndex, null;
        },
        set: function (a2) {
          var b2 = a2.parentNode;
          b2 &&
            (b2.selectedIndex, b2.parentNode && b2.parentNode.selectedIndex);
        },
      }),
    n.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        n.propFix[this.toLowerCase()] = this;
      }
    );
  var eb = /[\t\r\n\f]/g;
  function fb(a2) {
    return (a2.getAttribute && a2.getAttribute("class")) || "";
  }
  n.fn.extend({
    addClass: function (a2) {
      var b2,
        c2,
        d2,
        e2,
        f2,
        g2,
        h2,
        i3 = 0;
      if (n.isFunction(a2))
        return this.each(function (b3) {
          n(this).addClass(a2.call(this, b3, fb(this)));
        });
      if (typeof a2 == "string" && a2) {
        for (b2 = a2.match(G) || []; (c2 = this[i3++]); )
          if (
            ((e2 = fb(c2)),
            (d2 = c2.nodeType === 1 && (" " + e2 + " ").replace(eb, " ")))
          ) {
            for (g2 = 0; (f2 = b2[g2++]); )
              d2.indexOf(" " + f2 + " ") < 0 && (d2 += f2 + " ");
            (h2 = n.trim(d2)), e2 !== h2 && c2.setAttribute("class", h2);
          }
      }
      return this;
    },
    removeClass: function (a2) {
      var b2,
        c2,
        d2,
        e2,
        f2,
        g2,
        h2,
        i3 = 0;
      if (n.isFunction(a2))
        return this.each(function (b3) {
          n(this).removeClass(a2.call(this, b3, fb(this)));
        });
      if (!arguments.length) return this.attr("class", "");
      if (typeof a2 == "string" && a2) {
        for (b2 = a2.match(G) || []; (c2 = this[i3++]); )
          if (
            ((e2 = fb(c2)),
            (d2 = c2.nodeType === 1 && (" " + e2 + " ").replace(eb, " ")))
          ) {
            for (g2 = 0; (f2 = b2[g2++]); )
              for (; d2.indexOf(" " + f2 + " ") > -1; )
                d2 = d2.replace(" " + f2 + " ", " ");
            (h2 = n.trim(d2)), e2 !== h2 && c2.setAttribute("class", h2);
          }
      }
      return this;
    },
    toggleClass: function (a2, b2) {
      var c2 = typeof a2;
      return typeof b2 == "boolean" && c2 === "string"
        ? b2
          ? this.addClass(a2)
          : this.removeClass(a2)
        : n.isFunction(a2)
        ? this.each(function (c3) {
            n(this).toggleClass(a2.call(this, c3, fb(this), b2), b2);
          })
        : this.each(function () {
            var b3, d2, e2, f2;
            if (c2 === "string")
              for (
                d2 = 0, e2 = n(this), f2 = a2.match(G) || [];
                (b3 = f2[d2++]);

              )
                e2.hasClass(b3) ? e2.removeClass(b3) : e2.addClass(b3);
            else
              (a2 !== void 0 && c2 !== "boolean") ||
                ((b3 = fb(this)),
                b3 && N.set(this, "__className__", b3),
                this.setAttribute &&
                  this.setAttribute(
                    "class",
                    b3 || a2 === !1 ? "" : N.get(this, "__className__") || ""
                  ));
          });
    },
    hasClass: function (a2) {
      var b2,
        c2,
        d2 = 0;
      for (b2 = " " + a2 + " "; (c2 = this[d2++]); )
        if (
          c2.nodeType === 1 &&
          (" " + fb(c2) + " ").replace(eb, " ").indexOf(b2) > -1
        )
          return !0;
      return !1;
    },
  });
  var gb = /\r/g,
    hb = /[\x20\t\r\n\f]+/g;
  n.fn.extend({
    val: function (a2) {
      var b2,
        c2,
        d2,
        e2 = this[0];
      {
        if (arguments.length)
          return (
            (d2 = n.isFunction(a2)),
            this.each(function (c3) {
              var e3;
              this.nodeType === 1 &&
                ((e3 = d2 ? a2.call(this, c3, n(this).val()) : a2),
                e3 == null
                  ? (e3 = "")
                  : typeof e3 == "number"
                  ? (e3 += "")
                  : n.isArray(e3) &&
                    (e3 = n.map(e3, function (a3) {
                      return a3 == null ? "" : a3 + "";
                    })),
                (b2 =
                  n.valHooks[this.type] ||
                  n.valHooks[this.nodeName.toLowerCase()]),
                (b2 && "set" in b2 && b2.set(this, e3, "value") !== void 0) ||
                  (this.value = e3));
            })
          );
        if (e2)
          return (
            (b2 = n.valHooks[e2.type] || n.valHooks[e2.nodeName.toLowerCase()]),
            b2 && "get" in b2 && (c2 = b2.get(e2, "value")) !== void 0
              ? c2
              : ((c2 = e2.value),
                typeof c2 == "string" ? c2.replace(gb, "") : c2 ?? "")
          );
      }
    },
  }),
    n.extend({
      valHooks: {
        option: {
          get: function (a2) {
            var b2 = n.find.attr(a2, "value");
            return b2 ?? n.trim(n.text(a2)).replace(hb, " ");
          },
        },
        select: {
          get: function (a2) {
            for (
              var b2,
                c2,
                d2 = a2.options,
                e2 = a2.selectedIndex,
                f2 = a2.type === "select-one" || 0 > e2,
                g2 = f2 ? null : [],
                h2 = f2 ? e2 + 1 : d2.length,
                i3 = 0 > e2 ? h2 : f2 ? e2 : 0;
              h2 > i3;
              i3++
            )
              if (
                ((c2 = d2[i3]),
                (c2.selected || i3 === e2) &&
                  (l.optDisabled
                    ? !c2.disabled
                    : c2.getAttribute("disabled") === null) &&
                  (!c2.parentNode.disabled ||
                    !n.nodeName(c2.parentNode, "optgroup")))
              ) {
                if (((b2 = n(c2).val()), f2)) return b2;
                g2.push(b2);
              }
            return g2;
          },
          set: function (a2, b2) {
            for (
              var c2, d2, e2 = a2.options, f2 = n.makeArray(b2), g2 = e2.length;
              g2--;

            )
              (d2 = e2[g2]),
                (d2.selected = n.inArray(n.valHooks.option.get(d2), f2) > -1) &&
                  (c2 = !0);
            return c2 || (a2.selectedIndex = -1), f2;
          },
        },
      },
    }),
    n.each(["radio", "checkbox"], function () {
      (n.valHooks[this] = {
        set: function (a2, b2) {
          return n.isArray(b2)
            ? (a2.checked = n.inArray(n(a2).val(), b2) > -1)
            : void 0;
        },
      }),
        l.checkOn ||
          (n.valHooks[this].get = function (a2) {
            return a2.getAttribute("value") === null ? "on" : a2.value;
          });
    });
  var ib = /^(?:focusinfocus|focusoutblur)$/;
  n.extend(n.event, {
    trigger: function (b2, c2, e2, f2) {
      var g2,
        h2,
        i3,
        j2,
        l2,
        m2,
        o2,
        p2 = [e2 || d],
        q2 = k.call(b2, "type") ? b2.type : b2,
        r2 = k.call(b2, "namespace") ? b2.namespace.split(".") : [];
      if (
        ((h2 = i3 = e2 = e2 || d),
        e2.nodeType !== 3 &&
          e2.nodeType !== 8 &&
          !ib.test(q2 + n.event.triggered) &&
          (q2.indexOf(".") > -1 &&
            ((r2 = q2.split(".")), (q2 = r2.shift()), r2.sort()),
          (l2 = q2.indexOf(":") < 0 && "on" + q2),
          (b2 = b2[n.expando]
            ? b2
            : new n.Event(q2, typeof b2 == "object" && b2)),
          (b2.isTrigger = f2 ? 2 : 3),
          (b2.namespace = r2.join(".")),
          (b2.rnamespace = b2.namespace
            ? new RegExp("(^|\\.)" + r2.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (b2.result = void 0),
          b2.target || (b2.target = e2),
          (c2 = c2 == null ? [b2] : n.makeArray(c2, [b2])),
          (o2 = n.event.special[q2] || {}),
          f2 || !o2.trigger || o2.trigger.apply(e2, c2) !== !1))
      ) {
        if (!f2 && !o2.noBubble && !n.isWindow(e2)) {
          for (
            j2 = o2.delegateType || q2,
              ib.test(j2 + q2) || (h2 = h2.parentNode);
            h2;
            h2 = h2.parentNode
          )
            p2.push(h2), (i3 = h2);
          i3 === (e2.ownerDocument || d) &&
            p2.push(i3.defaultView || i3.parentWindow || a);
        }
        for (g2 = 0; (h2 = p2[g2++]) && !b2.isPropagationStopped(); )
          (b2.type = g2 > 1 ? j2 : o2.bindType || q2),
            (m2 = (N.get(h2, "events") || {})[b2.type] && N.get(h2, "handle")),
            m2 && m2.apply(h2, c2),
            (m2 = l2 && h2[l2]),
            m2 &&
              m2.apply &&
              L(h2) &&
              ((b2.result = m2.apply(h2, c2)),
              b2.result === !1 && b2.preventDefault());
        return (
          (b2.type = q2),
          f2 ||
            b2.isDefaultPrevented() ||
            (o2._default && o2._default.apply(p2.pop(), c2) !== !1) ||
            !L(e2) ||
            (l2 &&
              n.isFunction(e2[q2]) &&
              !n.isWindow(e2) &&
              ((i3 = e2[l2]),
              i3 && (e2[l2] = null),
              (n.event.triggered = q2),
              e2[q2](),
              (n.event.triggered = void 0),
              i3 && (e2[l2] = i3))),
          b2.result
        );
      }
    },
    simulate: function (a2, b2, c2) {
      var d2 = n.extend(new n.Event(), c2, { type: a2, isSimulated: !0 });
      n.event.trigger(d2, null, b2);
    },
  }),
    n.fn.extend({
      trigger: function (a2, b2) {
        return this.each(function () {
          n.event.trigger(a2, b2, this);
        });
      },
      triggerHandler: function (a2, b2) {
        var c2 = this[0];
        return c2 ? n.event.trigger(a2, b2, c2, !0) : void 0;
      },
    }),
    n.each(
      "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
        " "
      ),
      function (a2, b2) {
        n.fn[b2] = function (a3, c2) {
          return arguments.length > 0
            ? this.on(b2, null, a3, c2)
            : this.trigger(b2);
        };
      }
    ),
    n.fn.extend({
      hover: function (a2, b2) {
        return this.mouseenter(a2).mouseleave(b2 || a2);
      },
    }),
    (l.focusin = "onfocusin" in a),
    l.focusin ||
      n.each({ focus: "focusin", blur: "focusout" }, function (a2, b2) {
        var c2 = function (a3) {
          n.event.simulate(b2, a3.target, n.event.fix(a3));
        };
        n.event.special[b2] = {
          setup: function () {
            var d2 = this.ownerDocument || this,
              e2 = N.access(d2, b2);
            e2 || d2.addEventListener(a2, c2, !0),
              N.access(d2, b2, (e2 || 0) + 1);
          },
          teardown: function () {
            var d2 = this.ownerDocument || this,
              e2 = N.access(d2, b2) - 1;
            e2
              ? N.access(d2, b2, e2)
              : (d2.removeEventListener(a2, c2, !0), N.remove(d2, b2));
          },
        };
      });
  var jb = a.location,
    kb = n.now(),
    lb = /\?/;
  (n.parseJSON = function (a2) {
    return JSON.parse(a2 + "");
  }),
    (n.parseXML = function (b2) {
      var c2;
      if (!b2 || typeof b2 != "string") return null;
      try {
        c2 = new a.DOMParser().parseFromString(b2, "text/xml");
      } catch {
        c2 = void 0;
      }
      return (
        (c2 && !c2.getElementsByTagName("parsererror").length) ||
          n.error("Invalid XML: " + b2),
        c2
      );
    });
  var mb = /#.*$/,
    nb = /([?&])_=[^&]*/,
    ob = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    pb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    qb = /^(?:GET|HEAD)$/,
    rb = /^\/\//,
    sb = {},
    tb = {},
    ub = "*/".concat("*"),
    vb = d.createElement("a");
  vb.href = jb.href;
  function wb(a2) {
    return function (b2, c2) {
      typeof b2 != "string" && ((c2 = b2), (b2 = "*"));
      var d2,
        e2 = 0,
        f2 = b2.toLowerCase().match(G) || [];
      if (n.isFunction(c2))
        for (; (d2 = f2[e2++]); )
          d2[0] === "+"
            ? ((d2 = d2.slice(1) || "*"), (a2[d2] = a2[d2] || []).unshift(c2))
            : (a2[d2] = a2[d2] || []).push(c2);
    };
  }
  function xb(a2, b2, c2, d2) {
    var e2 = {},
      f2 = a2 === tb;
    function g2(h2) {
      var i3;
      return (
        (e2[h2] = !0),
        n.each(a2[h2] || [], function (a3, h3) {
          var j2 = h3(b2, c2, d2);
          return typeof j2 != "string" || f2 || e2[j2]
            ? f2
              ? !(i3 = j2)
              : void 0
            : (b2.dataTypes.unshift(j2), g2(j2), !1);
        }),
        i3
      );
    }
    return g2(b2.dataTypes[0]) || (!e2["*"] && g2("*"));
  }
  function yb(a2, b2) {
    var c2,
      d2,
      e2 = n.ajaxSettings.flatOptions || {};
    for (c2 in b2)
      b2[c2] !== void 0 && ((e2[c2] ? a2 : d2 || (d2 = {}))[c2] = b2[c2]);
    return d2 && n.extend(!0, a2, d2), a2;
  }
  function zb(a2, b2, c2) {
    for (
      var d2, e2, f2, g2, h2 = a2.contents, i3 = a2.dataTypes;
      i3[0] === "*";

    )
      i3.shift(),
        d2 === void 0 &&
          (d2 = a2.mimeType || b2.getResponseHeader("Content-Type"));
    if (d2) {
      for (e2 in h2)
        if (h2[e2] && h2[e2].test(d2)) {
          i3.unshift(e2);
          break;
        }
    }
    if (i3[0] in c2) f2 = i3[0];
    else {
      for (e2 in c2) {
        if (!i3[0] || a2.converters[e2 + " " + i3[0]]) {
          f2 = e2;
          break;
        }
        g2 || (g2 = e2);
      }
      f2 = f2 || g2;
    }
    return f2 ? (f2 !== i3[0] && i3.unshift(f2), c2[f2]) : void 0;
  }
  function Ab(a2, b2, c2, d2) {
    var e2,
      f2,
      g2,
      h2,
      i3,
      j2 = {},
      k2 = a2.dataTypes.slice();
    if (k2[1])
      for (g2 in a2.converters) j2[g2.toLowerCase()] = a2.converters[g2];
    for (f2 = k2.shift(); f2; )
      if (
        (a2.responseFields[f2] && (c2[a2.responseFields[f2]] = b2),
        !i3 && d2 && a2.dataFilter && (b2 = a2.dataFilter(b2, a2.dataType)),
        (i3 = f2),
        (f2 = k2.shift()))
      ) {
        if (f2 === "*") f2 = i3;
        else if (i3 !== "*" && i3 !== f2) {
          if (((g2 = j2[i3 + " " + f2] || j2["* " + f2]), !g2)) {
            for (e2 in j2)
              if (
                ((h2 = e2.split(" ")),
                h2[1] === f2 && (g2 = j2[i3 + " " + h2[0]] || j2["* " + h2[0]]))
              ) {
                g2 === !0
                  ? (g2 = j2[e2])
                  : j2[e2] !== !0 && ((f2 = h2[0]), k2.unshift(h2[1]));
                break;
              }
          }
          if (g2 !== !0)
            if (g2 && a2.throws) b2 = g2(b2);
            else
              try {
                b2 = g2(b2);
              } catch (l2) {
                return {
                  state: "parsererror",
                  error: g2 ? l2 : "No conversion from " + i3 + " to " + f2,
                };
              }
        }
      }
    return { state: "success", data: b2 };
  }
  n.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: jb.href,
      type: "GET",
      isLocal: pb.test(jb.protocol),
      global: !0,
      processData: !0,
      async: !0,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": ub,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript",
      },
      contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON",
      },
      converters: {
        "* text": String,
        "text html": !0,
        "text json": n.parseJSON,
        "text xml": n.parseXML,
      },
      flatOptions: { url: !0, context: !0 },
    },
    ajaxSetup: function (a2, b2) {
      return b2 ? yb(yb(a2, n.ajaxSettings), b2) : yb(n.ajaxSettings, a2);
    },
    ajaxPrefilter: wb(sb),
    ajaxTransport: wb(tb),
    ajax: function (b2, c2) {
      typeof b2 == "object" && ((c2 = b2), (b2 = void 0)), (c2 = c2 || {});
      var e2,
        f2,
        g2,
        h2,
        i3,
        j2,
        k2,
        l2,
        m2 = n.ajaxSetup({}, c2),
        o2 = m2.context || m2,
        p2 = m2.context && (o2.nodeType || o2.jquery) ? n(o2) : n.event,
        q2 = n.Deferred(),
        r2 = n.Callbacks("once memory"),
        s2 = m2.statusCode || {},
        t2 = {},
        u2 = {},
        v2 = 0,
        w2 = "canceled",
        x2 = {
          readyState: 0,
          getResponseHeader: function (a2) {
            var b3;
            if (v2 === 2) {
              if (!h2)
                for (h2 = {}; (b3 = ob.exec(g2)); )
                  h2[b3[1].toLowerCase()] = b3[2];
              b3 = h2[a2.toLowerCase()];
            }
            return b3 ?? null;
          },
          getAllResponseHeaders: function () {
            return v2 === 2 ? g2 : null;
          },
          setRequestHeader: function (a2, b3) {
            var c3 = a2.toLowerCase();
            return v2 || ((a2 = u2[c3] = u2[c3] || a2), (t2[a2] = b3)), this;
          },
          overrideMimeType: function (a2) {
            return v2 || (m2.mimeType = a2), this;
          },
          statusCode: function (a2) {
            var b3;
            if (a2)
              if (2 > v2) for (b3 in a2) s2[b3] = [s2[b3], a2[b3]];
              else x2.always(a2[x2.status]);
            return this;
          },
          abort: function (a2) {
            var b3 = a2 || w2;
            return e2 && e2.abort(b3), z2(0, b3), this;
          },
        };
      if (
        ((q2.promise(x2).complete = r2.add),
        (x2.success = x2.done),
        (x2.error = x2.fail),
        (m2.url = ((b2 || m2.url || jb.href) + "")
          .replace(mb, "")
          .replace(rb, jb.protocol + "//")),
        (m2.type = c2.method || c2.type || m2.method || m2.type),
        (m2.dataTypes = n
          .trim(m2.dataType || "*")
          .toLowerCase()
          .match(G) || [""]),
        m2.crossDomain == null)
      ) {
        j2 = d.createElement("a");
        try {
          (j2.href = m2.url),
            (j2.href = j2.href),
            (m2.crossDomain =
              vb.protocol + "//" + vb.host != j2.protocol + "//" + j2.host);
        } catch {
          m2.crossDomain = !0;
        }
      }
      if (
        (m2.data &&
          m2.processData &&
          typeof m2.data != "string" &&
          (m2.data = n.param(m2.data, m2.traditional)),
        xb(sb, m2, c2, x2),
        v2 === 2)
      )
        return x2;
      (k2 = n.event && m2.global),
        k2 && n.active++ === 0 && n.event.trigger("ajaxStart"),
        (m2.type = m2.type.toUpperCase()),
        (m2.hasContent = !qb.test(m2.type)),
        (f2 = m2.url),
        m2.hasContent ||
          (m2.data &&
            ((f2 = m2.url += (lb.test(f2) ? "&" : "?") + m2.data),
            delete m2.data),
          m2.cache === !1 &&
            (m2.url = nb.test(f2)
              ? f2.replace(nb, "$1_=" + kb++)
              : f2 + (lb.test(f2) ? "&" : "?") + "_=" + kb++)),
        m2.ifModified &&
          (n.lastModified[f2] &&
            x2.setRequestHeader("If-Modified-Since", n.lastModified[f2]),
          n.etag[f2] && x2.setRequestHeader("If-None-Match", n.etag[f2])),
        ((m2.data && m2.hasContent && m2.contentType !== !1) ||
          c2.contentType) &&
          x2.setRequestHeader("Content-Type", m2.contentType),
        x2.setRequestHeader(
          "Accept",
          m2.dataTypes[0] && m2.accepts[m2.dataTypes[0]]
            ? m2.accepts[m2.dataTypes[0]] +
                (m2.dataTypes[0] !== "*" ? ", " + ub + "; q=0.01" : "")
            : m2.accepts["*"]
        );
      for (l2 in m2.headers) x2.setRequestHeader(l2, m2.headers[l2]);
      if (m2.beforeSend && (m2.beforeSend.call(o2, x2, m2) === !1 || v2 === 2))
        return x2.abort();
      w2 = "abort";
      for (l2 in { success: 1, error: 1, complete: 1 }) x2[l2](m2[l2]);
      if ((e2 = xb(tb, m2, c2, x2))) {
        if (
          ((x2.readyState = 1),
          k2 && p2.trigger("ajaxSend", [x2, m2]),
          v2 === 2)
        )
          return x2;
        m2.async &&
          m2.timeout > 0 &&
          (i3 = a.setTimeout(function () {
            x2.abort("timeout");
          }, m2.timeout));
        try {
          (v2 = 1), e2.send(t2, z2);
        } catch (y2) {
          if (!(2 > v2)) throw y2;
          z2(-1, y2);
        }
      } else z2(-1, "No Transport");
      function z2(b3, c3, d2, h3) {
        var j3,
          l3,
          t3,
          u3,
          w3,
          y2 = c3;
        v2 !== 2 &&
          ((v2 = 2),
          i3 && a.clearTimeout(i3),
          (e2 = void 0),
          (g2 = h3 || ""),
          (x2.readyState = b3 > 0 ? 4 : 0),
          (j3 = (b3 >= 200 && 300 > b3) || b3 === 304),
          d2 && (u3 = zb(m2, x2, d2)),
          (u3 = Ab(m2, u3, x2, j3)),
          j3
            ? (m2.ifModified &&
                ((w3 = x2.getResponseHeader("Last-Modified")),
                w3 && (n.lastModified[f2] = w3),
                (w3 = x2.getResponseHeader("etag")),
                w3 && (n.etag[f2] = w3)),
              b3 === 204 || m2.type === "HEAD"
                ? (y2 = "nocontent")
                : b3 === 304
                ? (y2 = "notmodified")
                : ((y2 = u3.state),
                  (l3 = u3.data),
                  (t3 = u3.error),
                  (j3 = !t3)))
            : ((t3 = y2), (!b3 && y2) || ((y2 = "error"), 0 > b3 && (b3 = 0))),
          (x2.status = b3),
          (x2.statusText = (c3 || y2) + ""),
          j3
            ? q2.resolveWith(o2, [l3, y2, x2])
            : q2.rejectWith(o2, [x2, y2, t3]),
          x2.statusCode(s2),
          (s2 = void 0),
          k2 &&
            p2.trigger(j3 ? "ajaxSuccess" : "ajaxError", [
              x2,
              m2,
              j3 ? l3 : t3,
            ]),
          r2.fireWith(o2, [x2, y2]),
          k2 &&
            (p2.trigger("ajaxComplete", [x2, m2]),
            --n.active || n.event.trigger("ajaxStop")));
      }
      return x2;
    },
    getJSON: function (a2, b2, c2) {
      return n.get(a2, b2, c2, "json");
    },
    getScript: function (a2, b2) {
      return n.get(a2, void 0, b2, "script");
    },
  }),
    n.each(["get", "post"], function (a2, b2) {
      n[b2] = function (a3, c2, d2, e2) {
        return (
          n.isFunction(c2) && ((e2 = e2 || d2), (d2 = c2), (c2 = void 0)),
          n.ajax(
            n.extend(
              { url: a3, type: b2, dataType: e2, data: c2, success: d2 },
              n.isPlainObject(a3) && a3
            )
          )
        );
      };
    }),
    (n._evalUrl = function (a2) {
      return n.ajax({
        url: a2,
        type: "GET",
        dataType: "script",
        async: !1,
        global: !1,
        throws: !0,
      });
    }),
    n.fn.extend({
      wrapAll: function (a2) {
        var b2;
        return n.isFunction(a2)
          ? this.each(function (b3) {
              n(this).wrapAll(a2.call(this, b3));
            })
          : (this[0] &&
              ((b2 = n(a2, this[0].ownerDocument).eq(0).clone(!0)),
              this[0].parentNode && b2.insertBefore(this[0]),
              b2
                .map(function () {
                  for (var a3 = this; a3.firstElementChild; )
                    a3 = a3.firstElementChild;
                  return a3;
                })
                .append(this)),
            this);
      },
      wrapInner: function (a2) {
        return n.isFunction(a2)
          ? this.each(function (b2) {
              n(this).wrapInner(a2.call(this, b2));
            })
          : this.each(function () {
              var b2 = n(this),
                c2 = b2.contents();
              c2.length ? c2.wrapAll(a2) : b2.append(a2);
            });
      },
      wrap: function (a2) {
        var b2 = n.isFunction(a2);
        return this.each(function (c2) {
          n(this).wrapAll(b2 ? a2.call(this, c2) : a2);
        });
      },
      unwrap: function () {
        return this.parent()
          .each(function () {
            n.nodeName(this, "body") || n(this).replaceWith(this.childNodes);
          })
          .end();
      },
    }),
    (n.expr.filters.hidden = function (a2) {
      return !n.expr.filters.visible(a2);
    }),
    (n.expr.filters.visible = function (a2) {
      return (
        a2.offsetWidth > 0 ||
        a2.offsetHeight > 0 ||
        a2.getClientRects().length > 0
      );
    });
  var Bb = /%20/g,
    Cb = /\[\]$/,
    Db = /\r?\n/g,
    Eb = /^(?:submit|button|image|reset|file)$/i,
    Fb = /^(?:input|select|textarea|keygen)/i;
  function Gb(a2, b2, c2, d2) {
    var e2;
    if (n.isArray(b2))
      n.each(b2, function (b3, e3) {
        c2 || Cb.test(a2)
          ? d2(a2, e3)
          : Gb(
              a2 + "[" + (typeof e3 == "object" && e3 != null ? b3 : "") + "]",
              e3,
              c2,
              d2
            );
      });
    else if (c2 || n.type(b2) !== "object") d2(a2, b2);
    else for (e2 in b2) Gb(a2 + "[" + e2 + "]", b2[e2], c2, d2);
  }
  (n.param = function (a2, b2) {
    var c2,
      d2 = [],
      e2 = function (a3, b3) {
        (b3 = n.isFunction(b3) ? b3() : b3 ?? ""),
          (d2[d2.length] =
            encodeURIComponent(a3) + "=" + encodeURIComponent(b3));
      };
    if (
      (b2 === void 0 && (b2 = n.ajaxSettings && n.ajaxSettings.traditional),
      n.isArray(a2) || (a2.jquery && !n.isPlainObject(a2)))
    )
      n.each(a2, function () {
        e2(this.name, this.value);
      });
    else for (c2 in a2) Gb(c2, a2[c2], b2, e2);
    return d2.join("&").replace(Bb, "+");
  }),
    n.fn.extend({
      serialize: function () {
        return n.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var a2 = n.prop(this, "elements");
          return a2 ? n.makeArray(a2) : this;
        })
          .filter(function () {
            var a2 = this.type;
            return (
              this.name &&
              !n(this).is(":disabled") &&
              Fb.test(this.nodeName) &&
              !Eb.test(a2) &&
              (this.checked || !X.test(a2))
            );
          })
          .map(function (a2, b2) {
            var c2 = n(this).val();
            return c2 == null
              ? null
              : n.isArray(c2)
              ? n.map(c2, function (a3) {
                  return {
                    name: b2.name,
                    value: a3.replace(
                      Db,
                      `\r
`
                    ),
                  };
                })
              : {
                  name: b2.name,
                  value: c2.replace(
                    Db,
                    `\r
`
                  ),
                };
          })
          .get();
      },
    }),
    (n.ajaxSettings.xhr = function () {
      try {
        return new a.XMLHttpRequest();
      } catch {}
    });
  var Hb = { 0: 200, 1223: 204 },
    Ib = n.ajaxSettings.xhr();
  (l.cors = !!Ib && "withCredentials" in Ib),
    (l.ajax = Ib = !!Ib),
    n.ajaxTransport(function (b2) {
      var c2, d2;
      return l.cors || (Ib && !b2.crossDomain)
        ? {
            send: function (e2, f2) {
              var g2,
                h2 = b2.xhr();
              if (
                (h2.open(b2.type, b2.url, b2.async, b2.username, b2.password),
                b2.xhrFields)
              )
                for (g2 in b2.xhrFields) h2[g2] = b2.xhrFields[g2];
              b2.mimeType &&
                h2.overrideMimeType &&
                h2.overrideMimeType(b2.mimeType),
                b2.crossDomain ||
                  e2["X-Requested-With"] ||
                  (e2["X-Requested-With"] = "XMLHttpRequest");
              for (g2 in e2) h2.setRequestHeader(g2, e2[g2]);
              (c2 = function (a2) {
                return function () {
                  c2 &&
                    ((c2 =
                      d2 =
                      h2.onload =
                      h2.onerror =
                      h2.onabort =
                      h2.onreadystatechange =
                        null),
                    a2 === "abort"
                      ? h2.abort()
                      : a2 === "error"
                      ? typeof h2.status != "number"
                        ? f2(0, "error")
                        : f2(h2.status, h2.statusText)
                      : f2(
                          Hb[h2.status] || h2.status,
                          h2.statusText,
                          (h2.responseType || "text") !== "text" ||
                            typeof h2.responseText != "string"
                            ? { binary: h2.response }
                            : { text: h2.responseText },
                          h2.getAllResponseHeaders()
                        ));
                };
              }),
                (h2.onload = c2()),
                (d2 = h2.onerror = c2("error")),
                h2.onabort !== void 0
                  ? (h2.onabort = d2)
                  : (h2.onreadystatechange = function () {
                      h2.readyState === 4 &&
                        a.setTimeout(function () {
                          c2 && d2();
                        });
                    }),
                (c2 = c2("abort"));
              try {
                h2.send((b2.hasContent && b2.data) || null);
              } catch (i3) {
                if (c2) throw i3;
              }
            },
            abort: function () {
              c2 && c2();
            },
          }
        : void 0;
    }),
    n.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function (a2) {
          return n.globalEval(a2), a2;
        },
      },
    }),
    n.ajaxPrefilter("script", function (a2) {
      a2.cache === void 0 && (a2.cache = !1),
        a2.crossDomain && (a2.type = "GET");
    }),
    n.ajaxTransport("script", function (a2) {
      if (a2.crossDomain) {
        var b2, c2;
        return {
          send: function (e2, f2) {
            (b2 = n("<script>")
              .prop({ charset: a2.scriptCharset, src: a2.url })
              .on(
                "load error",
                (c2 = function (a3) {
                  b2.remove(),
                    (c2 = null),
                    a3 && f2(a3.type === "error" ? 404 : 200, a3.type);
                })
              )),
              d.head.appendChild(b2[0]);
          },
          abort: function () {
            c2 && c2();
          },
        };
      }
    });
  var Jb = [],
    Kb = /(=)\?(?=&|$)|\?\?/;
  n.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var a2 = Jb.pop() || n.expando + "_" + kb++;
      return (this[a2] = !0), a2;
    },
  }),
    n.ajaxPrefilter("json jsonp", function (b2, c2, d2) {
      var e2,
        f2,
        g2,
        h2 =
          b2.jsonp !== !1 &&
          (Kb.test(b2.url)
            ? "url"
            : typeof b2.data == "string" &&
              (b2.contentType || "").indexOf(
                "application/x-www-form-urlencoded"
              ) === 0 &&
              Kb.test(b2.data) &&
              "data");
      return h2 || b2.dataTypes[0] === "jsonp"
        ? ((e2 = b2.jsonpCallback =
            n.isFunction(b2.jsonpCallback)
              ? b2.jsonpCallback()
              : b2.jsonpCallback),
          h2
            ? (b2[h2] = b2[h2].replace(Kb, "$1" + e2))
            : b2.jsonp !== !1 &&
              (b2.url += (lb.test(b2.url) ? "&" : "?") + b2.jsonp + "=" + e2),
          (b2.converters["script json"] = function () {
            return g2 || n.error(e2 + " was not called"), g2[0];
          }),
          (b2.dataTypes[0] = "json"),
          (f2 = a[e2]),
          (a[e2] = function () {
            g2 = arguments;
          }),
          d2.always(function () {
            f2 === void 0 ? n(a).removeProp(e2) : (a[e2] = f2),
              b2[e2] && ((b2.jsonpCallback = c2.jsonpCallback), Jb.push(e2)),
              g2 && n.isFunction(f2) && f2(g2[0]),
              (g2 = f2 = void 0);
          }),
          "script")
        : void 0;
    }),
    (n.parseHTML = function (a2, b2, c2) {
      if (!a2 || typeof a2 != "string") return null;
      typeof b2 == "boolean" && ((c2 = b2), (b2 = !1)), (b2 = b2 || d);
      var e2 = x.exec(a2),
        f2 = !c2 && [];
      return e2
        ? [b2.createElement(e2[1])]
        : ((e2 = ca([a2], b2, f2)),
          f2 && f2.length && n(f2).remove(),
          n.merge([], e2.childNodes));
    });
  var Lb = n.fn.load;
  (n.fn.load = function (a2, b2, c2) {
    if (typeof a2 != "string" && Lb) return Lb.apply(this, arguments);
    var d2,
      e2,
      f2,
      g2 = this,
      h2 = a2.indexOf(" ");
    return (
      h2 > -1 && ((d2 = n.trim(a2.slice(h2))), (a2 = a2.slice(0, h2))),
      n.isFunction(b2)
        ? ((c2 = b2), (b2 = void 0))
        : b2 && typeof b2 == "object" && (e2 = "POST"),
      g2.length > 0 &&
        n
          .ajax({ url: a2, type: e2 || "GET", dataType: "html", data: b2 })
          .done(function (a3) {
            (f2 = arguments),
              g2.html(d2 ? n("<div>").append(n.parseHTML(a3)).find(d2) : a3);
          })
          .always(
            c2 &&
              function (a3, b3) {
                g2.each(function () {
                  c2.apply(this, f2 || [a3.responseText, b3, a3]);
                });
              }
          ),
      this
    );
  }),
    n.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (a2, b2) {
        n.fn[b2] = function (a3) {
          return this.on(b2, a3);
        };
      }
    ),
    (n.expr.filters.animated = function (a2) {
      return n.grep(n.timers, function (b2) {
        return a2 === b2.elem;
      }).length;
    });
  function Mb(a2) {
    return n.isWindow(a2) ? a2 : a2.nodeType === 9 && a2.defaultView;
  }
  (n.offset = {
    setOffset: function (a2, b2, c2) {
      var d2,
        e2,
        f2,
        g2,
        h2,
        i3,
        j2,
        k2 = n.css(a2, "position"),
        l2 = n(a2),
        m2 = {};
      k2 === "static" && (a2.style.position = "relative"),
        (h2 = l2.offset()),
        (f2 = n.css(a2, "top")),
        (i3 = n.css(a2, "left")),
        (j2 =
          (k2 === "absolute" || k2 === "fixed") &&
          (f2 + i3).indexOf("auto") > -1),
        j2
          ? ((d2 = l2.position()), (g2 = d2.top), (e2 = d2.left))
          : ((g2 = parseFloat(f2) || 0), (e2 = parseFloat(i3) || 0)),
        n.isFunction(b2) && (b2 = b2.call(a2, c2, n.extend({}, h2))),
        b2.top != null && (m2.top = b2.top - h2.top + g2),
        b2.left != null && (m2.left = b2.left - h2.left + e2),
        "using" in b2 ? b2.using.call(a2, m2) : l2.css(m2);
    },
  }),
    n.fn.extend({
      offset: function (a2) {
        if (arguments.length)
          return a2 === void 0
            ? this
            : this.each(function (b3) {
                n.offset.setOffset(this, a2, b3);
              });
        var b2,
          c2,
          d2 = this[0],
          e2 = { top: 0, left: 0 },
          f2 = d2 && d2.ownerDocument;
        if (f2)
          return (
            (b2 = f2.documentElement),
            n.contains(b2, d2)
              ? ((e2 = d2.getBoundingClientRect()),
                (c2 = Mb(f2)),
                {
                  top: e2.top + c2.pageYOffset - b2.clientTop,
                  left: e2.left + c2.pageXOffset - b2.clientLeft,
                })
              : e2
          );
      },
      position: function () {
        if (this[0]) {
          var a2,
            b2,
            c2 = this[0],
            d2 = { top: 0, left: 0 };
          return (
            n.css(c2, "position") === "fixed"
              ? (b2 = c2.getBoundingClientRect())
              : ((a2 = this.offsetParent()),
                (b2 = this.offset()),
                n.nodeName(a2[0], "html") || (d2 = a2.offset()),
                (d2.top += n.css(a2[0], "borderTopWidth", !0)),
                (d2.left += n.css(a2[0], "borderLeftWidth", !0))),
            {
              top: b2.top - d2.top - n.css(c2, "marginTop", !0),
              left: b2.left - d2.left - n.css(c2, "marginLeft", !0),
            }
          );
        }
      },
      offsetParent: function () {
        return this.map(function () {
          for (
            var a2 = this.offsetParent;
            a2 && n.css(a2, "position") === "static";

          )
            a2 = a2.offsetParent;
          return a2 || Ea;
        });
      },
    }),
    n.each(
      { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
      function (a2, b2) {
        var c2 = b2 === "pageYOffset";
        n.fn[a2] = function (d2) {
          return K(
            this,
            function (a3, d3, e2) {
              var f2 = Mb(a3);
              return e2 === void 0
                ? f2
                  ? f2[b2]
                  : a3[d3]
                : void (f2
                    ? f2.scrollTo(
                        c2 ? f2.pageXOffset : e2,
                        c2 ? e2 : f2.pageYOffset
                      )
                    : (a3[d3] = e2));
            },
            a2,
            d2,
            arguments.length
          );
        };
      }
    ),
    n.each(["top", "left"], function (a2, b2) {
      n.cssHooks[b2] = Ga(l.pixelPosition, function (a3, c2) {
        return c2
          ? ((c2 = Fa(a3, b2)), Ba.test(c2) ? n(a3).position()[b2] + "px" : c2)
          : void 0;
      });
    }),
    n.each({ Height: "height", Width: "width" }, function (a2, b2) {
      n.each(
        { padding: "inner" + a2, content: b2, "": "outer" + a2 },
        function (c2, d2) {
          n.fn[d2] = function (d3, e2) {
            var f2 = arguments.length && (c2 || typeof d3 != "boolean"),
              g2 = c2 || (d3 === !0 || e2 === !0 ? "margin" : "border");
            return K(
              this,
              function (b3, c3, d4) {
                var e3;
                return n.isWindow(b3)
                  ? b3.document.documentElement["client" + a2]
                  : b3.nodeType === 9
                  ? ((e3 = b3.documentElement),
                    Math.max(
                      b3.body["scroll" + a2],
                      e3["scroll" + a2],
                      b3.body["offset" + a2],
                      e3["offset" + a2],
                      e3["client" + a2]
                    ))
                  : d4 === void 0
                  ? n.css(b3, c3, g2)
                  : n.style(b3, c3, d4, g2);
              },
              b2,
              f2 ? d3 : void 0,
              f2,
              null
            );
          };
        }
      );
    }),
    n.fn.extend({
      bind: function (a2, b2, c2) {
        return this.on(a2, null, b2, c2);
      },
      unbind: function (a2, b2) {
        return this.off(a2, null, b2);
      },
      delegate: function (a2, b2, c2, d2) {
        return this.on(b2, a2, c2, d2);
      },
      undelegate: function (a2, b2, c2) {
        return arguments.length === 1
          ? this.off(a2, "**")
          : this.off(b2, a2 || "**", c2);
      },
      size: function () {
        return this.length;
      },
    }),
    (n.fn.andSelf = n.fn.addBack),
    typeof define == "function" &&
      define.amd &&
      define("jquery", [], function () {
        return n;
      });
  var Nb = a.jQuery,
    Ob = a.$;
  return (
    (n.noConflict = function (b2) {
      return (
        a.$ === n && (a.$ = Ob), b2 && a.jQuery === n && (a.jQuery = Nb), n
      );
    }),
    b || (a.jQuery = a.$ = n),
    n
  );
}),
  (function (e, t) {
    typeof exports == "object" && typeof module < "u"
      ? (module.exports = t())
      : typeof define == "function" && define.amd
      ? define(t)
      : ((e = e || self).Swiper = t());
  })(this, function () {
    "use strict";
    var e =
        typeof document > "u"
          ? {
              body: {},
              addEventListener: function () {},
              removeEventListener: function () {},
              activeElement: { blur: function () {}, nodeName: "" },
              querySelector: function () {
                return null;
              },
              querySelectorAll: function () {
                return [];
              },
              getElementById: function () {
                return null;
              },
              createEvent: function () {
                return { initEvent: function () {} };
              },
              createElement: function () {
                return {
                  children: [],
                  childNodes: [],
                  style: {},
                  setAttribute: function () {},
                  getElementsByTagName: function () {
                    return [];
                  },
                };
              },
              location: { hash: "" },
            }
          : document,
      t =
        typeof window > "u"
          ? {
              document: e,
              navigator: { userAgent: "" },
              location: {},
              history: {},
              CustomEvent: function () {
                return this;
              },
              addEventListener: function () {},
              removeEventListener: function () {},
              getComputedStyle: function () {
                return {
                  getPropertyValue: function () {
                    return "";
                  },
                };
              },
              Image: function () {},
              Date: function () {},
              screen: {},
              setTimeout: function () {},
              clearTimeout: function () {},
            }
          : window,
      i2 = function (e2) {
        for (var t2 = 0; t2 < e2.length; t2 += 1) this[t2] = e2[t2];
        return (this.length = e2.length), this;
      };
    function s(s2, a2) {
      var r2 = [],
        n2 = 0;
      if (s2 && !a2 && s2 instanceof i2) return s2;
      if (s2) {
        if (typeof s2 == "string") {
          var o2,
            l2,
            d2 = s2.trim();
          if (d2.indexOf("<") >= 0 && d2.indexOf(">") >= 0) {
            var h2 = "div";
            for (
              d2.indexOf("<li") === 0 && (h2 = "ul"),
                d2.indexOf("<tr") === 0 && (h2 = "tbody"),
                (d2.indexOf("<td") !== 0 && d2.indexOf("<th") !== 0) ||
                  (h2 = "tr"),
                d2.indexOf("<tbody") === 0 && (h2 = "table"),
                d2.indexOf("<option") === 0 && (h2 = "select"),
                (l2 = e.createElement(h2)).innerHTML = d2,
                n2 = 0;
              n2 < l2.childNodes.length;
              n2 += 1
            )
              r2.push(l2.childNodes[n2]);
          } else
            for (
              o2 =
                a2 || s2[0] !== "#" || s2.match(/[ .<>:~]/)
                  ? (a2 || e).querySelectorAll(s2.trim())
                  : [e.getElementById(s2.trim().split("#")[1])],
                n2 = 0;
              n2 < o2.length;
              n2 += 1
            )
              o2[n2] && r2.push(o2[n2]);
        } else if (s2.nodeType || s2 === t || s2 === e) r2.push(s2);
        else if (s2.length > 0 && s2[0].nodeType)
          for (n2 = 0; n2 < s2.length; n2 += 1) r2.push(s2[n2]);
      }
      return new i2(r2);
    }
    function a(e2) {
      for (var t2 = [], i3 = 0; i3 < e2.length; i3 += 1)
        t2.indexOf(e2[i3]) === -1 && t2.push(e2[i3]);
      return t2;
    }
    (s.fn = i2.prototype), (s.Class = i2), (s.Dom7 = i2);
    var r = {
      addClass: function (e2) {
        if (e2 === void 0) return this;
        for (var t2 = e2.split(" "), i3 = 0; i3 < t2.length; i3 += 1)
          for (var s2 = 0; s2 < this.length; s2 += 1)
            this[s2] !== void 0 &&
              this[s2].classList !== void 0 &&
              this[s2].classList.add(t2[i3]);
        return this;
      },
      removeClass: function (e2) {
        for (var t2 = e2.split(" "), i3 = 0; i3 < t2.length; i3 += 1)
          for (var s2 = 0; s2 < this.length; s2 += 1)
            this[s2] !== void 0 &&
              this[s2].classList !== void 0 &&
              this[s2].classList.remove(t2[i3]);
        return this;
      },
      hasClass: function (e2) {
        return !!this[0] && this[0].classList.contains(e2);
      },
      toggleClass: function (e2) {
        for (var t2 = e2.split(" "), i3 = 0; i3 < t2.length; i3 += 1)
          for (var s2 = 0; s2 < this.length; s2 += 1)
            this[s2] !== void 0 &&
              this[s2].classList !== void 0 &&
              this[s2].classList.toggle(t2[i3]);
        return this;
      },
      attr: function (e2, t2) {
        var i3 = arguments;
        if (arguments.length === 1 && typeof e2 == "string")
          return this[0] ? this[0].getAttribute(e2) : void 0;
        for (var s2 = 0; s2 < this.length; s2 += 1)
          if (i3.length === 2) this[s2].setAttribute(e2, t2);
          else
            for (var a2 in e2)
              (this[s2][a2] = e2[a2]), this[s2].setAttribute(a2, e2[a2]);
        return this;
      },
      removeAttr: function (e2) {
        for (var t2 = 0; t2 < this.length; t2 += 1)
          this[t2].removeAttribute(e2);
        return this;
      },
      data: function (e2, t2) {
        var i3;
        if (t2 !== void 0) {
          for (var s2 = 0; s2 < this.length; s2 += 1)
            (i3 = this[s2]).dom7ElementDataStorage ||
              (i3.dom7ElementDataStorage = {}),
              (i3.dom7ElementDataStorage[e2] = t2);
          return this;
        }
        if ((i3 = this[0])) {
          if (i3.dom7ElementDataStorage && e2 in i3.dom7ElementDataStorage)
            return i3.dom7ElementDataStorage[e2];
          var a2 = i3.getAttribute("data-" + e2);
          return a2 || void 0;
        }
      },
      transform: function (e2) {
        for (var t2 = 0; t2 < this.length; t2 += 1) {
          var i3 = this[t2].style;
          (i3.webkitTransform = e2), (i3.transform = e2);
        }
        return this;
      },
      transition: function (e2) {
        typeof e2 != "string" && (e2 += "ms");
        for (var t2 = 0; t2 < this.length; t2 += 1) {
          var i3 = this[t2].style;
          (i3.webkitTransitionDuration = e2), (i3.transitionDuration = e2);
        }
        return this;
      },
      on: function () {
        for (var e2, t2 = [], i3 = arguments.length; i3--; )
          t2[i3] = arguments[i3];
        var a2 = t2[0],
          r2 = t2[1],
          n2 = t2[2],
          o2 = t2[3];
        function l2(e3) {
          var t3 = e3.target;
          if (t3) {
            var i4 = e3.target.dom7EventData || [];
            if ((i4.indexOf(e3) < 0 && i4.unshift(e3), s(t3).is(r2)))
              n2.apply(t3, i4);
            else
              for (var a3 = s(t3).parents(), o3 = 0; o3 < a3.length; o3 += 1)
                s(a3[o3]).is(r2) && n2.apply(a3[o3], i4);
          }
        }
        function d2(e3) {
          var t3 = (e3 && e3.target && e3.target.dom7EventData) || [];
          t3.indexOf(e3) < 0 && t3.unshift(e3), n2.apply(this, t3);
        }
        typeof t2[1] == "function" &&
          ((a2 = (e2 = t2)[0]), (n2 = e2[1]), (o2 = e2[2]), (r2 = void 0)),
          o2 || (o2 = !1);
        for (var h2, p2 = a2.split(" "), c2 = 0; c2 < this.length; c2 += 1) {
          var u2 = this[c2];
          if (r2)
            for (h2 = 0; h2 < p2.length; h2 += 1) {
              var v2 = p2[h2];
              u2.dom7LiveListeners || (u2.dom7LiveListeners = {}),
                u2.dom7LiveListeners[v2] || (u2.dom7LiveListeners[v2] = []),
                u2.dom7LiveListeners[v2].push({
                  listener: n2,
                  proxyListener: l2,
                }),
                u2.addEventListener(v2, l2, o2);
            }
          else
            for (h2 = 0; h2 < p2.length; h2 += 1) {
              var f2 = p2[h2];
              u2.dom7Listeners || (u2.dom7Listeners = {}),
                u2.dom7Listeners[f2] || (u2.dom7Listeners[f2] = []),
                u2.dom7Listeners[f2].push({ listener: n2, proxyListener: d2 }),
                u2.addEventListener(f2, d2, o2);
            }
        }
        return this;
      },
      off: function () {
        for (var e2, t2 = [], i3 = arguments.length; i3--; )
          t2[i3] = arguments[i3];
        var s2 = t2[0],
          a2 = t2[1],
          r2 = t2[2],
          n2 = t2[3];
        typeof t2[1] == "function" &&
          ((s2 = (e2 = t2)[0]), (r2 = e2[1]), (n2 = e2[2]), (a2 = void 0)),
          n2 || (n2 = !1);
        for (var o2 = s2.split(" "), l2 = 0; l2 < o2.length; l2 += 1)
          for (var d2 = o2[l2], h2 = 0; h2 < this.length; h2 += 1) {
            var p2 = this[h2],
              c2 = void 0;
            if (
              (!a2 && p2.dom7Listeners
                ? (c2 = p2.dom7Listeners[d2])
                : a2 && p2.dom7LiveListeners && (c2 = p2.dom7LiveListeners[d2]),
              c2 && c2.length)
            )
              for (var u2 = c2.length - 1; u2 >= 0; u2 -= 1) {
                var v2 = c2[u2];
                (r2 && v2.listener === r2) ||
                (r2 &&
                  v2.listener &&
                  v2.listener.dom7proxy &&
                  v2.listener.dom7proxy === r2)
                  ? (p2.removeEventListener(d2, v2.proxyListener, n2),
                    c2.splice(u2, 1))
                  : r2 ||
                    (p2.removeEventListener(d2, v2.proxyListener, n2),
                    c2.splice(u2, 1));
              }
          }
        return this;
      },
      trigger: function () {
        for (var i3 = [], s2 = arguments.length; s2--; ) i3[s2] = arguments[s2];
        for (
          var a2 = i3[0].split(" "), r2 = i3[1], n2 = 0;
          n2 < a2.length;
          n2 += 1
        )
          for (var o2 = a2[n2], l2 = 0; l2 < this.length; l2 += 1) {
            var d2 = this[l2],
              h2 = void 0;
            try {
              h2 = new t.CustomEvent(o2, {
                detail: r2,
                bubbles: !0,
                cancelable: !0,
              });
            } catch {
              (h2 = e.createEvent("Event")).initEvent(o2, !0, !0),
                (h2.detail = r2);
            }
            (d2.dom7EventData = i3.filter(function (e2, t2) {
              return t2 > 0;
            })),
              d2.dispatchEvent(h2),
              (d2.dom7EventData = []),
              delete d2.dom7EventData;
          }
        return this;
      },
      transitionEnd: function (e2) {
        var t2,
          i3 = ["webkitTransitionEnd", "transitionend"],
          s2 = this;
        function a2(r2) {
          if (r2.target === this)
            for (e2.call(this, r2), t2 = 0; t2 < i3.length; t2 += 1)
              s2.off(i3[t2], a2);
        }
        if (e2) for (t2 = 0; t2 < i3.length; t2 += 1) s2.on(i3[t2], a2);
        return this;
      },
      outerWidth: function (e2) {
        if (this.length > 0) {
          if (e2) {
            var t2 = this.styles();
            return (
              this[0].offsetWidth +
              parseFloat(t2.getPropertyValue("margin-right")) +
              parseFloat(t2.getPropertyValue("margin-left"))
            );
          }
          return this[0].offsetWidth;
        }
        return null;
      },
      outerHeight: function (e2) {
        if (this.length > 0) {
          if (e2) {
            var t2 = this.styles();
            return (
              this[0].offsetHeight +
              parseFloat(t2.getPropertyValue("margin-top")) +
              parseFloat(t2.getPropertyValue("margin-bottom"))
            );
          }
          return this[0].offsetHeight;
        }
        return null;
      },
      offset: function () {
        if (this.length > 0) {
          var i3 = this[0],
            s2 = i3.getBoundingClientRect(),
            a2 = e.body,
            r2 = i3.clientTop || a2.clientTop || 0,
            n2 = i3.clientLeft || a2.clientLeft || 0,
            o2 = i3 === t ? t.scrollY : i3.scrollTop,
            l2 = i3 === t ? t.scrollX : i3.scrollLeft;
          return { top: s2.top + o2 - r2, left: s2.left + l2 - n2 };
        }
        return null;
      },
      css: function (e2, i3) {
        var s2;
        if (arguments.length === 1) {
          if (typeof e2 != "string") {
            for (s2 = 0; s2 < this.length; s2 += 1)
              for (var a2 in e2) this[s2].style[a2] = e2[a2];
            return this;
          }
          if (this[0])
            return t.getComputedStyle(this[0], null).getPropertyValue(e2);
        }
        if (arguments.length === 2 && typeof e2 == "string") {
          for (s2 = 0; s2 < this.length; s2 += 1) this[s2].style[e2] = i3;
          return this;
        }
        return this;
      },
      each: function (e2) {
        if (!e2) return this;
        for (var t2 = 0; t2 < this.length; t2 += 1)
          if (e2.call(this[t2], t2, this[t2]) === !1) return this;
        return this;
      },
      html: function (e2) {
        if (e2 === void 0) return this[0] ? this[0].innerHTML : void 0;
        for (var t2 = 0; t2 < this.length; t2 += 1) this[t2].innerHTML = e2;
        return this;
      },
      text: function (e2) {
        if (e2 === void 0) return this[0] ? this[0].textContent.trim() : null;
        for (var t2 = 0; t2 < this.length; t2 += 1) this[t2].textContent = e2;
        return this;
      },
      is: function (a2) {
        var r2,
          n2,
          o2 = this[0];
        if (!o2 || a2 === void 0) return !1;
        if (typeof a2 == "string") {
          if (o2.matches) return o2.matches(a2);
          if (o2.webkitMatchesSelector) return o2.webkitMatchesSelector(a2);
          if (o2.msMatchesSelector) return o2.msMatchesSelector(a2);
          for (r2 = s(a2), n2 = 0; n2 < r2.length; n2 += 1)
            if (r2[n2] === o2) return !0;
          return !1;
        }
        if (a2 === e) return o2 === e;
        if (a2 === t) return o2 === t;
        if (a2.nodeType || a2 instanceof i2) {
          for (r2 = a2.nodeType ? [a2] : a2, n2 = 0; n2 < r2.length; n2 += 1)
            if (r2[n2] === o2) return !0;
          return !1;
        }
        return !1;
      },
      index: function () {
        var e2,
          t2 = this[0];
        if (t2) {
          for (e2 = 0; (t2 = t2.previousSibling) !== null; )
            t2.nodeType === 1 && (e2 += 1);
          return e2;
        }
      },
      eq: function (e2) {
        if (e2 === void 0) return this;
        var t2,
          s2 = this.length;
        return new i2(
          e2 > s2 - 1
            ? []
            : e2 < 0
            ? (t2 = s2 + e2) < 0
              ? []
              : [this[t2]]
            : [this[e2]]
        );
      },
      append: function () {
        for (var t2, s2 = [], a2 = arguments.length; a2--; )
          s2[a2] = arguments[a2];
        for (var r2 = 0; r2 < s2.length; r2 += 1) {
          t2 = s2[r2];
          for (var n2 = 0; n2 < this.length; n2 += 1)
            if (typeof t2 == "string") {
              var o2 = e.createElement("div");
              for (o2.innerHTML = t2; o2.firstChild; )
                this[n2].appendChild(o2.firstChild);
            } else if (t2 instanceof i2)
              for (var l2 = 0; l2 < t2.length; l2 += 1)
                this[n2].appendChild(t2[l2]);
            else this[n2].appendChild(t2);
        }
        return this;
      },
      prepend: function (t2) {
        var s2, a2;
        for (s2 = 0; s2 < this.length; s2 += 1)
          if (typeof t2 == "string") {
            var r2 = e.createElement("div");
            for (
              r2.innerHTML = t2, a2 = r2.childNodes.length - 1;
              a2 >= 0;
              a2 -= 1
            )
              this[s2].insertBefore(r2.childNodes[a2], this[s2].childNodes[0]);
          } else if (t2 instanceof i2)
            for (a2 = 0; a2 < t2.length; a2 += 1)
              this[s2].insertBefore(t2[a2], this[s2].childNodes[0]);
          else this[s2].insertBefore(t2, this[s2].childNodes[0]);
        return this;
      },
      next: function (e2) {
        return this.length > 0
          ? e2
            ? this[0].nextElementSibling && s(this[0].nextElementSibling).is(e2)
              ? new i2([this[0].nextElementSibling])
              : new i2([])
            : this[0].nextElementSibling
            ? new i2([this[0].nextElementSibling])
            : new i2([])
          : new i2([]);
      },
      nextAll: function (e2) {
        var t2 = [],
          a2 = this[0];
        if (!a2) return new i2([]);
        for (; a2.nextElementSibling; ) {
          var r2 = a2.nextElementSibling;
          e2 ? s(r2).is(e2) && t2.push(r2) : t2.push(r2), (a2 = r2);
        }
        return new i2(t2);
      },
      prev: function (e2) {
        if (this.length > 0) {
          var t2 = this[0];
          return e2
            ? t2.previousElementSibling && s(t2.previousElementSibling).is(e2)
              ? new i2([t2.previousElementSibling])
              : new i2([])
            : t2.previousElementSibling
            ? new i2([t2.previousElementSibling])
            : new i2([]);
        }
        return new i2([]);
      },
      prevAll: function (e2) {
        var t2 = [],
          a2 = this[0];
        if (!a2) return new i2([]);
        for (; a2.previousElementSibling; ) {
          var r2 = a2.previousElementSibling;
          e2 ? s(r2).is(e2) && t2.push(r2) : t2.push(r2), (a2 = r2);
        }
        return new i2(t2);
      },
      parent: function (e2) {
        for (var t2 = [], i3 = 0; i3 < this.length; i3 += 1)
          this[i3].parentNode !== null &&
            (e2
              ? s(this[i3].parentNode).is(e2) && t2.push(this[i3].parentNode)
              : t2.push(this[i3].parentNode));
        return s(a(t2));
      },
      parents: function (e2) {
        for (var t2 = [], i3 = 0; i3 < this.length; i3 += 1)
          for (var r2 = this[i3].parentNode; r2; )
            e2 ? s(r2).is(e2) && t2.push(r2) : t2.push(r2),
              (r2 = r2.parentNode);
        return s(a(t2));
      },
      closest: function (e2) {
        var t2 = this;
        return e2 === void 0
          ? new i2([])
          : (t2.is(e2) || (t2 = t2.parents(e2).eq(0)), t2);
      },
      find: function (e2) {
        for (var t2 = [], s2 = 0; s2 < this.length; s2 += 1)
          for (
            var a2 = this[s2].querySelectorAll(e2), r2 = 0;
            r2 < a2.length;
            r2 += 1
          )
            t2.push(a2[r2]);
        return new i2(t2);
      },
      children: function (e2) {
        for (var t2 = [], r2 = 0; r2 < this.length; r2 += 1)
          for (var n2 = this[r2].childNodes, o2 = 0; o2 < n2.length; o2 += 1)
            e2
              ? n2[o2].nodeType === 1 && s(n2[o2]).is(e2) && t2.push(n2[o2])
              : n2[o2].nodeType === 1 && t2.push(n2[o2]);
        return new i2(a(t2));
      },
      filter: function (e2) {
        for (var t2 = [], s2 = 0; s2 < this.length; s2 += 1)
          e2.call(this[s2], s2, this[s2]) && t2.push(this[s2]);
        return new i2(t2);
      },
      remove: function () {
        for (var e2 = 0; e2 < this.length; e2 += 1)
          this[e2].parentNode && this[e2].parentNode.removeChild(this[e2]);
        return this;
      },
      add: function () {
        for (var e2 = [], t2 = arguments.length; t2--; ) e2[t2] = arguments[t2];
        var i3,
          a2,
          r2 = this;
        for (i3 = 0; i3 < e2.length; i3 += 1) {
          var n2 = s(e2[i3]);
          for (a2 = 0; a2 < n2.length; a2 += 1)
            (r2[r2.length] = n2[a2]), (r2.length += 1);
        }
        return r2;
      },
      styles: function () {
        return this[0] ? t.getComputedStyle(this[0], null) : {};
      },
    };
    Object.keys(r).forEach(function (e2) {
      s.fn[e2] = s.fn[e2] || r[e2];
    });
    var n = {
        deleteProps: function (e2) {
          var t2 = e2;
          Object.keys(t2).forEach(function (e3) {
            try {
              t2[e3] = null;
            } catch {}
            try {
              delete t2[e3];
            } catch {}
          });
        },
        nextTick: function (e2, t2) {
          return t2 === void 0 && (t2 = 0), setTimeout(e2, t2);
        },
        now: function () {
          return Date.now();
        },
        getTranslate: function (e2, i3) {
          var s2, a2, r2;
          i3 === void 0 && (i3 = "x");
          var n2 = t.getComputedStyle(e2, null);
          return (
            t.WebKitCSSMatrix
              ? ((a2 = n2.transform || n2.webkitTransform).split(",").length >
                  6 &&
                  (a2 = a2
                    .split(", ")
                    .map(function (e3) {
                      return e3.replace(",", ".");
                    })
                    .join(", ")),
                (r2 = new t.WebKitCSSMatrix(a2 === "none" ? "" : a2)))
              : (s2 = (r2 =
                  n2.MozTransform ||
                  n2.OTransform ||
                  n2.MsTransform ||
                  n2.msTransform ||
                  n2.transform ||
                  n2
                    .getPropertyValue("transform")
                    .replace("translate(", "matrix(1, 0, 0, 1,"))
                  .toString()
                  .split(",")),
            i3 === "x" &&
              (a2 = t.WebKitCSSMatrix
                ? r2.m41
                : s2.length === 16
                ? parseFloat(s2[12])
                : parseFloat(s2[4])),
            i3 === "y" &&
              (a2 = t.WebKitCSSMatrix
                ? r2.m42
                : s2.length === 16
                ? parseFloat(s2[13])
                : parseFloat(s2[5])),
            a2 || 0
          );
        },
        parseUrlQuery: function (e2) {
          var i3,
            s2,
            a2,
            r2,
            n2 = {},
            o2 = e2 || t.location.href;
          if (typeof o2 == "string" && o2.length)
            for (
              r2 = (s2 = (o2 =
                o2.indexOf("?") > -1 ? o2.replace(/\S*\?/, "") : "")
                .split("&")
                .filter(function (e3) {
                  return e3 !== "";
                })).length,
                i3 = 0;
              i3 < r2;
              i3 += 1
            )
              (a2 = s2[i3].replace(/#\S+/g, "").split("=")),
                (n2[decodeURIComponent(a2[0])] =
                  a2[1] === void 0 ? void 0 : decodeURIComponent(a2[1]) || "");
          return n2;
        },
        isObject: function (e2) {
          return (
            typeof e2 == "object" &&
            e2 !== null &&
            e2.constructor &&
            e2.constructor === Object
          );
        },
        extend: function () {
          for (var e2 = [], t2 = arguments.length; t2--; )
            e2[t2] = arguments[t2];
          for (var i3 = Object(e2[0]), s2 = 1; s2 < e2.length; s2 += 1) {
            var a2 = e2[s2];
            if (a2 != null)
              for (
                var r2 = Object.keys(Object(a2)), o2 = 0, l2 = r2.length;
                o2 < l2;
                o2 += 1
              ) {
                var d2 = r2[o2],
                  h2 = Object.getOwnPropertyDescriptor(a2, d2);
                h2 !== void 0 &&
                  h2.enumerable &&
                  (n.isObject(i3[d2]) && n.isObject(a2[d2])
                    ? n.extend(i3[d2], a2[d2])
                    : !n.isObject(i3[d2]) && n.isObject(a2[d2])
                    ? ((i3[d2] = {}), n.extend(i3[d2], a2[d2]))
                    : (i3[d2] = a2[d2]));
              }
          }
          return i3;
        },
      },
      o = {
        touch:
          (t.Modernizr && t.Modernizr.touch === !0) ||
          !!(
            t.navigator.maxTouchPoints > 0 ||
            "ontouchstart" in t ||
            (t.DocumentTouch && e instanceof t.DocumentTouch)
          ),
        pointerEvents:
          !!t.PointerEvent &&
          "maxTouchPoints" in t.navigator &&
          t.navigator.maxTouchPoints > 0,
        observer: "MutationObserver" in t || "WebkitMutationObserver" in t,
        passiveListener: (function () {
          var e2 = !1;
          try {
            var i3 = Object.defineProperty({}, "passive", {
              get: function () {
                e2 = !0;
              },
            });
            t.addEventListener("testPassiveListener", null, i3);
          } catch {}
          return e2;
        })(),
        gestures: "ongesturestart" in t,
      },
      l = function (e2) {
        e2 === void 0 && (e2 = {});
        var t2 = this;
        (t2.params = e2),
          (t2.eventsListeners = {}),
          t2.params &&
            t2.params.on &&
            Object.keys(t2.params.on).forEach(function (e3) {
              t2.on(e3, t2.params.on[e3]);
            });
      },
      d = { components: { configurable: !0 } };
    (l.prototype.on = function (e2, t2, i3) {
      var s2 = this;
      if (typeof t2 != "function") return s2;
      var a2 = i3 ? "unshift" : "push";
      return (
        e2.split(" ").forEach(function (e3) {
          s2.eventsListeners[e3] || (s2.eventsListeners[e3] = []),
            s2.eventsListeners[e3][a2](t2);
        }),
        s2
      );
    }),
      (l.prototype.once = function (e2, t2, i3) {
        var s2 = this;
        if (typeof t2 != "function") return s2;
        function a2() {
          for (var i4 = [], r2 = arguments.length; r2--; )
            i4[r2] = arguments[r2];
          s2.off(e2, a2), a2.f7proxy && delete a2.f7proxy, t2.apply(s2, i4);
        }
        return (a2.f7proxy = t2), s2.on(e2, a2, i3);
      }),
      (l.prototype.off = function (e2, t2) {
        var i3 = this;
        return (
          i3.eventsListeners &&
            e2.split(" ").forEach(function (e3) {
              t2 === void 0
                ? (i3.eventsListeners[e3] = [])
                : i3.eventsListeners[e3] &&
                  i3.eventsListeners[e3].length &&
                  i3.eventsListeners[e3].forEach(function (s2, a2) {
                    (s2 === t2 || (s2.f7proxy && s2.f7proxy === t2)) &&
                      i3.eventsListeners[e3].splice(a2, 1);
                  });
            }),
          i3
        );
      }),
      (l.prototype.emit = function () {
        for (var e2 = [], t2 = arguments.length; t2--; ) e2[t2] = arguments[t2];
        var i3,
          s2,
          a2,
          r2 = this;
        if (!r2.eventsListeners) return r2;
        typeof e2[0] == "string" || Array.isArray(e2[0])
          ? ((i3 = e2[0]), (s2 = e2.slice(1, e2.length)), (a2 = r2))
          : ((i3 = e2[0].events),
            (s2 = e2[0].data),
            (a2 = e2[0].context || r2));
        var n2 = Array.isArray(i3) ? i3 : i3.split(" ");
        return (
          n2.forEach(function (e3) {
            if (r2.eventsListeners && r2.eventsListeners[e3]) {
              var t3 = [];
              r2.eventsListeners[e3].forEach(function (e4) {
                t3.push(e4);
              }),
                t3.forEach(function (e4) {
                  e4.apply(a2, s2);
                });
            }
          }),
          r2
        );
      }),
      (l.prototype.useModulesParams = function (e2) {
        var t2 = this;
        t2.modules &&
          Object.keys(t2.modules).forEach(function (i3) {
            var s2 = t2.modules[i3];
            s2.params && n.extend(e2, s2.params);
          });
      }),
      (l.prototype.useModules = function (e2) {
        e2 === void 0 && (e2 = {});
        var t2 = this;
        t2.modules &&
          Object.keys(t2.modules).forEach(function (i3) {
            var s2 = t2.modules[i3],
              a2 = e2[i3] || {};
            s2.instance &&
              Object.keys(s2.instance).forEach(function (e3) {
                var i4 = s2.instance[e3];
                t2[e3] = typeof i4 == "function" ? i4.bind(t2) : i4;
              }),
              s2.on &&
                t2.on &&
                Object.keys(s2.on).forEach(function (e3) {
                  t2.on(e3, s2.on[e3]);
                }),
              s2.create && s2.create.bind(t2)(a2);
          });
      }),
      (d.components.set = function (e2) {
        this.use && this.use(e2);
      }),
      (l.installModule = function (e2) {
        for (var t2 = [], i3 = arguments.length - 1; i3-- > 0; )
          t2[i3] = arguments[i3 + 1];
        var s2 = this;
        s2.prototype.modules || (s2.prototype.modules = {});
        var a2 =
          e2.name || Object.keys(s2.prototype.modules).length + "_" + n.now();
        return (
          (s2.prototype.modules[a2] = e2),
          e2.proto &&
            Object.keys(e2.proto).forEach(function (t3) {
              s2.prototype[t3] = e2.proto[t3];
            }),
          e2.static &&
            Object.keys(e2.static).forEach(function (t3) {
              s2[t3] = e2.static[t3];
            }),
          e2.install && e2.install.apply(s2, t2),
          s2
        );
      }),
      (l.use = function (e2) {
        for (var t2 = [], i3 = arguments.length - 1; i3-- > 0; )
          t2[i3] = arguments[i3 + 1];
        var s2 = this;
        return Array.isArray(e2)
          ? (e2.forEach(function (e3) {
              return s2.installModule(e3);
            }),
            s2)
          : s2.installModule.apply(s2, [e2].concat(t2));
      }),
      Object.defineProperties(l, d);
    var h = {
        updateSize: function () {
          var e2,
            t2,
            i3 = this.$el;
          (e2 =
            this.params.width !== void 0
              ? this.params.width
              : i3[0].clientWidth),
            (t2 =
              this.params.height !== void 0
                ? this.params.height
                : i3[0].clientHeight),
            (e2 === 0 && this.isHorizontal()) ||
              (t2 === 0 && this.isVertical()) ||
              ((e2 =
                e2 -
                parseInt(i3.css("padding-left"), 10) -
                parseInt(i3.css("padding-right"), 10)),
              (t2 =
                t2 -
                parseInt(i3.css("padding-top"), 10) -
                parseInt(i3.css("padding-bottom"), 10)),
              n.extend(this, {
                width: e2,
                height: t2,
                size: this.isHorizontal() ? e2 : t2,
              }));
        },
        updateSlides: function () {
          var e2 = this.params,
            i3 = this.$wrapperEl,
            s2 = this.size,
            a2 = this.rtlTranslate,
            r2 = this.wrongRTL,
            o2 = this.virtual && e2.virtual.enabled,
            l2 = o2 ? this.virtual.slides.length : this.slides.length,
            d2 = i3.children("." + this.params.slideClass),
            h2 = o2 ? this.virtual.slides.length : d2.length,
            p2 = [],
            c2 = [],
            u2 = [];
          function v2(t2) {
            return !e2.cssMode || t2 !== d2.length - 1;
          }
          var f2 = e2.slidesOffsetBefore;
          typeof f2 == "function" && (f2 = e2.slidesOffsetBefore.call(this));
          var m2 = e2.slidesOffsetAfter;
          typeof m2 == "function" && (m2 = e2.slidesOffsetAfter.call(this));
          var g2 = this.snapGrid.length,
            b2 = this.snapGrid.length,
            w2 = e2.spaceBetween,
            y2 = -f2,
            x2 = 0,
            T2 = 0;
          if (s2 !== void 0) {
            var E2, S2;
            typeof w2 == "string" &&
              w2.indexOf("%") >= 0 &&
              (w2 = (parseFloat(w2.replace("%", "")) / 100) * s2),
              (this.virtualSize = -w2),
              a2
                ? d2.css({ marginLeft: "", marginTop: "" })
                : d2.css({ marginRight: "", marginBottom: "" }),
              e2.slidesPerColumn > 1 &&
                ((E2 =
                  Math.floor(h2 / e2.slidesPerColumn) ===
                  h2 / this.params.slidesPerColumn
                    ? h2
                    : Math.ceil(h2 / e2.slidesPerColumn) * e2.slidesPerColumn),
                e2.slidesPerView !== "auto" &&
                  e2.slidesPerColumnFill === "row" &&
                  (E2 = Math.max(E2, e2.slidesPerView * e2.slidesPerColumn)));
            for (
              var C2,
                M2 = e2.slidesPerColumn,
                P2 = E2 / M2,
                z2 = Math.floor(h2 / e2.slidesPerColumn),
                k2 = 0;
              k2 < h2;
              k2 += 1
            ) {
              S2 = 0;
              var $3 = d2.eq(k2);
              if (e2.slidesPerColumn > 1) {
                var L2 = void 0,
                  I2 = void 0,
                  D2 = void 0;
                if (e2.slidesPerColumnFill === "row" && e2.slidesPerGroup > 1) {
                  var O2 = Math.floor(
                      k2 / (e2.slidesPerGroup * e2.slidesPerColumn)
                    ),
                    A2 = k2 - e2.slidesPerColumn * e2.slidesPerGroup * O2,
                    G2 =
                      O2 === 0
                        ? e2.slidesPerGroup
                        : Math.min(
                            Math.ceil((h2 - O2 * M2 * e2.slidesPerGroup) / M2),
                            e2.slidesPerGroup
                          );
                  (L2 =
                    (I2 =
                      A2 -
                      (D2 = Math.floor(A2 / G2)) * G2 +
                      O2 * e2.slidesPerGroup) +
                    (D2 * E2) / M2),
                    $3.css({
                      "-webkit-box-ordinal-group": L2,
                      "-moz-box-ordinal-group": L2,
                      "-ms-flex-order": L2,
                      "-webkit-order": L2,
                      order: L2,
                    });
                } else
                  e2.slidesPerColumnFill === "column"
                    ? ((D2 = k2 - (I2 = Math.floor(k2 / M2)) * M2),
                      (I2 > z2 || (I2 === z2 && D2 === M2 - 1)) &&
                        (D2 += 1) >= M2 &&
                        ((D2 = 0), (I2 += 1)))
                    : (I2 = k2 - (D2 = Math.floor(k2 / P2)) * P2);
                $3.css(
                  "margin-" + (this.isHorizontal() ? "top" : "left"),
                  D2 !== 0 && e2.spaceBetween && e2.spaceBetween + "px"
                );
              }
              if ($3.css("display") !== "none") {
                if (e2.slidesPerView === "auto") {
                  var H2 = t.getComputedStyle($3[0], null),
                    B2 = $3[0].style.transform,
                    N2 = $3[0].style.webkitTransform;
                  if (
                    (B2 && ($3[0].style.transform = "none"),
                    N2 && ($3[0].style.webkitTransform = "none"),
                    e2.roundLengths)
                  )
                    S2 = this.isHorizontal()
                      ? $3.outerWidth(!0)
                      : $3.outerHeight(!0);
                  else if (this.isHorizontal()) {
                    var X2 = parseFloat(H2.getPropertyValue("width")),
                      V2 = parseFloat(H2.getPropertyValue("padding-left")),
                      Y2 = parseFloat(H2.getPropertyValue("padding-right")),
                      F2 = parseFloat(H2.getPropertyValue("margin-left")),
                      W2 = parseFloat(H2.getPropertyValue("margin-right")),
                      R2 = H2.getPropertyValue("box-sizing");
                    S2 =
                      R2 && R2 === "border-box"
                        ? X2 + F2 + W2
                        : X2 + V2 + Y2 + F2 + W2;
                  } else {
                    var q2 = parseFloat(H2.getPropertyValue("height")),
                      j2 = parseFloat(H2.getPropertyValue("padding-top")),
                      K2 = parseFloat(H2.getPropertyValue("padding-bottom")),
                      U2 = parseFloat(H2.getPropertyValue("margin-top")),
                      _2 = parseFloat(H2.getPropertyValue("margin-bottom")),
                      Z2 = H2.getPropertyValue("box-sizing");
                    S2 =
                      Z2 && Z2 === "border-box"
                        ? q2 + U2 + _2
                        : q2 + j2 + K2 + U2 + _2;
                  }
                  B2 && ($3[0].style.transform = B2),
                    N2 && ($3[0].style.webkitTransform = N2),
                    e2.roundLengths && (S2 = Math.floor(S2));
                } else
                  (S2 = (s2 - (e2.slidesPerView - 1) * w2) / e2.slidesPerView),
                    e2.roundLengths && (S2 = Math.floor(S2)),
                    d2[k2] &&
                      (this.isHorizontal()
                        ? (d2[k2].style.width = S2 + "px")
                        : (d2[k2].style.height = S2 + "px"));
                d2[k2] && (d2[k2].swiperSlideSize = S2),
                  u2.push(S2),
                  e2.centeredSlides
                    ? ((y2 = y2 + S2 / 2 + x2 / 2 + w2),
                      x2 === 0 && k2 !== 0 && (y2 = y2 - s2 / 2 - w2),
                      k2 === 0 && (y2 = y2 - s2 / 2 - w2),
                      Math.abs(y2) < 0.001 && (y2 = 0),
                      e2.roundLengths && (y2 = Math.floor(y2)),
                      T2 % e2.slidesPerGroup == 0 && p2.push(y2),
                      c2.push(y2))
                    : (e2.roundLengths && (y2 = Math.floor(y2)),
                      (T2 - Math.min(this.params.slidesPerGroupSkip, T2)) %
                        this.params.slidesPerGroup ==
                        0 && p2.push(y2),
                      c2.push(y2),
                      (y2 = y2 + S2 + w2)),
                  (this.virtualSize += S2 + w2),
                  (x2 = S2),
                  (T2 += 1);
              }
            }
            if (
              ((this.virtualSize = Math.max(this.virtualSize, s2) + m2),
              a2 &&
                r2 &&
                (e2.effect === "slide" || e2.effect === "coverflow") &&
                i3.css({ width: this.virtualSize + e2.spaceBetween + "px" }),
              e2.setWrapperSize &&
                (this.isHorizontal()
                  ? i3.css({ width: this.virtualSize + e2.spaceBetween + "px" })
                  : i3.css({
                      height: this.virtualSize + e2.spaceBetween + "px",
                    })),
              e2.slidesPerColumn > 1 &&
                ((this.virtualSize = (S2 + e2.spaceBetween) * E2),
                (this.virtualSize =
                  Math.ceil(this.virtualSize / e2.slidesPerColumn) -
                  e2.spaceBetween),
                this.isHorizontal()
                  ? i3.css({ width: this.virtualSize + e2.spaceBetween + "px" })
                  : i3.css({
                      height: this.virtualSize + e2.spaceBetween + "px",
                    }),
                e2.centeredSlides))
            ) {
              C2 = [];
              for (var Q2 = 0; Q2 < p2.length; Q2 += 1) {
                var J2 = p2[Q2];
                e2.roundLengths && (J2 = Math.floor(J2)),
                  p2[Q2] < this.virtualSize + p2[0] && C2.push(J2);
              }
              p2 = C2;
            }
            if (!e2.centeredSlides) {
              C2 = [];
              for (var ee2 = 0; ee2 < p2.length; ee2 += 1) {
                var te2 = p2[ee2];
                e2.roundLengths && (te2 = Math.floor(te2)),
                  p2[ee2] <= this.virtualSize - s2 && C2.push(te2);
              }
              (p2 = C2),
                Math.floor(this.virtualSize - s2) -
                  Math.floor(p2[p2.length - 1]) >
                  1 && p2.push(this.virtualSize - s2);
            }
            if (
              (p2.length === 0 && (p2 = [0]),
              e2.spaceBetween !== 0 &&
                (this.isHorizontal()
                  ? a2
                    ? d2.filter(v2).css({ marginLeft: w2 + "px" })
                    : d2.filter(v2).css({ marginRight: w2 + "px" })
                  : d2.filter(v2).css({ marginBottom: w2 + "px" })),
              e2.centeredSlides && e2.centeredSlidesBounds)
            ) {
              var ie2 = 0;
              u2.forEach(function (t2) {
                ie2 += t2 + (e2.spaceBetween ? e2.spaceBetween : 0);
              });
              var se2 = (ie2 -= e2.spaceBetween) - s2;
              p2 = p2.map(function (e3) {
                return e3 < 0 ? -f2 : e3 > se2 ? se2 + m2 : e3;
              });
            }
            if (e2.centerInsufficientSlides) {
              var ae2 = 0;
              if (
                (u2.forEach(function (t2) {
                  ae2 += t2 + (e2.spaceBetween ? e2.spaceBetween : 0);
                }),
                (ae2 -= e2.spaceBetween) < s2)
              ) {
                var re2 = (s2 - ae2) / 2;
                p2.forEach(function (e3, t2) {
                  p2[t2] = e3 - re2;
                }),
                  c2.forEach(function (e3, t2) {
                    c2[t2] = e3 + re2;
                  });
              }
            }
            n.extend(this, {
              slides: d2,
              snapGrid: p2,
              slidesGrid: c2,
              slidesSizesGrid: u2,
            }),
              h2 !== l2 && this.emit("slidesLengthChange"),
              p2.length !== g2 &&
                (this.params.watchOverflow && this.checkOverflow(),
                this.emit("snapGridLengthChange")),
              c2.length !== b2 && this.emit("slidesGridLengthChange"),
              (e2.watchSlidesProgress || e2.watchSlidesVisibility) &&
                this.updateSlidesOffset();
          }
        },
        updateAutoHeight: function (e2) {
          var t2,
            i3 = [],
            s2 = 0;
          if (
            (typeof e2 == "number"
              ? this.setTransition(e2)
              : e2 === !0 && this.setTransition(this.params.speed),
            this.params.slidesPerView !== "auto" &&
              this.params.slidesPerView > 1)
          )
            if (this.params.centeredSlides)
              this.visibleSlides.each(function (e3, t3) {
                i3.push(t3);
              });
            else
              for (t2 = 0; t2 < Math.ceil(this.params.slidesPerView); t2 += 1) {
                var a2 = this.activeIndex + t2;
                if (a2 > this.slides.length) break;
                i3.push(this.slides.eq(a2)[0]);
              }
          else i3.push(this.slides.eq(this.activeIndex)[0]);
          for (t2 = 0; t2 < i3.length; t2 += 1)
            if (i3[t2] !== void 0) {
              var r2 = i3[t2].offsetHeight;
              s2 = r2 > s2 ? r2 : s2;
            }
          s2 && this.$wrapperEl.css("height", s2 + "px");
        },
        updateSlidesOffset: function () {
          for (var e2 = this.slides, t2 = 0; t2 < e2.length; t2 += 1)
            e2[t2].swiperSlideOffset = this.isHorizontal()
              ? e2[t2].offsetLeft
              : e2[t2].offsetTop;
        },
        updateSlidesProgress: function (e2) {
          e2 === void 0 && (e2 = (this && this.translate) || 0);
          var t2 = this.params,
            i3 = this.slides,
            a2 = this.rtlTranslate;
          if (i3.length !== 0) {
            i3[0].swiperSlideOffset === void 0 && this.updateSlidesOffset();
            var r2 = -e2;
            a2 && (r2 = e2),
              i3.removeClass(t2.slideVisibleClass),
              (this.visibleSlidesIndexes = []),
              (this.visibleSlides = []);
            for (var n2 = 0; n2 < i3.length; n2 += 1) {
              var o2 = i3[n2],
                l2 =
                  (r2 +
                    (t2.centeredSlides ? this.minTranslate() : 0) -
                    o2.swiperSlideOffset) /
                  (o2.swiperSlideSize + t2.spaceBetween);
              if (
                t2.watchSlidesVisibility ||
                (t2.centeredSlides && t2.autoHeight)
              ) {
                var d2 = -(r2 - o2.swiperSlideOffset),
                  h2 = d2 + this.slidesSizesGrid[n2];
                ((d2 >= 0 && d2 < this.size - 1) ||
                  (h2 > 1 && h2 <= this.size) ||
                  (d2 <= 0 && h2 >= this.size)) &&
                  (this.visibleSlides.push(o2),
                  this.visibleSlidesIndexes.push(n2),
                  i3.eq(n2).addClass(t2.slideVisibleClass));
              }
              o2.progress = a2 ? -l2 : l2;
            }
            this.visibleSlides = s(this.visibleSlides);
          }
        },
        updateProgress: function (e2) {
          if (e2 === void 0) {
            var t2 = this.rtlTranslate ? -1 : 1;
            e2 = (this && this.translate && this.translate * t2) || 0;
          }
          var i3 = this.params,
            s2 = this.maxTranslate() - this.minTranslate(),
            a2 = this.progress,
            r2 = this.isBeginning,
            o2 = this.isEnd,
            l2 = r2,
            d2 = o2;
          s2 === 0
            ? ((a2 = 0), (r2 = !0), (o2 = !0))
            : ((r2 = (a2 = (e2 - this.minTranslate()) / s2) <= 0),
              (o2 = a2 >= 1)),
            n.extend(this, { progress: a2, isBeginning: r2, isEnd: o2 }),
            (i3.watchSlidesProgress ||
              i3.watchSlidesVisibility ||
              (i3.centeredSlides && i3.autoHeight)) &&
              this.updateSlidesProgress(e2),
            r2 && !l2 && this.emit("reachBeginning toEdge"),
            o2 && !d2 && this.emit("reachEnd toEdge"),
            ((l2 && !r2) || (d2 && !o2)) && this.emit("fromEdge"),
            this.emit("progress", a2);
        },
        updateSlidesClasses: function () {
          var e2,
            t2 = this.slides,
            i3 = this.params,
            s2 = this.$wrapperEl,
            a2 = this.activeIndex,
            r2 = this.realIndex,
            n2 = this.virtual && i3.virtual.enabled;
          t2.removeClass(
            i3.slideActiveClass +
              " " +
              i3.slideNextClass +
              " " +
              i3.slidePrevClass +
              " " +
              i3.slideDuplicateActiveClass +
              " " +
              i3.slideDuplicateNextClass +
              " " +
              i3.slideDuplicatePrevClass
          ),
            (e2 = n2
              ? this.$wrapperEl.find(
                  "." + i3.slideClass + '[data-swiper-slide-index="' + a2 + '"]'
                )
              : t2.eq(a2)).addClass(i3.slideActiveClass),
            i3.loop &&
              (e2.hasClass(i3.slideDuplicateClass)
                ? s2
                    .children(
                      "." +
                        i3.slideClass +
                        ":not(." +
                        i3.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        r2 +
                        '"]'
                    )
                    .addClass(i3.slideDuplicateActiveClass)
                : s2
                    .children(
                      "." +
                        i3.slideClass +
                        "." +
                        i3.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        r2 +
                        '"]'
                    )
                    .addClass(i3.slideDuplicateActiveClass));
          var o2 = e2
            .nextAll("." + i3.slideClass)
            .eq(0)
            .addClass(i3.slideNextClass);
          i3.loop &&
            o2.length === 0 &&
            (o2 = t2.eq(0)).addClass(i3.slideNextClass);
          var l2 = e2
            .prevAll("." + i3.slideClass)
            .eq(0)
            .addClass(i3.slidePrevClass);
          i3.loop &&
            l2.length === 0 &&
            (l2 = t2.eq(-1)).addClass(i3.slidePrevClass),
            i3.loop &&
              (o2.hasClass(i3.slideDuplicateClass)
                ? s2
                    .children(
                      "." +
                        i3.slideClass +
                        ":not(." +
                        i3.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        o2.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i3.slideDuplicateNextClass)
                : s2
                    .children(
                      "." +
                        i3.slideClass +
                        "." +
                        i3.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        o2.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i3.slideDuplicateNextClass),
              l2.hasClass(i3.slideDuplicateClass)
                ? s2
                    .children(
                      "." +
                        i3.slideClass +
                        ":not(." +
                        i3.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        l2.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i3.slideDuplicatePrevClass)
                : s2
                    .children(
                      "." +
                        i3.slideClass +
                        "." +
                        i3.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        l2.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i3.slideDuplicatePrevClass));
        },
        updateActiveIndex: function (e2) {
          var t2,
            i3 = this.rtlTranslate ? this.translate : -this.translate,
            s2 = this.slidesGrid,
            a2 = this.snapGrid,
            r2 = this.params,
            o2 = this.activeIndex,
            l2 = this.realIndex,
            d2 = this.snapIndex,
            h2 = e2;
          if (h2 === void 0) {
            for (var p2 = 0; p2 < s2.length; p2 += 1)
              s2[p2 + 1] !== void 0
                ? i3 >= s2[p2] && i3 < s2[p2 + 1] - (s2[p2 + 1] - s2[p2]) / 2
                  ? (h2 = p2)
                  : i3 >= s2[p2] && i3 < s2[p2 + 1] && (h2 = p2 + 1)
                : i3 >= s2[p2] && (h2 = p2);
            r2.normalizeSlideIndex && (h2 < 0 || h2 === void 0) && (h2 = 0);
          }
          if (a2.indexOf(i3) >= 0) t2 = a2.indexOf(i3);
          else {
            var c2 = Math.min(r2.slidesPerGroupSkip, h2);
            t2 = c2 + Math.floor((h2 - c2) / r2.slidesPerGroup);
          }
          if ((t2 >= a2.length && (t2 = a2.length - 1), h2 !== o2)) {
            var u2 = parseInt(
              this.slides.eq(h2).attr("data-swiper-slide-index") || h2,
              10
            );
            n.extend(this, {
              snapIndex: t2,
              realIndex: u2,
              previousIndex: o2,
              activeIndex: h2,
            }),
              this.emit("activeIndexChange"),
              this.emit("snapIndexChange"),
              l2 !== u2 && this.emit("realIndexChange"),
              (this.initialized || this.params.runCallbacksOnInit) &&
                this.emit("slideChange");
          } else
            t2 !== d2 && ((this.snapIndex = t2), this.emit("snapIndexChange"));
        },
        updateClickedSlide: function (e2) {
          var t2 = this.params,
            i3 = s(e2.target).closest("." + t2.slideClass)[0],
            a2 = !1;
          if (i3)
            for (var r2 = 0; r2 < this.slides.length; r2 += 1)
              this.slides[r2] === i3 && (a2 = !0);
          if (!i3 || !a2)
            return (
              (this.clickedSlide = void 0), void (this.clickedIndex = void 0)
            );
          (this.clickedSlide = i3),
            this.virtual && this.params.virtual.enabled
              ? (this.clickedIndex = parseInt(
                  s(i3).attr("data-swiper-slide-index"),
                  10
                ))
              : (this.clickedIndex = s(i3).index()),
            t2.slideToClickedSlide &&
              this.clickedIndex !== void 0 &&
              this.clickedIndex !== this.activeIndex &&
              this.slideToClickedSlide();
        },
      },
      p = {
        getTranslate: function (e2) {
          e2 === void 0 && (e2 = this.isHorizontal() ? "x" : "y");
          var t2 = this.params,
            i3 = this.rtlTranslate,
            s2 = this.translate,
            a2 = this.$wrapperEl;
          if (t2.virtualTranslate) return i3 ? -s2 : s2;
          if (t2.cssMode) return s2;
          var r2 = n.getTranslate(a2[0], e2);
          return i3 && (r2 = -r2), r2 || 0;
        },
        setTranslate: function (e2, t2) {
          var i3 = this.rtlTranslate,
            s2 = this.params,
            a2 = this.$wrapperEl,
            r2 = this.wrapperEl,
            n2 = this.progress,
            o2 = 0,
            l2 = 0;
          this.isHorizontal() ? (o2 = i3 ? -e2 : e2) : (l2 = e2),
            s2.roundLengths && ((o2 = Math.floor(o2)), (l2 = Math.floor(l2))),
            s2.cssMode
              ? (r2[this.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                  this.isHorizontal() ? -o2 : -l2)
              : s2.virtualTranslate ||
                a2.transform("translate3d(" + o2 + "px, " + l2 + "px, 0px)"),
            (this.previousTranslate = this.translate),
            (this.translate = this.isHorizontal() ? o2 : l2);
          var d2 = this.maxTranslate() - this.minTranslate();
          (d2 === 0 ? 0 : (e2 - this.minTranslate()) / d2) !== n2 &&
            this.updateProgress(e2),
            this.emit("setTranslate", this.translate, t2);
        },
        minTranslate: function () {
          return -this.snapGrid[0];
        },
        maxTranslate: function () {
          return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function (e2, t2, i3, s2, a2) {
          var r2;
          e2 === void 0 && (e2 = 0),
            t2 === void 0 && (t2 = this.params.speed),
            i3 === void 0 && (i3 = !0),
            s2 === void 0 && (s2 = !0);
          var n2 = this,
            o2 = n2.params,
            l2 = n2.wrapperEl;
          if (n2.animating && o2.preventInteractionOnTransition) return !1;
          var d2,
            h2 = n2.minTranslate(),
            p2 = n2.maxTranslate();
          if (
            ((d2 = s2 && e2 > h2 ? h2 : s2 && e2 < p2 ? p2 : e2),
            n2.updateProgress(d2),
            o2.cssMode)
          ) {
            var c2 = n2.isHorizontal();
            return (
              t2 === 0
                ? (l2[c2 ? "scrollLeft" : "scrollTop"] = -d2)
                : l2.scrollTo
                ? l2.scrollTo(
                    (((r2 = {})[c2 ? "left" : "top"] = -d2),
                    (r2.behavior = "smooth"),
                    r2)
                  )
                : (l2[c2 ? "scrollLeft" : "scrollTop"] = -d2),
              !0
            );
          }
          return (
            t2 === 0
              ? (n2.setTransition(0),
                n2.setTranslate(d2),
                i3 &&
                  (n2.emit("beforeTransitionStart", t2, a2),
                  n2.emit("transitionEnd")))
              : (n2.setTransition(t2),
                n2.setTranslate(d2),
                i3 &&
                  (n2.emit("beforeTransitionStart", t2, a2),
                  n2.emit("transitionStart")),
                n2.animating ||
                  ((n2.animating = !0),
                  n2.onTranslateToWrapperTransitionEnd ||
                    (n2.onTranslateToWrapperTransitionEnd = function (e3) {
                      n2 &&
                        !n2.destroyed &&
                        e3.target === this &&
                        (n2.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          n2.onTranslateToWrapperTransitionEnd
                        ),
                        n2.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          n2.onTranslateToWrapperTransitionEnd
                        ),
                        (n2.onTranslateToWrapperTransitionEnd = null),
                        delete n2.onTranslateToWrapperTransitionEnd,
                        i3 && n2.emit("transitionEnd"));
                    }),
                  n2.$wrapperEl[0].addEventListener(
                    "transitionend",
                    n2.onTranslateToWrapperTransitionEnd
                  ),
                  n2.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    n2.onTranslateToWrapperTransitionEnd
                  ))),
            !0
          );
        },
      },
      c = {
        setTransition: function (e2, t2) {
          this.params.cssMode || this.$wrapperEl.transition(e2),
            this.emit("setTransition", e2, t2);
        },
        transitionStart: function (e2, t2) {
          e2 === void 0 && (e2 = !0);
          var i3 = this.activeIndex,
            s2 = this.params,
            a2 = this.previousIndex;
          if (!s2.cssMode) {
            s2.autoHeight && this.updateAutoHeight();
            var r2 = t2;
            if (
              (r2 || (r2 = i3 > a2 ? "next" : i3 < a2 ? "prev" : "reset"),
              this.emit("transitionStart"),
              e2 && i3 !== a2)
            ) {
              if (r2 === "reset")
                return void this.emit("slideResetTransitionStart");
              this.emit("slideChangeTransitionStart"),
                r2 === "next"
                  ? this.emit("slideNextTransitionStart")
                  : this.emit("slidePrevTransitionStart");
            }
          }
        },
        transitionEnd: function (e2, t2) {
          e2 === void 0 && (e2 = !0);
          var i3 = this.activeIndex,
            s2 = this.previousIndex,
            a2 = this.params;
          if (((this.animating = !1), !a2.cssMode)) {
            this.setTransition(0);
            var r2 = t2;
            if (
              (r2 || (r2 = i3 > s2 ? "next" : i3 < s2 ? "prev" : "reset"),
              this.emit("transitionEnd"),
              e2 && i3 !== s2)
            ) {
              if (r2 === "reset")
                return void this.emit("slideResetTransitionEnd");
              this.emit("slideChangeTransitionEnd"),
                r2 === "next"
                  ? this.emit("slideNextTransitionEnd")
                  : this.emit("slidePrevTransitionEnd");
            }
          }
        },
      },
      u = {
        slideTo: function (e2, t2, i3, s2) {
          var a2;
          e2 === void 0 && (e2 = 0),
            t2 === void 0 && (t2 = this.params.speed),
            i3 === void 0 && (i3 = !0);
          var r2 = this,
            n2 = e2;
          n2 < 0 && (n2 = 0);
          var o2 = r2.params,
            l2 = r2.snapGrid,
            d2 = r2.slidesGrid,
            h2 = r2.previousIndex,
            p2 = r2.activeIndex,
            c2 = r2.rtlTranslate,
            u2 = r2.wrapperEl;
          if (r2.animating && o2.preventInteractionOnTransition) return !1;
          var v2 = Math.min(r2.params.slidesPerGroupSkip, n2),
            f2 = v2 + Math.floor((n2 - v2) / r2.params.slidesPerGroup);
          f2 >= l2.length && (f2 = l2.length - 1),
            (p2 || o2.initialSlide || 0) === (h2 || 0) &&
              i3 &&
              r2.emit("beforeSlideChangeStart");
          var m2,
            g2 = -l2[f2];
          if ((r2.updateProgress(g2), o2.normalizeSlideIndex))
            for (var b2 = 0; b2 < d2.length; b2 += 1)
              -Math.floor(100 * g2) >= Math.floor(100 * d2[b2]) && (n2 = b2);
          if (
            r2.initialized &&
            n2 !== p2 &&
            ((!r2.allowSlideNext &&
              g2 < r2.translate &&
              g2 < r2.minTranslate()) ||
              (!r2.allowSlidePrev &&
                g2 > r2.translate &&
                g2 > r2.maxTranslate() &&
                (p2 || 0) !== n2))
          )
            return !1;
          if (
            ((m2 = n2 > p2 ? "next" : n2 < p2 ? "prev" : "reset"),
            (c2 && -g2 === r2.translate) || (!c2 && g2 === r2.translate))
          )
            return (
              r2.updateActiveIndex(n2),
              o2.autoHeight && r2.updateAutoHeight(),
              r2.updateSlidesClasses(),
              o2.effect !== "slide" && r2.setTranslate(g2),
              m2 !== "reset" &&
                (r2.transitionStart(i3, m2), r2.transitionEnd(i3, m2)),
              !1
            );
          if (o2.cssMode) {
            var w2 = r2.isHorizontal(),
              y2 = -g2;
            return (
              c2 && (y2 = u2.scrollWidth - u2.offsetWidth - y2),
              t2 === 0
                ? (u2[w2 ? "scrollLeft" : "scrollTop"] = y2)
                : u2.scrollTo
                ? u2.scrollTo(
                    (((a2 = {})[w2 ? "left" : "top"] = y2),
                    (a2.behavior = "smooth"),
                    a2)
                  )
                : (u2[w2 ? "scrollLeft" : "scrollTop"] = y2),
              !0
            );
          }
          return (
            t2 === 0
              ? (r2.setTransition(0),
                r2.setTranslate(g2),
                r2.updateActiveIndex(n2),
                r2.updateSlidesClasses(),
                r2.emit("beforeTransitionStart", t2, s2),
                r2.transitionStart(i3, m2),
                r2.transitionEnd(i3, m2))
              : (r2.setTransition(t2),
                r2.setTranslate(g2),
                r2.updateActiveIndex(n2),
                r2.updateSlidesClasses(),
                r2.emit("beforeTransitionStart", t2, s2),
                r2.transitionStart(i3, m2),
                r2.animating ||
                  ((r2.animating = !0),
                  r2.onSlideToWrapperTransitionEnd ||
                    (r2.onSlideToWrapperTransitionEnd = function (e3) {
                      r2 &&
                        !r2.destroyed &&
                        e3.target === this &&
                        (r2.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          r2.onSlideToWrapperTransitionEnd
                        ),
                        r2.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          r2.onSlideToWrapperTransitionEnd
                        ),
                        (r2.onSlideToWrapperTransitionEnd = null),
                        delete r2.onSlideToWrapperTransitionEnd,
                        r2.transitionEnd(i3, m2));
                    }),
                  r2.$wrapperEl[0].addEventListener(
                    "transitionend",
                    r2.onSlideToWrapperTransitionEnd
                  ),
                  r2.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    r2.onSlideToWrapperTransitionEnd
                  ))),
            !0
          );
        },
        slideToLoop: function (e2, t2, i3, s2) {
          e2 === void 0 && (e2 = 0),
            t2 === void 0 && (t2 = this.params.speed),
            i3 === void 0 && (i3 = !0);
          var a2 = e2;
          return (
            this.params.loop && (a2 += this.loopedSlides),
            this.slideTo(a2, t2, i3, s2)
          );
        },
        slideNext: function (e2, t2, i3) {
          e2 === void 0 && (e2 = this.params.speed), t2 === void 0 && (t2 = !0);
          var s2 = this.params,
            a2 = this.animating,
            r2 =
              this.activeIndex < s2.slidesPerGroupSkip ? 1 : s2.slidesPerGroup;
          if (s2.loop) {
            if (a2) return !1;
            this.loopFix(), (this._clientLeft = this.$wrapperEl[0].clientLeft);
          }
          return this.slideTo(this.activeIndex + r2, e2, t2, i3);
        },
        slidePrev: function (e2, t2, i3) {
          e2 === void 0 && (e2 = this.params.speed), t2 === void 0 && (t2 = !0);
          var s2 = this.params,
            a2 = this.animating,
            r2 = this.snapGrid,
            n2 = this.slidesGrid,
            o2 = this.rtlTranslate;
          if (s2.loop) {
            if (a2) return !1;
            this.loopFix(), (this._clientLeft = this.$wrapperEl[0].clientLeft);
          }
          function l2(e3) {
            return e3 < 0 ? -Math.floor(Math.abs(e3)) : Math.floor(e3);
          }
          var d2,
            h2 = l2(o2 ? this.translate : -this.translate),
            p2 = r2.map(function (e3) {
              return l2(e3);
            }),
            c2 =
              (n2.map(function (e3) {
                return l2(e3);
              }),
              r2[p2.indexOf(h2)],
              r2[p2.indexOf(h2) - 1]);
          return (
            c2 === void 0 &&
              s2.cssMode &&
              r2.forEach(function (e3) {
                !c2 && h2 >= e3 && (c2 = e3);
              }),
            c2 !== void 0 &&
              (d2 = n2.indexOf(c2)) < 0 &&
              (d2 = this.activeIndex - 1),
            this.slideTo(d2, e2, t2, i3)
          );
        },
        slideReset: function (e2, t2, i3) {
          return (
            e2 === void 0 && (e2 = this.params.speed),
            t2 === void 0 && (t2 = !0),
            this.slideTo(this.activeIndex, e2, t2, i3)
          );
        },
        slideToClosest: function (e2, t2, i3, s2) {
          e2 === void 0 && (e2 = this.params.speed),
            t2 === void 0 && (t2 = !0),
            s2 === void 0 && (s2 = 0.5);
          var a2 = this.activeIndex,
            r2 = Math.min(this.params.slidesPerGroupSkip, a2),
            n2 = r2 + Math.floor((a2 - r2) / this.params.slidesPerGroup),
            o2 = this.rtlTranslate ? this.translate : -this.translate;
          if (o2 >= this.snapGrid[n2]) {
            var l2 = this.snapGrid[n2];
            o2 - l2 > (this.snapGrid[n2 + 1] - l2) * s2 &&
              (a2 += this.params.slidesPerGroup);
          } else {
            var d2 = this.snapGrid[n2 - 1];
            o2 - d2 <= (this.snapGrid[n2] - d2) * s2 &&
              (a2 -= this.params.slidesPerGroup);
          }
          return (
            (a2 = Math.max(a2, 0)),
            (a2 = Math.min(a2, this.slidesGrid.length - 1)),
            this.slideTo(a2, e2, t2, i3)
          );
        },
        slideToClickedSlide: function () {
          var e2,
            t2 = this,
            i3 = t2.params,
            a2 = t2.$wrapperEl,
            r2 =
              i3.slidesPerView === "auto"
                ? t2.slidesPerViewDynamic()
                : i3.slidesPerView,
            o2 = t2.clickedIndex;
          if (i3.loop) {
            if (t2.animating) return;
            (e2 = parseInt(
              s(t2.clickedSlide).attr("data-swiper-slide-index"),
              10
            )),
              i3.centeredSlides
                ? o2 < t2.loopedSlides - r2 / 2 ||
                  o2 > t2.slides.length - t2.loopedSlides + r2 / 2
                  ? (t2.loopFix(),
                    (o2 = a2
                      .children(
                        "." +
                          i3.slideClass +
                          '[data-swiper-slide-index="' +
                          e2 +
                          '"]:not(.' +
                          i3.slideDuplicateClass +
                          ")"
                      )
                      .eq(0)
                      .index()),
                    n.nextTick(function () {
                      t2.slideTo(o2);
                    }))
                  : t2.slideTo(o2)
                : o2 > t2.slides.length - r2
                ? (t2.loopFix(),
                  (o2 = a2
                    .children(
                      "." +
                        i3.slideClass +
                        '[data-swiper-slide-index="' +
                        e2 +
                        '"]:not(.' +
                        i3.slideDuplicateClass +
                        ")"
                    )
                    .eq(0)
                    .index()),
                  n.nextTick(function () {
                    t2.slideTo(o2);
                  }))
                : t2.slideTo(o2);
          } else t2.slideTo(o2);
        },
      },
      v = {
        loopCreate: function () {
          var t2 = this,
            i3 = t2.params,
            a2 = t2.$wrapperEl;
          a2.children(
            "." + i3.slideClass + "." + i3.slideDuplicateClass
          ).remove();
          var r2 = a2.children("." + i3.slideClass);
          if (i3.loopFillGroupWithBlank) {
            var n2 = i3.slidesPerGroup - (r2.length % i3.slidesPerGroup);
            if (n2 !== i3.slidesPerGroup) {
              for (var o2 = 0; o2 < n2; o2 += 1) {
                var l2 = s(e.createElement("div")).addClass(
                  i3.slideClass + " " + i3.slideBlankClass
                );
                a2.append(l2);
              }
              r2 = a2.children("." + i3.slideClass);
            }
          }
          i3.slidesPerView !== "auto" ||
            i3.loopedSlides ||
            (i3.loopedSlides = r2.length),
            (t2.loopedSlides = Math.ceil(
              parseFloat(i3.loopedSlides || i3.slidesPerView, 10)
            )),
            (t2.loopedSlides += i3.loopAdditionalSlides),
            t2.loopedSlides > r2.length && (t2.loopedSlides = r2.length);
          var d2 = [],
            h2 = [];
          r2.each(function (e2, i4) {
            var a3 = s(i4);
            e2 < t2.loopedSlides && h2.push(i4),
              e2 < r2.length &&
                e2 >= r2.length - t2.loopedSlides &&
                d2.push(i4),
              a3.attr("data-swiper-slide-index", e2);
          });
          for (var p2 = 0; p2 < h2.length; p2 += 1)
            a2.append(s(h2[p2].cloneNode(!0)).addClass(i3.slideDuplicateClass));
          for (var c2 = d2.length - 1; c2 >= 0; c2 -= 1)
            a2.prepend(
              s(d2[c2].cloneNode(!0)).addClass(i3.slideDuplicateClass)
            );
        },
        loopFix: function () {
          this.emit("beforeLoopFix");
          var e2,
            t2 = this.activeIndex,
            i3 = this.slides,
            s2 = this.loopedSlides,
            a2 = this.allowSlidePrev,
            r2 = this.allowSlideNext,
            n2 = this.snapGrid,
            o2 = this.rtlTranslate;
          (this.allowSlidePrev = !0), (this.allowSlideNext = !0);
          var l2 = -n2[t2] - this.getTranslate();
          t2 < s2
            ? ((e2 = i3.length - 3 * s2 + t2),
              (e2 += s2),
              this.slideTo(e2, 0, !1, !0) &&
                l2 !== 0 &&
                this.setTranslate((o2 ? -this.translate : this.translate) - l2))
            : t2 >= i3.length - s2 &&
              ((e2 = -i3.length + t2 + s2),
              (e2 += s2),
              this.slideTo(e2, 0, !1, !0) &&
                l2 !== 0 &&
                this.setTranslate(
                  (o2 ? -this.translate : this.translate) - l2
                )),
            (this.allowSlidePrev = a2),
            (this.allowSlideNext = r2),
            this.emit("loopFix");
        },
        loopDestroy: function () {
          var e2 = this.$wrapperEl,
            t2 = this.params,
            i3 = this.slides;
          e2
            .children(
              "." +
                t2.slideClass +
                "." +
                t2.slideDuplicateClass +
                ",." +
                t2.slideClass +
                "." +
                t2.slideBlankClass
            )
            .remove(),
            i3.removeAttr("data-swiper-slide-index");
        },
      },
      f = {
        setGrabCursor: function (e2) {
          if (
            !(
              o.touch ||
              !this.params.simulateTouch ||
              (this.params.watchOverflow && this.isLocked) ||
              this.params.cssMode
            )
          ) {
            var t2 = this.el;
            (t2.style.cursor = "move"),
              (t2.style.cursor = e2 ? "-webkit-grabbing" : "-webkit-grab"),
              (t2.style.cursor = e2 ? "-moz-grabbin" : "-moz-grab"),
              (t2.style.cursor = e2 ? "grabbing" : "grab");
          }
        },
        unsetGrabCursor: function () {
          o.touch ||
            (this.params.watchOverflow && this.isLocked) ||
            this.params.cssMode ||
            (this.el.style.cursor = "");
        },
      },
      m,
      g,
      b,
      w,
      y,
      x,
      T,
      E,
      S,
      C,
      M,
      P,
      z,
      k,
      $2,
      L = {
        appendSlide: function (e2) {
          var t2 = this.$wrapperEl,
            i3 = this.params;
          if (
            (i3.loop && this.loopDestroy(),
            typeof e2 == "object" && "length" in e2)
          )
            for (var s2 = 0; s2 < e2.length; s2 += 1)
              e2[s2] && t2.append(e2[s2]);
          else t2.append(e2);
          i3.loop && this.loopCreate(),
            (i3.observer && o.observer) || this.update();
        },
        prependSlide: function (e2) {
          var t2 = this.params,
            i3 = this.$wrapperEl,
            s2 = this.activeIndex;
          t2.loop && this.loopDestroy();
          var a2 = s2 + 1;
          if (typeof e2 == "object" && "length" in e2) {
            for (var r2 = 0; r2 < e2.length; r2 += 1)
              e2[r2] && i3.prepend(e2[r2]);
            a2 = s2 + e2.length;
          } else i3.prepend(e2);
          t2.loop && this.loopCreate(),
            (t2.observer && o.observer) || this.update(),
            this.slideTo(a2, 0, !1);
        },
        addSlide: function (e2, t2) {
          var i3 = this.$wrapperEl,
            s2 = this.params,
            a2 = this.activeIndex;
          s2.loop &&
            ((a2 -= this.loopedSlides),
            this.loopDestroy(),
            (this.slides = i3.children("." + s2.slideClass)));
          var r2 = this.slides.length;
          if (e2 <= 0) this.prependSlide(t2);
          else if (e2 >= r2) this.appendSlide(t2);
          else {
            for (
              var n2 = a2 > e2 ? a2 + 1 : a2, l2 = [], d2 = r2 - 1;
              d2 >= e2;
              d2 -= 1
            ) {
              var h2 = this.slides.eq(d2);
              h2.remove(), l2.unshift(h2);
            }
            if (typeof t2 == "object" && "length" in t2) {
              for (var p2 = 0; p2 < t2.length; p2 += 1)
                t2[p2] && i3.append(t2[p2]);
              n2 = a2 > e2 ? a2 + t2.length : a2;
            } else i3.append(t2);
            for (var c2 = 0; c2 < l2.length; c2 += 1) i3.append(l2[c2]);
            s2.loop && this.loopCreate(),
              (s2.observer && o.observer) || this.update(),
              s2.loop
                ? this.slideTo(n2 + this.loopedSlides, 0, !1)
                : this.slideTo(n2, 0, !1);
          }
        },
        removeSlide: function (e2) {
          var t2 = this.params,
            i3 = this.$wrapperEl,
            s2 = this.activeIndex;
          t2.loop &&
            ((s2 -= this.loopedSlides),
            this.loopDestroy(),
            (this.slides = i3.children("." + t2.slideClass)));
          var a2,
            r2 = s2;
          if (typeof e2 == "object" && "length" in e2) {
            for (var n2 = 0; n2 < e2.length; n2 += 1)
              (a2 = e2[n2]),
                this.slides[a2] && this.slides.eq(a2).remove(),
                a2 < r2 && (r2 -= 1);
            r2 = Math.max(r2, 0);
          } else
            (a2 = e2),
              this.slides[a2] && this.slides.eq(a2).remove(),
              a2 < r2 && (r2 -= 1),
              (r2 = Math.max(r2, 0));
          t2.loop && this.loopCreate(),
            (t2.observer && o.observer) || this.update(),
            t2.loop
              ? this.slideTo(r2 + this.loopedSlides, 0, !1)
              : this.slideTo(r2, 0, !1);
        },
        removeAllSlides: function () {
          for (var e2 = [], t2 = 0; t2 < this.slides.length; t2 += 1)
            e2.push(t2);
          this.removeSlide(e2);
        },
      },
      I =
        ((m = t.navigator.platform),
        (g = t.navigator.userAgent),
        (b = {
          ios: !1,
          android: !1,
          androidChrome: !1,
          desktop: !1,
          iphone: !1,
          ipod: !1,
          ipad: !1,
          edge: !1,
          ie: !1,
          firefox: !1,
          macos: !1,
          windows: !1,
          cordova: !(!t.cordova && !t.phonegap),
          phonegap: !(!t.cordova && !t.phonegap),
          electron: !1,
        }),
        (w = t.screen.width),
        (y = t.screen.height),
        (x = g.match(/(Android);?[\s\/]+([\d.]+)?/)),
        (T = g.match(/(iPad).*OS\s([\d_]+)/)),
        (E = g.match(/(iPod)(.*OS\s([\d_]+))?/)),
        (S = !T && g.match(/(iPhone\sOS|iOS)\s([\d_]+)/)),
        (C = g.indexOf("MSIE ") >= 0 || g.indexOf("Trident/") >= 0),
        (M = g.indexOf("Edge/") >= 0),
        (P = g.indexOf("Gecko/") >= 0 && g.indexOf("Firefox/") >= 0),
        (z = m === "Win32"),
        (k = g.toLowerCase().indexOf("electron") >= 0),
        ($2 = m === "MacIntel"),
        !T &&
          $2 &&
          o.touch &&
          ((w === 1024 && y === 1366) ||
            (w === 834 && y === 1194) ||
            (w === 834 && y === 1112) ||
            (w === 768 && y === 1024)) &&
          ((T = g.match(/(Version)\/([\d.]+)/)), ($2 = !1)),
        (b.ie = C),
        (b.edge = M),
        (b.firefox = P),
        x &&
          !z &&
          ((b.os = "android"),
          (b.osVersion = x[2]),
          (b.android = !0),
          (b.androidChrome = g.toLowerCase().indexOf("chrome") >= 0)),
        (T || S || E) && ((b.os = "ios"), (b.ios = !0)),
        S && !E && ((b.osVersion = S[2].replace(/_/g, ".")), (b.iphone = !0)),
        T && ((b.osVersion = T[2].replace(/_/g, ".")), (b.ipad = !0)),
        E &&
          ((b.osVersion = E[3] ? E[3].replace(/_/g, ".") : null),
          (b.ipod = !0)),
        b.ios &&
          b.osVersion &&
          g.indexOf("Version/") >= 0 &&
          b.osVersion.split(".")[0] === "10" &&
          (b.osVersion = g.toLowerCase().split("version/")[1].split(" ")[0]),
        (b.webView =
          !(
            !(S || T || E) ||
            (!g.match(/.*AppleWebKit(?!.*Safari)/i) && !t.navigator.standalone)
          ) ||
          (t.matchMedia && t.matchMedia("(display-mode: standalone)").matches)),
        (b.webview = b.webView),
        (b.standalone = b.webView),
        (b.desktop = !(b.ios || b.android) || k),
        b.desktop &&
          ((b.electron = k),
          (b.macos = $2),
          (b.windows = z),
          b.macos && (b.os = "macos"),
          b.windows && (b.os = "windows")),
        (b.pixelRatio = t.devicePixelRatio || 1),
        b);
    function D(i3) {
      var a2 = this.touchEventsData,
        r2 = this.params,
        o2 = this.touches;
      if (!this.animating || !r2.preventInteractionOnTransition) {
        var l2 = i3;
        l2.originalEvent && (l2 = l2.originalEvent);
        var d2 = s(l2.target);
        if (
          (r2.touchEventsTarget !== "wrapper" ||
            d2.closest(this.wrapperEl).length) &&
          ((a2.isTouchEvent = l2.type === "touchstart"),
          (a2.isTouchEvent || !("which" in l2) || l2.which !== 3) &&
            !(
              (!a2.isTouchEvent && "button" in l2 && l2.button > 0) ||
              (a2.isTouched && a2.isMoved)
            ))
        ) {
          if (
            r2.noSwiping &&
            d2.closest(
              r2.noSwipingSelector
                ? r2.noSwipingSelector
                : "." + r2.noSwipingClass
            )[0]
          )
            this.allowClick = !0;
          else if (!r2.swipeHandler || d2.closest(r2.swipeHandler)[0]) {
            (o2.currentX =
              l2.type === "touchstart" ? l2.targetTouches[0].pageX : l2.pageX),
              (o2.currentY =
                l2.type === "touchstart"
                  ? l2.targetTouches[0].pageY
                  : l2.pageY);
            var h2 = o2.currentX,
              p2 = o2.currentY,
              c2 = r2.edgeSwipeDetection || r2.iOSEdgeSwipeDetection,
              u2 = r2.edgeSwipeThreshold || r2.iOSEdgeSwipeThreshold;
            if (!c2 || !(h2 <= u2 || h2 >= t.screen.width - u2)) {
              if (
                (n.extend(a2, {
                  isTouched: !0,
                  isMoved: !1,
                  allowTouchCallbacks: !0,
                  isScrolling: void 0,
                  startMoving: void 0,
                }),
                (o2.startX = h2),
                (o2.startY = p2),
                (a2.touchStartTime = n.now()),
                (this.allowClick = !0),
                this.updateSize(),
                (this.swipeDirection = void 0),
                r2.threshold > 0 && (a2.allowThresholdMove = !1),
                l2.type !== "touchstart")
              ) {
                var v2 = !0;
                d2.is(a2.formElements) && (v2 = !1),
                  e.activeElement &&
                    s(e.activeElement).is(a2.formElements) &&
                    e.activeElement !== d2[0] &&
                    e.activeElement.blur();
                var f2 =
                  v2 && this.allowTouchMove && r2.touchStartPreventDefault;
                (r2.touchStartForcePreventDefault || f2) && l2.preventDefault();
              }
              this.emit("touchStart", l2);
            }
          }
        }
      }
    }
    function O(t2) {
      var i3 = this.touchEventsData,
        a2 = this.params,
        r2 = this.touches,
        o2 = this.rtlTranslate,
        l2 = t2;
      if ((l2.originalEvent && (l2 = l2.originalEvent), i3.isTouched)) {
        if (!i3.isTouchEvent || l2.type !== "mousemove") {
          var d2 =
              l2.type === "touchmove" &&
              l2.targetTouches &&
              (l2.targetTouches[0] || l2.changedTouches[0]),
            h2 = l2.type === "touchmove" ? d2.pageX : l2.pageX,
            p2 = l2.type === "touchmove" ? d2.pageY : l2.pageY;
          if (l2.preventedByNestedSwiper)
            return (r2.startX = h2), void (r2.startY = p2);
          if (!this.allowTouchMove)
            return (
              (this.allowClick = !1),
              void (
                i3.isTouched &&
                (n.extend(r2, {
                  startX: h2,
                  startY: p2,
                  currentX: h2,
                  currentY: p2,
                }),
                (i3.touchStartTime = n.now()))
              )
            );
          if (i3.isTouchEvent && a2.touchReleaseOnEdges && !a2.loop) {
            if (this.isVertical()) {
              if (
                (p2 < r2.startY && this.translate <= this.maxTranslate()) ||
                (p2 > r2.startY && this.translate >= this.minTranslate())
              )
                return (i3.isTouched = !1), void (i3.isMoved = !1);
            } else if (
              (h2 < r2.startX && this.translate <= this.maxTranslate()) ||
              (h2 > r2.startX && this.translate >= this.minTranslate())
            )
              return;
          }
          if (
            i3.isTouchEvent &&
            e.activeElement &&
            l2.target === e.activeElement &&
            s(l2.target).is(i3.formElements)
          )
            return (i3.isMoved = !0), void (this.allowClick = !1);
          if (
            (i3.allowTouchCallbacks && this.emit("touchMove", l2),
            !(l2.targetTouches && l2.targetTouches.length > 1))
          ) {
            (r2.currentX = h2), (r2.currentY = p2);
            var c2 = r2.currentX - r2.startX,
              u2 = r2.currentY - r2.startY;
            if (
              !(
                this.params.threshold &&
                Math.sqrt(Math.pow(c2, 2) + Math.pow(u2, 2)) <
                  this.params.threshold
              )
            ) {
              var v2;
              if (
                (i3.isScrolling === void 0 &&
                  ((this.isHorizontal() && r2.currentY === r2.startY) ||
                  (this.isVertical() && r2.currentX === r2.startX)
                    ? (i3.isScrolling = !1)
                    : c2 * c2 + u2 * u2 >= 25 &&
                      ((v2 =
                        (180 * Math.atan2(Math.abs(u2), Math.abs(c2))) /
                        Math.PI),
                      (i3.isScrolling = this.isHorizontal()
                        ? v2 > a2.touchAngle
                        : 90 - v2 > a2.touchAngle))),
                i3.isScrolling && this.emit("touchMoveOpposite", l2),
                i3.startMoving === void 0 &&
                  ((r2.currentX === r2.startX && r2.currentY === r2.startY) ||
                    (i3.startMoving = !0)),
                i3.isScrolling)
              )
                i3.isTouched = !1;
              else if (i3.startMoving) {
                (this.allowClick = !1),
                  a2.cssMode || l2.preventDefault(),
                  a2.touchMoveStopPropagation &&
                    !a2.nested &&
                    l2.stopPropagation(),
                  i3.isMoved ||
                    (a2.loop && this.loopFix(),
                    (i3.startTranslate = this.getTranslate()),
                    this.setTransition(0),
                    this.animating &&
                      this.$wrapperEl.trigger(
                        "webkitTransitionEnd transitionend"
                      ),
                    (i3.allowMomentumBounce = !1),
                    !a2.grabCursor ||
                      (this.allowSlideNext !== !0 &&
                        this.allowSlidePrev !== !0) ||
                      this.setGrabCursor(!0),
                    this.emit("sliderFirstMove", l2)),
                  this.emit("sliderMove", l2),
                  (i3.isMoved = !0);
                var f2 = this.isHorizontal() ? c2 : u2;
                (r2.diff = f2),
                  (f2 *= a2.touchRatio),
                  o2 && (f2 = -f2),
                  (this.swipeDirection = f2 > 0 ? "prev" : "next"),
                  (i3.currentTranslate = f2 + i3.startTranslate);
                var m2 = !0,
                  g2 = a2.resistanceRatio;
                if (
                  (a2.touchReleaseOnEdges && (g2 = 0),
                  f2 > 0 && i3.currentTranslate > this.minTranslate()
                    ? ((m2 = !1),
                      a2.resistance &&
                        (i3.currentTranslate =
                          this.minTranslate() -
                          1 +
                          Math.pow(
                            -this.minTranslate() + i3.startTranslate + f2,
                            g2
                          )))
                    : f2 < 0 &&
                      i3.currentTranslate < this.maxTranslate() &&
                      ((m2 = !1),
                      a2.resistance &&
                        (i3.currentTranslate =
                          this.maxTranslate() +
                          1 -
                          Math.pow(
                            this.maxTranslate() - i3.startTranslate - f2,
                            g2
                          ))),
                  m2 && (l2.preventedByNestedSwiper = !0),
                  !this.allowSlideNext &&
                    this.swipeDirection === "next" &&
                    i3.currentTranslate < i3.startTranslate &&
                    (i3.currentTranslate = i3.startTranslate),
                  !this.allowSlidePrev &&
                    this.swipeDirection === "prev" &&
                    i3.currentTranslate > i3.startTranslate &&
                    (i3.currentTranslate = i3.startTranslate),
                  a2.threshold > 0)
                ) {
                  if (!(Math.abs(f2) > a2.threshold || i3.allowThresholdMove))
                    return void (i3.currentTranslate = i3.startTranslate);
                  if (!i3.allowThresholdMove)
                    return (
                      (i3.allowThresholdMove = !0),
                      (r2.startX = r2.currentX),
                      (r2.startY = r2.currentY),
                      (i3.currentTranslate = i3.startTranslate),
                      void (r2.diff = this.isHorizontal()
                        ? r2.currentX - r2.startX
                        : r2.currentY - r2.startY)
                    );
                }
                a2.followFinger &&
                  !a2.cssMode &&
                  ((a2.freeMode ||
                    a2.watchSlidesProgress ||
                    a2.watchSlidesVisibility) &&
                    (this.updateActiveIndex(), this.updateSlidesClasses()),
                  a2.freeMode &&
                    (i3.velocities.length === 0 &&
                      i3.velocities.push({
                        position: r2[this.isHorizontal() ? "startX" : "startY"],
                        time: i3.touchStartTime,
                      }),
                    i3.velocities.push({
                      position:
                        r2[this.isHorizontal() ? "currentX" : "currentY"],
                      time: n.now(),
                    })),
                  this.updateProgress(i3.currentTranslate),
                  this.setTranslate(i3.currentTranslate));
              }
            }
          }
        }
      } else i3.startMoving && i3.isScrolling && this.emit("touchMoveOpposite", l2);
    }
    function A(e2) {
      var t2 = this,
        i3 = t2.touchEventsData,
        s2 = t2.params,
        a2 = t2.touches,
        r2 = t2.rtlTranslate,
        o2 = t2.$wrapperEl,
        l2 = t2.slidesGrid,
        d2 = t2.snapGrid,
        h2 = e2;
      if (
        (h2.originalEvent && (h2 = h2.originalEvent),
        i3.allowTouchCallbacks && t2.emit("touchEnd", h2),
        (i3.allowTouchCallbacks = !1),
        !i3.isTouched)
      )
        return (
          i3.isMoved && s2.grabCursor && t2.setGrabCursor(!1),
          (i3.isMoved = !1),
          void (i3.startMoving = !1)
        );
      s2.grabCursor &&
        i3.isMoved &&
        i3.isTouched &&
        (t2.allowSlideNext === !0 || t2.allowSlidePrev === !0) &&
        t2.setGrabCursor(!1);
      var p2,
        c2 = n.now(),
        u2 = c2 - i3.touchStartTime;
      if (
        (t2.allowClick &&
          (t2.updateClickedSlide(h2),
          t2.emit("tap click", h2),
          u2 < 300 &&
            c2 - i3.lastClickTime < 300 &&
            t2.emit("doubleTap doubleClick", h2)),
        (i3.lastClickTime = n.now()),
        n.nextTick(function () {
          t2.destroyed || (t2.allowClick = !0);
        }),
        !i3.isTouched ||
          !i3.isMoved ||
          !t2.swipeDirection ||
          a2.diff === 0 ||
          i3.currentTranslate === i3.startTranslate)
      )
        return (
          (i3.isTouched = !1), (i3.isMoved = !1), void (i3.startMoving = !1)
        );
      if (
        ((i3.isTouched = !1),
        (i3.isMoved = !1),
        (i3.startMoving = !1),
        (p2 = s2.followFinger
          ? r2
            ? t2.translate
            : -t2.translate
          : -i3.currentTranslate),
        !s2.cssMode)
      )
        if (s2.freeMode) {
          if (p2 < -t2.minTranslate()) return void t2.slideTo(t2.activeIndex);
          if (p2 > -t2.maxTranslate())
            return void (t2.slides.length < d2.length
              ? t2.slideTo(d2.length - 1)
              : t2.slideTo(t2.slides.length - 1));
          if (s2.freeModeMomentum) {
            if (i3.velocities.length > 1) {
              var v2 = i3.velocities.pop(),
                f2 = i3.velocities.pop(),
                m2 = v2.position - f2.position,
                g2 = v2.time - f2.time;
              (t2.velocity = m2 / g2),
                (t2.velocity /= 2),
                Math.abs(t2.velocity) < s2.freeModeMinimumVelocity &&
                  (t2.velocity = 0),
                (g2 > 150 || n.now() - v2.time > 300) && (t2.velocity = 0);
            } else t2.velocity = 0;
            (t2.velocity *= s2.freeModeMomentumVelocityRatio),
              (i3.velocities.length = 0);
            var b2 = 1e3 * s2.freeModeMomentumRatio,
              w2 = t2.velocity * b2,
              y2 = t2.translate + w2;
            r2 && (y2 = -y2);
            var x2,
              T2,
              E2 = !1,
              S2 = 20 * Math.abs(t2.velocity) * s2.freeModeMomentumBounceRatio;
            if (y2 < t2.maxTranslate())
              s2.freeModeMomentumBounce
                ? (y2 + t2.maxTranslate() < -S2 &&
                    (y2 = t2.maxTranslate() - S2),
                  (x2 = t2.maxTranslate()),
                  (E2 = !0),
                  (i3.allowMomentumBounce = !0))
                : (y2 = t2.maxTranslate()),
                s2.loop && s2.centeredSlides && (T2 = !0);
            else if (y2 > t2.minTranslate())
              s2.freeModeMomentumBounce
                ? (y2 - t2.minTranslate() > S2 && (y2 = t2.minTranslate() + S2),
                  (x2 = t2.minTranslate()),
                  (E2 = !0),
                  (i3.allowMomentumBounce = !0))
                : (y2 = t2.minTranslate()),
                s2.loop && s2.centeredSlides && (T2 = !0);
            else if (s2.freeModeSticky) {
              for (var C2, M2 = 0; M2 < d2.length; M2 += 1)
                if (d2[M2] > -y2) {
                  C2 = M2;
                  break;
                }
              y2 = -(y2 =
                Math.abs(d2[C2] - y2) < Math.abs(d2[C2 - 1] - y2) ||
                t2.swipeDirection === "next"
                  ? d2[C2]
                  : d2[C2 - 1]);
            }
            if (
              (T2 &&
                t2.once("transitionEnd", function () {
                  t2.loopFix();
                }),
              t2.velocity !== 0)
            ) {
              if (
                ((b2 = Math.abs(
                  r2
                    ? (-y2 - t2.translate) / t2.velocity
                    : (y2 - t2.translate) / t2.velocity
                )),
                s2.freeModeSticky)
              ) {
                var P2 = Math.abs((r2 ? -y2 : y2) - t2.translate),
                  z2 = t2.slidesSizesGrid[t2.activeIndex];
                b2 =
                  P2 < z2
                    ? s2.speed
                    : P2 < 2 * z2
                    ? 1.5 * s2.speed
                    : 2.5 * s2.speed;
              }
            } else if (s2.freeModeSticky) return void t2.slideToClosest();
            s2.freeModeMomentumBounce && E2
              ? (t2.updateProgress(x2),
                t2.setTransition(b2),
                t2.setTranslate(y2),
                t2.transitionStart(!0, t2.swipeDirection),
                (t2.animating = !0),
                o2.transitionEnd(function () {
                  t2 &&
                    !t2.destroyed &&
                    i3.allowMomentumBounce &&
                    (t2.emit("momentumBounce"),
                    t2.setTransition(s2.speed),
                    setTimeout(function () {
                      t2.setTranslate(x2),
                        o2.transitionEnd(function () {
                          t2 && !t2.destroyed && t2.transitionEnd();
                        });
                    }, 0));
                }))
              : t2.velocity
              ? (t2.updateProgress(y2),
                t2.setTransition(b2),
                t2.setTranslate(y2),
                t2.transitionStart(!0, t2.swipeDirection),
                t2.animating ||
                  ((t2.animating = !0),
                  o2.transitionEnd(function () {
                    t2 && !t2.destroyed && t2.transitionEnd();
                  })))
              : t2.updateProgress(y2),
              t2.updateActiveIndex(),
              t2.updateSlidesClasses();
          } else if (s2.freeModeSticky) return void t2.slideToClosest();
          (!s2.freeModeMomentum || u2 >= s2.longSwipesMs) &&
            (t2.updateProgress(),
            t2.updateActiveIndex(),
            t2.updateSlidesClasses());
        } else {
          for (
            var k2 = 0, $3 = t2.slidesSizesGrid[0], L2 = 0;
            L2 < l2.length;
            L2 += L2 < s2.slidesPerGroupSkip ? 1 : s2.slidesPerGroup
          ) {
            var I2 = L2 < s2.slidesPerGroupSkip - 1 ? 1 : s2.slidesPerGroup;
            l2[L2 + I2] !== void 0
              ? p2 >= l2[L2] &&
                p2 < l2[L2 + I2] &&
                ((k2 = L2), ($3 = l2[L2 + I2] - l2[L2]))
              : p2 >= l2[L2] &&
                ((k2 = L2), ($3 = l2[l2.length - 1] - l2[l2.length - 2]));
          }
          var D2 = (p2 - l2[k2]) / $3,
            O2 = k2 < s2.slidesPerGroupSkip - 1 ? 1 : s2.slidesPerGroup;
          if (u2 > s2.longSwipesMs) {
            if (!s2.longSwipes) return void t2.slideTo(t2.activeIndex);
            t2.swipeDirection === "next" &&
              (D2 >= s2.longSwipesRatio ? t2.slideTo(k2 + O2) : t2.slideTo(k2)),
              t2.swipeDirection === "prev" &&
                (D2 > 1 - s2.longSwipesRatio
                  ? t2.slideTo(k2 + O2)
                  : t2.slideTo(k2));
          } else {
            if (!s2.shortSwipes) return void t2.slideTo(t2.activeIndex);
            t2.navigation &&
            (h2.target === t2.navigation.nextEl ||
              h2.target === t2.navigation.prevEl)
              ? h2.target === t2.navigation.nextEl
                ? t2.slideTo(k2 + O2)
                : t2.slideTo(k2)
              : (t2.swipeDirection === "next" && t2.slideTo(k2 + O2),
                t2.swipeDirection === "prev" && t2.slideTo(k2));
          }
        }
    }
    function G() {
      var e2 = this.params,
        t2 = this.el;
      if (!t2 || t2.offsetWidth !== 0) {
        e2.breakpoints && this.setBreakpoint();
        var i3 = this.allowSlideNext,
          s2 = this.allowSlidePrev,
          a2 = this.snapGrid;
        (this.allowSlideNext = !0),
          (this.allowSlidePrev = !0),
          this.updateSize(),
          this.updateSlides(),
          this.updateSlidesClasses(),
          (e2.slidesPerView === "auto" || e2.slidesPerView > 1) &&
          this.isEnd &&
          !this.params.centeredSlides
            ? this.slideTo(this.slides.length - 1, 0, !1, !0)
            : this.slideTo(this.activeIndex, 0, !1, !0),
          this.autoplay &&
            this.autoplay.running &&
            this.autoplay.paused &&
            this.autoplay.run(),
          (this.allowSlidePrev = s2),
          (this.allowSlideNext = i3),
          this.params.watchOverflow &&
            a2 !== this.snapGrid &&
            this.checkOverflow();
      }
    }
    function H(e2) {
      this.allowClick ||
        (this.params.preventClicks && e2.preventDefault(),
        this.params.preventClicksPropagation &&
          this.animating &&
          (e2.stopPropagation(), e2.stopImmediatePropagation()));
    }
    function B() {
      var e2 = this.wrapperEl,
        t2 = this.rtlTranslate;
      (this.previousTranslate = this.translate),
        this.isHorizontal()
          ? (this.translate = t2
              ? e2.scrollWidth - e2.offsetWidth - e2.scrollLeft
              : -e2.scrollLeft)
          : (this.translate = -e2.scrollTop),
        this.translate === -0 && (this.translate = 0),
        this.updateActiveIndex(),
        this.updateSlidesClasses();
      var i3 = this.maxTranslate() - this.minTranslate();
      (i3 === 0 ? 0 : (this.translate - this.minTranslate()) / i3) !==
        this.progress &&
        this.updateProgress(t2 ? -this.translate : this.translate),
        this.emit("setTranslate", this.translate, !1);
    }
    var N = !1;
    function X() {}
    var V = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        preventInteractionOnTransition: !1,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: 0.02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: 0.85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: "swiper-container-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-invisible-blank",
        slideActiveClass: "swiper-slide-active",
        slideDuplicateActiveClass: "swiper-slide-duplicate-active",
        slideVisibleClass: "swiper-slide-visible",
        slideDuplicateClass: "swiper-slide-duplicate",
        slideNextClass: "swiper-slide-next",
        slideDuplicateNextClass: "swiper-slide-duplicate-next",
        slidePrevClass: "swiper-slide-prev",
        slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
        wrapperClass: "swiper-wrapper",
        runCallbacksOnInit: !0,
      },
      Y = {
        update: h,
        translate: p,
        transition: c,
        slide: u,
        loop: v,
        grabCursor: f,
        manipulation: L,
        events: {
          attachEvents: function () {
            var t2 = this.params,
              i3 = this.touchEvents,
              s2 = this.el,
              a2 = this.wrapperEl;
            (this.onTouchStart = D.bind(this)),
              (this.onTouchMove = O.bind(this)),
              (this.onTouchEnd = A.bind(this)),
              t2.cssMode && (this.onScroll = B.bind(this)),
              (this.onClick = H.bind(this));
            var r2 = !!t2.nested;
            if (!o.touch && o.pointerEvents)
              s2.addEventListener(i3.start, this.onTouchStart, !1),
                e.addEventListener(i3.move, this.onTouchMove, r2),
                e.addEventListener(i3.end, this.onTouchEnd, !1);
            else {
              if (o.touch) {
                var n2 = !(
                  i3.start !== "touchstart" ||
                  !o.passiveListener ||
                  !t2.passiveListeners
                ) && { passive: !0, capture: !1 };
                s2.addEventListener(i3.start, this.onTouchStart, n2),
                  s2.addEventListener(
                    i3.move,
                    this.onTouchMove,
                    o.passiveListener ? { passive: !1, capture: r2 } : r2
                  ),
                  s2.addEventListener(i3.end, this.onTouchEnd, n2),
                  i3.cancel &&
                    s2.addEventListener(i3.cancel, this.onTouchEnd, n2),
                  N || (e.addEventListener("touchstart", X), (N = !0));
              }
              ((t2.simulateTouch && !I.ios && !I.android) ||
                (t2.simulateTouch && !o.touch && I.ios)) &&
                (s2.addEventListener("mousedown", this.onTouchStart, !1),
                e.addEventListener("mousemove", this.onTouchMove, r2),
                e.addEventListener("mouseup", this.onTouchEnd, !1));
            }
            (t2.preventClicks || t2.preventClicksPropagation) &&
              s2.addEventListener("click", this.onClick, !0),
              t2.cssMode && a2.addEventListener("scroll", this.onScroll),
              t2.updateOnWindowResize
                ? this.on(
                    I.ios || I.android
                      ? "resize orientationchange observerUpdate"
                      : "resize observerUpdate",
                    G,
                    !0
                  )
                : this.on("observerUpdate", G, !0);
          },
          detachEvents: function () {
            var t2 = this.params,
              i3 = this.touchEvents,
              s2 = this.el,
              a2 = this.wrapperEl,
              r2 = !!t2.nested;
            if (!o.touch && o.pointerEvents)
              s2.removeEventListener(i3.start, this.onTouchStart, !1),
                e.removeEventListener(i3.move, this.onTouchMove, r2),
                e.removeEventListener(i3.end, this.onTouchEnd, !1);
            else {
              if (o.touch) {
                var n2 = !(
                  i3.start !== "onTouchStart" ||
                  !o.passiveListener ||
                  !t2.passiveListeners
                ) && { passive: !0, capture: !1 };
                s2.removeEventListener(i3.start, this.onTouchStart, n2),
                  s2.removeEventListener(i3.move, this.onTouchMove, r2),
                  s2.removeEventListener(i3.end, this.onTouchEnd, n2),
                  i3.cancel &&
                    s2.removeEventListener(i3.cancel, this.onTouchEnd, n2);
              }
              ((t2.simulateTouch && !I.ios && !I.android) ||
                (t2.simulateTouch && !o.touch && I.ios)) &&
                (s2.removeEventListener("mousedown", this.onTouchStart, !1),
                e.removeEventListener("mousemove", this.onTouchMove, r2),
                e.removeEventListener("mouseup", this.onTouchEnd, !1));
            }
            (t2.preventClicks || t2.preventClicksPropagation) &&
              s2.removeEventListener("click", this.onClick, !0),
              t2.cssMode && a2.removeEventListener("scroll", this.onScroll),
              this.off(
                I.ios || I.android
                  ? "resize orientationchange observerUpdate"
                  : "resize observerUpdate",
                G
              );
          },
        },
        breakpoints: {
          setBreakpoint: function () {
            var e2 = this.activeIndex,
              t2 = this.initialized,
              i3 = this.loopedSlides;
            i3 === void 0 && (i3 = 0);
            var s2 = this.params,
              a2 = this.$el,
              r2 = s2.breakpoints;
            if (r2 && (!r2 || Object.keys(r2).length !== 0)) {
              var o2 = this.getBreakpoint(r2);
              if (o2 && this.currentBreakpoint !== o2) {
                var l2 = o2 in r2 ? r2[o2] : void 0;
                l2 &&
                  [
                    "slidesPerView",
                    "spaceBetween",
                    "slidesPerGroup",
                    "slidesPerGroupSkip",
                    "slidesPerColumn",
                  ].forEach(function (e3) {
                    var t3 = l2[e3];
                    t3 !== void 0 &&
                      (l2[e3] =
                        e3 !== "slidesPerView" ||
                        (t3 !== "AUTO" && t3 !== "auto")
                          ? e3 === "slidesPerView"
                            ? parseFloat(t3)
                            : parseInt(t3, 10)
                          : "auto");
                  });
                var d2 = l2 || this.originalParams,
                  h2 = s2.slidesPerColumn > 1,
                  p2 = d2.slidesPerColumn > 1;
                h2 && !p2
                  ? a2.removeClass(
                      s2.containerModifierClass +
                        "multirow " +
                        s2.containerModifierClass +
                        "multirow-column"
                    )
                  : !h2 &&
                    p2 &&
                    (a2.addClass(s2.containerModifierClass + "multirow"),
                    d2.slidesPerColumnFill === "column" &&
                      a2.addClass(
                        s2.containerModifierClass + "multirow-column"
                      ));
                var c2 = d2.direction && d2.direction !== s2.direction,
                  u2 = s2.loop && (d2.slidesPerView !== s2.slidesPerView || c2);
                c2 && t2 && this.changeDirection(),
                  n.extend(this.params, d2),
                  n.extend(this, {
                    allowTouchMove: this.params.allowTouchMove,
                    allowSlideNext: this.params.allowSlideNext,
                    allowSlidePrev: this.params.allowSlidePrev,
                  }),
                  (this.currentBreakpoint = o2),
                  u2 &&
                    t2 &&
                    (this.loopDestroy(),
                    this.loopCreate(),
                    this.updateSlides(),
                    this.slideTo(e2 - i3 + this.loopedSlides, 0, !1)),
                  this.emit("breakpoint", d2);
              }
            }
          },
          getBreakpoint: function (e2) {
            if (e2) {
              var i3 = !1,
                s2 = Object.keys(e2).map(function (e3) {
                  if (typeof e3 == "string" && e3.indexOf("@") === 0) {
                    var i4 = parseFloat(e3.substr(1));
                    return { value: t.innerHeight * i4, point: e3 };
                  }
                  return { value: e3, point: e3 };
                });
              s2.sort(function (e3, t2) {
                return parseInt(e3.value, 10) - parseInt(t2.value, 10);
              });
              for (var a2 = 0; a2 < s2.length; a2 += 1) {
                var r2 = s2[a2],
                  n2 = r2.point;
                r2.value <= t.innerWidth && (i3 = n2);
              }
              return i3 || "max";
            }
          },
        },
        checkOverflow: {
          checkOverflow: function () {
            var e2 = this.params,
              t2 = this.isLocked,
              i3 =
                this.slides.length > 0 &&
                e2.slidesOffsetBefore +
                  e2.spaceBetween * (this.slides.length - 1) +
                  this.slides[0].offsetWidth * this.slides.length;
            e2.slidesOffsetBefore && e2.slidesOffsetAfter && i3
              ? (this.isLocked = i3 <= this.size)
              : (this.isLocked = this.snapGrid.length === 1),
              (this.allowSlideNext = !this.isLocked),
              (this.allowSlidePrev = !this.isLocked),
              t2 !== this.isLocked &&
                this.emit(this.isLocked ? "lock" : "unlock"),
              t2 &&
                t2 !== this.isLocked &&
                ((this.isEnd = !1), this.navigation.update());
          },
        },
        classes: {
          addClasses: function () {
            var e2 = this.classNames,
              t2 = this.params,
              i3 = this.rtl,
              s2 = this.$el,
              a2 = [];
            a2.push("initialized"),
              a2.push(t2.direction),
              t2.freeMode && a2.push("free-mode"),
              t2.autoHeight && a2.push("autoheight"),
              i3 && a2.push("rtl"),
              t2.slidesPerColumn > 1 &&
                (a2.push("multirow"),
                t2.slidesPerColumnFill === "column" &&
                  a2.push("multirow-column")),
              I.android && a2.push("android"),
              I.ios && a2.push("ios"),
              t2.cssMode && a2.push("css-mode"),
              a2.forEach(function (i4) {
                e2.push(t2.containerModifierClass + i4);
              }),
              s2.addClass(e2.join(" "));
          },
          removeClasses: function () {
            var e2 = this.$el,
              t2 = this.classNames;
            e2.removeClass(t2.join(" "));
          },
        },
        images: {
          loadImage: function (e2, i3, s2, a2, r2, n2) {
            var o2;
            function l2() {
              n2 && n2();
            }
            e2.complete && r2
              ? l2()
              : i3
              ? (((o2 = new t.Image()).onload = l2),
                (o2.onerror = l2),
                a2 && (o2.sizes = a2),
                s2 && (o2.srcset = s2),
                i3 && (o2.src = i3))
              : l2();
          },
          preloadImages: function () {
            var e2 = this;
            function t2() {
              e2 != null &&
                e2 &&
                !e2.destroyed &&
                (e2.imagesLoaded !== void 0 && (e2.imagesLoaded += 1),
                e2.imagesLoaded === e2.imagesToLoad.length &&
                  (e2.params.updateOnImagesReady && e2.update(),
                  e2.emit("imagesReady")));
            }
            e2.imagesToLoad = e2.$el.find("img");
            for (var i3 = 0; i3 < e2.imagesToLoad.length; i3 += 1) {
              var s2 = e2.imagesToLoad[i3];
              e2.loadImage(
                s2,
                s2.currentSrc || s2.getAttribute("src"),
                s2.srcset || s2.getAttribute("srcset"),
                s2.sizes || s2.getAttribute("sizes"),
                !0,
                t2
              );
            }
          },
        },
      },
      F = {},
      W = (function (e2) {
        function t2() {
          for (var i4, a2, r2, l2 = [], d2 = arguments.length; d2--; )
            l2[d2] = arguments[d2];
          l2.length === 1 && l2[0].constructor && l2[0].constructor === Object
            ? (r2 = l2[0])
            : ((a2 = (i4 = l2)[0]), (r2 = i4[1])),
            r2 || (r2 = {}),
            (r2 = n.extend({}, r2)),
            a2 && !r2.el && (r2.el = a2),
            e2.call(this, r2),
            Object.keys(Y).forEach(function (e3) {
              Object.keys(Y[e3]).forEach(function (i5) {
                t2.prototype[i5] || (t2.prototype[i5] = Y[e3][i5]);
              });
            });
          var h2 = this;
          h2.modules === void 0 && (h2.modules = {}),
            Object.keys(h2.modules).forEach(function (e3) {
              var t3 = h2.modules[e3];
              if (t3.params) {
                var i5 = Object.keys(t3.params)[0],
                  s2 = t3.params[i5];
                if (
                  typeof s2 != "object" ||
                  s2 === null ||
                  !(i5 in r2) ||
                  !("enabled" in s2)
                )
                  return;
                r2[i5] === !0 && (r2[i5] = { enabled: !0 }),
                  typeof r2[i5] != "object" ||
                    "enabled" in r2[i5] ||
                    (r2[i5].enabled = !0),
                  r2[i5] || (r2[i5] = { enabled: !1 });
              }
            });
          var p2 = n.extend({}, V);
          h2.useModulesParams(p2),
            (h2.params = n.extend({}, p2, F, r2)),
            (h2.originalParams = n.extend({}, h2.params)),
            (h2.passedParams = n.extend({}, r2)),
            (h2.$ = s);
          var c2 = s(h2.params.el);
          if ((a2 = c2[0])) {
            if (c2.length > 1) {
              var u2 = [];
              return (
                c2.each(function (e3, i5) {
                  var s2 = n.extend({}, r2, { el: i5 });
                  u2.push(new t2(s2));
                }),
                u2
              );
            }
            var v2, f2, m2;
            return (
              (a2.swiper = h2),
              c2.data("swiper", h2),
              a2 && a2.shadowRoot && a2.shadowRoot.querySelector
                ? ((v2 = s(
                    a2.shadowRoot.querySelector("." + h2.params.wrapperClass)
                  )).children = function (e3) {
                    return c2.children(e3);
                  })
                : (v2 = c2.children("." + h2.params.wrapperClass)),
              n.extend(h2, {
                $el: c2,
                el: a2,
                $wrapperEl: v2,
                wrapperEl: v2[0],
                classNames: [],
                slides: s(),
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal: function () {
                  return h2.params.direction === "horizontal";
                },
                isVertical: function () {
                  return h2.params.direction === "vertical";
                },
                rtl:
                  a2.dir.toLowerCase() === "rtl" ||
                  c2.css("direction") === "rtl",
                rtlTranslate:
                  h2.params.direction === "horizontal" &&
                  (a2.dir.toLowerCase() === "rtl" ||
                    c2.css("direction") === "rtl"),
                wrongRTL: v2.css("display") === "-webkit-box",
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                allowSlideNext: h2.params.allowSlideNext,
                allowSlidePrev: h2.params.allowSlidePrev,
                touchEvents:
                  ((f2 = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel",
                  ]),
                  (m2 = ["mousedown", "mousemove", "mouseup"]),
                  o.pointerEvents &&
                    (m2 = ["pointerdown", "pointermove", "pointerup"]),
                  (h2.touchEventsTouch = {
                    start: f2[0],
                    move: f2[1],
                    end: f2[2],
                    cancel: f2[3],
                  }),
                  (h2.touchEventsDesktop = {
                    start: m2[0],
                    move: m2[1],
                    end: m2[2],
                  }),
                  o.touch || !h2.params.simulateTouch
                    ? h2.touchEventsTouch
                    : h2.touchEventsDesktop),
                touchEventsData: {
                  isTouched: void 0,
                  isMoved: void 0,
                  allowTouchCallbacks: void 0,
                  touchStartTime: void 0,
                  isScrolling: void 0,
                  currentTranslate: void 0,
                  startTranslate: void 0,
                  allowThresholdMove: void 0,
                  formElements:
                    "input, select, option, textarea, button, video, label",
                  lastClickTime: n.now(),
                  clickTimeout: void 0,
                  velocities: [],
                  allowMomentumBounce: void 0,
                  isTouchEvent: void 0,
                  startMoving: void 0,
                },
                allowClick: !0,
                allowTouchMove: h2.params.allowTouchMove,
                touches: {
                  startX: 0,
                  startY: 0,
                  currentX: 0,
                  currentY: 0,
                  diff: 0,
                },
                imagesToLoad: [],
                imagesLoaded: 0,
              }),
              h2.useModules(),
              h2.params.init && h2.init(),
              h2
            );
          }
        }
        e2 && (t2.__proto__ = e2),
          (t2.prototype = Object.create(e2 && e2.prototype)),
          (t2.prototype.constructor = t2);
        var i3 = {
          extendedDefaults: { configurable: !0 },
          defaults: { configurable: !0 },
          Class: { configurable: !0 },
          $: { configurable: !0 },
        };
        return (
          (t2.prototype.slidesPerViewDynamic = function () {
            var e3 = this.params,
              t3 = this.slides,
              i4 = this.slidesGrid,
              s2 = this.size,
              a2 = this.activeIndex,
              r2 = 1;
            if (e3.centeredSlides) {
              for (
                var n2, o2 = t3[a2].swiperSlideSize, l2 = a2 + 1;
                l2 < t3.length;
                l2 += 1
              )
                t3[l2] &&
                  !n2 &&
                  ((r2 += 1), (o2 += t3[l2].swiperSlideSize) > s2 && (n2 = !0));
              for (var d2 = a2 - 1; d2 >= 0; d2 -= 1)
                t3[d2] &&
                  !n2 &&
                  ((r2 += 1), (o2 += t3[d2].swiperSlideSize) > s2 && (n2 = !0));
            } else
              for (var h2 = a2 + 1; h2 < t3.length; h2 += 1)
                i4[h2] - i4[a2] < s2 && (r2 += 1);
            return r2;
          }),
          (t2.prototype.update = function () {
            var e3 = this;
            if (e3 && !e3.destroyed) {
              var t3 = e3.snapGrid,
                i4 = e3.params;
              i4.breakpoints && e3.setBreakpoint(),
                e3.updateSize(),
                e3.updateSlides(),
                e3.updateProgress(),
                e3.updateSlidesClasses(),
                e3.params.freeMode
                  ? (s2(), e3.params.autoHeight && e3.updateAutoHeight())
                  : ((e3.params.slidesPerView === "auto" ||
                      e3.params.slidesPerView > 1) &&
                    e3.isEnd &&
                    !e3.params.centeredSlides
                      ? e3.slideTo(e3.slides.length - 1, 0, !1, !0)
                      : e3.slideTo(e3.activeIndex, 0, !1, !0)) || s2(),
                i4.watchOverflow && t3 !== e3.snapGrid && e3.checkOverflow(),
                e3.emit("update");
            }
            function s2() {
              var t4 = e3.rtlTranslate ? -1 * e3.translate : e3.translate,
                i5 = Math.min(
                  Math.max(t4, e3.maxTranslate()),
                  e3.minTranslate()
                );
              e3.setTranslate(i5),
                e3.updateActiveIndex(),
                e3.updateSlidesClasses();
            }
          }),
          (t2.prototype.changeDirection = function (e3, t3) {
            t3 === void 0 && (t3 = !0);
            var i4 = this.params.direction;
            return (
              e3 || (e3 = i4 === "horizontal" ? "vertical" : "horizontal"),
              e3 === i4 ||
                (e3 !== "horizontal" && e3 !== "vertical") ||
                (this.$el
                  .removeClass("" + this.params.containerModifierClass + i4)
                  .addClass("" + this.params.containerModifierClass + e3),
                (this.params.direction = e3),
                this.slides.each(function (t4, i5) {
                  e3 === "vertical"
                    ? (i5.style.width = "")
                    : (i5.style.height = "");
                }),
                this.emit("changeDirection"),
                t3 && this.update()),
              this
            );
          }),
          (t2.prototype.init = function () {
            this.initialized ||
              (this.emit("beforeInit"),
              this.params.breakpoints && this.setBreakpoint(),
              this.addClasses(),
              this.params.loop && this.loopCreate(),
              this.updateSize(),
              this.updateSlides(),
              this.params.watchOverflow && this.checkOverflow(),
              this.params.grabCursor && this.setGrabCursor(),
              this.params.preloadImages && this.preloadImages(),
              this.params.loop
                ? this.slideTo(
                    this.params.initialSlide + this.loopedSlides,
                    0,
                    this.params.runCallbacksOnInit
                  )
                : this.slideTo(
                    this.params.initialSlide,
                    0,
                    this.params.runCallbacksOnInit
                  ),
              this.attachEvents(),
              (this.initialized = !0),
              this.emit("init"));
          }),
          (t2.prototype.destroy = function (e3, t3) {
            e3 === void 0 && (e3 = !0), t3 === void 0 && (t3 = !0);
            var i4 = this,
              s2 = i4.params,
              a2 = i4.$el,
              r2 = i4.$wrapperEl,
              o2 = i4.slides;
            return (
              i4.params === void 0 ||
                i4.destroyed ||
                (i4.emit("beforeDestroy"),
                (i4.initialized = !1),
                i4.detachEvents(),
                s2.loop && i4.loopDestroy(),
                t3 &&
                  (i4.removeClasses(),
                  a2.removeAttr("style"),
                  r2.removeAttr("style"),
                  o2 &&
                    o2.length &&
                    o2
                      .removeClass(
                        [
                          s2.slideVisibleClass,
                          s2.slideActiveClass,
                          s2.slideNextClass,
                          s2.slidePrevClass,
                        ].join(" ")
                      )
                      .removeAttr("style")
                      .removeAttr("data-swiper-slide-index")),
                i4.emit("destroy"),
                Object.keys(i4.eventsListeners).forEach(function (e4) {
                  i4.off(e4);
                }),
                e3 !== !1 &&
                  ((i4.$el[0].swiper = null),
                  i4.$el.data("swiper", null),
                  n.deleteProps(i4)),
                (i4.destroyed = !0)),
              null
            );
          }),
          (t2.extendDefaults = function (e3) {
            n.extend(F, e3);
          }),
          (i3.extendedDefaults.get = function () {
            return F;
          }),
          (i3.defaults.get = function () {
            return V;
          }),
          (i3.Class.get = function () {
            return e2;
          }),
          (i3.$.get = function () {
            return s;
          }),
          Object.defineProperties(t2, i3),
          t2
        );
      })(l),
      R = { name: "device", proto: { device: I }, static: { device: I } },
      q = { name: "support", proto: { support: o }, static: { support: o } },
      j = {
        isEdge: !!t.navigator.userAgent.match(/Edge/g),
        isSafari: (function () {
          var e2 = t.navigator.userAgent.toLowerCase();
          return (
            e2.indexOf("safari") >= 0 &&
            e2.indexOf("chrome") < 0 &&
            e2.indexOf("android") < 0
          );
        })(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
          t.navigator.userAgent
        ),
      },
      K = { name: "browser", proto: { browser: j }, static: { browser: j } },
      U = {
        name: "resize",
        create: function () {
          var e2 = this;
          n.extend(e2, {
            resize: {
              resizeHandler: function () {
                e2 &&
                  !e2.destroyed &&
                  e2.initialized &&
                  (e2.emit("beforeResize"), e2.emit("resize"));
              },
              orientationChangeHandler: function () {
                e2 &&
                  !e2.destroyed &&
                  e2.initialized &&
                  e2.emit("orientationchange");
              },
            },
          });
        },
        on: {
          init: function () {
            t.addEventListener("resize", this.resize.resizeHandler),
              t.addEventListener(
                "orientationchange",
                this.resize.orientationChangeHandler
              );
          },
          destroy: function () {
            t.removeEventListener("resize", this.resize.resizeHandler),
              t.removeEventListener(
                "orientationchange",
                this.resize.orientationChangeHandler
              );
          },
        },
      },
      _ = {
        func: t.MutationObserver || t.WebkitMutationObserver,
        attach: function (e2, i3) {
          i3 === void 0 && (i3 = {});
          var s2 = this,
            a2 = new _.func(function (e3) {
              if (e3.length !== 1) {
                var i4 = function () {
                  s2.emit("observerUpdate", e3[0]);
                };
                t.requestAnimationFrame
                  ? t.requestAnimationFrame(i4)
                  : t.setTimeout(i4, 0);
              } else s2.emit("observerUpdate", e3[0]);
            });
          a2.observe(e2, {
            attributes: i3.attributes === void 0 || i3.attributes,
            childList: i3.childList === void 0 || i3.childList,
            characterData: i3.characterData === void 0 || i3.characterData,
          }),
            s2.observer.observers.push(a2);
        },
        init: function () {
          if (o.observer && this.params.observer) {
            if (this.params.observeParents)
              for (var e2 = this.$el.parents(), t2 = 0; t2 < e2.length; t2 += 1)
                this.observer.attach(e2[t2]);
            this.observer.attach(this.$el[0], {
              childList: this.params.observeSlideChildren,
            }),
              this.observer.attach(this.$wrapperEl[0], { attributes: !1 });
          }
        },
        destroy: function () {
          this.observer.observers.forEach(function (e2) {
            e2.disconnect();
          }),
            (this.observer.observers = []);
        },
      },
      Z = {
        name: "observer",
        params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
        create: function () {
          n.extend(this, {
            observer: {
              init: _.init.bind(this),
              attach: _.attach.bind(this),
              destroy: _.destroy.bind(this),
              observers: [],
            },
          });
        },
        on: {
          init: function () {
            this.observer.init();
          },
          destroy: function () {
            this.observer.destroy();
          },
        },
      },
      Q = {
        update: function (e2) {
          var t2 = this,
            i3 = t2.params,
            s2 = i3.slidesPerView,
            a2 = i3.slidesPerGroup,
            r2 = i3.centeredSlides,
            o2 = t2.params.virtual,
            l2 = o2.addSlidesBefore,
            d2 = o2.addSlidesAfter,
            h2 = t2.virtual,
            p2 = h2.from,
            c2 = h2.to,
            u2 = h2.slides,
            v2 = h2.slidesGrid,
            f2 = h2.renderSlide,
            m2 = h2.offset;
          t2.updateActiveIndex();
          var g2,
            b2,
            w2,
            y2 = t2.activeIndex || 0;
          (g2 = t2.rtlTranslate ? "right" : t2.isHorizontal() ? "left" : "top"),
            r2
              ? ((b2 = Math.floor(s2 / 2) + a2 + l2),
                (w2 = Math.floor(s2 / 2) + a2 + d2))
              : ((b2 = s2 + (a2 - 1) + l2), (w2 = a2 + d2));
          var x2 = Math.max((y2 || 0) - w2, 0),
            T2 = Math.min((y2 || 0) + b2, u2.length - 1),
            E2 = (t2.slidesGrid[x2] || 0) - (t2.slidesGrid[0] || 0);
          function S2() {
            t2.updateSlides(),
              t2.updateProgress(),
              t2.updateSlidesClasses(),
              t2.lazy && t2.params.lazy.enabled && t2.lazy.load();
          }
          if (
            (n.extend(t2.virtual, {
              from: x2,
              to: T2,
              offset: E2,
              slidesGrid: t2.slidesGrid,
            }),
            p2 === x2 && c2 === T2 && !e2)
          )
            return (
              t2.slidesGrid !== v2 && E2 !== m2 && t2.slides.css(g2, E2 + "px"),
              void t2.updateProgress()
            );
          if (t2.params.virtual.renderExternal)
            return (
              t2.params.virtual.renderExternal.call(t2, {
                offset: E2,
                from: x2,
                to: T2,
                slides: (function () {
                  for (var e3 = [], t3 = x2; t3 <= T2; t3 += 1) e3.push(u2[t3]);
                  return e3;
                })(),
              }),
              void S2()
            );
          var C2 = [],
            M2 = [];
          if (e2) t2.$wrapperEl.find("." + t2.params.slideClass).remove();
          else
            for (var P2 = p2; P2 <= c2; P2 += 1)
              (P2 < x2 || P2 > T2) &&
                t2.$wrapperEl
                  .find(
                    "." +
                      t2.params.slideClass +
                      '[data-swiper-slide-index="' +
                      P2 +
                      '"]'
                  )
                  .remove();
          for (var z2 = 0; z2 < u2.length; z2 += 1)
            z2 >= x2 &&
              z2 <= T2 &&
              (c2 === void 0 || e2
                ? M2.push(z2)
                : (z2 > c2 && M2.push(z2), z2 < p2 && C2.push(z2)));
          M2.forEach(function (e3) {
            t2.$wrapperEl.append(f2(u2[e3], e3));
          }),
            C2.sort(function (e3, t3) {
              return t3 - e3;
            }).forEach(function (e3) {
              t2.$wrapperEl.prepend(f2(u2[e3], e3));
            }),
            t2.$wrapperEl.children(".swiper-slide").css(g2, E2 + "px"),
            S2();
        },
        renderSlide: function (e2, t2) {
          var i3 = this.params.virtual;
          if (i3.cache && this.virtual.cache[t2]) return this.virtual.cache[t2];
          var a2 = i3.renderSlide
            ? s(i3.renderSlide.call(this, e2, t2))
            : s(
                '<div class="' +
                  this.params.slideClass +
                  '" data-swiper-slide-index="' +
                  t2 +
                  '">' +
                  e2 +
                  "</div>"
              );
          return (
            a2.attr("data-swiper-slide-index") ||
              a2.attr("data-swiper-slide-index", t2),
            i3.cache && (this.virtual.cache[t2] = a2),
            a2
          );
        },
        appendSlide: function (e2) {
          if (typeof e2 == "object" && "length" in e2)
            for (var t2 = 0; t2 < e2.length; t2 += 1)
              e2[t2] && this.virtual.slides.push(e2[t2]);
          else this.virtual.slides.push(e2);
          this.virtual.update(!0);
        },
        prependSlide: function (e2) {
          var t2 = this.activeIndex,
            i3 = t2 + 1,
            s2 = 1;
          if (Array.isArray(e2)) {
            for (var a2 = 0; a2 < e2.length; a2 += 1)
              e2[a2] && this.virtual.slides.unshift(e2[a2]);
            (i3 = t2 + e2.length), (s2 = e2.length);
          } else this.virtual.slides.unshift(e2);
          if (this.params.virtual.cache) {
            var r2 = this.virtual.cache,
              n2 = {};
            Object.keys(r2).forEach(function (e3) {
              var t3 = r2[e3],
                i4 = t3.attr("data-swiper-slide-index");
              i4 && t3.attr("data-swiper-slide-index", parseInt(i4, 10) + 1),
                (n2[parseInt(e3, 10) + s2] = t3);
            }),
              (this.virtual.cache = n2);
          }
          this.virtual.update(!0), this.slideTo(i3, 0);
        },
        removeSlide: function (e2) {
          if (e2 != null) {
            var t2 = this.activeIndex;
            if (Array.isArray(e2))
              for (var i3 = e2.length - 1; i3 >= 0; i3 -= 1)
                this.virtual.slides.splice(e2[i3], 1),
                  this.params.virtual.cache &&
                    delete this.virtual.cache[e2[i3]],
                  e2[i3] < t2 && (t2 -= 1),
                  (t2 = Math.max(t2, 0));
            else
              this.virtual.slides.splice(e2, 1),
                this.params.virtual.cache && delete this.virtual.cache[e2],
                e2 < t2 && (t2 -= 1),
                (t2 = Math.max(t2, 0));
            this.virtual.update(!0), this.slideTo(t2, 0);
          }
        },
        removeAllSlides: function () {
          (this.virtual.slides = []),
            this.params.virtual.cache && (this.virtual.cache = {}),
            this.virtual.update(!0),
            this.slideTo(0, 0);
        },
      },
      J = {
        name: "virtual",
        params: {
          virtual: {
            enabled: !1,
            slides: [],
            cache: !0,
            renderSlide: null,
            renderExternal: null,
            addSlidesBefore: 0,
            addSlidesAfter: 0,
          },
        },
        create: function () {
          n.extend(this, {
            virtual: {
              update: Q.update.bind(this),
              appendSlide: Q.appendSlide.bind(this),
              prependSlide: Q.prependSlide.bind(this),
              removeSlide: Q.removeSlide.bind(this),
              removeAllSlides: Q.removeAllSlides.bind(this),
              renderSlide: Q.renderSlide.bind(this),
              slides: this.params.virtual.slides,
              cache: {},
            },
          });
        },
        on: {
          beforeInit: function () {
            if (this.params.virtual.enabled) {
              this.classNames.push(
                this.params.containerModifierClass + "virtual"
              );
              var e2 = { watchSlidesProgress: !0 };
              n.extend(this.params, e2),
                n.extend(this.originalParams, e2),
                this.params.initialSlide || this.virtual.update();
            }
          },
          setTranslate: function () {
            this.params.virtual.enabled && this.virtual.update();
          },
        },
      },
      ee = {
        handle: function (i3) {
          var s2 = this.rtlTranslate,
            a2 = i3;
          a2.originalEvent && (a2 = a2.originalEvent);
          var r2 = a2.keyCode || a2.charCode;
          if (
            (!this.allowSlideNext &&
              ((this.isHorizontal() && r2 === 39) ||
                (this.isVertical() && r2 === 40) ||
                r2 === 34)) ||
            (!this.allowSlidePrev &&
              ((this.isHorizontal() && r2 === 37) ||
                (this.isVertical() && r2 === 38) ||
                r2 === 33))
          )
            return !1;
          if (
            !(
              a2.shiftKey ||
              a2.altKey ||
              a2.ctrlKey ||
              a2.metaKey ||
              (e.activeElement &&
                e.activeElement.nodeName &&
                (e.activeElement.nodeName.toLowerCase() === "input" ||
                  e.activeElement.nodeName.toLowerCase() === "textarea"))
            )
          ) {
            if (
              this.params.keyboard.onlyInViewport &&
              (r2 === 33 ||
                r2 === 34 ||
                r2 === 37 ||
                r2 === 39 ||
                r2 === 38 ||
                r2 === 40)
            ) {
              var n2 = !1;
              if (
                this.$el.parents("." + this.params.slideClass).length > 0 &&
                this.$el.parents("." + this.params.slideActiveClass).length ===
                  0
              )
                return;
              var o2 = t.innerWidth,
                l2 = t.innerHeight,
                d2 = this.$el.offset();
              s2 && (d2.left -= this.$el[0].scrollLeft);
              for (
                var h2 = [
                    [d2.left, d2.top],
                    [d2.left + this.width, d2.top],
                    [d2.left, d2.top + this.height],
                    [d2.left + this.width, d2.top + this.height],
                  ],
                  p2 = 0;
                p2 < h2.length;
                p2 += 1
              ) {
                var c2 = h2[p2];
                c2[0] >= 0 &&
                  c2[0] <= o2 &&
                  c2[1] >= 0 &&
                  c2[1] <= l2 &&
                  (n2 = !0);
              }
              if (!n2) return;
            }
            this.isHorizontal()
              ? ((r2 !== 33 && r2 !== 34 && r2 !== 37 && r2 !== 39) ||
                  (a2.preventDefault
                    ? a2.preventDefault()
                    : (a2.returnValue = !1)),
                (((r2 !== 34 && r2 !== 39) || s2) &&
                  ((r2 !== 33 && r2 !== 37) || !s2)) ||
                  this.slideNext(),
                (((r2 !== 33 && r2 !== 37) || s2) &&
                  ((r2 !== 34 && r2 !== 39) || !s2)) ||
                  this.slidePrev())
              : ((r2 !== 33 && r2 !== 34 && r2 !== 38 && r2 !== 40) ||
                  (a2.preventDefault
                    ? a2.preventDefault()
                    : (a2.returnValue = !1)),
                (r2 !== 34 && r2 !== 40) || this.slideNext(),
                (r2 !== 33 && r2 !== 38) || this.slidePrev()),
              this.emit("keyPress", r2);
          }
        },
        enable: function () {
          this.keyboard.enabled ||
            (s(e).on("keydown", this.keyboard.handle),
            (this.keyboard.enabled = !0));
        },
        disable: function () {
          this.keyboard.enabled &&
            (s(e).off("keydown", this.keyboard.handle),
            (this.keyboard.enabled = !1));
        },
      },
      te = {
        name: "keyboard",
        params: { keyboard: { enabled: !1, onlyInViewport: !0 } },
        create: function () {
          n.extend(this, {
            keyboard: {
              enabled: !1,
              enable: ee.enable.bind(this),
              disable: ee.disable.bind(this),
              handle: ee.handle.bind(this),
            },
          });
        },
        on: {
          init: function () {
            this.params.keyboard.enabled && this.keyboard.enable();
          },
          destroy: function () {
            this.keyboard.enabled && this.keyboard.disable();
          },
        },
      },
      ie = {
        lastScrollTime: n.now(),
        lastEventBeforeSnap: void 0,
        recentWheelEvents: [],
        event: function () {
          return t.navigator.userAgent.indexOf("firefox") > -1
            ? "DOMMouseScroll"
            : (function () {
                var t2 = "onwheel" in e;
                if (!t2) {
                  var i3 = e.createElement("div");
                  i3.setAttribute("onwheel", "return;"),
                    (t2 = typeof i3.onwheel == "function");
                }
                return (
                  !t2 &&
                    e.implementation &&
                    e.implementation.hasFeature &&
                    e.implementation.hasFeature("", "") !== !0 &&
                    (t2 = e.implementation.hasFeature("Events.wheel", "3.0")),
                  t2
                );
              })()
            ? "wheel"
            : "mousewheel";
        },
        normalize: function (e2) {
          var t2 = 0,
            i3 = 0,
            s2 = 0,
            a2 = 0;
          return (
            "detail" in e2 && (i3 = e2.detail),
            "wheelDelta" in e2 && (i3 = -e2.wheelDelta / 120),
            "wheelDeltaY" in e2 && (i3 = -e2.wheelDeltaY / 120),
            "wheelDeltaX" in e2 && (t2 = -e2.wheelDeltaX / 120),
            "axis" in e2 &&
              e2.axis === e2.HORIZONTAL_AXIS &&
              ((t2 = i3), (i3 = 0)),
            (s2 = 10 * t2),
            (a2 = 10 * i3),
            "deltaY" in e2 && (a2 = e2.deltaY),
            "deltaX" in e2 && (s2 = e2.deltaX),
            e2.shiftKey && !s2 && ((s2 = a2), (a2 = 0)),
            (s2 || a2) &&
              e2.deltaMode &&
              (e2.deltaMode === 1
                ? ((s2 *= 40), (a2 *= 40))
                : ((s2 *= 800), (a2 *= 800))),
            s2 && !t2 && (t2 = s2 < 1 ? -1 : 1),
            a2 && !i3 && (i3 = a2 < 1 ? -1 : 1),
            { spinX: t2, spinY: i3, pixelX: s2, pixelY: a2 }
          );
        },
        handleMouseEnter: function () {
          this.mouseEntered = !0;
        },
        handleMouseLeave: function () {
          this.mouseEntered = !1;
        },
        handle: function (e2) {
          var t2 = e2,
            i3 = this,
            a2 = i3.params.mousewheel;
          i3.params.cssMode && t2.preventDefault();
          var r2 = i3.$el;
          if (
            (i3.params.mousewheel.eventsTarged !== "container" &&
              (r2 = s(i3.params.mousewheel.eventsTarged)),
            !i3.mouseEntered &&
              !r2[0].contains(t2.target) &&
              !a2.releaseOnEdges)
          )
            return !0;
          t2.originalEvent && (t2 = t2.originalEvent);
          var o2 = 0,
            l2 = i3.rtlTranslate ? -1 : 1,
            d2 = ie.normalize(t2);
          if (a2.forceToAxis)
            if (i3.isHorizontal()) {
              if (!(Math.abs(d2.pixelX) > Math.abs(d2.pixelY))) return !0;
              o2 = d2.pixelX * l2;
            } else {
              if (!(Math.abs(d2.pixelY) > Math.abs(d2.pixelX))) return !0;
              o2 = d2.pixelY;
            }
          else
            o2 =
              Math.abs(d2.pixelX) > Math.abs(d2.pixelY)
                ? -d2.pixelX * l2
                : -d2.pixelY;
          if (o2 === 0) return !0;
          if ((a2.invert && (o2 = -o2), i3.params.freeMode)) {
            var h2 = {
                time: n.now(),
                delta: Math.abs(o2),
                direction: Math.sign(o2),
              },
              p2 = i3.mousewheel.lastEventBeforeSnap,
              c2 =
                p2 &&
                h2.time < p2.time + 500 &&
                h2.delta <= p2.delta &&
                h2.direction === p2.direction;
            if (!c2) {
              (i3.mousewheel.lastEventBeforeSnap = void 0),
                i3.params.loop && i3.loopFix();
              var u2 = i3.getTranslate() + o2 * a2.sensitivity,
                v2 = i3.isBeginning,
                f2 = i3.isEnd;
              if (
                (u2 >= i3.minTranslate() && (u2 = i3.minTranslate()),
                u2 <= i3.maxTranslate() && (u2 = i3.maxTranslate()),
                i3.setTransition(0),
                i3.setTranslate(u2),
                i3.updateProgress(),
                i3.updateActiveIndex(),
                i3.updateSlidesClasses(),
                ((!v2 && i3.isBeginning) || (!f2 && i3.isEnd)) &&
                  i3.updateSlidesClasses(),
                i3.params.freeModeSticky)
              ) {
                clearTimeout(i3.mousewheel.timeout),
                  (i3.mousewheel.timeout = void 0);
                var m2 = i3.mousewheel.recentWheelEvents;
                m2.length >= 15 && m2.shift();
                var g2 = m2.length ? m2[m2.length - 1] : void 0,
                  b2 = m2[0];
                if (
                  (m2.push(h2),
                  g2 && (h2.delta > g2.delta || h2.direction !== g2.direction))
                )
                  m2.splice(0);
                else if (
                  m2.length >= 15 &&
                  h2.time - b2.time < 500 &&
                  b2.delta - h2.delta >= 1 &&
                  h2.delta <= 6
                ) {
                  var w2 = o2 > 0 ? 0.8 : 0.2;
                  (i3.mousewheel.lastEventBeforeSnap = h2),
                    m2.splice(0),
                    (i3.mousewheel.timeout = n.nextTick(function () {
                      i3.slideToClosest(i3.params.speed, !0, void 0, w2);
                    }, 0));
                }
                i3.mousewheel.timeout ||
                  (i3.mousewheel.timeout = n.nextTick(function () {
                    (i3.mousewheel.lastEventBeforeSnap = h2),
                      m2.splice(0),
                      i3.slideToClosest(i3.params.speed, !0, void 0, 0.5);
                  }, 500));
              }
              if (
                (c2 || i3.emit("scroll", t2),
                i3.params.autoplay &&
                  i3.params.autoplayDisableOnInteraction &&
                  i3.autoplay.stop(),
                u2 === i3.minTranslate() || u2 === i3.maxTranslate())
              )
                return !0;
            }
          } else {
            var y2 = {
                time: n.now(),
                delta: Math.abs(o2),
                direction: Math.sign(o2),
                raw: e2,
              },
              x2 = i3.mousewheel.recentWheelEvents;
            x2.length >= 2 && x2.shift();
            var T2 = x2.length ? x2[x2.length - 1] : void 0;
            if (
              (x2.push(y2),
              T2
                ? (y2.direction !== T2.direction || y2.delta > T2.delta) &&
                  i3.mousewheel.animateSlider(y2)
                : i3.mousewheel.animateSlider(y2),
              i3.mousewheel.releaseScroll(y2))
            )
              return !0;
          }
          return (
            t2.preventDefault ? t2.preventDefault() : (t2.returnValue = !1), !1
          );
        },
        animateSlider: function (e2) {
          return (
            (e2.delta >= 6 && n.now() - this.mousewheel.lastScrollTime < 60) ||
            (e2.direction < 0
              ? (this.isEnd && !this.params.loop) ||
                this.animating ||
                (this.slideNext(), this.emit("scroll", e2.raw))
              : (this.isBeginning && !this.params.loop) ||
                this.animating ||
                (this.slidePrev(), this.emit("scroll", e2.raw)),
            (this.mousewheel.lastScrollTime = new t.Date().getTime()),
            !1)
          );
        },
        releaseScroll: function (e2) {
          var t2 = this.params.mousewheel;
          if (e2.direction < 0) {
            if (this.isEnd && !this.params.loop && t2.releaseOnEdges) return !0;
          } else if (this.isBeginning && !this.params.loop && t2.releaseOnEdges)
            return !0;
          return !1;
        },
        enable: function () {
          var e2 = ie.event();
          if (this.params.cssMode)
            return (
              this.wrapperEl.removeEventListener(e2, this.mousewheel.handle), !0
            );
          if (!e2 || this.mousewheel.enabled) return !1;
          var t2 = this.$el;
          return (
            this.params.mousewheel.eventsTarged !== "container" &&
              (t2 = s(this.params.mousewheel.eventsTarged)),
            t2.on("mouseenter", this.mousewheel.handleMouseEnter),
            t2.on("mouseleave", this.mousewheel.handleMouseLeave),
            t2.on(e2, this.mousewheel.handle),
            (this.mousewheel.enabled = !0),
            !0
          );
        },
        disable: function () {
          var e2 = ie.event();
          if (this.params.cssMode)
            return (
              this.wrapperEl.addEventListener(e2, this.mousewheel.handle), !0
            );
          if (!e2 || !this.mousewheel.enabled) return !1;
          var t2 = this.$el;
          return (
            this.params.mousewheel.eventsTarged !== "container" &&
              (t2 = s(this.params.mousewheel.eventsTarged)),
            t2.off(e2, this.mousewheel.handle),
            (this.mousewheel.enabled = !1),
            !0
          );
        },
      },
      se = {
        update: function () {
          var e2 = this.params.navigation;
          if (!this.params.loop) {
            var t2 = this.navigation,
              i3 = t2.$nextEl,
              s2 = t2.$prevEl;
            s2 &&
              s2.length > 0 &&
              (this.isBeginning
                ? s2.addClass(e2.disabledClass)
                : s2.removeClass(e2.disabledClass),
              s2[
                this.params.watchOverflow && this.isLocked
                  ? "addClass"
                  : "removeClass"
              ](e2.lockClass)),
              i3 &&
                i3.length > 0 &&
                (this.isEnd
                  ? i3.addClass(e2.disabledClass)
                  : i3.removeClass(e2.disabledClass),
                i3[
                  this.params.watchOverflow && this.isLocked
                    ? "addClass"
                    : "removeClass"
                ](e2.lockClass));
          }
        },
        onPrevClick: function (e2) {
          e2.preventDefault(),
            (this.isBeginning && !this.params.loop) || this.slidePrev();
        },
        onNextClick: function (e2) {
          e2.preventDefault(),
            (this.isEnd && !this.params.loop) || this.slideNext();
        },
        init: function () {
          var e2,
            t2,
            i3 = this.params.navigation;
          (i3.nextEl || i3.prevEl) &&
            (i3.nextEl &&
              ((e2 = s(i3.nextEl)),
              this.params.uniqueNavElements &&
                typeof i3.nextEl == "string" &&
                e2.length > 1 &&
                this.$el.find(i3.nextEl).length === 1 &&
                (e2 = this.$el.find(i3.nextEl))),
            i3.prevEl &&
              ((t2 = s(i3.prevEl)),
              this.params.uniqueNavElements &&
                typeof i3.prevEl == "string" &&
                t2.length > 1 &&
                this.$el.find(i3.prevEl).length === 1 &&
                (t2 = this.$el.find(i3.prevEl))),
            e2 && e2.length > 0 && e2.on("click", this.navigation.onNextClick),
            t2 && t2.length > 0 && t2.on("click", this.navigation.onPrevClick),
            n.extend(this.navigation, {
              $nextEl: e2,
              nextEl: e2 && e2[0],
              $prevEl: t2,
              prevEl: t2 && t2[0],
            }));
        },
        destroy: function () {
          var e2 = this.navigation,
            t2 = e2.$nextEl,
            i3 = e2.$prevEl;
          t2 &&
            t2.length &&
            (t2.off("click", this.navigation.onNextClick),
            t2.removeClass(this.params.navigation.disabledClass)),
            i3 &&
              i3.length &&
              (i3.off("click", this.navigation.onPrevClick),
              i3.removeClass(this.params.navigation.disabledClass));
        },
      },
      ae = {
        update: function () {
          var e2 = this.rtl,
            t2 = this.params.pagination;
          if (
            t2.el &&
            this.pagination.el &&
            this.pagination.$el &&
            this.pagination.$el.length !== 0
          ) {
            var i3,
              a2 =
                this.virtual && this.params.virtual.enabled
                  ? this.virtual.slides.length
                  : this.slides.length,
              r2 = this.pagination.$el,
              n2 = this.params.loop
                ? Math.ceil(
                    (a2 - 2 * this.loopedSlides) / this.params.slidesPerGroup
                  )
                : this.snapGrid.length;
            if (
              (this.params.loop
                ? ((i3 = Math.ceil(
                    (this.activeIndex - this.loopedSlides) /
                      this.params.slidesPerGroup
                  )) >
                    a2 - 1 - 2 * this.loopedSlides &&
                    (i3 -= a2 - 2 * this.loopedSlides),
                  i3 > n2 - 1 && (i3 -= n2),
                  i3 < 0 &&
                    this.params.paginationType !== "bullets" &&
                    (i3 = n2 + i3))
                : (i3 =
                    this.snapIndex !== void 0
                      ? this.snapIndex
                      : this.activeIndex || 0),
              t2.type === "bullets" &&
                this.pagination.bullets &&
                this.pagination.bullets.length > 0)
            ) {
              var o2,
                l2,
                d2,
                h2 = this.pagination.bullets;
              if (
                (t2.dynamicBullets &&
                  ((this.pagination.bulletSize = h2
                    .eq(0)
                    [this.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                  r2.css(
                    this.isHorizontal() ? "width" : "height",
                    this.pagination.bulletSize * (t2.dynamicMainBullets + 4) +
                      "px"
                  ),
                  t2.dynamicMainBullets > 1 &&
                    this.previousIndex !== void 0 &&
                    ((this.pagination.dynamicBulletIndex +=
                      i3 - this.previousIndex),
                    this.pagination.dynamicBulletIndex >
                    t2.dynamicMainBullets - 1
                      ? (this.pagination.dynamicBulletIndex =
                          t2.dynamicMainBullets - 1)
                      : this.pagination.dynamicBulletIndex < 0 &&
                        (this.pagination.dynamicBulletIndex = 0)),
                  (o2 = i3 - this.pagination.dynamicBulletIndex),
                  (d2 =
                    ((l2 =
                      o2 + (Math.min(h2.length, t2.dynamicMainBullets) - 1)) +
                      o2) /
                    2)),
                h2.removeClass(
                  t2.bulletActiveClass +
                    " " +
                    t2.bulletActiveClass +
                    "-next " +
                    t2.bulletActiveClass +
                    "-next-next " +
                    t2.bulletActiveClass +
                    "-prev " +
                    t2.bulletActiveClass +
                    "-prev-prev " +
                    t2.bulletActiveClass +
                    "-main"
                ),
                r2.length > 1)
              )
                h2.each(function (e3, a3) {
                  var r3 = s(a3),
                    n3 = r3.index();
                  n3 === i3 && r3.addClass(t2.bulletActiveClass),
                    t2.dynamicBullets &&
                      (n3 >= o2 &&
                        n3 <= l2 &&
                        r3.addClass(t2.bulletActiveClass + "-main"),
                      n3 === o2 &&
                        r3
                          .prev()
                          .addClass(t2.bulletActiveClass + "-prev")
                          .prev()
                          .addClass(t2.bulletActiveClass + "-prev-prev"),
                      n3 === l2 &&
                        r3
                          .next()
                          .addClass(t2.bulletActiveClass + "-next")
                          .next()
                          .addClass(t2.bulletActiveClass + "-next-next"));
                });
              else {
                var p2 = h2.eq(i3),
                  c2 = p2.index();
                if ((p2.addClass(t2.bulletActiveClass), t2.dynamicBullets)) {
                  for (
                    var u2 = h2.eq(o2), v2 = h2.eq(l2), f2 = o2;
                    f2 <= l2;
                    f2 += 1
                  )
                    h2.eq(f2).addClass(t2.bulletActiveClass + "-main");
                  if (this.params.loop)
                    if (c2 >= h2.length - t2.dynamicMainBullets) {
                      for (var m2 = t2.dynamicMainBullets; m2 >= 0; m2 -= 1)
                        h2.eq(h2.length - m2).addClass(
                          t2.bulletActiveClass + "-main"
                        );
                      h2.eq(h2.length - t2.dynamicMainBullets - 1).addClass(
                        t2.bulletActiveClass + "-prev"
                      );
                    } else
                      u2
                        .prev()
                        .addClass(t2.bulletActiveClass + "-prev")
                        .prev()
                        .addClass(t2.bulletActiveClass + "-prev-prev"),
                        v2
                          .next()
                          .addClass(t2.bulletActiveClass + "-next")
                          .next()
                          .addClass(t2.bulletActiveClass + "-next-next");
                  else
                    u2
                      .prev()
                      .addClass(t2.bulletActiveClass + "-prev")
                      .prev()
                      .addClass(t2.bulletActiveClass + "-prev-prev"),
                      v2
                        .next()
                        .addClass(t2.bulletActiveClass + "-next")
                        .next()
                        .addClass(t2.bulletActiveClass + "-next-next");
                }
              }
              if (t2.dynamicBullets) {
                var g2 = Math.min(h2.length, t2.dynamicMainBullets + 4),
                  b2 =
                    (this.pagination.bulletSize * g2 -
                      this.pagination.bulletSize) /
                      2 -
                    d2 * this.pagination.bulletSize,
                  w2 = e2 ? "right" : "left";
                h2.css(this.isHorizontal() ? w2 : "top", b2 + "px");
              }
            }
            if (
              (t2.type === "fraction" &&
                (r2
                  .find("." + t2.currentClass)
                  .text(t2.formatFractionCurrent(i3 + 1)),
                r2.find("." + t2.totalClass).text(t2.formatFractionTotal(n2))),
              t2.type === "progressbar")
            ) {
              var y2;
              y2 = t2.progressbarOpposite
                ? this.isHorizontal()
                  ? "vertical"
                  : "horizontal"
                : this.isHorizontal()
                ? "horizontal"
                : "vertical";
              var x2 = (i3 + 1) / n2,
                T2 = 1,
                E2 = 1;
              y2 === "horizontal" ? (T2 = x2) : (E2 = x2),
                r2
                  .find("." + t2.progressbarFillClass)
                  .transform(
                    "translate3d(0,0,0) scaleX(" + T2 + ") scaleY(" + E2 + ")"
                  )
                  .transition(this.params.speed);
            }
            t2.type === "custom" && t2.renderCustom
              ? (r2.html(t2.renderCustom(this, i3 + 1, n2)),
                this.emit("paginationRender", this, r2[0]))
              : this.emit("paginationUpdate", this, r2[0]),
              r2[
                this.params.watchOverflow && this.isLocked
                  ? "addClass"
                  : "removeClass"
              ](t2.lockClass);
          }
        },
        render: function () {
          var e2 = this.params.pagination;
          if (
            e2.el &&
            this.pagination.el &&
            this.pagination.$el &&
            this.pagination.$el.length !== 0
          ) {
            var t2 =
                this.virtual && this.params.virtual.enabled
                  ? this.virtual.slides.length
                  : this.slides.length,
              i3 = this.pagination.$el,
              s2 = "";
            if (e2.type === "bullets") {
              for (
                var a2 = this.params.loop
                    ? Math.ceil(
                        (t2 - 2 * this.loopedSlides) /
                          this.params.slidesPerGroup
                      )
                    : this.snapGrid.length,
                  r2 = 0;
                r2 < a2;
                r2 += 1
              )
                e2.renderBullet
                  ? (s2 += e2.renderBullet.call(this, r2, e2.bulletClass))
                  : (s2 +=
                      "<" +
                      e2.bulletElement +
                      ' class="' +
                      e2.bulletClass +
                      '"></' +
                      e2.bulletElement +
                      ">");
              i3.html(s2),
                (this.pagination.bullets = i3.find("." + e2.bulletClass));
            }
            e2.type === "fraction" &&
              ((s2 = e2.renderFraction
                ? e2.renderFraction.call(this, e2.currentClass, e2.totalClass)
                : '<span class="' +
                  e2.currentClass +
                  '"></span> / <span class="' +
                  e2.totalClass +
                  '"></span>'),
              i3.html(s2)),
              e2.type === "progressbar" &&
                ((s2 = e2.renderProgressbar
                  ? e2.renderProgressbar.call(this, e2.progressbarFillClass)
                  : '<span class="' + e2.progressbarFillClass + '"></span>'),
                i3.html(s2)),
              e2.type !== "custom" &&
                this.emit("paginationRender", this.pagination.$el[0]);
          }
        },
        init: function () {
          var e2 = this,
            t2 = e2.params.pagination;
          if (t2.el) {
            var i3 = s(t2.el);
            i3.length !== 0 &&
              (e2.params.uniqueNavElements &&
                typeof t2.el == "string" &&
                i3.length > 1 &&
                e2.$el.find(t2.el).length === 1 &&
                (i3 = e2.$el.find(t2.el)),
              t2.type === "bullets" &&
                t2.clickable &&
                i3.addClass(t2.clickableClass),
              i3.addClass(t2.modifierClass + t2.type),
              t2.type === "bullets" &&
                t2.dynamicBullets &&
                (i3.addClass("" + t2.modifierClass + t2.type + "-dynamic"),
                (e2.pagination.dynamicBulletIndex = 0),
                t2.dynamicMainBullets < 1 && (t2.dynamicMainBullets = 1)),
              t2.type === "progressbar" &&
                t2.progressbarOpposite &&
                i3.addClass(t2.progressbarOppositeClass),
              t2.clickable &&
                i3.on("click", "." + t2.bulletClass, function (t3) {
                  t3.preventDefault();
                  var i4 = s(this).index() * e2.params.slidesPerGroup;
                  e2.params.loop && (i4 += e2.loopedSlides), e2.slideTo(i4);
                }),
              n.extend(e2.pagination, { $el: i3, el: i3[0] }));
          }
        },
        destroy: function () {
          var e2 = this.params.pagination;
          if (
            e2.el &&
            this.pagination.el &&
            this.pagination.$el &&
            this.pagination.$el.length !== 0
          ) {
            var t2 = this.pagination.$el;
            t2.removeClass(e2.hiddenClass),
              t2.removeClass(e2.modifierClass + e2.type),
              this.pagination.bullets &&
                this.pagination.bullets.removeClass(e2.bulletActiveClass),
              e2.clickable && t2.off("click", "." + e2.bulletClass);
          }
        },
      },
      re = {
        setTranslate: function () {
          if (this.params.scrollbar.el && this.scrollbar.el) {
            var e2 = this.scrollbar,
              t2 = this.rtlTranslate,
              i3 = this.progress,
              s2 = e2.dragSize,
              a2 = e2.trackSize,
              r2 = e2.$dragEl,
              n2 = e2.$el,
              o2 = this.params.scrollbar,
              l2 = s2,
              d2 = (a2 - s2) * i3;
            t2
              ? (d2 = -d2) > 0
                ? ((l2 = s2 - d2), (d2 = 0))
                : -d2 + s2 > a2 && (l2 = a2 + d2)
              : d2 < 0
              ? ((l2 = s2 + d2), (d2 = 0))
              : d2 + s2 > a2 && (l2 = a2 - d2),
              this.isHorizontal()
                ? (r2.transform("translate3d(" + d2 + "px, 0, 0)"),
                  (r2[0].style.width = l2 + "px"))
                : (r2.transform("translate3d(0px, " + d2 + "px, 0)"),
                  (r2[0].style.height = l2 + "px")),
              o2.hide &&
                (clearTimeout(this.scrollbar.timeout),
                (n2[0].style.opacity = 1),
                (this.scrollbar.timeout = setTimeout(function () {
                  (n2[0].style.opacity = 0), n2.transition(400);
                }, 1e3)));
          }
        },
        setTransition: function (e2) {
          this.params.scrollbar.el &&
            this.scrollbar.el &&
            this.scrollbar.$dragEl.transition(e2);
        },
        updateSize: function () {
          if (this.params.scrollbar.el && this.scrollbar.el) {
            var e2 = this.scrollbar,
              t2 = e2.$dragEl,
              i3 = e2.$el;
            (t2[0].style.width = ""), (t2[0].style.height = "");
            var s2,
              a2 = this.isHorizontal() ? i3[0].offsetWidth : i3[0].offsetHeight,
              r2 = this.size / this.virtualSize,
              o2 = r2 * (a2 / this.size);
            (s2 =
              this.params.scrollbar.dragSize === "auto"
                ? a2 * r2
                : parseInt(this.params.scrollbar.dragSize, 10)),
              this.isHorizontal()
                ? (t2[0].style.width = s2 + "px")
                : (t2[0].style.height = s2 + "px"),
              (i3[0].style.display = r2 >= 1 ? "none" : ""),
              this.params.scrollbar.hide && (i3[0].style.opacity = 0),
              n.extend(e2, {
                trackSize: a2,
                divider: r2,
                moveDivider: o2,
                dragSize: s2,
              }),
              e2.$el[
                this.params.watchOverflow && this.isLocked
                  ? "addClass"
                  : "removeClass"
              ](this.params.scrollbar.lockClass);
          }
        },
        getPointerPosition: function (e2) {
          return this.isHorizontal()
            ? e2.type === "touchstart" || e2.type === "touchmove"
              ? e2.targetTouches[0].clientX
              : e2.clientX
            : e2.type === "touchstart" || e2.type === "touchmove"
            ? e2.targetTouches[0].clientY
            : e2.clientY;
        },
        setDragPosition: function (e2) {
          var t2,
            i3 = this.scrollbar,
            s2 = this.rtlTranslate,
            a2 = i3.$el,
            r2 = i3.dragSize,
            n2 = i3.trackSize,
            o2 = i3.dragStartPos;
          (t2 =
            (i3.getPointerPosition(e2) -
              a2.offset()[this.isHorizontal() ? "left" : "top"] -
              (o2 !== null ? o2 : r2 / 2)) /
            (n2 - r2)),
            (t2 = Math.max(Math.min(t2, 1), 0)),
            s2 && (t2 = 1 - t2);
          var l2 =
            this.minTranslate() +
            (this.maxTranslate() - this.minTranslate()) * t2;
          this.updateProgress(l2),
            this.setTranslate(l2),
            this.updateActiveIndex(),
            this.updateSlidesClasses();
        },
        onDragStart: function (e2) {
          var t2 = this.params.scrollbar,
            i3 = this.scrollbar,
            s2 = this.$wrapperEl,
            a2 = i3.$el,
            r2 = i3.$dragEl;
          (this.scrollbar.isTouched = !0),
            (this.scrollbar.dragStartPos =
              e2.target === r2[0] || e2.target === r2
                ? i3.getPointerPosition(e2) -
                  e2.target.getBoundingClientRect()[
                    this.isHorizontal() ? "left" : "top"
                  ]
                : null),
            e2.preventDefault(),
            e2.stopPropagation(),
            s2.transition(100),
            r2.transition(100),
            i3.setDragPosition(e2),
            clearTimeout(this.scrollbar.dragTimeout),
            a2.transition(0),
            t2.hide && a2.css("opacity", 1),
            this.params.cssMode &&
              this.$wrapperEl.css("scroll-snap-type", "none"),
            this.emit("scrollbarDragStart", e2);
        },
        onDragMove: function (e2) {
          var t2 = this.scrollbar,
            i3 = this.$wrapperEl,
            s2 = t2.$el,
            a2 = t2.$dragEl;
          this.scrollbar.isTouched &&
            (e2.preventDefault ? e2.preventDefault() : (e2.returnValue = !1),
            t2.setDragPosition(e2),
            i3.transition(0),
            s2.transition(0),
            a2.transition(0),
            this.emit("scrollbarDragMove", e2));
        },
        onDragEnd: function (e2) {
          var t2 = this.params.scrollbar,
            i3 = this.scrollbar,
            s2 = this.$wrapperEl,
            a2 = i3.$el;
          this.scrollbar.isTouched &&
            ((this.scrollbar.isTouched = !1),
            this.params.cssMode &&
              (this.$wrapperEl.css("scroll-snap-type", ""), s2.transition("")),
            t2.hide &&
              (clearTimeout(this.scrollbar.dragTimeout),
              (this.scrollbar.dragTimeout = n.nextTick(function () {
                a2.css("opacity", 0), a2.transition(400);
              }, 1e3))),
            this.emit("scrollbarDragEnd", e2),
            t2.snapOnRelease && this.slideToClosest());
        },
        enableDraggable: function () {
          if (this.params.scrollbar.el) {
            var t2 = this.scrollbar,
              i3 = this.touchEventsTouch,
              s2 = this.touchEventsDesktop,
              a2 = this.params,
              r2 = t2.$el[0],
              n2 = !(!o.passiveListener || !a2.passiveListeners) && {
                passive: !1,
                capture: !1,
              },
              l2 = !(!o.passiveListener || !a2.passiveListeners) && {
                passive: !0,
                capture: !1,
              };
            o.touch
              ? (r2.addEventListener(i3.start, this.scrollbar.onDragStart, n2),
                r2.addEventListener(i3.move, this.scrollbar.onDragMove, n2),
                r2.addEventListener(i3.end, this.scrollbar.onDragEnd, l2))
              : (r2.addEventListener(s2.start, this.scrollbar.onDragStart, n2),
                e.addEventListener(s2.move, this.scrollbar.onDragMove, n2),
                e.addEventListener(s2.end, this.scrollbar.onDragEnd, l2));
          }
        },
        disableDraggable: function () {
          if (this.params.scrollbar.el) {
            var t2 = this.scrollbar,
              i3 = this.touchEventsTouch,
              s2 = this.touchEventsDesktop,
              a2 = this.params,
              r2 = t2.$el[0],
              n2 = !(!o.passiveListener || !a2.passiveListeners) && {
                passive: !1,
                capture: !1,
              },
              l2 = !(!o.passiveListener || !a2.passiveListeners) && {
                passive: !0,
                capture: !1,
              };
            o.touch
              ? (r2.removeEventListener(
                  i3.start,
                  this.scrollbar.onDragStart,
                  n2
                ),
                r2.removeEventListener(i3.move, this.scrollbar.onDragMove, n2),
                r2.removeEventListener(i3.end, this.scrollbar.onDragEnd, l2))
              : (r2.removeEventListener(
                  s2.start,
                  this.scrollbar.onDragStart,
                  n2
                ),
                e.removeEventListener(s2.move, this.scrollbar.onDragMove, n2),
                e.removeEventListener(s2.end, this.scrollbar.onDragEnd, l2));
          }
        },
        init: function () {
          if (this.params.scrollbar.el) {
            var e2 = this.scrollbar,
              t2 = this.$el,
              i3 = this.params.scrollbar,
              a2 = s(i3.el);
            this.params.uniqueNavElements &&
              typeof i3.el == "string" &&
              a2.length > 1 &&
              t2.find(i3.el).length === 1 &&
              (a2 = t2.find(i3.el));
            var r2 = a2.find("." + this.params.scrollbar.dragClass);
            r2.length === 0 &&
              ((r2 = s(
                '<div class="' + this.params.scrollbar.dragClass + '"></div>'
              )),
              a2.append(r2)),
              n.extend(e2, { $el: a2, el: a2[0], $dragEl: r2, dragEl: r2[0] }),
              i3.draggable && e2.enableDraggable();
          }
        },
        destroy: function () {
          this.scrollbar.disableDraggable();
        },
      },
      ne = {
        setTransform: function (e2, t2) {
          var i3 = this.rtl,
            a2 = s(e2),
            r2 = i3 ? -1 : 1,
            n2 = a2.attr("data-swiper-parallax") || "0",
            o2 = a2.attr("data-swiper-parallax-x"),
            l2 = a2.attr("data-swiper-parallax-y"),
            d2 = a2.attr("data-swiper-parallax-scale"),
            h2 = a2.attr("data-swiper-parallax-opacity");
          if (
            (o2 || l2
              ? ((o2 = o2 || "0"), (l2 = l2 || "0"))
              : this.isHorizontal()
              ? ((o2 = n2), (l2 = "0"))
              : ((l2 = n2), (o2 = "0")),
            (o2 =
              o2.indexOf("%") >= 0
                ? parseInt(o2, 10) * t2 * r2 + "%"
                : o2 * t2 * r2 + "px"),
            (l2 =
              l2.indexOf("%") >= 0
                ? parseInt(l2, 10) * t2 + "%"
                : l2 * t2 + "px"),
            h2 != null)
          ) {
            var p2 = h2 - (h2 - 1) * (1 - Math.abs(t2));
            a2[0].style.opacity = p2;
          }
          if (d2 == null)
            a2.transform("translate3d(" + o2 + ", " + l2 + ", 0px)");
          else {
            var c2 = d2 - (d2 - 1) * (1 - Math.abs(t2));
            a2.transform(
              "translate3d(" + o2 + ", " + l2 + ", 0px) scale(" + c2 + ")"
            );
          }
        },
        setTranslate: function () {
          var e2 = this,
            t2 = e2.$el,
            i3 = e2.slides,
            a2 = e2.progress,
            r2 = e2.snapGrid;
          t2
            .children(
              "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
            )
            .each(function (t3, i4) {
              e2.parallax.setTransform(i4, a2);
            }),
            i3.each(function (t3, i4) {
              var n2 = i4.progress;
              e2.params.slidesPerGroup > 1 &&
                e2.params.slidesPerView !== "auto" &&
                (n2 += Math.ceil(t3 / 2) - a2 * (r2.length - 1)),
                (n2 = Math.min(Math.max(n2, -1), 1)),
                s(i4)
                  .find(
                    "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                  )
                  .each(function (t4, i5) {
                    e2.parallax.setTransform(i5, n2);
                  });
            });
        },
        setTransition: function (e2) {
          e2 === void 0 && (e2 = this.params.speed),
            this.$el
              .find(
                "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
              )
              .each(function (t2, i3) {
                var a2 = s(i3),
                  r2 =
                    parseInt(a2.attr("data-swiper-parallax-duration"), 10) ||
                    e2;
                e2 === 0 && (r2 = 0), a2.transition(r2);
              });
        },
      },
      oe = {
        getDistanceBetweenTouches: function (e2) {
          if (e2.targetTouches.length < 2) return 1;
          var t2 = e2.targetTouches[0].pageX,
            i3 = e2.targetTouches[0].pageY,
            s2 = e2.targetTouches[1].pageX,
            a2 = e2.targetTouches[1].pageY;
          return Math.sqrt(Math.pow(s2 - t2, 2) + Math.pow(a2 - i3, 2));
        },
        onGestureStart: function (e2) {
          var t2 = this.params.zoom,
            i3 = this.zoom,
            a2 = i3.gesture;
          if (
            ((i3.fakeGestureTouched = !1),
            (i3.fakeGestureMoved = !1),
            !o.gestures)
          ) {
            if (
              e2.type !== "touchstart" ||
              (e2.type === "touchstart" && e2.targetTouches.length < 2)
            )
              return;
            (i3.fakeGestureTouched = !0),
              (a2.scaleStart = oe.getDistanceBetweenTouches(e2));
          }
          (a2.$slideEl && a2.$slideEl.length) ||
          ((a2.$slideEl = s(e2.target).closest("." + this.params.slideClass)),
          a2.$slideEl.length === 0 &&
            (a2.$slideEl = this.slides.eq(this.activeIndex)),
          (a2.$imageEl = a2.$slideEl.find(
            "img, svg, canvas, picture, .swiper-zoom-target"
          )),
          (a2.$imageWrapEl = a2.$imageEl.parent("." + t2.containerClass)),
          (a2.maxRatio =
            a2.$imageWrapEl.attr("data-swiper-zoom") || t2.maxRatio),
          a2.$imageWrapEl.length !== 0)
            ? (a2.$imageEl && a2.$imageEl.transition(0),
              (this.zoom.isScaling = !0))
            : (a2.$imageEl = void 0);
        },
        onGestureChange: function (e2) {
          var t2 = this.params.zoom,
            i3 = this.zoom,
            s2 = i3.gesture;
          if (!o.gestures) {
            if (
              e2.type !== "touchmove" ||
              (e2.type === "touchmove" && e2.targetTouches.length < 2)
            )
              return;
            (i3.fakeGestureMoved = !0),
              (s2.scaleMove = oe.getDistanceBetweenTouches(e2));
          }
          s2.$imageEl &&
            s2.$imageEl.length !== 0 &&
            ((i3.scale = o.gestures
              ? e2.scale * i3.currentScale
              : (s2.scaleMove / s2.scaleStart) * i3.currentScale),
            i3.scale > s2.maxRatio &&
              (i3.scale =
                s2.maxRatio - 1 + Math.pow(i3.scale - s2.maxRatio + 1, 0.5)),
            i3.scale < t2.minRatio &&
              (i3.scale =
                t2.minRatio + 1 - Math.pow(t2.minRatio - i3.scale + 1, 0.5)),
            s2.$imageEl.transform(
              "translate3d(0,0,0) scale(" + i3.scale + ")"
            ));
        },
        onGestureEnd: function (e2) {
          var t2 = this.params.zoom,
            i3 = this.zoom,
            s2 = i3.gesture;
          if (!o.gestures) {
            if (
              !i3.fakeGestureTouched ||
              !i3.fakeGestureMoved ||
              e2.type !== "touchend" ||
              (e2.type === "touchend" &&
                e2.changedTouches.length < 2 &&
                !I.android)
            )
              return;
            (i3.fakeGestureTouched = !1), (i3.fakeGestureMoved = !1);
          }
          s2.$imageEl &&
            s2.$imageEl.length !== 0 &&
            ((i3.scale = Math.max(
              Math.min(i3.scale, s2.maxRatio),
              t2.minRatio
            )),
            s2.$imageEl
              .transition(this.params.speed)
              .transform("translate3d(0,0,0) scale(" + i3.scale + ")"),
            (i3.currentScale = i3.scale),
            (i3.isScaling = !1),
            i3.scale === 1 && (s2.$slideEl = void 0));
        },
        onTouchStart: function (e2) {
          var t2 = this.zoom,
            i3 = t2.gesture,
            s2 = t2.image;
          i3.$imageEl &&
            i3.$imageEl.length !== 0 &&
            (s2.isTouched ||
              (I.android && e2.preventDefault(),
              (s2.isTouched = !0),
              (s2.touchesStart.x =
                e2.type === "touchstart"
                  ? e2.targetTouches[0].pageX
                  : e2.pageX),
              (s2.touchesStart.y =
                e2.type === "touchstart"
                  ? e2.targetTouches[0].pageY
                  : e2.pageY)));
        },
        onTouchMove: function (e2) {
          var t2 = this.zoom,
            i3 = t2.gesture,
            s2 = t2.image,
            a2 = t2.velocity;
          if (
            i3.$imageEl &&
            i3.$imageEl.length !== 0 &&
            ((this.allowClick = !1), s2.isTouched && i3.$slideEl)
          ) {
            s2.isMoved ||
              ((s2.width = i3.$imageEl[0].offsetWidth),
              (s2.height = i3.$imageEl[0].offsetHeight),
              (s2.startX = n.getTranslate(i3.$imageWrapEl[0], "x") || 0),
              (s2.startY = n.getTranslate(i3.$imageWrapEl[0], "y") || 0),
              (i3.slideWidth = i3.$slideEl[0].offsetWidth),
              (i3.slideHeight = i3.$slideEl[0].offsetHeight),
              i3.$imageWrapEl.transition(0),
              this.rtl && ((s2.startX = -s2.startX), (s2.startY = -s2.startY)));
            var r2 = s2.width * t2.scale,
              o2 = s2.height * t2.scale;
            if (!(r2 < i3.slideWidth && o2 < i3.slideHeight)) {
              if (
                ((s2.minX = Math.min(i3.slideWidth / 2 - r2 / 2, 0)),
                (s2.maxX = -s2.minX),
                (s2.minY = Math.min(i3.slideHeight / 2 - o2 / 2, 0)),
                (s2.maxY = -s2.minY),
                (s2.touchesCurrent.x =
                  e2.type === "touchmove"
                    ? e2.targetTouches[0].pageX
                    : e2.pageX),
                (s2.touchesCurrent.y =
                  e2.type === "touchmove"
                    ? e2.targetTouches[0].pageY
                    : e2.pageY),
                !s2.isMoved &&
                  !t2.isScaling &&
                  ((this.isHorizontal() &&
                    ((Math.floor(s2.minX) === Math.floor(s2.startX) &&
                      s2.touchesCurrent.x < s2.touchesStart.x) ||
                      (Math.floor(s2.maxX) === Math.floor(s2.startX) &&
                        s2.touchesCurrent.x > s2.touchesStart.x))) ||
                    (!this.isHorizontal() &&
                      ((Math.floor(s2.minY) === Math.floor(s2.startY) &&
                        s2.touchesCurrent.y < s2.touchesStart.y) ||
                        (Math.floor(s2.maxY) === Math.floor(s2.startY) &&
                          s2.touchesCurrent.y > s2.touchesStart.y)))))
              )
                return void (s2.isTouched = !1);
              e2.preventDefault(),
                e2.stopPropagation(),
                (s2.isMoved = !0),
                (s2.currentX =
                  s2.touchesCurrent.x - s2.touchesStart.x + s2.startX),
                (s2.currentY =
                  s2.touchesCurrent.y - s2.touchesStart.y + s2.startY),
                s2.currentX < s2.minX &&
                  (s2.currentX =
                    s2.minX + 1 - Math.pow(s2.minX - s2.currentX + 1, 0.8)),
                s2.currentX > s2.maxX &&
                  (s2.currentX =
                    s2.maxX - 1 + Math.pow(s2.currentX - s2.maxX + 1, 0.8)),
                s2.currentY < s2.minY &&
                  (s2.currentY =
                    s2.minY + 1 - Math.pow(s2.minY - s2.currentY + 1, 0.8)),
                s2.currentY > s2.maxY &&
                  (s2.currentY =
                    s2.maxY - 1 + Math.pow(s2.currentY - s2.maxY + 1, 0.8)),
                a2.prevPositionX || (a2.prevPositionX = s2.touchesCurrent.x),
                a2.prevPositionY || (a2.prevPositionY = s2.touchesCurrent.y),
                a2.prevTime || (a2.prevTime = Date.now()),
                (a2.x =
                  (s2.touchesCurrent.x - a2.prevPositionX) /
                  (Date.now() - a2.prevTime) /
                  2),
                (a2.y =
                  (s2.touchesCurrent.y - a2.prevPositionY) /
                  (Date.now() - a2.prevTime) /
                  2),
                Math.abs(s2.touchesCurrent.x - a2.prevPositionX) < 2 &&
                  (a2.x = 0),
                Math.abs(s2.touchesCurrent.y - a2.prevPositionY) < 2 &&
                  (a2.y = 0),
                (a2.prevPositionX = s2.touchesCurrent.x),
                (a2.prevPositionY = s2.touchesCurrent.y),
                (a2.prevTime = Date.now()),
                i3.$imageWrapEl.transform(
                  "translate3d(" + s2.currentX + "px, " + s2.currentY + "px,0)"
                );
            }
          }
        },
        onTouchEnd: function () {
          var e2 = this.zoom,
            t2 = e2.gesture,
            i3 = e2.image,
            s2 = e2.velocity;
          if (t2.$imageEl && t2.$imageEl.length !== 0) {
            if (!i3.isTouched || !i3.isMoved)
              return (i3.isTouched = !1), void (i3.isMoved = !1);
            (i3.isTouched = !1), (i3.isMoved = !1);
            var a2 = 300,
              r2 = 300,
              n2 = s2.x * a2,
              o2 = i3.currentX + n2,
              l2 = s2.y * r2,
              d2 = i3.currentY + l2;
            s2.x !== 0 && (a2 = Math.abs((o2 - i3.currentX) / s2.x)),
              s2.y !== 0 && (r2 = Math.abs((d2 - i3.currentY) / s2.y));
            var h2 = Math.max(a2, r2);
            (i3.currentX = o2), (i3.currentY = d2);
            var p2 = i3.width * e2.scale,
              c2 = i3.height * e2.scale;
            (i3.minX = Math.min(t2.slideWidth / 2 - p2 / 2, 0)),
              (i3.maxX = -i3.minX),
              (i3.minY = Math.min(t2.slideHeight / 2 - c2 / 2, 0)),
              (i3.maxY = -i3.minY),
              (i3.currentX = Math.max(Math.min(i3.currentX, i3.maxX), i3.minX)),
              (i3.currentY = Math.max(Math.min(i3.currentY, i3.maxY), i3.minY)),
              t2.$imageWrapEl
                .transition(h2)
                .transform(
                  "translate3d(" + i3.currentX + "px, " + i3.currentY + "px,0)"
                );
          }
        },
        onTransitionEnd: function () {
          var e2 = this.zoom,
            t2 = e2.gesture;
          t2.$slideEl &&
            this.previousIndex !== this.activeIndex &&
            (t2.$imageEl &&
              t2.$imageEl.transform("translate3d(0,0,0) scale(1)"),
            t2.$imageWrapEl && t2.$imageWrapEl.transform("translate3d(0,0,0)"),
            (e2.scale = 1),
            (e2.currentScale = 1),
            (t2.$slideEl = void 0),
            (t2.$imageEl = void 0),
            (t2.$imageWrapEl = void 0));
        },
        toggle: function (e2) {
          var t2 = this.zoom;
          t2.scale && t2.scale !== 1 ? t2.out() : t2.in(e2);
        },
        in: function (e2) {
          var t2,
            i3,
            s2,
            a2,
            r2,
            n2,
            o2,
            l2,
            d2,
            h2,
            p2,
            c2,
            u2,
            v2,
            f2,
            m2,
            g2 = this.zoom,
            b2 = this.params.zoom,
            w2 = g2.gesture,
            y2 = g2.image;
          w2.$slideEl ||
            (this.params.virtual && this.params.virtual.enabled && this.virtual
              ? (w2.$slideEl = this.$wrapperEl.children(
                  "." + this.params.slideActiveClass
                ))
              : (w2.$slideEl = this.slides.eq(this.activeIndex)),
            (w2.$imageEl = w2.$slideEl.find(
              "img, svg, canvas, picture, .swiper-zoom-target"
            )),
            (w2.$imageWrapEl = w2.$imageEl.parent("." + b2.containerClass))),
            w2.$imageEl &&
              w2.$imageEl.length !== 0 &&
              (w2.$slideEl.addClass("" + b2.zoomedSlideClass),
              y2.touchesStart.x === void 0 && e2
                ? ((t2 =
                    e2.type === "touchend"
                      ? e2.changedTouches[0].pageX
                      : e2.pageX),
                  (i3 =
                    e2.type === "touchend"
                      ? e2.changedTouches[0].pageY
                      : e2.pageY))
                : ((t2 = y2.touchesStart.x), (i3 = y2.touchesStart.y)),
              (g2.scale =
                w2.$imageWrapEl.attr("data-swiper-zoom") || b2.maxRatio),
              (g2.currentScale =
                w2.$imageWrapEl.attr("data-swiper-zoom") || b2.maxRatio),
              e2
                ? ((f2 = w2.$slideEl[0].offsetWidth),
                  (m2 = w2.$slideEl[0].offsetHeight),
                  (s2 = w2.$slideEl.offset().left + f2 / 2 - t2),
                  (a2 = w2.$slideEl.offset().top + m2 / 2 - i3),
                  (o2 = w2.$imageEl[0].offsetWidth),
                  (l2 = w2.$imageEl[0].offsetHeight),
                  (d2 = o2 * g2.scale),
                  (h2 = l2 * g2.scale),
                  (u2 = -(p2 = Math.min(f2 / 2 - d2 / 2, 0))),
                  (v2 = -(c2 = Math.min(m2 / 2 - h2 / 2, 0))),
                  (r2 = s2 * g2.scale) < p2 && (r2 = p2),
                  r2 > u2 && (r2 = u2),
                  (n2 = a2 * g2.scale) < c2 && (n2 = c2),
                  n2 > v2 && (n2 = v2))
                : ((r2 = 0), (n2 = 0)),
              w2.$imageWrapEl
                .transition(300)
                .transform("translate3d(" + r2 + "px, " + n2 + "px,0)"),
              w2.$imageEl
                .transition(300)
                .transform("translate3d(0,0,0) scale(" + g2.scale + ")"));
        },
        out: function () {
          var e2 = this.zoom,
            t2 = this.params.zoom,
            i3 = e2.gesture;
          i3.$slideEl ||
            (this.params.virtual && this.params.virtual.enabled && this.virtual
              ? (i3.$slideEl = this.$wrapperEl.children(
                  "." + this.params.slideActiveClass
                ))
              : (i3.$slideEl = this.slides.eq(this.activeIndex)),
            (i3.$imageEl = i3.$slideEl.find(
              "img, svg, canvas, picture, .swiper-zoom-target"
            )),
            (i3.$imageWrapEl = i3.$imageEl.parent("." + t2.containerClass))),
            i3.$imageEl &&
              i3.$imageEl.length !== 0 &&
              ((e2.scale = 1),
              (e2.currentScale = 1),
              i3.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
              i3.$imageEl
                .transition(300)
                .transform("translate3d(0,0,0) scale(1)"),
              i3.$slideEl.removeClass("" + t2.zoomedSlideClass),
              (i3.$slideEl = void 0));
        },
        enable: function () {
          var e2 = this.zoom;
          if (!e2.enabled) {
            e2.enabled = !0;
            var t2 = !(
                this.touchEvents.start !== "touchstart" ||
                !o.passiveListener ||
                !this.params.passiveListeners
              ) && { passive: !0, capture: !1 },
              i3 = !o.passiveListener || { passive: !1, capture: !0 },
              s2 = "." + this.params.slideClass;
            o.gestures
              ? (this.$wrapperEl.on("gesturestart", s2, e2.onGestureStart, t2),
                this.$wrapperEl.on("gesturechange", s2, e2.onGestureChange, t2),
                this.$wrapperEl.on("gestureend", s2, e2.onGestureEnd, t2))
              : this.touchEvents.start === "touchstart" &&
                (this.$wrapperEl.on(
                  this.touchEvents.start,
                  s2,
                  e2.onGestureStart,
                  t2
                ),
                this.$wrapperEl.on(
                  this.touchEvents.move,
                  s2,
                  e2.onGestureChange,
                  i3
                ),
                this.$wrapperEl.on(
                  this.touchEvents.end,
                  s2,
                  e2.onGestureEnd,
                  t2
                ),
                this.touchEvents.cancel &&
                  this.$wrapperEl.on(
                    this.touchEvents.cancel,
                    s2,
                    e2.onGestureEnd,
                    t2
                  )),
              this.$wrapperEl.on(
                this.touchEvents.move,
                "." + this.params.zoom.containerClass,
                e2.onTouchMove,
                i3
              );
          }
        },
        disable: function () {
          var e2 = this.zoom;
          if (e2.enabled) {
            this.zoom.enabled = !1;
            var t2 = !(
                this.touchEvents.start !== "touchstart" ||
                !o.passiveListener ||
                !this.params.passiveListeners
              ) && { passive: !0, capture: !1 },
              i3 = !o.passiveListener || { passive: !1, capture: !0 },
              s2 = "." + this.params.slideClass;
            o.gestures
              ? (this.$wrapperEl.off("gesturestart", s2, e2.onGestureStart, t2),
                this.$wrapperEl.off(
                  "gesturechange",
                  s2,
                  e2.onGestureChange,
                  t2
                ),
                this.$wrapperEl.off("gestureend", s2, e2.onGestureEnd, t2))
              : this.touchEvents.start === "touchstart" &&
                (this.$wrapperEl.off(
                  this.touchEvents.start,
                  s2,
                  e2.onGestureStart,
                  t2
                ),
                this.$wrapperEl.off(
                  this.touchEvents.move,
                  s2,
                  e2.onGestureChange,
                  i3
                ),
                this.$wrapperEl.off(
                  this.touchEvents.end,
                  s2,
                  e2.onGestureEnd,
                  t2
                ),
                this.touchEvents.cancel &&
                  this.$wrapperEl.off(
                    this.touchEvents.cancel,
                    s2,
                    e2.onGestureEnd,
                    t2
                  )),
              this.$wrapperEl.off(
                this.touchEvents.move,
                "." + this.params.zoom.containerClass,
                e2.onTouchMove,
                i3
              );
          }
        },
      },
      le = {
        loadInSlide: function (e2, t2) {
          t2 === void 0 && (t2 = !0);
          var i3 = this,
            a2 = i3.params.lazy;
          if (e2 !== void 0 && i3.slides.length !== 0) {
            var r2 =
                i3.virtual && i3.params.virtual.enabled
                  ? i3.$wrapperEl.children(
                      "." +
                        i3.params.slideClass +
                        '[data-swiper-slide-index="' +
                        e2 +
                        '"]'
                    )
                  : i3.slides.eq(e2),
              n2 = r2.find(
                "." +
                  a2.elementClass +
                  ":not(." +
                  a2.loadedClass +
                  "):not(." +
                  a2.loadingClass +
                  ")"
              );
            !r2.hasClass(a2.elementClass) ||
              r2.hasClass(a2.loadedClass) ||
              r2.hasClass(a2.loadingClass) ||
              (n2 = n2.add(r2[0])),
              n2.length !== 0 &&
                n2.each(function (e3, n3) {
                  var o2 = s(n3);
                  o2.addClass(a2.loadingClass);
                  var l2 = o2.attr("data-background"),
                    d2 = o2.attr("data-src"),
                    h2 = o2.attr("data-srcset"),
                    p2 = o2.attr("data-sizes");
                  i3.loadImage(o2[0], d2 || l2, h2, p2, !1, function () {
                    if (
                      i3 != null &&
                      i3 &&
                      (!i3 || i3.params) &&
                      !i3.destroyed
                    ) {
                      if (
                        (l2
                          ? (o2.css("background-image", 'url("' + l2 + '")'),
                            o2.removeAttr("data-background"))
                          : (h2 &&
                              (o2.attr("srcset", h2),
                              o2.removeAttr("data-srcset")),
                            p2 &&
                              (o2.attr("sizes", p2),
                              o2.removeAttr("data-sizes")),
                            d2 &&
                              (o2.attr("src", d2), o2.removeAttr("data-src"))),
                        o2
                          .addClass(a2.loadedClass)
                          .removeClass(a2.loadingClass),
                        r2.find("." + a2.preloaderClass).remove(),
                        i3.params.loop && t2)
                      ) {
                        var e4 = r2.attr("data-swiper-slide-index");
                        if (r2.hasClass(i3.params.slideDuplicateClass)) {
                          var s2 = i3.$wrapperEl.children(
                            '[data-swiper-slide-index="' +
                              e4 +
                              '"]:not(.' +
                              i3.params.slideDuplicateClass +
                              ")"
                          );
                          i3.lazy.loadInSlide(s2.index(), !1);
                        } else {
                          var n4 = i3.$wrapperEl.children(
                            "." +
                              i3.params.slideDuplicateClass +
                              '[data-swiper-slide-index="' +
                              e4 +
                              '"]'
                          );
                          i3.lazy.loadInSlide(n4.index(), !1);
                        }
                      }
                      i3.emit("lazyImageReady", r2[0], o2[0]),
                        i3.params.autoHeight && i3.updateAutoHeight();
                    }
                  }),
                    i3.emit("lazyImageLoad", r2[0], o2[0]);
                });
          }
        },
        load: function () {
          var e2 = this,
            t2 = e2.$wrapperEl,
            i3 = e2.params,
            a2 = e2.slides,
            r2 = e2.activeIndex,
            n2 = e2.virtual && i3.virtual.enabled,
            o2 = i3.lazy,
            l2 = i3.slidesPerView;
          function d2(e3) {
            if (n2) {
              if (
                t2.children(
                  "." + i3.slideClass + '[data-swiper-slide-index="' + e3 + '"]'
                ).length
              )
                return !0;
            } else if (a2[e3]) return !0;
            return !1;
          }
          function h2(e3) {
            return n2 ? s(e3).attr("data-swiper-slide-index") : s(e3).index();
          }
          if (
            (l2 === "auto" && (l2 = 0),
            e2.lazy.initialImageLoaded || (e2.lazy.initialImageLoaded = !0),
            e2.params.watchSlidesVisibility)
          )
            t2.children("." + i3.slideVisibleClass).each(function (t3, i4) {
              var a3 = n2
                ? s(i4).attr("data-swiper-slide-index")
                : s(i4).index();
              e2.lazy.loadInSlide(a3);
            });
          else if (l2 > 1)
            for (var p2 = r2; p2 < r2 + l2; p2 += 1)
              d2(p2) && e2.lazy.loadInSlide(p2);
          else e2.lazy.loadInSlide(r2);
          if (o2.loadPrevNext)
            if (
              l2 > 1 ||
              (o2.loadPrevNextAmount && o2.loadPrevNextAmount > 1)
            ) {
              for (
                var c2 = o2.loadPrevNextAmount,
                  u2 = l2,
                  v2 = Math.min(r2 + u2 + Math.max(c2, u2), a2.length),
                  f2 = Math.max(r2 - Math.max(u2, c2), 0),
                  m2 = r2 + l2;
                m2 < v2;
                m2 += 1
              )
                d2(m2) && e2.lazy.loadInSlide(m2);
              for (var g2 = f2; g2 < r2; g2 += 1)
                d2(g2) && e2.lazy.loadInSlide(g2);
            } else {
              var b2 = t2.children("." + i3.slideNextClass);
              b2.length > 0 && e2.lazy.loadInSlide(h2(b2));
              var w2 = t2.children("." + i3.slidePrevClass);
              w2.length > 0 && e2.lazy.loadInSlide(h2(w2));
            }
        },
      },
      de = {
        LinearSpline: function (e2, t2) {
          var i3,
            s2,
            a2,
            r2,
            n2,
            o2 = function (e3, t3) {
              for (s2 = -1, i3 = e3.length; i3 - s2 > 1; )
                e3[(a2 = (i3 + s2) >> 1)] <= t3 ? (s2 = a2) : (i3 = a2);
              return i3;
            };
          return (
            (this.x = e2),
            (this.y = t2),
            (this.lastIndex = e2.length - 1),
            (this.interpolate = function (e3) {
              return e3
                ? ((n2 = o2(this.x, e3)),
                  (r2 = n2 - 1),
                  ((e3 - this.x[r2]) * (this.y[n2] - this.y[r2])) /
                    (this.x[n2] - this.x[r2]) +
                    this.y[r2])
                : 0;
            }),
            this
          );
        },
        getInterpolateFunction: function (e2) {
          this.controller.spline ||
            (this.controller.spline = this.params.loop
              ? new de.LinearSpline(this.slidesGrid, e2.slidesGrid)
              : new de.LinearSpline(this.snapGrid, e2.snapGrid));
        },
        setTranslate: function (e2, t2) {
          var i3,
            s2,
            a2 = this,
            r2 = a2.controller.control;
          function n2(e3) {
            var t3 = a2.rtlTranslate ? -a2.translate : a2.translate;
            a2.params.controller.by === "slide" &&
              (a2.controller.getInterpolateFunction(e3),
              (s2 = -a2.controller.spline.interpolate(-t3))),
              (s2 && a2.params.controller.by !== "container") ||
                ((i3 =
                  (e3.maxTranslate() - e3.minTranslate()) /
                  (a2.maxTranslate() - a2.minTranslate())),
                (s2 = (t3 - a2.minTranslate()) * i3 + e3.minTranslate())),
              a2.params.controller.inverse && (s2 = e3.maxTranslate() - s2),
              e3.updateProgress(s2),
              e3.setTranslate(s2, a2),
              e3.updateActiveIndex(),
              e3.updateSlidesClasses();
          }
          if (Array.isArray(r2))
            for (var o2 = 0; o2 < r2.length; o2 += 1)
              r2[o2] !== t2 && r2[o2] instanceof W && n2(r2[o2]);
          else r2 instanceof W && t2 !== r2 && n2(r2);
        },
        setTransition: function (e2, t2) {
          var i3,
            s2 = this,
            a2 = s2.controller.control;
          function r2(t3) {
            t3.setTransition(e2, s2),
              e2 !== 0 &&
                (t3.transitionStart(),
                t3.params.autoHeight &&
                  n.nextTick(function () {
                    t3.updateAutoHeight();
                  }),
                t3.$wrapperEl.transitionEnd(function () {
                  a2 &&
                    (t3.params.loop &&
                      s2.params.controller.by === "slide" &&
                      t3.loopFix(),
                    t3.transitionEnd());
                }));
          }
          if (Array.isArray(a2))
            for (i3 = 0; i3 < a2.length; i3 += 1)
              a2[i3] !== t2 && a2[i3] instanceof W && r2(a2[i3]);
          else a2 instanceof W && t2 !== a2 && r2(a2);
        },
      },
      he = {
        makeElFocusable: function (e2) {
          return e2.attr("tabIndex", "0"), e2;
        },
        addElRole: function (e2, t2) {
          return e2.attr("role", t2), e2;
        },
        addElLabel: function (e2, t2) {
          return e2.attr("aria-label", t2), e2;
        },
        disableEl: function (e2) {
          return e2.attr("aria-disabled", !0), e2;
        },
        enableEl: function (e2) {
          return e2.attr("aria-disabled", !1), e2;
        },
        onEnterKey: function (e2) {
          var t2 = this.params.a11y;
          if (e2.keyCode === 13) {
            var i3 = s(e2.target);
            this.navigation &&
              this.navigation.$nextEl &&
              i3.is(this.navigation.$nextEl) &&
              ((this.isEnd && !this.params.loop) || this.slideNext(),
              this.isEnd
                ? this.a11y.notify(t2.lastSlideMessage)
                : this.a11y.notify(t2.nextSlideMessage)),
              this.navigation &&
                this.navigation.$prevEl &&
                i3.is(this.navigation.$prevEl) &&
                ((this.isBeginning && !this.params.loop) || this.slidePrev(),
                this.isBeginning
                  ? this.a11y.notify(t2.firstSlideMessage)
                  : this.a11y.notify(t2.prevSlideMessage)),
              this.pagination &&
                i3.is("." + this.params.pagination.bulletClass) &&
                i3[0].click();
          }
        },
        notify: function (e2) {
          var t2 = this.a11y.liveRegion;
          t2.length !== 0 && (t2.html(""), t2.html(e2));
        },
        updateNavigation: function () {
          if (!this.params.loop && this.navigation) {
            var e2 = this.navigation,
              t2 = e2.$nextEl,
              i3 = e2.$prevEl;
            i3 &&
              i3.length > 0 &&
              (this.isBeginning
                ? this.a11y.disableEl(i3)
                : this.a11y.enableEl(i3)),
              t2 &&
                t2.length > 0 &&
                (this.isEnd ? this.a11y.disableEl(t2) : this.a11y.enableEl(t2));
          }
        },
        updatePagination: function () {
          var e2 = this,
            t2 = e2.params.a11y;
          e2.pagination &&
            e2.params.pagination.clickable &&
            e2.pagination.bullets &&
            e2.pagination.bullets.length &&
            e2.pagination.bullets.each(function (i3, a2) {
              var r2 = s(a2);
              e2.a11y.makeElFocusable(r2),
                e2.a11y.addElRole(r2, "button"),
                e2.a11y.addElLabel(
                  r2,
                  t2.paginationBulletMessage.replace(
                    /\{\{index\}\}/,
                    r2.index() + 1
                  )
                );
            });
        },
        init: function () {
          this.$el.append(this.a11y.liveRegion);
          var e2,
            t2,
            i3 = this.params.a11y;
          this.navigation &&
            this.navigation.$nextEl &&
            (e2 = this.navigation.$nextEl),
            this.navigation &&
              this.navigation.$prevEl &&
              (t2 = this.navigation.$prevEl),
            e2 &&
              (this.a11y.makeElFocusable(e2),
              this.a11y.addElRole(e2, "button"),
              this.a11y.addElLabel(e2, i3.nextSlideMessage),
              e2.on("keydown", this.a11y.onEnterKey)),
            t2 &&
              (this.a11y.makeElFocusable(t2),
              this.a11y.addElRole(t2, "button"),
              this.a11y.addElLabel(t2, i3.prevSlideMessage),
              t2.on("keydown", this.a11y.onEnterKey)),
            this.pagination &&
              this.params.pagination.clickable &&
              this.pagination.bullets &&
              this.pagination.bullets.length &&
              this.pagination.$el.on(
                "keydown",
                "." + this.params.pagination.bulletClass,
                this.a11y.onEnterKey
              );
        },
        destroy: function () {
          var e2, t2;
          this.a11y.liveRegion &&
            this.a11y.liveRegion.length > 0 &&
            this.a11y.liveRegion.remove(),
            this.navigation &&
              this.navigation.$nextEl &&
              (e2 = this.navigation.$nextEl),
            this.navigation &&
              this.navigation.$prevEl &&
              (t2 = this.navigation.$prevEl),
            e2 && e2.off("keydown", this.a11y.onEnterKey),
            t2 && t2.off("keydown", this.a11y.onEnterKey),
            this.pagination &&
              this.params.pagination.clickable &&
              this.pagination.bullets &&
              this.pagination.bullets.length &&
              this.pagination.$el.off(
                "keydown",
                "." + this.params.pagination.bulletClass,
                this.a11y.onEnterKey
              );
        },
      },
      pe = {
        init: function () {
          if (this.params.history) {
            if (!t.history || !t.history.pushState)
              return (
                (this.params.history.enabled = !1),
                void (this.params.hashNavigation.enabled = !0)
              );
            var e2 = this.history;
            (e2.initialized = !0),
              (e2.paths = pe.getPathValues()),
              (e2.paths.key || e2.paths.value) &&
                (e2.scrollToSlide(
                  0,
                  e2.paths.value,
                  this.params.runCallbacksOnInit
                ),
                this.params.history.replaceState ||
                  t.addEventListener(
                    "popstate",
                    this.history.setHistoryPopState
                  ));
          }
        },
        destroy: function () {
          this.params.history.replaceState ||
            t.removeEventListener("popstate", this.history.setHistoryPopState);
        },
        setHistoryPopState: function () {
          (this.history.paths = pe.getPathValues()),
            this.history.scrollToSlide(
              this.params.speed,
              this.history.paths.value,
              !1
            );
        },
        getPathValues: function () {
          var e2 = t.location.pathname
              .slice(1)
              .split("/")
              .filter(function (e3) {
                return e3 !== "";
              }),
            i3 = e2.length;
          return { key: e2[i3 - 2], value: e2[i3 - 1] };
        },
        setHistory: function (e2, i3) {
          if (this.history.initialized && this.params.history.enabled) {
            var s2 = this.slides.eq(i3),
              a2 = pe.slugify(s2.attr("data-history"));
            t.location.pathname.includes(e2) || (a2 = e2 + "/" + a2);
            var r2 = t.history.state;
            (r2 && r2.value === a2) ||
              (this.params.history.replaceState
                ? t.history.replaceState({ value: a2 }, null, a2)
                : t.history.pushState({ value: a2 }, null, a2));
          }
        },
        slugify: function (e2) {
          return e2
            .toString()
            .replace(/\s+/g, "-")
            .replace(/[^\w-]+/g, "")
            .replace(/--+/g, "-")
            .replace(/^-+/, "")
            .replace(/-+$/, "");
        },
        scrollToSlide: function (e2, t2, i3) {
          if (t2)
            for (var s2 = 0, a2 = this.slides.length; s2 < a2; s2 += 1) {
              var r2 = this.slides.eq(s2);
              if (
                pe.slugify(r2.attr("data-history")) === t2 &&
                !r2.hasClass(this.params.slideDuplicateClass)
              ) {
                var n2 = r2.index();
                this.slideTo(n2, e2, i3);
              }
            }
          else this.slideTo(0, e2, i3);
        },
      },
      ce = {
        onHashCange: function () {
          var t2 = e.location.hash.replace("#", "");
          if (t2 !== this.slides.eq(this.activeIndex).attr("data-hash")) {
            var i3 = this.$wrapperEl
              .children(
                "." + this.params.slideClass + '[data-hash="' + t2 + '"]'
              )
              .index();
            if (i3 === void 0) return;
            this.slideTo(i3);
          }
        },
        setHash: function () {
          if (
            this.hashNavigation.initialized &&
            this.params.hashNavigation.enabled
          )
            if (
              this.params.hashNavigation.replaceState &&
              t.history &&
              t.history.replaceState
            )
              t.history.replaceState(
                null,
                null,
                "#" + this.slides.eq(this.activeIndex).attr("data-hash") || ""
              );
            else {
              var i3 = this.slides.eq(this.activeIndex),
                s2 = i3.attr("data-hash") || i3.attr("data-history");
              e.location.hash = s2 || "";
            }
        },
        init: function () {
          if (
            !(
              !this.params.hashNavigation.enabled ||
              (this.params.history && this.params.history.enabled)
            )
          ) {
            this.hashNavigation.initialized = !0;
            var i3 = e.location.hash.replace("#", "");
            if (i3)
              for (var a2 = 0, r2 = this.slides.length; a2 < r2; a2 += 1) {
                var n2 = this.slides.eq(a2);
                if (
                  (n2.attr("data-hash") || n2.attr("data-history")) === i3 &&
                  !n2.hasClass(this.params.slideDuplicateClass)
                ) {
                  var o2 = n2.index();
                  this.slideTo(o2, 0, this.params.runCallbacksOnInit, !0);
                }
              }
            this.params.hashNavigation.watchState &&
              s(t).on("hashchange", this.hashNavigation.onHashCange);
          }
        },
        destroy: function () {
          this.params.hashNavigation.watchState &&
            s(t).off("hashchange", this.hashNavigation.onHashCange);
        },
      },
      ue = {
        run: function () {
          var e2 = this,
            t2 = e2.slides.eq(e2.activeIndex),
            i3 = e2.params.autoplay.delay;
          t2.attr("data-swiper-autoplay") &&
            (i3 = t2.attr("data-swiper-autoplay") || e2.params.autoplay.delay),
            clearTimeout(e2.autoplay.timeout),
            (e2.autoplay.timeout = n.nextTick(function () {
              e2.params.autoplay.reverseDirection
                ? e2.params.loop
                  ? (e2.loopFix(),
                    e2.slidePrev(e2.params.speed, !0, !0),
                    e2.emit("autoplay"))
                  : e2.isBeginning
                  ? e2.params.autoplay.stopOnLastSlide
                    ? e2.autoplay.stop()
                    : (e2.slideTo(
                        e2.slides.length - 1,
                        e2.params.speed,
                        !0,
                        !0
                      ),
                      e2.emit("autoplay"))
                  : (e2.slidePrev(e2.params.speed, !0, !0), e2.emit("autoplay"))
                : e2.params.loop
                ? (e2.loopFix(),
                  e2.slideNext(e2.params.speed, !0, !0),
                  e2.emit("autoplay"))
                : e2.isEnd
                ? e2.params.autoplay.stopOnLastSlide
                  ? e2.autoplay.stop()
                  : (e2.slideTo(0, e2.params.speed, !0, !0),
                    e2.emit("autoplay"))
                : (e2.slideNext(e2.params.speed, !0, !0), e2.emit("autoplay")),
                e2.params.cssMode && e2.autoplay.running && e2.autoplay.run();
            }, i3));
        },
        start: function () {
          return (
            this.autoplay.timeout === void 0 &&
            !this.autoplay.running &&
            ((this.autoplay.running = !0),
            this.emit("autoplayStart"),
            this.autoplay.run(),
            !0)
          );
        },
        stop: function () {
          return (
            !!this.autoplay.running &&
            this.autoplay.timeout !== void 0 &&
            (this.autoplay.timeout &&
              (clearTimeout(this.autoplay.timeout),
              (this.autoplay.timeout = void 0)),
            (this.autoplay.running = !1),
            this.emit("autoplayStop"),
            !0)
          );
        },
        pause: function (e2) {
          this.autoplay.running &&
            (this.autoplay.paused ||
              (this.autoplay.timeout && clearTimeout(this.autoplay.timeout),
              (this.autoplay.paused = !0),
              e2 !== 0 && this.params.autoplay.waitForTransition
                ? (this.$wrapperEl[0].addEventListener(
                    "transitionend",
                    this.autoplay.onTransitionEnd
                  ),
                  this.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    this.autoplay.onTransitionEnd
                  ))
                : ((this.autoplay.paused = !1), this.autoplay.run())));
        },
      },
      ve = {
        setTranslate: function () {
          for (var e2 = this.slides, t2 = 0; t2 < e2.length; t2 += 1) {
            var i3 = this.slides.eq(t2),
              s2 = -i3[0].swiperSlideOffset;
            this.params.virtualTranslate || (s2 -= this.translate);
            var a2 = 0;
            this.isHorizontal() || ((a2 = s2), (s2 = 0));
            var r2 = this.params.fadeEffect.crossFade
              ? Math.max(1 - Math.abs(i3[0].progress), 0)
              : 1 + Math.min(Math.max(i3[0].progress, -1), 0);
            i3.css({ opacity: r2 }).transform(
              "translate3d(" + s2 + "px, " + a2 + "px, 0px)"
            );
          }
        },
        setTransition: function (e2) {
          var t2 = this,
            i3 = t2.slides,
            s2 = t2.$wrapperEl;
          if ((i3.transition(e2), t2.params.virtualTranslate && e2 !== 0)) {
            var a2 = !1;
            i3.transitionEnd(function () {
              if (!a2 && t2 && !t2.destroyed) {
                (a2 = !0), (t2.animating = !1);
                for (
                  var e3 = ["webkitTransitionEnd", "transitionend"], i4 = 0;
                  i4 < e3.length;
                  i4 += 1
                )
                  s2.trigger(e3[i4]);
              }
            });
          }
        },
      },
      fe = {
        setTranslate: function () {
          var e2,
            t2 = this.$el,
            i3 = this.$wrapperEl,
            a2 = this.slides,
            r2 = this.width,
            n2 = this.height,
            o2 = this.rtlTranslate,
            l2 = this.size,
            d2 = this.params.cubeEffect,
            h2 = this.isHorizontal(),
            p2 = this.virtual && this.params.virtual.enabled,
            c2 = 0;
          d2.shadow &&
            (h2
              ? ((e2 = i3.find(".swiper-cube-shadow")).length === 0 &&
                  ((e2 = s('<div class="swiper-cube-shadow"></div>')),
                  i3.append(e2)),
                e2.css({ height: r2 + "px" }))
              : (e2 = t2.find(".swiper-cube-shadow")).length === 0 &&
                ((e2 = s('<div class="swiper-cube-shadow"></div>')),
                t2.append(e2)));
          for (var u2 = 0; u2 < a2.length; u2 += 1) {
            var v2 = a2.eq(u2),
              f2 = u2;
            p2 && (f2 = parseInt(v2.attr("data-swiper-slide-index"), 10));
            var m2 = 90 * f2,
              g2 = Math.floor(m2 / 360);
            o2 && ((m2 = -m2), (g2 = Math.floor(-m2 / 360)));
            var b2 = Math.max(Math.min(v2[0].progress, 1), -1),
              w2 = 0,
              y2 = 0,
              x2 = 0;
            f2 % 4 == 0
              ? ((w2 = 4 * -g2 * l2), (x2 = 0))
              : (f2 - 1) % 4 == 0
              ? ((w2 = 0), (x2 = 4 * -g2 * l2))
              : (f2 - 2) % 4 == 0
              ? ((w2 = l2 + 4 * g2 * l2), (x2 = l2))
              : (f2 - 3) % 4 == 0 && ((w2 = -l2), (x2 = 3 * l2 + 4 * l2 * g2)),
              o2 && (w2 = -w2),
              h2 || ((y2 = w2), (w2 = 0));
            var T2 =
              "rotateX(" +
              (h2 ? 0 : -m2) +
              "deg) rotateY(" +
              (h2 ? m2 : 0) +
              "deg) translate3d(" +
              w2 +
              "px, " +
              y2 +
              "px, " +
              x2 +
              "px)";
            if (
              (b2 <= 1 &&
                b2 > -1 &&
                ((c2 = 90 * f2 + 90 * b2), o2 && (c2 = 90 * -f2 - 90 * b2)),
              v2.transform(T2),
              d2.slideShadows)
            ) {
              var E2 = h2
                  ? v2.find(".swiper-slide-shadow-left")
                  : v2.find(".swiper-slide-shadow-top"),
                S2 = h2
                  ? v2.find(".swiper-slide-shadow-right")
                  : v2.find(".swiper-slide-shadow-bottom");
              E2.length === 0 &&
                ((E2 = s(
                  '<div class="swiper-slide-shadow-' +
                    (h2 ? "left" : "top") +
                    '"></div>'
                )),
                v2.append(E2)),
                S2.length === 0 &&
                  ((S2 = s(
                    '<div class="swiper-slide-shadow-' +
                      (h2 ? "right" : "bottom") +
                      '"></div>'
                  )),
                  v2.append(S2)),
                E2.length && (E2[0].style.opacity = Math.max(-b2, 0)),
                S2.length && (S2[0].style.opacity = Math.max(b2, 0));
            }
          }
          if (
            (i3.css({
              "-webkit-transform-origin": "50% 50% -" + l2 / 2 + "px",
              "-moz-transform-origin": "50% 50% -" + l2 / 2 + "px",
              "-ms-transform-origin": "50% 50% -" + l2 / 2 + "px",
              "transform-origin": "50% 50% -" + l2 / 2 + "px",
            }),
            d2.shadow)
          )
            if (h2)
              e2.transform(
                "translate3d(0px, " +
                  (r2 / 2 + d2.shadowOffset) +
                  "px, " +
                  -r2 / 2 +
                  "px) rotateX(90deg) rotateZ(0deg) scale(" +
                  d2.shadowScale +
                  ")"
              );
            else {
              var C2 = Math.abs(c2) - 90 * Math.floor(Math.abs(c2) / 90),
                M2 =
                  1.5 -
                  (Math.sin((2 * C2 * Math.PI) / 360) / 2 +
                    Math.cos((2 * C2 * Math.PI) / 360) / 2),
                P2 = d2.shadowScale,
                z2 = d2.shadowScale / M2,
                k2 = d2.shadowOffset;
              e2.transform(
                "scale3d(" +
                  P2 +
                  ", 1, " +
                  z2 +
                  ") translate3d(0px, " +
                  (n2 / 2 + k2) +
                  "px, " +
                  -n2 / 2 / z2 +
                  "px) rotateX(-90deg)"
              );
            }
          var $3 = j.isSafari || j.isUiWebView ? -l2 / 2 : 0;
          i3.transform(
            "translate3d(0px,0," +
              $3 +
              "px) rotateX(" +
              (this.isHorizontal() ? 0 : c2) +
              "deg) rotateY(" +
              (this.isHorizontal() ? -c2 : 0) +
              "deg)"
          );
        },
        setTransition: function (e2) {
          var t2 = this.$el;
          this.slides
            .transition(e2)
            .find(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            )
            .transition(e2),
            this.params.cubeEffect.shadow &&
              !this.isHorizontal() &&
              t2.find(".swiper-cube-shadow").transition(e2);
        },
      },
      me = {
        setTranslate: function () {
          for (
            var e2 = this.slides, t2 = this.rtlTranslate, i3 = 0;
            i3 < e2.length;
            i3 += 1
          ) {
            var a2 = e2.eq(i3),
              r2 = a2[0].progress;
            this.params.flipEffect.limitRotation &&
              (r2 = Math.max(Math.min(a2[0].progress, 1), -1));
            var n2 = -180 * r2,
              o2 = 0,
              l2 = -a2[0].swiperSlideOffset,
              d2 = 0;
            if (
              (this.isHorizontal()
                ? t2 && (n2 = -n2)
                : ((d2 = l2), (l2 = 0), (o2 = -n2), (n2 = 0)),
              (a2[0].style.zIndex = -Math.abs(Math.round(r2)) + e2.length),
              this.params.flipEffect.slideShadows)
            ) {
              var h2 = this.isHorizontal()
                  ? a2.find(".swiper-slide-shadow-left")
                  : a2.find(".swiper-slide-shadow-top"),
                p2 = this.isHorizontal()
                  ? a2.find(".swiper-slide-shadow-right")
                  : a2.find(".swiper-slide-shadow-bottom");
              h2.length === 0 &&
                ((h2 = s(
                  '<div class="swiper-slide-shadow-' +
                    (this.isHorizontal() ? "left" : "top") +
                    '"></div>'
                )),
                a2.append(h2)),
                p2.length === 0 &&
                  ((p2 = s(
                    '<div class="swiper-slide-shadow-' +
                      (this.isHorizontal() ? "right" : "bottom") +
                      '"></div>'
                  )),
                  a2.append(p2)),
                h2.length && (h2[0].style.opacity = Math.max(-r2, 0)),
                p2.length && (p2[0].style.opacity = Math.max(r2, 0));
            }
            a2.transform(
              "translate3d(" +
                l2 +
                "px, " +
                d2 +
                "px, 0px) rotateX(" +
                o2 +
                "deg) rotateY(" +
                n2 +
                "deg)"
            );
          }
        },
        setTransition: function (e2) {
          var t2 = this,
            i3 = t2.slides,
            s2 = t2.activeIndex,
            a2 = t2.$wrapperEl;
          if (
            (i3
              .transition(e2)
              .find(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
              )
              .transition(e2),
            t2.params.virtualTranslate && e2 !== 0)
          ) {
            var r2 = !1;
            i3.eq(s2).transitionEnd(function () {
              if (!r2 && t2 && !t2.destroyed) {
                (r2 = !0), (t2.animating = !1);
                for (
                  var e3 = ["webkitTransitionEnd", "transitionend"], i4 = 0;
                  i4 < e3.length;
                  i4 += 1
                )
                  a2.trigger(e3[i4]);
              }
            });
          }
        },
      },
      ge = {
        setTranslate: function () {
          for (
            var e2 = this.width,
              t2 = this.height,
              i3 = this.slides,
              a2 = this.$wrapperEl,
              r2 = this.slidesSizesGrid,
              n2 = this.params.coverflowEffect,
              l2 = this.isHorizontal(),
              d2 = this.translate,
              h2 = l2 ? e2 / 2 - d2 : t2 / 2 - d2,
              p2 = l2 ? n2.rotate : -n2.rotate,
              c2 = n2.depth,
              u2 = 0,
              v2 = i3.length;
            u2 < v2;
            u2 += 1
          ) {
            var f2 = i3.eq(u2),
              m2 = r2[u2],
              g2 = ((h2 - f2[0].swiperSlideOffset - m2 / 2) / m2) * n2.modifier,
              b2 = l2 ? p2 * g2 : 0,
              w2 = l2 ? 0 : p2 * g2,
              y2 = -c2 * Math.abs(g2),
              x2 = n2.stretch;
            typeof x2 == "string" &&
              x2.indexOf("%") !== -1 &&
              (x2 = (parseFloat(n2.stretch) / 100) * m2);
            var T2 = l2 ? 0 : x2 * g2,
              E2 = l2 ? x2 * g2 : 0;
            Math.abs(E2) < 0.001 && (E2 = 0),
              Math.abs(T2) < 0.001 && (T2 = 0),
              Math.abs(y2) < 0.001 && (y2 = 0),
              Math.abs(b2) < 0.001 && (b2 = 0),
              Math.abs(w2) < 0.001 && (w2 = 0);
            var S2 =
              "translate3d(" +
              E2 +
              "px," +
              T2 +
              "px," +
              y2 +
              "px)  rotateX(" +
              w2 +
              "deg) rotateY(" +
              b2 +
              "deg)";
            if (
              (f2.transform(S2),
              (f2[0].style.zIndex = 1 - Math.abs(Math.round(g2))),
              n2.slideShadows)
            ) {
              var C2 = l2
                  ? f2.find(".swiper-slide-shadow-left")
                  : f2.find(".swiper-slide-shadow-top"),
                M2 = l2
                  ? f2.find(".swiper-slide-shadow-right")
                  : f2.find(".swiper-slide-shadow-bottom");
              C2.length === 0 &&
                ((C2 = s(
                  '<div class="swiper-slide-shadow-' +
                    (l2 ? "left" : "top") +
                    '"></div>'
                )),
                f2.append(C2)),
                M2.length === 0 &&
                  ((M2 = s(
                    '<div class="swiper-slide-shadow-' +
                      (l2 ? "right" : "bottom") +
                      '"></div>'
                  )),
                  f2.append(M2)),
                C2.length && (C2[0].style.opacity = g2 > 0 ? g2 : 0),
                M2.length && (M2[0].style.opacity = -g2 > 0 ? -g2 : 0);
            }
          }
          (o.pointerEvents || o.prefixedPointerEvents) &&
            (a2[0].style.perspectiveOrigin = h2 + "px 50%");
        },
        setTransition: function (e2) {
          this.slides
            .transition(e2)
            .find(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            )
            .transition(e2);
        },
      },
      be = {
        init: function () {
          var e2 = this.params.thumbs,
            t2 = this.constructor;
          e2.swiper instanceof t2
            ? ((this.thumbs.swiper = e2.swiper),
              n.extend(this.thumbs.swiper.originalParams, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }),
              n.extend(this.thumbs.swiper.params, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }))
            : n.isObject(e2.swiper) &&
              ((this.thumbs.swiper = new t2(
                n.extend({}, e2.swiper, {
                  watchSlidesVisibility: !0,
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                })
              )),
              (this.thumbs.swiperCreated = !0)),
            this.thumbs.swiper.$el.addClass(
              this.params.thumbs.thumbsContainerClass
            ),
            this.thumbs.swiper.on("tap", this.thumbs.onThumbClick);
        },
        onThumbClick: function () {
          var e2 = this.thumbs.swiper;
          if (e2) {
            var t2 = e2.clickedIndex,
              i3 = e2.clickedSlide;
            if (
              !(
                (i3 &&
                  s(i3).hasClass(this.params.thumbs.slideThumbActiveClass)) ||
                t2 == null
              )
            ) {
              var a2;
              if (
                ((a2 = e2.params.loop
                  ? parseInt(
                      s(e2.clickedSlide).attr("data-swiper-slide-index"),
                      10
                    )
                  : t2),
                this.params.loop)
              ) {
                var r2 = this.activeIndex;
                this.slides.eq(r2).hasClass(this.params.slideDuplicateClass) &&
                  (this.loopFix(),
                  (this._clientLeft = this.$wrapperEl[0].clientLeft),
                  (r2 = this.activeIndex));
                var n2 = this.slides
                    .eq(r2)
                    .prevAll('[data-swiper-slide-index="' + a2 + '"]')
                    .eq(0)
                    .index(),
                  o2 = this.slides
                    .eq(r2)
                    .nextAll('[data-swiper-slide-index="' + a2 + '"]')
                    .eq(0)
                    .index();
                a2 =
                  n2 === void 0
                    ? o2
                    : o2 === void 0
                    ? n2
                    : o2 - r2 < r2 - n2
                    ? o2
                    : n2;
              }
              this.slideTo(a2);
            }
          }
        },
        update: function (e2) {
          var t2 = this.thumbs.swiper;
          if (t2) {
            var i3 =
                t2.params.slidesPerView === "auto"
                  ? t2.slidesPerViewDynamic()
                  : t2.params.slidesPerView,
              s2 = this.params.thumbs.autoScrollOffset,
              a2 = s2 && !t2.params.loop;
            if (this.realIndex !== t2.realIndex || a2) {
              var r2,
                n2,
                o2 = t2.activeIndex;
              if (t2.params.loop) {
                t2.slides.eq(o2).hasClass(t2.params.slideDuplicateClass) &&
                  (t2.loopFix(),
                  (t2._clientLeft = t2.$wrapperEl[0].clientLeft),
                  (o2 = t2.activeIndex));
                var l2 = t2.slides
                    .eq(o2)
                    .prevAll(
                      '[data-swiper-slide-index="' + this.realIndex + '"]'
                    )
                    .eq(0)
                    .index(),
                  d2 = t2.slides
                    .eq(o2)
                    .nextAll(
                      '[data-swiper-slide-index="' + this.realIndex + '"]'
                    )
                    .eq(0)
                    .index();
                (r2 =
                  l2 === void 0
                    ? d2
                    : d2 === void 0
                    ? l2
                    : d2 - o2 == o2 - l2
                    ? o2
                    : d2 - o2 < o2 - l2
                    ? d2
                    : l2),
                  (n2 =
                    this.activeIndex > this.previousIndex ? "next" : "prev");
              } else
                n2 =
                  (r2 = this.realIndex) > this.previousIndex ? "next" : "prev";
              a2 && (r2 += n2 === "next" ? s2 : -1 * s2),
                t2.visibleSlidesIndexes &&
                  t2.visibleSlidesIndexes.indexOf(r2) < 0 &&
                  (t2.params.centeredSlides
                    ? (r2 =
                        r2 > o2
                          ? r2 - Math.floor(i3 / 2) + 1
                          : r2 + Math.floor(i3 / 2) - 1)
                    : r2 > o2 && (r2 = r2 - i3 + 1),
                  t2.slideTo(r2, e2 ? 0 : void 0));
            }
            var h2 = 1,
              p2 = this.params.thumbs.slideThumbActiveClass;
            if (
              (this.params.slidesPerView > 1 &&
                !this.params.centeredSlides &&
                (h2 = this.params.slidesPerView),
              this.params.thumbs.multipleActiveThumbs || (h2 = 1),
              (h2 = Math.floor(h2)),
              t2.slides.removeClass(p2),
              t2.params.loop ||
                (t2.params.virtual && t2.params.virtual.enabled))
            )
              for (var c2 = 0; c2 < h2; c2 += 1)
                t2.$wrapperEl
                  .children(
                    '[data-swiper-slide-index="' + (this.realIndex + c2) + '"]'
                  )
                  .addClass(p2);
            else
              for (var u2 = 0; u2 < h2; u2 += 1)
                t2.slides.eq(this.realIndex + u2).addClass(p2);
          }
        },
      },
      we = [
        R,
        q,
        K,
        U,
        Z,
        J,
        te,
        {
          name: "mousewheel",
          params: {
            mousewheel: {
              enabled: !1,
              releaseOnEdges: !1,
              invert: !1,
              forceToAxis: !1,
              sensitivity: 1,
              eventsTarged: "container",
            },
          },
          create: function () {
            n.extend(this, {
              mousewheel: {
                enabled: !1,
                enable: ie.enable.bind(this),
                disable: ie.disable.bind(this),
                handle: ie.handle.bind(this),
                handleMouseEnter: ie.handleMouseEnter.bind(this),
                handleMouseLeave: ie.handleMouseLeave.bind(this),
                animateSlider: ie.animateSlider.bind(this),
                releaseScroll: ie.releaseScroll.bind(this),
                lastScrollTime: n.now(),
                lastEventBeforeSnap: void 0,
                recentWheelEvents: [],
              },
            });
          },
          on: {
            init: function () {
              !this.params.mousewheel.enabled &&
                this.params.cssMode &&
                this.mousewheel.disable(),
                this.params.mousewheel.enabled && this.mousewheel.enable();
            },
            destroy: function () {
              this.params.cssMode && this.mousewheel.enable(),
                this.mousewheel.enabled && this.mousewheel.disable();
            },
          },
        },
        {
          name: "navigation",
          params: {
            navigation: {
              nextEl: null,
              prevEl: null,
              hideOnClick: !1,
              disabledClass: "swiper-button-disabled",
              hiddenClass: "swiper-button-hidden",
              lockClass: "swiper-button-lock",
            },
          },
          create: function () {
            n.extend(this, {
              navigation: {
                init: se.init.bind(this),
                update: se.update.bind(this),
                destroy: se.destroy.bind(this),
                onNextClick: se.onNextClick.bind(this),
                onPrevClick: se.onPrevClick.bind(this),
              },
            });
          },
          on: {
            init: function () {
              this.navigation.init(), this.navigation.update();
            },
            toEdge: function () {
              this.navigation.update();
            },
            fromEdge: function () {
              this.navigation.update();
            },
            destroy: function () {
              this.navigation.destroy();
            },
            click: function (e2) {
              var t2,
                i3 = this.navigation,
                a2 = i3.$nextEl,
                r2 = i3.$prevEl;
              !this.params.navigation.hideOnClick ||
                s(e2.target).is(r2) ||
                s(e2.target).is(a2) ||
                (a2
                  ? (t2 = a2.hasClass(this.params.navigation.hiddenClass))
                  : r2 &&
                    (t2 = r2.hasClass(this.params.navigation.hiddenClass)),
                t2 === !0
                  ? this.emit("navigationShow", this)
                  : this.emit("navigationHide", this),
                a2 && a2.toggleClass(this.params.navigation.hiddenClass),
                r2 && r2.toggleClass(this.params.navigation.hiddenClass));
            },
          },
        },
        {
          name: "pagination",
          params: {
            pagination: {
              el: null,
              bulletElement: "span",
              clickable: !1,
              hideOnClick: !1,
              renderBullet: null,
              renderProgressbar: null,
              renderFraction: null,
              renderCustom: null,
              progressbarOpposite: !1,
              type: "bullets",
              dynamicBullets: !1,
              dynamicMainBullets: 1,
              formatFractionCurrent: function (e2) {
                return e2;
              },
              formatFractionTotal: function (e2) {
                return e2;
              },
              bulletClass: "swiper-pagination-bullet",
              bulletActiveClass: "swiper-pagination-bullet-active",
              modifierClass: "swiper-pagination-",
              currentClass: "swiper-pagination-current",
              totalClass: "swiper-pagination-total",
              hiddenClass: "swiper-pagination-hidden",
              progressbarFillClass: "swiper-pagination-progressbar-fill",
              progressbarOppositeClass:
                "swiper-pagination-progressbar-opposite",
              clickableClass: "swiper-pagination-clickable",
              lockClass: "swiper-pagination-lock",
            },
          },
          create: function () {
            n.extend(this, {
              pagination: {
                init: ae.init.bind(this),
                render: ae.render.bind(this),
                update: ae.update.bind(this),
                destroy: ae.destroy.bind(this),
                dynamicBulletIndex: 0,
              },
            });
          },
          on: {
            init: function () {
              this.pagination.init(),
                this.pagination.render(),
                this.pagination.update();
            },
            activeIndexChange: function () {
              (this.params.loop || this.snapIndex === void 0) &&
                this.pagination.update();
            },
            snapIndexChange: function () {
              this.params.loop || this.pagination.update();
            },
            slidesLengthChange: function () {
              this.params.loop &&
                (this.pagination.render(), this.pagination.update());
            },
            snapGridLengthChange: function () {
              this.params.loop ||
                (this.pagination.render(), this.pagination.update());
            },
            destroy: function () {
              this.pagination.destroy();
            },
            click: function (e2) {
              this.params.pagination.el &&
                this.params.pagination.hideOnClick &&
                this.pagination.$el.length > 0 &&
                !s(e2.target).hasClass(this.params.pagination.bulletClass) &&
                (this.pagination.$el.hasClass(
                  this.params.pagination.hiddenClass
                ) === !0
                  ? this.emit("paginationShow", this)
                  : this.emit("paginationHide", this),
                this.pagination.$el.toggleClass(
                  this.params.pagination.hiddenClass
                ));
            },
          },
        },
        {
          name: "scrollbar",
          params: {
            scrollbar: {
              el: null,
              dragSize: "auto",
              hide: !1,
              draggable: !1,
              snapOnRelease: !0,
              lockClass: "swiper-scrollbar-lock",
              dragClass: "swiper-scrollbar-drag",
            },
          },
          create: function () {
            n.extend(this, {
              scrollbar: {
                init: re.init.bind(this),
                destroy: re.destroy.bind(this),
                updateSize: re.updateSize.bind(this),
                setTranslate: re.setTranslate.bind(this),
                setTransition: re.setTransition.bind(this),
                enableDraggable: re.enableDraggable.bind(this),
                disableDraggable: re.disableDraggable.bind(this),
                setDragPosition: re.setDragPosition.bind(this),
                getPointerPosition: re.getPointerPosition.bind(this),
                onDragStart: re.onDragStart.bind(this),
                onDragMove: re.onDragMove.bind(this),
                onDragEnd: re.onDragEnd.bind(this),
                isTouched: !1,
                timeout: null,
                dragTimeout: null,
              },
            });
          },
          on: {
            init: function () {
              this.scrollbar.init(),
                this.scrollbar.updateSize(),
                this.scrollbar.setTranslate();
            },
            update: function () {
              this.scrollbar.updateSize();
            },
            resize: function () {
              this.scrollbar.updateSize();
            },
            observerUpdate: function () {
              this.scrollbar.updateSize();
            },
            setTranslate: function () {
              this.scrollbar.setTranslate();
            },
            setTransition: function (e2) {
              this.scrollbar.setTransition(e2);
            },
            destroy: function () {
              this.scrollbar.destroy();
            },
          },
        },
        {
          name: "parallax",
          params: { parallax: { enabled: !1 } },
          create: function () {
            n.extend(this, {
              parallax: {
                setTransform: ne.setTransform.bind(this),
                setTranslate: ne.setTranslate.bind(this),
                setTransition: ne.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              this.params.parallax.enabled &&
                ((this.params.watchSlidesProgress = !0),
                (this.originalParams.watchSlidesProgress = !0));
            },
            init: function () {
              this.params.parallax.enabled && this.parallax.setTranslate();
            },
            setTranslate: function () {
              this.params.parallax.enabled && this.parallax.setTranslate();
            },
            setTransition: function (e2) {
              this.params.parallax.enabled && this.parallax.setTransition(e2);
            },
          },
        },
        {
          name: "zoom",
          params: {
            zoom: {
              enabled: !1,
              maxRatio: 3,
              minRatio: 1,
              toggle: !0,
              containerClass: "swiper-zoom-container",
              zoomedSlideClass: "swiper-slide-zoomed",
            },
          },
          create: function () {
            var e2 = this,
              t2 = {
                enabled: !1,
                scale: 1,
                currentScale: 1,
                isScaling: !1,
                gesture: {
                  $slideEl: void 0,
                  slideWidth: void 0,
                  slideHeight: void 0,
                  $imageEl: void 0,
                  $imageWrapEl: void 0,
                  maxRatio: 3,
                },
                image: {
                  isTouched: void 0,
                  isMoved: void 0,
                  currentX: void 0,
                  currentY: void 0,
                  minX: void 0,
                  minY: void 0,
                  maxX: void 0,
                  maxY: void 0,
                  width: void 0,
                  height: void 0,
                  startX: void 0,
                  startY: void 0,
                  touchesStart: {},
                  touchesCurrent: {},
                },
                velocity: {
                  x: void 0,
                  y: void 0,
                  prevPositionX: void 0,
                  prevPositionY: void 0,
                  prevTime: void 0,
                },
              };
            "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out"
              .split(" ")
              .forEach(function (i4) {
                t2[i4] = oe[i4].bind(e2);
              }),
              n.extend(e2, { zoom: t2 });
            var i3 = 1;
            Object.defineProperty(e2.zoom, "scale", {
              get: function () {
                return i3;
              },
              set: function (t3) {
                if (i3 !== t3) {
                  var s2 = e2.zoom.gesture.$imageEl
                      ? e2.zoom.gesture.$imageEl[0]
                      : void 0,
                    a2 = e2.zoom.gesture.$slideEl
                      ? e2.zoom.gesture.$slideEl[0]
                      : void 0;
                  e2.emit("zoomChange", t3, s2, a2);
                }
                i3 = t3;
              },
            });
          },
          on: {
            init: function () {
              this.params.zoom.enabled && this.zoom.enable();
            },
            destroy: function () {
              this.zoom.disable();
            },
            touchStart: function (e2) {
              this.zoom.enabled && this.zoom.onTouchStart(e2);
            },
            touchEnd: function (e2) {
              this.zoom.enabled && this.zoom.onTouchEnd(e2);
            },
            doubleTap: function (e2) {
              this.params.zoom.enabled &&
                this.zoom.enabled &&
                this.params.zoom.toggle &&
                this.zoom.toggle(e2);
            },
            transitionEnd: function () {
              this.zoom.enabled &&
                this.params.zoom.enabled &&
                this.zoom.onTransitionEnd();
            },
            slideChange: function () {
              this.zoom.enabled &&
                this.params.zoom.enabled &&
                this.params.cssMode &&
                this.zoom.onTransitionEnd();
            },
          },
        },
        {
          name: "lazy",
          params: {
            lazy: {
              enabled: !1,
              loadPrevNext: !1,
              loadPrevNextAmount: 1,
              loadOnTransitionStart: !1,
              elementClass: "swiper-lazy",
              loadingClass: "swiper-lazy-loading",
              loadedClass: "swiper-lazy-loaded",
              preloaderClass: "swiper-lazy-preloader",
            },
          },
          create: function () {
            n.extend(this, {
              lazy: {
                initialImageLoaded: !1,
                load: le.load.bind(this),
                loadInSlide: le.loadInSlide.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              this.params.lazy.enabled &&
                this.params.preloadImages &&
                (this.params.preloadImages = !1);
            },
            init: function () {
              this.params.lazy.enabled &&
                !this.params.loop &&
                this.params.initialSlide === 0 &&
                this.lazy.load();
            },
            scroll: function () {
              this.params.freeMode &&
                !this.params.freeModeSticky &&
                this.lazy.load();
            },
            resize: function () {
              this.params.lazy.enabled && this.lazy.load();
            },
            scrollbarDragMove: function () {
              this.params.lazy.enabled && this.lazy.load();
            },
            transitionStart: function () {
              this.params.lazy.enabled &&
                (this.params.lazy.loadOnTransitionStart ||
                  (!this.params.lazy.loadOnTransitionStart &&
                    !this.lazy.initialImageLoaded)) &&
                this.lazy.load();
            },
            transitionEnd: function () {
              this.params.lazy.enabled &&
                !this.params.lazy.loadOnTransitionStart &&
                this.lazy.load();
            },
            slideChange: function () {
              this.params.lazy.enabled &&
                this.params.cssMode &&
                this.lazy.load();
            },
          },
        },
        {
          name: "controller",
          params: { controller: { control: void 0, inverse: !1, by: "slide" } },
          create: function () {
            n.extend(this, {
              controller: {
                control: this.params.controller.control,
                getInterpolateFunction: de.getInterpolateFunction.bind(this),
                setTranslate: de.setTranslate.bind(this),
                setTransition: de.setTransition.bind(this),
              },
            });
          },
          on: {
            update: function () {
              this.controller.control &&
                this.controller.spline &&
                ((this.controller.spline = void 0),
                delete this.controller.spline);
            },
            resize: function () {
              this.controller.control &&
                this.controller.spline &&
                ((this.controller.spline = void 0),
                delete this.controller.spline);
            },
            observerUpdate: function () {
              this.controller.control &&
                this.controller.spline &&
                ((this.controller.spline = void 0),
                delete this.controller.spline);
            },
            setTranslate: function (e2, t2) {
              this.controller.control && this.controller.setTranslate(e2, t2);
            },
            setTransition: function (e2, t2) {
              this.controller.control && this.controller.setTransition(e2, t2);
            },
          },
        },
        {
          name: "a11y",
          params: {
            a11y: {
              enabled: !0,
              notificationClass: "swiper-notification",
              prevSlideMessage: "Previous slide",
              nextSlideMessage: "Next slide",
              firstSlideMessage: "This is the first slide",
              lastSlideMessage: "This is the last slide",
              paginationBulletMessage: "Go to slide {{index}}",
            },
          },
          create: function () {
            var e2 = this;
            n.extend(e2, {
              a11y: {
                liveRegion: s(
                  '<span class="' +
                    e2.params.a11y.notificationClass +
                    '" aria-live="assertive" aria-atomic="true"></span>'
                ),
              },
            }),
              Object.keys(he).forEach(function (t2) {
                e2.a11y[t2] = he[t2].bind(e2);
              });
          },
          on: {
            init: function () {
              this.params.a11y.enabled &&
                (this.a11y.init(), this.a11y.updateNavigation());
            },
            toEdge: function () {
              this.params.a11y.enabled && this.a11y.updateNavigation();
            },
            fromEdge: function () {
              this.params.a11y.enabled && this.a11y.updateNavigation();
            },
            paginationUpdate: function () {
              this.params.a11y.enabled && this.a11y.updatePagination();
            },
            destroy: function () {
              this.params.a11y.enabled && this.a11y.destroy();
            },
          },
        },
        {
          name: "history",
          params: { history: { enabled: !1, replaceState: !1, key: "slides" } },
          create: function () {
            n.extend(this, {
              history: {
                init: pe.init.bind(this),
                setHistory: pe.setHistory.bind(this),
                setHistoryPopState: pe.setHistoryPopState.bind(this),
                scrollToSlide: pe.scrollToSlide.bind(this),
                destroy: pe.destroy.bind(this),
              },
            });
          },
          on: {
            init: function () {
              this.params.history.enabled && this.history.init();
            },
            destroy: function () {
              this.params.history.enabled && this.history.destroy();
            },
            transitionEnd: function () {
              this.history.initialized &&
                this.history.setHistory(
                  this.params.history.key,
                  this.activeIndex
                );
            },
            slideChange: function () {
              this.history.initialized &&
                this.params.cssMode &&
                this.history.setHistory(
                  this.params.history.key,
                  this.activeIndex
                );
            },
          },
        },
        {
          name: "hash-navigation",
          params: {
            hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 },
          },
          create: function () {
            n.extend(this, {
              hashNavigation: {
                initialized: !1,
                init: ce.init.bind(this),
                destroy: ce.destroy.bind(this),
                setHash: ce.setHash.bind(this),
                onHashCange: ce.onHashCange.bind(this),
              },
            });
          },
          on: {
            init: function () {
              this.params.hashNavigation.enabled && this.hashNavigation.init();
            },
            destroy: function () {
              this.params.hashNavigation.enabled &&
                this.hashNavigation.destroy();
            },
            transitionEnd: function () {
              this.hashNavigation.initialized && this.hashNavigation.setHash();
            },
            slideChange: function () {
              this.hashNavigation.initialized &&
                this.params.cssMode &&
                this.hashNavigation.setHash();
            },
          },
        },
        {
          name: "autoplay",
          params: {
            autoplay: {
              enabled: !1,
              delay: 3e3,
              waitForTransition: !0,
              disableOnInteraction: !0,
              stopOnLastSlide: !1,
              reverseDirection: !1,
            },
          },
          create: function () {
            var e2 = this;
            n.extend(e2, {
              autoplay: {
                running: !1,
                paused: !1,
                run: ue.run.bind(e2),
                start: ue.start.bind(e2),
                stop: ue.stop.bind(e2),
                pause: ue.pause.bind(e2),
                onVisibilityChange: function () {
                  document.visibilityState === "hidden" &&
                    e2.autoplay.running &&
                    e2.autoplay.pause(),
                    document.visibilityState === "visible" &&
                      e2.autoplay.paused &&
                      (e2.autoplay.run(), (e2.autoplay.paused = !1));
                },
                onTransitionEnd: function (t2) {
                  e2 &&
                    !e2.destroyed &&
                    e2.$wrapperEl &&
                    t2.target === this &&
                    (e2.$wrapperEl[0].removeEventListener(
                      "transitionend",
                      e2.autoplay.onTransitionEnd
                    ),
                    e2.$wrapperEl[0].removeEventListener(
                      "webkitTransitionEnd",
                      e2.autoplay.onTransitionEnd
                    ),
                    (e2.autoplay.paused = !1),
                    e2.autoplay.running
                      ? e2.autoplay.run()
                      : e2.autoplay.stop());
                },
              },
            });
          },
          on: {
            init: function () {
              this.params.autoplay.enabled &&
                (this.autoplay.start(),
                document.addEventListener(
                  "visibilitychange",
                  this.autoplay.onVisibilityChange
                ));
            },
            beforeTransitionStart: function (e2, t2) {
              this.autoplay.running &&
                (t2 || !this.params.autoplay.disableOnInteraction
                  ? this.autoplay.pause(e2)
                  : this.autoplay.stop());
            },
            sliderFirstMove: function () {
              this.autoplay.running &&
                (this.params.autoplay.disableOnInteraction
                  ? this.autoplay.stop()
                  : this.autoplay.pause());
            },
            touchEnd: function () {
              this.params.cssMode &&
                this.autoplay.paused &&
                !this.params.autoplay.disableOnInteraction &&
                this.autoplay.run();
            },
            destroy: function () {
              this.autoplay.running && this.autoplay.stop(),
                document.removeEventListener(
                  "visibilitychange",
                  this.autoplay.onVisibilityChange
                );
            },
          },
        },
        {
          name: "effect-fade",
          params: { fadeEffect: { crossFade: !1 } },
          create: function () {
            n.extend(this, {
              fadeEffect: {
                setTranslate: ve.setTranslate.bind(this),
                setTransition: ve.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              if (this.params.effect === "fade") {
                this.classNames.push(
                  this.params.containerModifierClass + "fade"
                );
                var e2 = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  spaceBetween: 0,
                  virtualTranslate: !0,
                };
                n.extend(this.params, e2), n.extend(this.originalParams, e2);
              }
            },
            setTranslate: function () {
              this.params.effect === "fade" && this.fadeEffect.setTranslate();
            },
            setTransition: function (e2) {
              this.params.effect === "fade" &&
                this.fadeEffect.setTransition(e2);
            },
          },
        },
        {
          name: "effect-cube",
          params: {
            cubeEffect: {
              slideShadows: !0,
              shadow: !0,
              shadowOffset: 20,
              shadowScale: 0.94,
            },
          },
          create: function () {
            n.extend(this, {
              cubeEffect: {
                setTranslate: fe.setTranslate.bind(this),
                setTransition: fe.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              if (this.params.effect === "cube") {
                this.classNames.push(
                  this.params.containerModifierClass + "cube"
                ),
                  this.classNames.push(
                    this.params.containerModifierClass + "3d"
                  );
                var e2 = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  resistanceRatio: 0,
                  spaceBetween: 0,
                  centeredSlides: !1,
                  virtualTranslate: !0,
                };
                n.extend(this.params, e2), n.extend(this.originalParams, e2);
              }
            },
            setTranslate: function () {
              this.params.effect === "cube" && this.cubeEffect.setTranslate();
            },
            setTransition: function (e2) {
              this.params.effect === "cube" &&
                this.cubeEffect.setTransition(e2);
            },
          },
        },
        {
          name: "effect-flip",
          params: { flipEffect: { slideShadows: !0, limitRotation: !0 } },
          create: function () {
            n.extend(this, {
              flipEffect: {
                setTranslate: me.setTranslate.bind(this),
                setTransition: me.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              if (this.params.effect === "flip") {
                this.classNames.push(
                  this.params.containerModifierClass + "flip"
                ),
                  this.classNames.push(
                    this.params.containerModifierClass + "3d"
                  );
                var e2 = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  spaceBetween: 0,
                  virtualTranslate: !0,
                };
                n.extend(this.params, e2), n.extend(this.originalParams, e2);
              }
            },
            setTranslate: function () {
              this.params.effect === "flip" && this.flipEffect.setTranslate();
            },
            setTransition: function (e2) {
              this.params.effect === "flip" &&
                this.flipEffect.setTransition(e2);
            },
          },
        },
        {
          name: "effect-coverflow",
          params: {
            coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: !0,
            },
          },
          create: function () {
            n.extend(this, {
              coverflowEffect: {
                setTranslate: ge.setTranslate.bind(this),
                setTransition: ge.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              this.params.effect === "coverflow" &&
                (this.classNames.push(
                  this.params.containerModifierClass + "coverflow"
                ),
                this.classNames.push(this.params.containerModifierClass + "3d"),
                (this.params.watchSlidesProgress = !0),
                (this.originalParams.watchSlidesProgress = !0));
            },
            setTranslate: function () {
              this.params.effect === "coverflow" &&
                this.coverflowEffect.setTranslate();
            },
            setTransition: function (e2) {
              this.params.effect === "coverflow" &&
                this.coverflowEffect.setTransition(e2);
            },
          },
        },
        {
          name: "thumbs",
          params: {
            thumbs: {
              swiper: null,
              multipleActiveThumbs: !0,
              autoScrollOffset: 0,
              slideThumbActiveClass: "swiper-slide-thumb-active",
              thumbsContainerClass: "swiper-container-thumbs",
            },
          },
          create: function () {
            n.extend(this, {
              thumbs: {
                swiper: null,
                init: be.init.bind(this),
                update: be.update.bind(this),
                onThumbClick: be.onThumbClick.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              var e2 = this.params.thumbs;
              e2 && e2.swiper && (this.thumbs.init(), this.thumbs.update(!0));
            },
            slideChange: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            update: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            resize: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            observerUpdate: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            setTransition: function (e2) {
              var t2 = this.thumbs.swiper;
              t2 && t2.setTransition(e2);
            },
            beforeDestroy: function () {
              var e2 = this.thumbs.swiper;
              e2 && this.thumbs.swiperCreated && e2 && e2.destroy();
            },
          },
        },
      ];
    return (
      W.use === void 0 &&
        ((W.use = W.Class.use), (W.installModule = W.Class.installModule)),
      W.use(we),
      W
    );
  }),
  (function ($2) {
    ($2.fn.marquee = function (options) {
      return this.each(function () {
        var o = $2.extend({}, $2.fn.marquee.defaults, options),
          $this = $2(this),
          $marqueeWrapper,
          containerWidth,
          animationCss,
          verticalDir,
          elWidth,
          loopCount = 3,
          playState = "animation-play-state",
          css3AnimationIsSupported = !1,
          _prefixedEvent = function (element, type, callback) {
            for (
              var pfx = ["webkit", "moz", "MS", "o", ""], p = 0;
              p < pfx.length;
              p++
            )
              pfx[p] || (type = type.toLowerCase()),
                element.addEventListener(pfx[p] + type, callback, !1);
          },
          _objToString = function (obj) {
            var tabjson = [];
            for (var p in obj)
              obj.hasOwnProperty(p) && tabjson.push(p + ":" + obj[p]);
            return tabjson.push(), "{" + tabjson.join(",") + "}";
          },
          _startAnimationWithDelay = function () {
            $this.timer = setTimeout(animate, o.delayBeforeStart);
          },
          methods = {
            pause: function () {
              css3AnimationIsSupported && o.allowCss3Support
                ? $marqueeWrapper.css(playState, "paused")
                : $2.fn.pause && $marqueeWrapper.pause(),
                $this.data("runningStatus", "paused"),
                $this.trigger("paused");
            },
            resume: function () {
              css3AnimationIsSupported && o.allowCss3Support
                ? $marqueeWrapper.css(playState, "running")
                : $2.fn.resume && $marqueeWrapper.resume(),
                $this.data("runningStatus", "resumed"),
                $this.trigger("resumed");
            },
            toggle: function () {
              methods[
                $this.data("runningStatus") == "resumed" ? "pause" : "resume"
              ]();
            },
            destroy: function () {
              clearTimeout($this.timer),
                $this.find("*").addBack().off(),
                $this.html($this.find(".js-marquee:first").html());
            },
          };
        if (typeof options == "string") {
          $2.isFunction(methods[options]) &&
            ($marqueeWrapper ||
              ($marqueeWrapper = $this.find(".js-marquee-wrapper")),
            $this.data("css3AnimationIsSupported") === !0 &&
              (css3AnimationIsSupported = !0),
            methods[options]());
          return;
        }
        var dataAttributes = {},
          attr;
        $2.each(o, function (key, value) {
          if (((attr = $this.attr("data-" + key)), typeof attr < "u")) {
            switch (attr) {
              case "true":
                attr = !0;
                break;
              case "false":
                attr = !1;
                break;
            }
            o[key] = attr;
          }
        }),
          o.speed &&
            (o.duration = (parseInt($this.width(), 10) / o.speed) * 1e3),
          (verticalDir = o.direction == "up" || o.direction == "down"),
          (o.gap = o.duplicated ? parseInt(o.gap) : 0),
          $this.wrapInner('<div class="js-marquee"></div>');
        var $el = $this
          .find(".js-marquee")
          .css({ "margin-right": o.gap, float: "left" });
        if (
          (o.duplicated && $el.clone(!0).appendTo($this),
          $this.wrapInner(
            '<div style="width:100000px" class="js-marquee-wrapper"></div>'
          ),
          ($marqueeWrapper = $this.find(".js-marquee-wrapper")),
          verticalDir)
        ) {
          var containerHeight = $this.height();
          $marqueeWrapper.removeAttr("style"),
            $this.height(containerHeight),
            $this
              .find(".js-marquee")
              .css({
                float: "none",
                "margin-bottom": o.gap,
                "margin-right": 0,
              }),
            o.duplicated &&
              $this.find(".js-marquee:last").css({ "margin-bottom": 0 });
          var elHeight = $this.find(".js-marquee:first").height() + o.gap;
          o.startVisible && !o.duplicated
            ? ((o._completeDuration =
                ((parseInt(elHeight, 10) + parseInt(containerHeight, 10)) /
                  parseInt(containerHeight, 10)) *
                o.duration),
              (o.duration =
                (parseInt(elHeight, 10) / parseInt(containerHeight, 10)) *
                o.duration))
            : (o.duration =
                ((parseInt(elHeight, 10) + parseInt(containerHeight, 10)) /
                  parseInt(containerHeight, 10)) *
                o.duration);
        } else (elWidth = $this.find(".js-marquee:first").width() + o.gap), (containerWidth = $this.width()), o.startVisible && !o.duplicated ? ((o._completeDuration = ((parseInt(elWidth, 10) + parseInt(containerWidth, 10)) / parseInt(containerWidth, 10)) * o.duration), (o.duration = (parseInt(elWidth, 10) / parseInt(containerWidth, 10)) * o.duration)) : (o.duration = ((parseInt(elWidth, 10) + parseInt(containerWidth, 10)) / parseInt(containerWidth, 10)) * o.duration);
        if (
          (o.duplicated && (o.duration = o.duration / 2), o.allowCss3Support)
        ) {
          var elm = document.body || document.createElement("div"),
            animationName =
              "marqueeAnimation-" + Math.floor(Math.random() * 1e7),
            domPrefixes = "Webkit Moz O ms Khtml".split(" "),
            animationString = "animation",
            animationCss3Str = "",
            keyframeString = "";
          if (
            (elm.style.animation !== void 0 &&
              ((keyframeString = "@keyframes " + animationName + " "),
              (css3AnimationIsSupported = !0)),
            css3AnimationIsSupported === !1)
          ) {
            for (var i2 = 0; i2 < domPrefixes.length; i2++)
              if (elm.style[domPrefixes[i2] + "AnimationName"] !== void 0) {
                var prefix = "-" + domPrefixes[i2].toLowerCase() + "-";
                (animationString = prefix + animationString),
                  (playState = prefix + playState),
                  (keyframeString =
                    "@" + prefix + "keyframes " + animationName + " "),
                  (css3AnimationIsSupported = !0);
                break;
              }
          }
          css3AnimationIsSupported &&
            ((animationCss3Str =
              animationName +
              " " +
              o.duration / 1e3 +
              "s " +
              o.delayBeforeStart / 1e3 +
              "s infinite " +
              o.css3easing),
            $this.data("css3AnimationIsSupported", !0));
        }
        var _rePositionVertically = function () {
            $marqueeWrapper.css(
              "transform",
              "translateY(" +
                (o.direction == "up"
                  ? containerHeight + "px"
                  : "-" + elHeight + "px") +
                ")"
            );
          },
          _rePositionHorizontally = function () {
            $marqueeWrapper.css(
              "transform",
              "translateX(" +
                (o.direction == "left"
                  ? containerWidth + "px"
                  : "-" + elWidth + "px") +
                ")"
            );
          };
        o.duplicated
          ? (verticalDir
              ? o.startVisible
                ? $marqueeWrapper.css("transform", "translateY(0)")
                : $marqueeWrapper.css(
                    "transform",
                    "translateY(" +
                      (o.direction == "up"
                        ? containerHeight + "px"
                        : "-" + (elHeight * 2 - o.gap) + "px") +
                      ")"
                  )
              : o.startVisible
              ? $marqueeWrapper.css("transform", "translateX(0)")
              : $marqueeWrapper.css(
                  "transform",
                  "translateX(" +
                    (o.direction == "left"
                      ? containerWidth + "px"
                      : "-" + (elWidth * 2 - o.gap) + "px") +
                    ")"
                ),
            o.startVisible || (loopCount = 1))
          : o.startVisible
          ? (loopCount = 2)
          : verticalDir
          ? _rePositionVertically()
          : _rePositionHorizontally();
        var animate = function () {
          if (
            (o.duplicated &&
              (loopCount === 1
                ? ((o._originalDuration = o.duration),
                  verticalDir
                    ? (o.duration =
                        o.direction == "up"
                          ? o.duration +
                            containerHeight / (elHeight / o.duration)
                          : o.duration * 2)
                    : (o.duration =
                        o.direction == "left"
                          ? o.duration + containerWidth / (elWidth / o.duration)
                          : o.duration * 2),
                  animationCss3Str &&
                    (animationCss3Str =
                      animationName +
                      " " +
                      o.duration / 1e3 +
                      "s " +
                      o.delayBeforeStart / 1e3 +
                      "s " +
                      o.css3easing),
                  loopCount++)
                : loopCount === 2 &&
                  ((o.duration = o._originalDuration),
                  animationCss3Str &&
                    ((animationName = animationName + "0"),
                    (keyframeString = $2.trim(keyframeString) + "0 "),
                    (animationCss3Str =
                      animationName +
                      " " +
                      o.duration / 1e3 +
                      "s 0s infinite " +
                      o.css3easing)),
                  loopCount++)),
            verticalDir
              ? o.duplicated
                ? (loopCount > 2 &&
                    $marqueeWrapper.css(
                      "transform",
                      "translateY(" +
                        (o.direction == "up" ? 0 : "-" + elHeight + "px") +
                        ")"
                    ),
                  (animationCss = {
                    transform:
                      "translateY(" +
                      (o.direction == "up" ? "-" + elHeight + "px" : 0) +
                      ")",
                  }))
                : o.startVisible
                ? loopCount === 2
                  ? (animationCss3Str &&
                      (animationCss3Str =
                        animationName +
                        " " +
                        o.duration / 1e3 +
                        "s " +
                        o.delayBeforeStart / 1e3 +
                        "s " +
                        o.css3easing),
                    (animationCss = {
                      transform:
                        "translateY(" +
                        (o.direction == "up"
                          ? "-" + elHeight + "px"
                          : containerHeight + "px") +
                        ")",
                    }),
                    loopCount++)
                  : loopCount === 3 &&
                    ((o.duration = o._completeDuration),
                    animationCss3Str &&
                      ((animationName = animationName + "0"),
                      (keyframeString = $2.trim(keyframeString) + "0 "),
                      (animationCss3Str =
                        animationName +
                        " " +
                        o.duration / 1e3 +
                        "s 0s infinite " +
                        o.css3easing)),
                    _rePositionVertically())
                : (_rePositionVertically(),
                  (animationCss = {
                    transform:
                      "translateY(" +
                      (o.direction == "up"
                        ? "-" + $marqueeWrapper.height() + "px"
                        : containerHeight + "px") +
                      ")",
                  }))
              : o.duplicated
              ? (loopCount > 2 &&
                  $marqueeWrapper.css(
                    "transform",
                    "translateX(" +
                      (o.direction == "left" ? 0 : "-" + elWidth + "px") +
                      ")"
                  ),
                (animationCss = {
                  transform:
                    "translateX(" +
                    (o.direction == "left" ? "-" + elWidth + "px" : 0) +
                    ")",
                }))
              : o.startVisible
              ? loopCount === 2
                ? (animationCss3Str &&
                    (animationCss3Str =
                      animationName +
                      " " +
                      o.duration / 1e3 +
                      "s " +
                      o.delayBeforeStart / 1e3 +
                      "s " +
                      o.css3easing),
                  (animationCss = {
                    transform:
                      "translateX(" +
                      (o.direction == "left"
                        ? "-" + elWidth + "px"
                        : containerWidth + "px") +
                      ")",
                  }),
                  loopCount++)
                : loopCount === 3 &&
                  ((o.duration = o._completeDuration),
                  animationCss3Str &&
                    ((animationName = animationName + "0"),
                    (keyframeString = $2.trim(keyframeString) + "0 "),
                    (animationCss3Str =
                      animationName +
                      " " +
                      o.duration / 1e3 +
                      "s 0s infinite " +
                      o.css3easing)),
                  _rePositionHorizontally())
              : (_rePositionHorizontally(),
                (animationCss = {
                  transform:
                    "translateX(" +
                    (o.direction == "left"
                      ? "-" + elWidth + "px"
                      : containerWidth + "px") +
                    ")",
                })),
            $this.trigger("beforeStarting"),
            css3AnimationIsSupported)
          ) {
            $marqueeWrapper.css(animationString, animationCss3Str);
            var keyframeCss =
                keyframeString + " { 100%  " + _objToString(animationCss) + "}",
              $styles = $marqueeWrapper.find("style");
            $styles.length !== 0
              ? $styles.filter(":last").html(keyframeCss)
              : $2("head").append("<style>" + keyframeCss + "</style>"),
              _prefixedEvent(
                $marqueeWrapper[0],
                "AnimationIteration",
                function () {
                  $this.trigger("finished");
                }
              ),
              _prefixedEvent($marqueeWrapper[0], "AnimationEnd", function () {
                animate(), $this.trigger("finished");
              });
          } else
            $marqueeWrapper.animate(
              animationCss,
              o.duration,
              o.easing,
              function () {
                $this.trigger("finished"),
                  o.pauseOnCycle ? _startAnimationWithDelay() : animate();
              }
            );
          $this.data("runningStatus", "resumed");
        };
        $this.on("pause", methods.pause),
          $this.on("resume", methods.resume),
          o.pauseOnHover &&
            ($this.on("mouseenter", methods.pause),
            $this.on("mouseleave", methods.resume)),
          css3AnimationIsSupported && o.allowCss3Support
            ? animate()
            : _startAnimationWithDelay();
      });
    }),
      ($2.fn.marquee.defaults = {
        allowCss3Support: !0,
        css3easing: "linear",
        easing: "linear",
        delayBeforeStart: 1e3,
        direction: "left",
        duplicated: !1,
        duration: 5e3,
        speed: 0,
        gap: 20,
        pauseOnCycle: !1,
        pauseOnHover: !1,
        startVisible: !1,
      });
  })(jQuery),
  (function (t) {
    var e = {},
      s = {
        mode: "horizontal",
        slideSelector: "",
        infiniteLoop: !0,
        hideControlOnEnd: !1,
        speed: 500,
        easing: null,
        slideMargin: 0,
        startSlide: 0,
        randomStart: !1,
        captions: !1,
        ticker: !1,
        tickerHover: !1,
        adaptiveHeight: !1,
        adaptiveHeightSpeed: 500,
        video: !1,
        useCSS: !0,
        preloadImages: "visible",
        responsive: !0,
        slideZIndex: 50,
        touchEnabled: !0,
        swipeThreshold: 50,
        oneToOneTouch: !0,
        preventDefaultSwipeX: !0,
        preventDefaultSwipeY: !1,
        pager: !0,
        pagerType: "full",
        pagerShortSeparator: " / ",
        pagerSelector: null,
        buildPager: null,
        pagerCustom: null,
        controls: !0,
        nextText: "Next",
        prevText: "Prev",
        nextSelector: null,
        prevSelector: null,
        autoControls: !1,
        startText: "Start",
        stopText: "Stop",
        autoControlsCombine: !1,
        autoControlsSelector: null,
        auto: !1,
        pause: 4e3,
        autoStart: !0,
        autoDirection: "next",
        autoHover: !1,
        autoDelay: 0,
        minSlides: 1,
        maxSlides: 1,
        moveSlides: 0,
        slideWidth: 0,
        onSliderLoad: function () {},
        onSlideBefore: function () {},
        onSlideAfter: function () {},
        onSlideNext: function () {},
        onSlidePrev: function () {},
        onSliderResize: function () {},
      };
    t.fn.bxSlider = function (n) {
      if (this.length == 0) return this;
      if (this.length > 1)
        return (
          this.each(function () {
            t(this).bxSlider(n);
          }),
          this
        );
      var o = {},
        r = this;
      e.el = this;
      var a = t(window).width(),
        l = t(window).height(),
        d = function () {
          (o.settings = t.extend({}, s, n)),
            (o.settings.slideWidth = parseInt(o.settings.slideWidth)),
            (o.children = r.children(o.settings.slideSelector)),
            o.children.length < o.settings.minSlides &&
              (o.settings.minSlides = o.children.length),
            o.children.length < o.settings.maxSlides &&
              (o.settings.maxSlides = o.children.length),
            o.settings.randomStart &&
              (o.settings.startSlide = Math.floor(
                Math.random() * o.children.length
              )),
            (o.active = { index: o.settings.startSlide }),
            (o.carousel = o.settings.minSlides > 1 || o.settings.maxSlides > 1),
            o.carousel && (o.settings.preloadImages = "all"),
            (o.minThreshold =
              o.settings.minSlides * o.settings.slideWidth +
              (o.settings.minSlides - 1) * o.settings.slideMargin),
            (o.maxThreshold =
              o.settings.maxSlides * o.settings.slideWidth +
              (o.settings.maxSlides - 1) * o.settings.slideMargin),
            (o.working = !1),
            (o.controls = {}),
            (o.interval = null),
            (o.animProp = o.settings.mode == "vertical" ? "top" : "left"),
            (o.usingCSS =
              o.settings.useCSS &&
              o.settings.mode != "fade" &&
              (function () {
                var t2 = document.createElement("div"),
                  e2 = [
                    "WebkitPerspective",
                    "MozPerspective",
                    "OPerspective",
                    "msPerspective",
                  ];
                for (var i2 in e2)
                  if (t2.style[e2[i2]] !== void 0)
                    return (
                      (o.cssPrefix = e2[i2]
                        .replace("Perspective", "")
                        .toLowerCase()),
                      (o.animProp = "-" + o.cssPrefix + "-transform"),
                      !0
                    );
                return !1;
              })()),
            o.settings.mode == "vertical" &&
              (o.settings.maxSlides = o.settings.minSlides),
            r.data("origStyle", r.attr("style")),
            r.children(o.settings.slideSelector).each(function () {
              t(this).data("origStyle", t(this).attr("style"));
            }),
            c();
        },
        c = function () {
          r.wrap(
            '<div class="bx-wrapper"><div class="bx-viewport"></div></div>'
          ),
            (o.viewport = r.parent()),
            (o.loader = t('<div class="bx-loading" />')),
            o.viewport.prepend(o.loader),
            r.css({
              width:
                o.settings.mode == "horizontal"
                  ? 100 * o.children.length + 215 + "%"
                  : "auto",
              position: "relative",
            }),
            o.usingCSS && o.settings.easing
              ? r.css(
                  "-" + o.cssPrefix + "-transition-timing-function",
                  o.settings.easing
                )
              : o.settings.easing || (o.settings.easing = "swing"),
            f(),
            o.viewport.css({
              width: "100%",
              overflow: "hidden",
              position: "relative",
            }),
            o.viewport.parent().css({ maxWidth: p() }),
            o.settings.pager ||
              o.viewport.parent().css({ margin: "0 auto 0px" }),
            o.children.css({
              float: o.settings.mode == "horizontal" ? "left" : "none",
              listStyle: "none",
              position: "relative",
            }),
            o.children.css("width", u()),
            o.settings.mode == "horizontal" &&
              o.settings.slideMargin > 0 &&
              o.children.css("marginRight", o.settings.slideMargin),
            o.settings.mode == "vertical" &&
              o.settings.slideMargin > 0 &&
              o.children.css("marginBottom", o.settings.slideMargin),
            o.settings.mode == "fade" &&
              (o.children.css({
                position: "absolute",
                zIndex: 0,
                display: "none",
              }),
              o.children
                .eq(o.settings.startSlide)
                .css({ zIndex: o.settings.slideZIndex, display: "block" })),
            (o.controls.el = t('<div class="bx-controls" />')),
            o.settings.captions && P(),
            (o.active.last = o.settings.startSlide == x() - 1),
            o.settings.video && r.fitVids();
          var e2 = o.children.eq(o.settings.startSlide);
          o.settings.preloadImages == "all" && (e2 = o.children),
            o.settings.ticker
              ? (o.settings.pager = !1)
              : (o.settings.pager && T(),
                o.settings.controls && C(),
                o.settings.auto && o.settings.autoControls && E(),
                (o.settings.controls ||
                  o.settings.autoControls ||
                  o.settings.pager) &&
                  o.viewport.after(o.controls.el)),
            g(e2, h);
        },
        g = function (e2, i2) {
          var s2 = e2.find("img, iframe").length;
          if (s2 == 0) return i2(), void 0;
          var n2 = 0;
          e2.find("img, iframe").each(function () {
            t(this)
              .one("load", function () {
                ++n2 == s2 && i2();
              })
              .each(function () {
                this.complete && t(this).load();
              });
          });
        },
        h = function () {
          if (
            o.settings.infiniteLoop &&
            o.settings.mode != "fade" &&
            !o.settings.ticker
          ) {
            var e2 =
                o.settings.mode == "vertical"
                  ? o.settings.minSlides
                  : o.settings.maxSlides,
              i2 = o.children.slice(0, e2).clone().addClass("bx-clone"),
              s2 = o.children.slice(-e2).clone().addClass("bx-clone");
            r.append(i2).prepend(s2);
          }
          o.loader.remove(),
            S(),
            o.settings.mode == "vertical" && (o.settings.adaptiveHeight = !0),
            o.viewport.height(v()),
            r.redrawSlider(),
            o.settings.onSliderLoad(o.active.index),
            (o.initialized = !0),
            o.settings.responsive && t(window).bind("resize", Z),
            o.settings.auto && o.settings.autoStart && H(),
            o.settings.ticker && L(),
            o.settings.pager && q(o.settings.startSlide),
            o.settings.controls && W(),
            o.settings.touchEnabled && !o.settings.ticker && O();
        },
        v = function () {
          var e2 = 0,
            s2 = t();
          if (o.settings.mode == "vertical" || o.settings.adaptiveHeight)
            if (o.carousel) {
              var n2 =
                o.settings.moveSlides == 1
                  ? o.active.index
                  : o.active.index * m();
              for (
                s2 = o.children.eq(n2), i = 1;
                i <= o.settings.maxSlides - 1;
                i++
              )
                s2 =
                  n2 + i >= o.children.length
                    ? s2.add(o.children.eq(i - 1))
                    : s2.add(o.children.eq(n2 + i));
            } else s2 = o.children.eq(o.active.index);
          else s2 = o.children;
          return (
            o.settings.mode == "vertical"
              ? (s2.each(function () {
                  e2 += t(this).outerHeight();
                }),
                o.settings.slideMargin > 0 &&
                  (e2 += o.settings.slideMargin * (o.settings.minSlides - 1)))
              : (e2 = Math.max.apply(
                  Math,
                  s2
                    .map(function () {
                      return t(this).outerHeight(!1);
                    })
                    .get()
                )),
            e2
          );
        },
        p = function () {
          var t2 = "100%";
          return (
            o.settings.slideWidth > 0 &&
              (t2 =
                o.settings.mode == "horizontal"
                  ? o.settings.maxSlides * o.settings.slideWidth +
                    (o.settings.maxSlides - 1) * o.settings.slideMargin
                  : o.settings.slideWidth),
            t2
          );
        },
        u = function () {
          var t2 = o.settings.slideWidth,
            e2 = o.viewport.width();
          return (
            o.settings.slideWidth == 0 ||
            (o.settings.slideWidth > e2 && !o.carousel) ||
            o.settings.mode == "vertical"
              ? (t2 = e2)
              : o.settings.maxSlides > 1 &&
                o.settings.mode == "horizontal" &&
                (e2 > o.maxThreshold ||
                  (e2 < o.minThreshold &&
                    (t2 =
                      (e2 -
                        o.settings.slideMargin * (o.settings.minSlides - 1)) /
                      o.settings.minSlides))),
            t2
          );
        },
        f = function () {
          var t2 = 1;
          if (o.settings.mode == "horizontal" && o.settings.slideWidth > 0)
            if (o.viewport.width() < o.minThreshold) t2 = o.settings.minSlides;
            else if (o.viewport.width() > o.maxThreshold)
              t2 = o.settings.maxSlides;
            else {
              var e2 = o.children.first().width();
              t2 = Math.floor(o.viewport.width() / e2);
            }
          else o.settings.mode == "vertical" && (t2 = o.settings.minSlides);
          return t2;
        },
        x = function () {
          var t2 = 0;
          if (o.settings.moveSlides > 0)
            if (o.settings.infiniteLoop) t2 = o.children.length / m();
            else
              for (var e2 = 0, i2 = 0; e2 < o.children.length; )
                ++t2,
                  (e2 = i2 + f()),
                  (i2 +=
                    o.settings.moveSlides <= f() ? o.settings.moveSlides : f());
          else t2 = Math.ceil(o.children.length / f());
          return t2;
        },
        m = function () {
          return o.settings.moveSlides > 0 && o.settings.moveSlides <= f()
            ? o.settings.moveSlides
            : f();
        },
        S = function () {
          if (
            o.children.length > o.settings.maxSlides &&
            o.active.last &&
            !o.settings.infiniteLoop
          ) {
            if (o.settings.mode == "horizontal") {
              var t2 = o.children.last(),
                e2 = t2.position();
              b(-(e2.left - (o.viewport.width() - t2.width())), "reset", 0);
            } else if (o.settings.mode == "vertical") {
              var i2 = o.children.length - o.settings.minSlides,
                e2 = o.children.eq(i2).position();
              b(-e2.top, "reset", 0);
            }
          } else {
            var e2 = o.children.eq(o.active.index * m()).position();
            o.active.index == x() - 1 && (o.active.last = !0),
              e2 != null &&
                (o.settings.mode == "horizontal"
                  ? b(-e2.left, "reset", 0)
                  : o.settings.mode == "vertical" && b(-e2.top, "reset", 0));
          }
        },
        b = function (t2, e2, i2, s2) {
          if (o.usingCSS) {
            var n2 =
              o.settings.mode == "vertical"
                ? "translate3d(0, " + t2 + "px, 0)"
                : "translate3d(" + t2 + "px, 0, 0)";
            r.css("-" + o.cssPrefix + "-transition-duration", i2 / 1e3 + "s"),
              e2 == "slide"
                ? (r.css(o.animProp, n2),
                  r.bind(
                    "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",
                    function () {
                      r.unbind(
                        "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"
                      ),
                        D();
                    }
                  ))
                : e2 == "reset"
                ? r.css(o.animProp, n2)
                : e2 == "ticker" &&
                  (r.css(
                    "-" + o.cssPrefix + "-transition-timing-function",
                    "linear"
                  ),
                  r.css(o.animProp, n2),
                  r.bind(
                    "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",
                    function () {
                      r.unbind(
                        "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"
                      ),
                        b(s2.resetValue, "reset", 0),
                        N();
                    }
                  ));
          } else {
            var a2 = {};
            (a2[o.animProp] = t2),
              e2 == "slide"
                ? r.animate(a2, i2, o.settings.easing, function () {
                    D();
                  })
                : e2 == "reset"
                ? r.css(o.animProp, t2)
                : e2 == "ticker" &&
                  r.animate(a2, speed, "linear", function () {
                    b(s2.resetValue, "reset", 0), N();
                  });
          }
        },
        w = function () {
          for (var e2 = "", i2 = x(), s2 = 0; i2 > s2; s2++) {
            var n2 = "";
            o.settings.buildPager && t.isFunction(o.settings.buildPager)
              ? ((n2 = o.settings.buildPager(s2)),
                o.pagerEl.addClass("bx-custom-pager"))
              : ((n2 = s2 + 1), o.pagerEl.addClass("bx-default-pager")),
              (e2 +=
                '<div class="bx-pager-item"><a href="" data-slide-index="' +
                s2 +
                '" class="bx-pager-link">' +
                n2 +
                "</a></div>");
          }
          o.pagerEl.html(e2);
        },
        T = function () {
          o.settings.pagerCustom
            ? (o.pagerEl = t(o.settings.pagerCustom))
            : ((o.pagerEl = t('<div class="bx-pager" />')),
              o.settings.pagerSelector
                ? t(o.settings.pagerSelector).html(o.pagerEl)
                : o.controls.el.addClass("bx-has-pager").append(o.pagerEl),
              w()),
            o.pagerEl.on("click", "a", I);
        },
        C = function () {
          (o.controls.next = t(
            '<a class="bx-next" href="">' + o.settings.nextText + "</a>"
          )),
            (o.controls.prev = t(
              '<a class="bx-prev" href="">' + o.settings.prevText + "</a>"
            )),
            o.controls.next.bind("click", y),
            o.controls.prev.bind("click", z),
            o.settings.nextSelector &&
              t(o.settings.nextSelector).append(o.controls.next),
            o.settings.prevSelector &&
              t(o.settings.prevSelector).append(o.controls.prev),
            o.settings.nextSelector ||
              o.settings.prevSelector ||
              ((o.controls.directionEl = t(
                '<div class="bx-controls-direction" />'
              )),
              o.controls.directionEl
                .append(o.controls.prev)
                .append(o.controls.next),
              o.controls.el
                .addClass("bx-has-controls-direction")
                .append(o.controls.directionEl));
        },
        E = function () {
          (o.controls.start = t(
            '<div class="bx-controls-auto-item"><a class="bx-start" href="">' +
              o.settings.startText +
              "</a></div>"
          )),
            (o.controls.stop = t(
              '<div class="bx-controls-auto-item"><a class="bx-stop" href="">' +
                o.settings.stopText +
                "</a></div>"
            )),
            (o.controls.autoEl = t('<div class="bx-controls-auto" />')),
            o.controls.autoEl.on("click", ".bx-start", k),
            o.controls.autoEl.on("click", ".bx-stop", M),
            o.settings.autoControlsCombine
              ? o.controls.autoEl.append(o.controls.start)
              : o.controls.autoEl
                  .append(o.controls.start)
                  .append(o.controls.stop),
            o.settings.autoControlsSelector
              ? t(o.settings.autoControlsSelector).html(o.controls.autoEl)
              : o.controls.el
                  .addClass("bx-has-controls-auto")
                  .append(o.controls.autoEl),
            A(o.settings.autoStart ? "stop" : "start");
        },
        P = function () {
          o.children.each(function () {
            var e2 = t(this).find("img:first").attr("title");
            e2 != null &&
              ("" + e2).length &&
              t(this).append(
                '<div class="bx-caption"><span>' + e2 + "</span></div>"
              );
          });
        },
        y = function (t2) {
          o.settings.auto && r.stopAuto(),
            r.goToNextSlide(),
            t2.preventDefault();
        },
        z = function (t2) {
          o.settings.auto && r.stopAuto(),
            r.goToPrevSlide(),
            t2.preventDefault();
        },
        k = function (t2) {
          r.startAuto(), t2.preventDefault();
        },
        M = function (t2) {
          r.stopAuto(), t2.preventDefault();
        },
        I = function (e2) {
          o.settings.auto && r.stopAuto();
          var i2 = t(e2.currentTarget),
            s2 = parseInt(i2.attr("data-slide-index"));
          s2 != o.active.index && r.goToSlide(s2), e2.preventDefault();
        },
        q = function (e2) {
          var i2 = o.children.length;
          return o.settings.pagerType == "short"
            ? (o.settings.maxSlides > 1 &&
                (i2 = Math.ceil(o.children.length / o.settings.maxSlides)),
              o.pagerEl.html(e2 + 1 + o.settings.pagerShortSeparator + i2),
              void 0)
            : (o.pagerEl.find("a").removeClass("active"),
              o.pagerEl.each(function (i3, s2) {
                t(s2).find("a").eq(e2).addClass("active");
              }),
              void 0);
        },
        D = function () {
          if (o.settings.infiniteLoop) {
            var t2 = "";
            o.active.index == 0
              ? (t2 = o.children.eq(0).position())
              : o.active.index == x() - 1 && o.carousel
              ? (t2 = o.children.eq((x() - 1) * m()).position())
              : o.active.index == o.children.length - 1 &&
                (t2 = o.children.eq(o.children.length - 1).position()),
              t2 &&
                (o.settings.mode == "horizontal"
                  ? b(-t2.left, "reset", 0)
                  : o.settings.mode == "vertical" && b(-t2.top, "reset", 0));
          }
          (o.working = !1),
            o.settings.onSlideAfter(
              o.children.eq(o.active.index),
              o.oldIndex,
              o.active.index
            );
        },
        A = function (t2) {
          o.settings.autoControlsCombine
            ? o.controls.autoEl.html(o.controls[t2])
            : (o.controls.autoEl.find("a").removeClass("active"),
              o.controls.autoEl
                .find("a:not(.bx-" + t2 + ")")
                .addClass("active"));
        },
        W = function () {
          x() == 1
            ? (o.controls.prev.addClass("disabled"),
              o.controls.next.addClass("disabled"))
            : !o.settings.infiniteLoop &&
              o.settings.hideControlOnEnd &&
              (o.active.index == 0
                ? (o.controls.prev.addClass("disabled"),
                  o.controls.next.removeClass("disabled"))
                : o.active.index == x() - 1
                ? (o.controls.next.addClass("disabled"),
                  o.controls.prev.removeClass("disabled"))
                : (o.controls.prev.removeClass("disabled"),
                  o.controls.next.removeClass("disabled")));
        },
        H = function () {
          o.settings.autoDelay > 0
            ? setTimeout(r.startAuto, o.settings.autoDelay)
            : r.startAuto(),
            o.settings.autoHover &&
              r.hover(
                function () {
                  o.interval && (r.stopAuto(!0), (o.autoPaused = !0));
                },
                function () {
                  o.autoPaused && (r.startAuto(!0), (o.autoPaused = null));
                }
              );
        },
        L = function () {
          var e2 = 0;
          if (o.settings.autoDirection == "next")
            r.append(o.children.clone().addClass("bx-clone"));
          else {
            r.prepend(o.children.clone().addClass("bx-clone"));
            var i2 = o.children.first().position();
            e2 = o.settings.mode == "horizontal" ? -i2.left : -i2.top;
          }
          b(e2, "reset", 0),
            (o.settings.pager = !1),
            (o.settings.controls = !1),
            (o.settings.autoControls = !1),
            o.settings.tickerHover &&
              !o.usingCSS &&
              o.viewport.hover(
                function () {
                  r.stop();
                },
                function () {
                  var e3 = 0;
                  o.children.each(function () {
                    e3 +=
                      o.settings.mode == "horizontal"
                        ? t(this).outerWidth(!0)
                        : t(this).outerHeight(!0);
                  });
                  var i3 = o.settings.speed / e3,
                    s2 = o.settings.mode == "horizontal" ? "left" : "top",
                    n2 = i3 * (e3 - Math.abs(parseInt(r.css(s2))));
                  N(n2);
                }
              ),
            N();
        },
        N = function (t2) {
          speed = t2 || o.settings.speed;
          var e2 = { left: 0, top: 0 },
            i2 = { left: 0, top: 0 };
          o.settings.autoDirection == "next"
            ? (e2 = r.find(".bx-clone").first().position())
            : (i2 = o.children.first().position());
          var s2 = o.settings.mode == "horizontal" ? -e2.left : -e2.top,
            n2 = o.settings.mode == "horizontal" ? -i2.left : -i2.top,
            a2 = { resetValue: n2 };
          b(s2, "ticker", speed, a2);
        },
        O = function () {
          (o.touch = { start: { x: 0, y: 0 }, end: { x: 0, y: 0 } }),
            o.viewport.bind("touchstart", X);
        },
        X = function (t2) {
          if (o.working) t2.preventDefault();
          else {
            o.touch.originalPos = r.position();
            var e2 = t2.originalEvent;
            (o.touch.start.x = e2.changedTouches[0].pageX),
              (o.touch.start.y = e2.changedTouches[0].pageY),
              o.viewport.bind("touchmove", Y),
              o.viewport.bind("touchend", V);
          }
        },
        Y = function (t2) {
          var e2 = t2.originalEvent,
            i2 = Math.abs(e2.changedTouches[0].pageX - o.touch.start.x),
            s2 = Math.abs(e2.changedTouches[0].pageY - o.touch.start.y);
          if (
            (((3 * i2 > s2 && o.settings.preventDefaultSwipeX) ||
              (3 * s2 > i2 && o.settings.preventDefaultSwipeY)) &&
              t2.preventDefault(),
            o.settings.mode != "fade" && o.settings.oneToOneTouch)
          ) {
            var n2 = 0;
            if (o.settings.mode == "horizontal") {
              var r2 = e2.changedTouches[0].pageX - o.touch.start.x;
              n2 = o.touch.originalPos.left + r2;
            } else {
              var r2 = e2.changedTouches[0].pageY - o.touch.start.y;
              n2 = o.touch.originalPos.top + r2;
            }
            b(n2, "reset", 0);
          }
        },
        V = function (t2) {
          o.viewport.unbind("touchmove", Y);
          var e2 = t2.originalEvent,
            i2 = 0;
          if (
            ((o.touch.end.x = e2.changedTouches[0].pageX),
            (o.touch.end.y = e2.changedTouches[0].pageY),
            o.settings.mode == "fade")
          ) {
            var s2 = Math.abs(o.touch.start.x - o.touch.end.x);
            s2 >= o.settings.swipeThreshold &&
              (o.touch.start.x > o.touch.end.x
                ? r.goToNextSlide()
                : r.goToPrevSlide(),
              r.stopAuto());
          } else {
            var s2 = 0;
            o.settings.mode == "horizontal"
              ? ((s2 = o.touch.end.x - o.touch.start.x),
                (i2 = o.touch.originalPos.left))
              : ((s2 = o.touch.end.y - o.touch.start.y),
                (i2 = o.touch.originalPos.top)),
              !o.settings.infiniteLoop &&
              ((o.active.index == 0 && s2 > 0) || (o.active.last && 0 > s2))
                ? b(i2, "reset", 200)
                : Math.abs(s2) >= o.settings.swipeThreshold
                ? (0 > s2 ? r.goToNextSlide() : r.goToPrevSlide(), r.stopAuto())
                : b(i2, "reset", 200);
          }
          o.viewport.unbind("touchend", V);
        },
        Z = function () {
          var e2 = t(window).width(),
            i2 = t(window).height();
          (a != e2 || l != i2) &&
            ((a = e2),
            (l = i2),
            r.redrawSlider(),
            o.settings.onSliderResize.call(r, o.active.index));
        };
      return (
        (r.goToSlide = function (e2, i2) {
          if (!o.working && o.active.index != e2)
            if (
              ((o.working = !0),
              (o.oldIndex = o.active.index),
              (o.active.index = 0 > e2 ? x() - 1 : e2 >= x() ? 0 : e2),
              o.settings.onSlideBefore(
                o.children.eq(o.active.index),
                o.oldIndex,
                o.active.index
              ),
              i2 == "next"
                ? o.settings.onSlideNext(
                    o.children.eq(o.active.index),
                    o.oldIndex,
                    o.active.index
                  )
                : i2 == "prev" &&
                  o.settings.onSlidePrev(
                    o.children.eq(o.active.index),
                    o.oldIndex,
                    o.active.index
                  ),
              (o.active.last = o.active.index >= x() - 1),
              o.settings.pager && q(o.active.index),
              o.settings.controls && W(),
              o.settings.mode == "fade")
            )
              o.settings.adaptiveHeight &&
                o.viewport.height() != v() &&
                o.viewport.animate(
                  { height: v() },
                  o.settings.adaptiveHeightSpeed
                ),
                o.children
                  .filter(":visible")
                  .fadeOut(o.settings.speed)
                  .css({ zIndex: 0 }),
                o.children
                  .eq(o.active.index)
                  .css("zIndex", o.settings.slideZIndex + 1)
                  .fadeIn(o.settings.speed, function () {
                    t(this).css("zIndex", o.settings.slideZIndex), D();
                  });
            else {
              o.settings.adaptiveHeight &&
                o.viewport.height() != v() &&
                o.viewport.animate(
                  { height: v() },
                  o.settings.adaptiveHeightSpeed
                );
              var s2 = 0,
                n2 = { left: 0, top: 0 };
              if (!o.settings.infiniteLoop && o.carousel && o.active.last)
                if (o.settings.mode == "horizontal") {
                  var a2 = o.children.eq(o.children.length - 1);
                  (n2 = a2.position()),
                    (s2 = o.viewport.width() - a2.outerWidth());
                } else {
                  var l2 = o.children.length - o.settings.minSlides;
                  n2 = o.children.eq(l2).position();
                }
              else if (o.carousel && o.active.last && i2 == "prev") {
                var d2 =
                    o.settings.moveSlides == 1
                      ? o.settings.maxSlides - m()
                      : (x() - 1) * m() -
                        (o.children.length - o.settings.maxSlides),
                  a2 = r.children(".bx-clone").eq(d2);
                n2 = a2.position();
              } else if (i2 == "next" && o.active.index == 0)
                (n2 = r
                  .find("> .bx-clone")
                  .eq(o.settings.maxSlides)
                  .position()),
                  (o.active.last = !1);
              else if (e2 >= 0) {
                var c2 = e2 * m();
                n2 = o.children.eq(c2).position();
              }
              if (typeof n2 < "u") {
                var g2 =
                  o.settings.mode == "horizontal" ? -(n2.left - s2) : -n2.top;
                b(g2, "slide", o.settings.speed);
              }
            }
        }),
        (r.goToNextSlide = function () {
          if (o.settings.infiniteLoop || !o.active.last) {
            var t2 = parseInt(o.active.index) + 1;
            r.goToSlide(t2, "next");
          }
        }),
        (r.goToPrevSlide = function () {
          if (o.settings.infiniteLoop || o.active.index != 0) {
            var t2 = parseInt(o.active.index) - 1;
            r.goToSlide(t2, "prev");
          }
        }),
        (r.startAuto = function (t2) {
          o.interval ||
            ((o.interval = setInterval(function () {
              o.settings.autoDirection == "next"
                ? r.goToNextSlide()
                : r.goToPrevSlide();
            }, o.settings.pause)),
            o.settings.autoControls && t2 != 1 && A("stop"));
        }),
        (r.stopAuto = function (t2) {
          o.interval &&
            (clearInterval(o.interval),
            (o.interval = null),
            o.settings.autoControls && t2 != 1 && A("start"));
        }),
        (r.getCurrentSlide = function () {
          return o.active.index;
        }),
        (r.getCurrentSlideElement = function () {
          return o.children.eq(o.active.index);
        }),
        (r.getSlideCount = function () {
          return o.children.length;
        }),
        (r.redrawSlider = function () {
          o.children.add(r.find(".bx-clone")).outerWidth(u()),
            o.viewport.css("height", v()),
            o.settings.ticker || S(),
            o.active.last && (o.active.index = x() - 1),
            o.active.index >= x() && (o.active.last = !0),
            o.settings.pager &&
              !o.settings.pagerCustom &&
              (w(), q(o.active.index));
        }),
        (r.destroySlider = function () {
          o.initialized &&
            ((o.initialized = !1),
            t(".bx-clone", this).remove(),
            o.children.each(function () {
              t(this).data("origStyle") != null
                ? t(this).attr("style", t(this).data("origStyle"))
                : t(this).removeAttr("style");
            }),
            t(this).data("origStyle") != null
              ? this.attr("style", t(this).data("origStyle"))
              : t(this).removeAttr("style"),
            t(this).unwrap().unwrap(),
            o.controls.el && o.controls.el.remove(),
            o.controls.next && o.controls.next.remove(),
            o.controls.prev && o.controls.prev.remove(),
            o.pagerEl && o.settings.controls && o.pagerEl.remove(),
            t(".bx-caption", this).remove(),
            o.controls.autoEl && o.controls.autoEl.remove(),
            clearInterval(o.interval),
            o.settings.responsive && t(window).unbind("resize", Z));
        }),
        (r.reloadSlider = function (t2) {
          t2 != null && (n = t2), r.destroySlider(), d();
        }),
        d(),
        this
      );
    };
  })(jQuery),
  $(window).load(function () {
    
  }),
  $(window).load(function () {
    (slide_time0 = 85e3),
      (min_slide0 = 1.5),
      (slideMargin0 = 100),
      $(window).innerWidth() <= 480 &&
        ((slide_time0 = 65e3), (min_slide0 = 1), (slideMargin0 = 50)),
      $("#bxsliderhome").length &&
        $("#bxsliderhome").bxSlider({
          minSlides: 1.5,
          maxSlides: 5,
          slideWidth: 352,
          slideMargin: slideMargin0,
          ticker: !0,
          speed: slide_time0,
          tickerHover: !1,
          useCSS: !1,
        }),
      (slide_time2 = 55e3),
      (min_slide0 = 1.5),
      (slideMargin2 = 100),
      $(window).innerWidth() <= 480 &&
        ((slide_time2 = 35e3), (min_slide0 = 1), (slideMargin2 = 50)),
      $("#bxsliderhome2").length &&
        $("#bxsliderhome2").bxSlider({
          minSlides: 1.5,
          maxSlides: 5,
          slideWidth: 300,
          slideMargin: slideMargin2,
          ticker: !0,
          speed: slide_time2,
          tickerHover: !1,
          useCSS: !1,
        });
  }),
  $(document).ready(function () {
    $(".customized_li").show(),
      setTimeout(function () {
        $(".glitch_logo_loader").fadeOut(600);
      }, 5e3),
      $(".glitch_logo_loader video").attr("muted", "false"),
      $(".HorizontalList__Item").click(function () {
        $(this).hasClass("customized_li");
      });
    var people_slider = new Swiper("#people_slider", {
        spaceBetween: 0,
        loop: !0,
        autoplay: { delay: 4e3, disableOnInteraction: !1 },
        breakpoints: { 0: { slidesPerView: 1, spaceBetween: 10 } },
      }),
      partner_swiper = new Swiper("#mag24_ul", {
        spaceBetween: 0,
        navigation: { nextEl: ".mag24_ul_next1", prevEl: ".mag24_ul_prev1" },
        autoplay: { delay: 5, disableOnInteraction: !0 },
        speed: 5e3,
        loop: !0,
        freeMode: !0,
        breakpoints: {
          0: { slidesPerView: 1.7, spaceBetween: 20 },
          481: { slidesPerView: 2, spaceBetween: 30 },
          786: { slidesPerView: 3, spaceBetween: 30 },
          1100: { slidesPerView: 4, spaceBetween: 30 },
        },
      }),
      partner_swiper = new Swiper("#latest_prod_ul2", {
        spaceBetween: 0,
        navigation: { nextEl: ".latest_ul_next2", prevEl: ".latest_ul_prev2" },
        loop: !0,
        autoplay: { delay: 5e3, disableOnInteraction: !1 },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 0 },
          481: { slidesPerView: 1, spaceBetween: 0 },
          786: { slidesPerView: 1, spaceBetween: 0 },
          1100: { slidesPerView: 1, spaceBetween: 0 },
        },
      }),
      partner_swiper = new Swiper("#latest_prod_ul", {
        spaceBetween: 0,
        pagination: { el: ".latest_ul_pag1", clickable: !0 },
        navigation: { nextEl: ".latest_ul_next1", prevEl: ".latest_ul_prev1" },
        loop: !0,
        autoplay: { delay: 5e3, disableOnInteraction: !1 },
        autoplay: { delay: 5, disableOnInteraction: !0 },
        speed: 5e3,
        loop: !0,
        freeMode: !0,
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 20 },
          481: { slidesPerView: 1.5, spaceBetween: 30 },
          786: { slidesPerView: 2, spaceBetween: 30 },
          1100: { slidesPerView: 3, spaceBetween: 30 },
        },
      });
    if ($(window).innerWidth() <= 480) {
      $("#latest_prod_ul2333").addClass("swiper-container"),
        $("#latest_prod_ul2333").wrapInner(
          '<div class="swiper-wrapper"></div>'
        ),
        $("#latest_prod_ul2333 .swiper-wrapper li").wrap(
          '<div class="swiper-slide"></div>'
        ),
        $("#latest_prod_ul2333").append(
          '<div class="swiper-pagination rel latest_ul_pag23"></div>'
        );
      var latest_prod_ul2333 = new Swiper("#latest_prod_ul2333", {
        spaceBetween: 0,
        pagination: { el: ".latest_ul_pag23", clickable: !0 },
        loop: !0,
        autoplay: { delay: 5e3, disableOnInteraction: !1 },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 20 },
          481: { slidesPerView: 1.5, spaceBetween: 30 },
          786: { slidesPerView: 2, spaceBetween: 30 },
          1100: { slidesPerView: 3, spaceBetween: 30 },
        },
      });
    }
    var partner_swiper = new Swiper("#slider_top_24_wrap", {
      spaceBetween: 0,
      pagination: { el: ".top_slider_pag1", clickable: !0 },
      effect: "fade",
      navigation: { nextEl: ".top_slider_next1", prevEl: ".top_slider_prev1" },
      loop: !0,
      autoplay: { delay: 5e3, disableOnInteraction: !1 },
      breakpoints: { 0: { slidesPerView: 1, spaceBetween: 0 } },
    });
    $(".rotating_text").length &&
      ($(".template-cart").length ||
        $(".rotating_text").marquee({
          gap: 50,
          speed: 25,
          delayBeforeStart: 0,
          startVisible: !0,
          direction: "left",
          duplicated: !0,
          pauseOnHover: !0,
        })),
      $(".rotating_text_slow").length &&
        ($(".template-cart").length ||
          $(".rotating_text_slow").marquee({
            gap: 50,
            speed: 30,
            delayBeforeStart: 0,
            startVisible: !0,
            direction: "left",
            duplicated: !0,
            pauseOnHover: !0,
          }));
  }),
  $(document).ready(function () {
    
    (ysscount = 0),
      $(".ys_custom_gallery_swiper").each(function () {
        ysscount++,
          (this_item = $(this)),
          this_item.addClass("swiper-container customswiper" + ysscount),
          (desk_item = this_item.attr("data-desktop_items")),
          (mob_item = this_item.attr("data-mobile_items")),
          (ipad_item = this_item.attr("data-ipad_items")),
          (ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items")),
          (ipad_item_vertical = this_item.attr("data-ipad_vertical_items")),
          (slider_mode = this_item.attr("data-mode")),
          (swiper_arrows = this_item.attr("data-swiper-style-arrow")),
          (swiper_style = this_item.attr("data-swiper_style")),
          (slider_autoplay = this_item.attr("data-slider-autoplay")),
          (slider_center = this_item.attr("data-slider-center")),
          (slider_effect = this_item.attr("data-slider-effect")),
          (slider_desktop_padding = this_item.attr("data-desktop-padding")),
          (slider_ipad_horizontal_padding = this_item.attr(
            "data-ipad-horizontal-padding"
          )),
          (slider_ipad_vertical_padding = this_item.attr(
            "data-ipad-vertical-padding"
          )),
          (slider_mobile_padding = this_item.attr("data-mobile-padding")),
          (desktop_offset = this_item.attr("data-desktop-offset")),
          (mobile_offset = this_item.attr("data-mobile-offset")),
          (ipad_vertical_offset = this_item.attr("data-ipad-vertical-offset")),
          (ipad_horizontal_offset = this_item.attr(
            "data-ipad-horizontal-offset"
          )),
          (slider_loop = this_item.attr("data-slider-loop")),
          console.log(swiper_style),
          console.log(slider_center),
          console.log(slider_loop),
          (swiper_navigation = {}),
          (swiper_pagination = {}),
          (slider_autoplay_start = {});
        var is_slider_loop = !0,
          is_slider_center = !1;
        if (
          (slider_loop == "false"
            ? (is_slider_loop = !1)
            : (is_slider_loop = !0),
          slider_center == "false"
            ? (is_slider_center = !1)
            : (is_slider_center = !0),
          swiper_arrows == "true" &&
            (this_item.append(
              '<div class="swiper-button-next swiper_arrows  customswiper_next' +
                ysscount +
                '"></div><div class="swiper-button-prev swiper_arrows  customswiper_prev' +
                ysscount +
                '"></div>'
            ),
            (swiper_navigation = {
              nextEl: ".customswiper_next" + ysscount,
              prevEl: ".customswiper_prev" + ysscount,
            })),
          swiper_style == "donts"
            ? (this_item.append('<div class="swiper-pagination"></div>'),
              (swpier_pagination = {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: !0,
              }))
            : swiper_style == "progress_bar"
            ? (swpier_pagination = {
                el: ".swiper-pagination",
                type: "progressbar",
                clickable: !0,
              })
            : (swpier_pagination = {}),
          console.log(),
          slider_autoplay == "true"
            ? (slider_autoplay_start = {
                delay: (ysscount == 1)?40000:3500,
                disableOnInteraction: !1,
              })
            : (slider_autoplay_start = {
                delay: 25e10,
                disableOnInteraction: !0,
              }),
          slider_mode == "normal")
        )
          var partner_swiper = new Swiper(".customswiper" + ysscount, {
            spaceBetween: 0,
            navigation: swiper_navigation,
            effect: slider_effect == "fade" ? "fade" : "",
            pagination: {
              el: ".swiper-pagination",
              type: swiper_style == "progress_bar" ? "progressbar" : "bullets",
              clickable: !0,
            },
            loop: is_slider_loop,
            autoplay: slider_autoplay_start,
            centeredSlides: is_slider_center,
            breakpoints: {
              0: {
                slidesPerView: mob_item,
                spaceBetween: slider_mobile_padding,
                slidesOffsetBefore: mobile_offset,
              },
              481: {
                slidesPerView: ipad_item_vertical,
                spaceBetween: slider_ipad_vertical_padding,
                slidesOffsetBefore: ipad_vertical_offset,
              },
              786: {
                slidesPerView: ipad_item_horizontal,
                spaceBetween: slider_ipad_horizontal_padding,
                slidesOffsetBefore: ipad_horizontal_offset,
              },
              1100: {
                slidesPerView: desk_item,
                spaceBetween: slider_desktop_padding,
                slidesOffsetBefore: desktop_offset,
              },
            },
          });
        else {
          this_item.find(".swiper-wrapper").addClass("swipanim");
          var partner_swiper = new Swiper(".customswiper" + ysscount, {
            spaceBetween: 0,
            navigation: swiper_navigation,
            effect: slider_effect == "fade" ? "fade" : "",
            pagination: {
              el: ".swiper-pagination",
              type: swiper_style == "progress_bar" ? "progressbar" : "bullets",
              clickable: !0,
            },
            loop: is_slider_loop,
            freeMode: !0,
            spaceBetween: 0,
            grabCursor: !0,
            slidesPerView: 7,
            autoplay: { delay: 1, disableOnInteraction: !0 },
            freeMode: !0,
            speed: 5e3,
            freeModeMomentum: !1,
            breakpoints: {
              0: {
                slidesPerView: mob_item,
                spaceBetween: slider_mobile_padding,
                slidesOffsetBefore: mobile_offset,
              },
              481: {
                slidesPerView: ipad_item_vertical,
                spaceBetween: slider_ipad_vertical_padding,
                slidesOffsetBefore: ipad_vertical_offset,
              },
              786: {
                slidesPerView: ipad_item_horizontal,
                spaceBetween: slider_ipad_horizontal_padding,
                slidesOffsetBefore: ipad_horizontal_offset,
              },
              1100: {
                slidesPerView: desk_item,
                spaceBetween: slider_desktop_padding,
                slidesOffsetBefore: desktop_offset,
              },
            },
          });
        }
      }),
      $(".ys_custom_video_gallery_swiper").each(function () {
        ysscount++,
          (this_item = $(this)),
          this_item.addClass("swiper-container customswiper" + ysscount),
          this_item.wrapInner('<div class="swiper-wrapper"></div>'),
          this_item.find("li").wrap('<div class="swiper-slide"></div>'),
          this_item.append('<div class="swiper-pagination"></div>'),
          (desk_item = this_item.attr("data-desktop_items")),
          (mob_item = this_item.attr("data-mobile_items")),
          (ipad_item = this_item.attr("data-ipad_items")),
          (ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items")),
          (ipad_item_vertical = this_item.attr("data-ipad_vertical_items")),
          (slider_mode = this_item.attr("data-mode")),
          (swiper_arrows = this_item.attr("data-swiper-style-arrow")),
          (swiper_style = this_item.attr("data-swiper_style")),
          (slider_autoplay = this_item.attr("data-slider-autoplay")),
          (slider_center = this_item.attr("data-slider-center")),
          (slider_effect = this_item.attr("data-slider-effect")),
          (slider_desktop_padding = this_item.attr("data-desktop-padding")),
          (slider_ipad_horizontal_padding = this_item.attr(
            "data-ipad-horizontal-padding"
          )),
          (slider_ipad_vertical_padding = this_item.attr(
            "data-ipad-vertical-padding"
          )),
          (slider_mobile_padding = this_item.attr("data-mobile-padding")),
          (desktop_offset = this_item.attr("data-desktop-offset")),
          (mobile_offset = this_item.attr("data-mobile-offset")),
          (ipad_vertical_offset = this_item.attr("data-ipad-vertical-offset")),
          (ipad_horizontal_offset = this_item.attr(
            "data-ipad-horizontal-offset"
          )),
          (slider_loop = this_item.attr("data-slider-loop")),
          console.log(swiper_style),
          console.log(slider_center),
          console.log(slider_loop),
          (swiper_navigation = {}),
          (swiper_pagination = {}),
          (slider_autoplay_start = {});
        var is_slider_loop = !0,
          is_slider_center = !1;
        if (
          (slider_loop == "false"
            ? (is_slider_loop = !1)
            : (is_slider_loop = !0),
          slider_center == "false"
            ? (is_slider_center = !1)
            : (is_slider_center = !0),
          swiper_arrows == "true" &&
            (this_item.append(
              '<div class="swiper-button-next swiper_arrows  customswiper_next' +
                ysscount +
                '"></div><div class="swiper-button-prev swiper_arrows  customswiper_prev' +
                ysscount +
                '"></div>'
            ),
            (swiper_navigation = {
              nextEl: ".customswiper_next" + ysscount,
              prevEl: ".customswiper_prev" + ysscount,
            })),
          swiper_style == "donts"
            ? (this_item.append('<div class="swiper-pagination"></div>'),
              (swpier_pagination = {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: !0,
              }))
            : swiper_style == "progress_bar"
            ? (swpier_pagination = {
                el: ".swiper-pagination",
                type: "progressbar",
                clickable: !0,
              })
            : (swpier_pagination = {}),
          console.log(),
          slider_autoplay == "true"
            ? (slider_autoplay_start = {
                delay: 3500,
                disableOnInteraction: !1,
              })
            : (slider_autoplay_start = {
                delay: 25e10,
                disableOnInteraction: !0,
              }),
          slider_mode == "normal")
        )
          var partner_swiper = new Swiper(".customswiper" + ysscount, {
            spaceBetween: 0,
            navigation: swiper_navigation,
            effect: slider_effect == "fade" ? "fade" : "",
            pagination: {
              el: ".swiper-pagination",
              type: swiper_style == "progress_bar" ? "progressbar" : "bullets",
              clickable: !0,
            },
            loop: is_slider_loop,
            autoplay: slider_autoplay_start,
            centeredSlides: is_slider_center,
            breakpoints: {
              0: {
                slidesPerView: mob_item,
                spaceBetween: slider_mobile_padding,
                slidesOffsetBefore: mobile_offset,
              },
              481: {
                slidesPerView: ipad_item_vertical,
                spaceBetween: slider_ipad_vertical_padding,
                slidesOffsetBefore: ipad_vertical_offset,
              },
              786: {
                slidesPerView: ipad_item_horizontal,
                spaceBetween: slider_ipad_horizontal_padding,
                slidesOffsetBefore: ipad_horizontal_offset,
              },
              1100: {
                slidesPerView: desk_item,
                spaceBetween: slider_desktop_padding,
                slidesOffsetBefore: desktop_offset,
              },
            },
          });
        else {
          this_item.find(".swiper-wrapper").addClass("swipanim");
          var partner_swiper = new Swiper(".customswiper" + ysscount, {
            spaceBetween: 0,
            navigation: swiper_navigation,
            effect: slider_effect == "fade" ? "fade" : "",
            pagination: {
              el: ".swiper-pagination",
              type: swiper_style == "progress_bar" ? "progressbar" : "bullets",
              clickable: !0,
            },
            loop: is_slider_loop,
            freeMode: !0,
            spaceBetween: 0,
            grabCursor: !0,
            slidesPerView: 7,
            autoplay: { delay: 1, disableOnInteraction: !0 },
            freeMode: !0,
            speed: 5e3,
            freeModeMomentum: !1,
            breakpoints: {
              0: {
                slidesPerView: mob_item,
                spaceBetween: slider_mobile_padding,
                slidesOffsetBefore: mobile_offset,
              },
              481: {
                slidesPerView: ipad_item_vertical,
                spaceBetween: slider_ipad_vertical_padding,
                slidesOffsetBefore: ipad_vertical_offset,
              },
              786: {
                slidesPerView: ipad_item_horizontal,
                spaceBetween: slider_ipad_horizontal_padding,
                slidesOffsetBefore: ipad_horizontal_offset,
              },
              1100: {
                slidesPerView: desk_item,
                spaceBetween: slider_desktop_padding,
                slidesOffsetBefore: desktop_offset,
              },
            },
          });
        }
      }),
      $(".faq_wrap .title_wrap").click(function () {
        $(this).toggleClass("active"),
          $(this).parents(".faq_wrap").find(".ans_wrap").slideToggle(300);
      }),
      $(".ys_custom_gallery_swiper_test").each(function () {
        ysscount++,
          (this_item = $(this)),
          this_item.addClass("swiper-container customswiper" + ysscount),
          this_item.wrapInner('<div class="swiper-wrapper"></div>'),
          this_item.find("li").wrap('<div class="swiper-slide"></div>'),
          this_item.append(
            '<div class="swiper-button-next swiper_arrows2  customswiper_next' +
              ysscount +
              '"></div><div class="swiper-button-prev swiper_arrows2  customswiper_prev' +
              ysscount +
              '"></div>'
          ),
          (desk_item = this_item.attr("data-desktop_items")),
          (mob_item = this_item.attr("data-mobile_items"));
        var partner_swiper = new Swiper(".customswiper" + ysscount, {
          spaceBetween: 0,
          navigation: {
            nextEl: ".customswiper_next" + ysscount,
            prevEl: ".customswiper_prev" + ysscount,
          },
          loop: !1,
          breakpoints: {
            0: {
              slidesPerView: mob_item,
              spaceBetween: 20,
              slidesOffsetBefore: 30,
            },
            481: {
              slidesPerView: desk_item,
              spaceBetween: 30,
              slidesOffsetBefore: 230,
            },
            786: {
              slidesPerView: desk_item,
              spaceBetween: 30,
              slidesOffsetBefore: 30,
            },
            1100: {
              slidesPerView: desk_item,
              spaceBetween: 30,
              slidesOffsetBefore: 30,
            },
          },
        });
      });
  });
//# sourceMappingURL=/s/files/1/0622/6172/3323/t/9/assets/custom.js.map?v=1726653494

$(window).load(function(){

   
    
  setTimeout(function () {
   
      console.log("offer init");
  /* pdp_offers_carousel js starts */
new Swiper('#pdp_offers_carousel2', {
		spaceBetween: 0,
		loop: true,
		observer: true,
		//effect: "fade",
		lazy:true,
		observeParents: true,
		pagination: {
			el: '.offer_pagination2',
            dynamicBullets: true
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
  
		breakpoints: {
			0: {
				slidesPerView: 1,
				spaceBetween: 0
			}
		}
	});

     if ($(".template-cart").length > 0) {
        console.log("hi");
        try{
            $(".AnnouncementBar__Content ").marquee({
          gap: 50,
          speed: 25,
          delayBeforeStart: 0,
          startVisible: !0,
          direction: "left",
          duplicated: !0,
          pauseOnHover: !0,
        });
        }catch(ee){

        }
          
       
    }
/* pdp_offers_carousel js ends */
  },3000);

});


 

(function(){
      const vids = document.querySelectorAll('.lazy-video');
      if (!('IntersectionObserver' in window) || !vids.length) return;

      const io = new IntersectionObserver((entries) => {
        entries.forEach(({ target: v, isIntersecting }) => {
          if (isIntersecting) {
            // kick off loading + play when in view
            const play = v.play && v.play();
            if (play && play.catch) play.catch(() => {}); // ignore autoplay block
          } else {
            v.pause && v.pause();
          }
        });
      }, { threshold: 0.25 });

      vids.forEach(v => io.observe(v));
    })();